webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// The browser platform with a compiler
	// Application is using dynamic bootstrapping wit JIT (Just-In-Time) compiler
	var platform_browser_dynamic_1 = __webpack_require__(1);
	// The app module
	var AppModule_1 = __webpack_require__(23);
	var core_1 = __webpack_require__(3);
	core_1.enableProdMode();
	// Combine and launch the module
	platform_browser_dynamic_1.platformBrowserDynamic().bootstrapModule(AppModule_1.AppModule);


/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var platform_browser_1 = __webpack_require__(21);
	var core_2 = __webpack_require__(24);
	var shared_1 = __webpack_require__(106);
	var user_1 = __webpack_require__(120);
	var BookingModule_1 = __webpack_require__(312);
	var ParentProfileModule_1 = __webpack_require__(459);
	var RegisterModule_1 = __webpack_require__(464);
	// // Services
	var services_1 = __webpack_require__(315);
	// Components
	var LoginComponent_1 = __webpack_require__(469);
	var AppComponent_1 = __webpack_require__(472);
	var AppRouting_1 = __webpack_require__(783);
	var AppModule = (function () {
	    function AppModule() {
	    }
	    return AppModule;
	}());
	AppModule = __decorate([
	    core_1.NgModule({
	        imports: [
	            platform_browser_1.BrowserModule,
	            core_2.CoreModule,
	            shared_1.SharedModule,
	            user_1.UserModule,
	            BookingModule_1.BookingModule,
	            ParentProfileModule_1.ParentProfileModule,
	            AppRouting_1.routing,
	            RegisterModule_1.RegisterManagementModule
	        ],
	        declarations: [
	            LoginComponent_1.LoginComponent,
	            AppComponent_1.AppComponent
	        ],
	        providers: [
	            services_1.BookingHolidayService,
	            services_1.AttendanceService,
	            services_1.EmailService
	        ],
	        bootstrap: [
	            AppComponent_1.AppComponent
	        ]
	    })
	], AppModule);
	exports.AppModule = AppModule;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(25));


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	// Shared Modules
	var common_1 = __webpack_require__(22);
	var router_1 = __webpack_require__(26);
	// Shared Services
	var services_1 = __webpack_require__(58);
	// Components
	var FooterComponent_1 = __webpack_require__(74);
	var InspiredComponent_1 = __webpack_require__(80);
	var MainMenuComponent_1 = __webpack_require__(83);
	var TopMenuComponent_1 = __webpack_require__(91);
	var MenuHoverDirective_1 = __webpack_require__(94);
	var AdminHeaderComponent_1 = __webpack_require__(95);
	var AdminHeaderAuthComponent_1 = __webpack_require__(99);
	var AdminSidebarComponent_1 = __webpack_require__(102);
	// Services
	var AdminService_1 = __webpack_require__(87);
	var services_2 = __webpack_require__(105);
	var HolidayService_1 = __webpack_require__(86);
	var CoreModule = (function () {
	    function CoreModule(parentModule) {
	        // Guard to make sure that the CoreModule will be loaded one time only in the AppModule
	        if (parentModule) {
	            throw new Error('CoreModule is already loaded. Import it in the AppModule only.');
	        }
	    }
	    return CoreModule;
	}());
	CoreModule = __decorate([
	    core_1.NgModule({
	        imports: [
	            common_1.CommonModule,
	            router_1.RouterModule
	        ],
	        declarations: [
	            FooterComponent_1.FooterComponent,
	            MainMenuComponent_1.MainMenuComponent,
	            TopMenuComponent_1.TopMenuComponent,
	            MenuHoverDirective_1.MenuHoverDirective,
	            AdminHeaderComponent_1.AdminHeaderComponent,
	            AdminSidebarComponent_1.AdminSidebarComponent,
	            InspiredComponent_1.InspiredComponent,
	            AdminHeaderAuthComponent_1.AdminHeaderAuthComponent
	        ],
	        providers: [
	            // Services
	            services_1.SettingService,
	            services_1.ApiService,
	            services_1.LocalStorageService,
	            services_1.SessionStorageService,
	            services_1.FileService,
	            services_1.CatalogService,
	            services_1.StudentService,
	            services_1.MenuService,
	            AdminService_1.AdminService,
	            services_1.LocalNetworkService,
	            services_2.SessionService,
	            HolidayService_1.HolidayService
	        ],
	        exports: [
	            FooterComponent_1.FooterComponent,
	            MainMenuComponent_1.MainMenuComponent,
	            TopMenuComponent_1.TopMenuComponent,
	            MenuHoverDirective_1.MenuHoverDirective,
	            AdminHeaderComponent_1.AdminHeaderComponent,
	            AdminSidebarComponent_1.AdminSidebarComponent,
	            InspiredComponent_1.InspiredComponent,
	            AdminHeaderAuthComponent_1.AdminHeaderAuthComponent
	        ]
	    })
	    /**
	     * The CoreModule which will define the modules, components & directives that will
	     * be called only onetime in the main AppModule when the app loads. Do not import
	     * the CoreModule more than one time.
	     */
	    ,
	    __param(0, core_1.Optional()), __param(0, core_1.SkipSelf()),
	    __metadata("design:paramtypes", [CoreModule])
	], CoreModule);
	exports.CoreModule = CoreModule;


/***/ }),
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(59));
	__export(__webpack_require__(61));
	__export(__webpack_require__(67));
	__export(__webpack_require__(68));
	__export(__webpack_require__(62));
	__export(__webpack_require__(69));
	__export(__webpack_require__(66));
	__export(__webpack_require__(70));
	__export(__webpack_require__(73));


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var Observable_1 = __webpack_require__(7);
	var http_1 = __webpack_require__(60);
	var ApiService = (function () {
	    function ApiService(http) {
	        this.http = http;
	    }
	    /**
	     * Get Method to get data from Api Endpoint
	     * @param requestUrl - string
	     * @return Observable<Type>
	     */
	    ApiService.prototype.get = function (requestUrl) {
	        var options = new http_1.RequestOptions({ withCredentials: true });
	        return this.http.get(requestUrl, options)
	            .map(this.extractData)
	            .catch(this.handleError);
	    };
	    /**
	     * Get Method to get data from Api Endpoint - Use to export pdf
	     * @param requestUrl - string
	     * @return Observable<Type>
	     */
	    ApiService.prototype.getFile = function (requestUrl) {
	        var options = new http_1.RequestOptions({
	            withCredentials: true,
	        });
	        return this.http.get(requestUrl, options)
	            .map(function (response) {
	            var body = JSON.parse(response['_body']);
	            return body.buffer.data;
	        })
	            .catch(this.handleError);
	    };
	    /**
	     * Post Method to post data from Api Endpoint
	     * @param requestUrl - string
	     * @return Observable<Type>
	     */
	    ApiService.prototype.post = function (requestUrl, data) {
	        var headers;
	        if (!(data instanceof FormData)) {
	            headers = new http_1.Headers({ 'Content-Type': 'application/json' });
	        }
	        var options = new http_1.RequestOptions({
	            headers: headers,
	            withCredentials: true
	        });
	        return this.http.post(requestUrl, data, options)
	            .map(this.extractData)
	            .catch(this.handleError);
	    };
	    /**
	     * Put Method to post data to Api Endpoint
	     * @param requestUrl - string
	     * @return Observable<Type>
	     */
	    ApiService.prototype.put = function (requestUrl, data) {
	        var headers;
	        if (!(data instanceof FormData)) {
	            headers = new http_1.Headers({ 'Content-Type': 'application/json' });
	        }
	        var options = new http_1.RequestOptions({
	            headers: headers,
	            withCredentials: true
	        });
	        return this.http.put(requestUrl, data, options)
	            .map(this.extractData)
	            .catch(this.handleError);
	    };
	    /**
	     * Patch Method to update data through Api Endpoint
	     * @param requestUrl: string
	     * @return Observable<Type>
	     */
	    ApiService.prototype.patch = function (requestUrl, data) {
	        var headers;
	        if (!(data instanceof FormData)) {
	            headers = new http_1.Headers({ 'Content-Type': 'application/json' });
	        }
	        var options = new http_1.RequestOptions({
	            method: http_1.RequestMethod.Patch,
	            headers: headers,
	            withCredentials: true
	        });
	        return this.http.patch(requestUrl, data, options)
	            .map(this.extractData)
	            .catch(this.handleError);
	    };
	    /**
	     * Delete Method to remove the data through Api Endpoint
	     * @param requestUrl: string
	     * @return Observable<Type>
	     */
	    ApiService.prototype.delete = function (requestUrl) {
	        var options = new http_1.RequestOptions({ withCredentials: true });
	        return this.http.delete(requestUrl, options)
	            .catch(this.handleError);
	    };
	    /**
	     * Delete Method to remove the data through Api Endpoint
	     * @param requestUrl: string
	     * @return Observable<Type>
	     */
	    ApiService.prototype.deletePost = function (requestUrl, data) {
	        var headers;
	        if (!(data instanceof FormData)) {
	            headers = new http_1.Headers({ 'Content-Type': 'application/json' });
	        }
	        var options = new http_1.RequestOptions({
	            method: http_1.RequestMethod.Delete,
	            headers: headers,
	            withCredentials: true
	        });
	        return this.http.post(requestUrl, data, options)
	            .map(this.extractData)
	            .catch(this.handleError);
	    };
	    /**
	     * Extract Response data from Request Response
	     * @param res: Response
	     * @return JSON data
	     */
	    ApiService.prototype.extractData = function (res) {
	        var body;
	        var contentType = res.headers.get("content-type");
	        // If response has content type "application/json"
	        // then parse the body
	        if (contentType && contentType.indexOf('application/json') !== -1) {
	            try {
	                body = res.json();
	            }
	            catch (error) {
	                body = {};
	            }
	        }
	        else {
	            body = res.text();
	        }
	        return body;
	    };
	    /**
	     * Handle Error returned from Request Response
	     * @param error: any
	     * @return Observable<error>
	     */
	    ApiService.prototype.handleError = function (error) {
	        // In a real world app, we might use a remote logging infrastructure
	        // We'd also dig deeper into the error to get a better message
	        var errMsg = (error.message) ? error.message :
	            error.status ? error.status + " - " + error.statusText : 'Server error';
	        // console.log(errMsg); // log to console instead
	        return Observable_1.Observable.throw(error);
	    };
	    return ApiService;
	}());
	ApiService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [http_1.Http])
	], ApiService);
	exports.ApiService = ApiService;


/***/ }),
/* 60 */,
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	var Observable_1 = __webpack_require__(7);
	// Services
	var ApiService_1 = __webpack_require__(59);
	var SettingService_1 = __webpack_require__(62);
	var FileService_1 = __webpack_require__(66);
	var CatalogService = (function () {
	    function CatalogService(apiService, settingService, fileService) {
	        this.apiService = apiService;
	        this.settingService = settingService;
	        this.fileService = fileService;
	        this.fullCampusUrl = '/included-campuses';
	        this.campusUrl = '/campuses';
	        this.homeroomUrl = '/homerooms';
	        this.schoolyearUrl = '/school-years';
	        this.yearLevelUrl = '/year-levels';
	        this.semesterUrl = '/semesters';
	        this.termUrl = '/asa-terms';
	        this.currentSeasonUrl = '/seasons/currents';
	        this.allCurrentSeasonUrl = '/seasons/currents/all';
	        this.seasonUrl = '/seasons';
	        this.apiUrl = '';
	        this.apiUrl = this.settingService.getSetting('api_service_domain');
	    }
	    /**
	     * Get campus items
	     * @returns {Observable<Campus[]>} Array list of Campus class
	     */
	    CatalogService.prototype.getCampuses = function () {
	        var requestUrl = this.apiUrl + this.campusUrl;
	        return this.apiService.get(requestUrl);
	    };
	    /**
	     * Get full campus item with contain yearlevels and homerooms.
	     * @returns {Observable<CampusFullItem[]>} Array list of CampusFullItem class
	     */
	    CatalogService.prototype.getCampusesFullItems = function () {
	        var requestUrl = this.apiUrl + this.fullCampusUrl;
	        return this.apiService.get(requestUrl);
	    };
	    /**
	     * Get homerooms
	     * @returns {Observable<Homeroom[]>} Array list of Homeroom class
	     */
	    CatalogService.prototype.getHomerooms = function () {
	        var requestUrl = this.apiUrl + this.homeroomUrl;
	        return this.apiService.get(requestUrl);
	    };
	    /**
	     * Get school years
	     * @returns {Observable<Schoolyear[]>} Array list of Schoolyear class
	     */
	    CatalogService.prototype.getSchoolyears = function () {
	        var requestUrl = this.apiUrl + this.schoolyearUrl;
	        return this.apiService.get(requestUrl);
	    };
	    /**
	     * Get year levels
	     * @returns {Observable<YearLevel[]>} Array list of YearLevel class
	     */
	    CatalogService.prototype.getYearLevels = function () {
	        var requestUrl = this.apiUrl + this.yearLevelUrl;
	        return this.apiService.get(requestUrl);
	    };
	    CatalogService.prototype.getSemesters = function () {
	        var requestUrl = this.apiUrl + this.semesterUrl;
	        return this.apiService.get(requestUrl);
	    };
	    CatalogService.prototype.getTerms = function () {
	        var requestUrl = this.apiUrl + this.termUrl;
	        return this.apiService.get(requestUrl);
	    };
	    CatalogService.prototype.getSeason = function () {
	        var requestUrl = this.apiUrl + this.seasonUrl;
	        return this.apiService.get(requestUrl);
	    };
	    CatalogService.prototype.getCurrentSeason = function () {
	        var requestUrl = this.apiUrl + this.currentSeasonUrl;
	        return this.apiService.get(requestUrl);
	    };
	    CatalogService.prototype.getAllCurrentSeason = function () {
	        var requestUrl = this.apiUrl + this.allCurrentSeasonUrl;
	        return this.apiService.get(requestUrl);
	    };
	    CatalogService.prototype.getTermBySemesterId = function (semesterId) {
	        var requestUrl = this.apiUrl + this.termUrl + '?semester_id=' + semesterId;
	        return this.apiService.get(requestUrl);
	    };
	    CatalogService.prototype.getTemrmByCurrentSemester = function () {
	        var _this = this;
	        return this.getSemesters()
	            .map(function (semesterList) { return _.filter(semesterList, function (o) { return o.is_current; })[0].id; })
	            .switchMap(function (currentSemesterId) { return currentSemesterId ? _this.getTermBySemesterId(currentSemesterId) : Observable_1.Observable.of(null); });
	    };
	    /**
	     * Handle Promise errors
	     * @returns {String} Message error
	     */
	    CatalogService.prototype.handleError = function (error) {
	        return Promise.reject(error.message || error);
	    };
	    return CatalogService;
	}());
	CatalogService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [ApiService_1.ApiService,
	        SettingService_1.SettingService,
	        FileService_1.FileService])
	], CatalogService);
	exports.CatalogService = CatalogService;


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	// Setting configuration
	var Setting_1 = __webpack_require__(63);
	// Lodash
	var _ = __webpack_require__(64);
	var SettingService = (function () {
	    function SettingService() {
	    }
	    /**
	     * Find in the setting list the setting that has
	     * the id matched with settingId input
	     * @param {string} settingId - the id of the setting
	     * @return {string} - the setting value or empty string
	     */
	    SettingService.prototype.getSetting = function (settingId) {
	        var result = _.find(Setting_1.SETTINGS, { 'id': settingId });
	        return result ? result.value : '';
	    };
	    return SettingService;
	}());
	SettingService = __decorate([
	    core_1.Injectable()
	], SettingService);
	exports.SettingService = SettingService;


/***/ }),
/* 63 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Setting = (function () {
	    function Setting() {
	    }
	    return Setting;
	}());
	exports.Setting = Setting;
	exports.SETTINGS = [
	    {
	        id: 'api_service_domain',
	        value: '/api'
	    }
	];


/***/ }),
/* 64 */,
/* 65 */,
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	// Import Setting Service and User, Credential Model
	var SettingService_1 = __webpack_require__(62);
	var ApiService_1 = __webpack_require__(59);
	var FileService = (function () {
	    function FileService(settingService, apiService) {
	        this.settingService = settingService;
	        this.apiService = apiService;
	        this.fileUrl = '/files';
	        this.apiUrl = '';
	        this.apiUrl = this.settingService.getSetting('api_service_domain');
	    }
	    FileService.prototype.uploadFile = function (data) {
	        var requestUrl = this.apiUrl + this.fileUrl;
	        return this.apiService.post(requestUrl, data);
	    };
	    FileService.prototype.getFile = function (fileId) {
	        return this.apiUrl + this.fileUrl + '/' + fileId;
	    };
	    return FileService;
	}());
	FileService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [SettingService_1.SettingService,
	        ApiService_1.ApiService])
	], FileService);
	exports.FileService = FileService;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var LocalStorageService = (function () {
	    function LocalStorageService() {
	    }
	    LocalStorageService.prototype.getData = function (key) {
	        var text = window.localStorage.getItem(key);
	        return JSON.parse(text);
	    };
	    LocalStorageService.prototype.setData = function (key, data) {
	        var text = JSON.stringify(data);
	        try {
	            window.localStorage.setItem(key, text);
	            return true;
	        }
	        catch (error) {
	            console.log("Cannot set local storage data:");
	            console.log(data);
	            return false;
	        }
	    };
	    LocalStorageService.prototype.removeData = function (key) {
	        try {
	            window.localStorage.removeItem(key);
	            return true;
	        }
	        catch (error) {
	            console.log("Cannot remove local storage data. Data key: " + key);
	            return false;
	        }
	    };
	    return LocalStorageService;
	}());
	LocalStorageService = __decorate([
	    core_1.Injectable()
	], LocalStorageService);
	exports.LocalStorageService = LocalStorageService;


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var SessionStorageService = (function () {
	    function SessionStorageService() {
	    }
	    SessionStorageService.prototype.getData = function (key) {
	        var text = window.sessionStorage.getItem(key);
	        return text ? JSON.parse(text) : '';
	    };
	    SessionStorageService.prototype.setData = function (key, data) {
	        var text = JSON.stringify(data);
	        try {
	            window.sessionStorage.setItem(key, text);
	            return true;
	        }
	        catch (error) {
	            console.log("Cannot set local storage data:");
	            console.log(data);
	            return false;
	        }
	    };
	    SessionStorageService.prototype.removeData = function (key) {
	        try {
	            window.sessionStorage.removeItem(key);
	            return true;
	        }
	        catch (error) {
	            console.log("Cannot remove local storage data. Data key: " + key);
	            return false;
	        }
	    };
	    return SessionStorageService;
	}());
	SessionStorageService = __decorate([
	    core_1.Injectable()
	], SessionStorageService);
	exports.SessionStorageService = SessionStorageService;


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	// Services
	var ApiService_1 = __webpack_require__(59);
	var SettingService_1 = __webpack_require__(62);
	var StudentService = (function () {
	    function StudentService(apiService, settingService) {
	        this.apiService = apiService;
	        this.settingService = settingService;
	        this.studentUrl = '/students';
	        this.holidayStudentUrl = '/hol/student';
	        this.studentScheduleUrl = '/asa-required-class-children';
	        this.importStudentScheduleUrl = '/students-schedule';
	        this.apiUrl = '';
	        this.apiUrl = this.settingService.getSetting('api_service_domain');
	    }
	    /**
	     *
	     */
	    StudentService.prototype.getStudents = function (filter) {
	        var requestUrl = this.apiUrl + this.studentUrl;
	        var hasFilter = false;
	        // Setup filter conditions
	        for (var condition in filter) {
	            if (filter[condition]) {
	                if (hasFilter) {
	                    requestUrl += '&';
	                }
	                else {
	                    requestUrl += '?';
	                    hasFilter = true;
	                }
	                requestUrl += condition + '=' + filter[condition];
	            }
	        }
	        return this.apiService.get(requestUrl);
	    };
	    StudentService.prototype.getHolidayStudents = function (holidayStudentFilter) {
	        var requestUrl = this.apiUrl + this.holidayStudentUrl;
	        var hasFilter = false;
	        // Setup filter conditions
	        for (var condition in holidayStudentFilter) {
	            if (holidayStudentFilter[condition]) {
	                if (hasFilter) {
	                    requestUrl += '&';
	                }
	                else {
	                    requestUrl += '?';
	                    hasFilter = true;
	                }
	                requestUrl += condition + '=' + holidayStudentFilter[condition];
	            }
	        }
	        return this.apiService.get(requestUrl);
	    };
	    StudentService.prototype.getHolidayStudentDetail = function (studentId) {
	        var requestUrl = this.apiUrl + this.holidayStudentUrl + '?id=' + studentId + '&page=1';
	        return this.apiService.get(requestUrl);
	    };
	    StudentService.prototype.updateHolidayStudentStatus = function (data) {
	        var requestUrl = this.apiUrl + this.holidayStudentUrl;
	        // Post content
	        var body = JSON.stringify(data);
	        return this.apiService.patch(requestUrl, body);
	    };
	    StudentService.prototype.getStudentsSchedule = function (filter) {
	        var requestUrl = this.apiUrl + this.studentScheduleUrl;
	        var hasFilter = false;
	        // Setup filter conditions
	        for (var condition in filter) {
	            if (filter[condition]) {
	                if (hasFilter) {
	                    requestUrl += '&';
	                }
	                else {
	                    requestUrl += '?';
	                    hasFilter = true;
	                }
	                requestUrl += condition + '=' + filter[condition];
	            }
	        }
	        return this.apiService.get(requestUrl);
	    };
	    StudentService.prototype.getHolidayStudentInfo = function () {
	        var requestUrl = this.apiUrl + this.holidayStudentUrl;
	        return this.apiService.get(requestUrl);
	    };
	    StudentService.prototype.importStudent = function (data) {
	        var requestUrl = this.apiUrl + this.studentUrl;
	        return this.apiService.patch(requestUrl, data);
	    };
	    StudentService.prototype.importStudentSchedule = function (data) {
	        var requestUrl = this.apiUrl + this.importStudentScheduleUrl;
	        return this.apiService.patch(requestUrl, data);
	    };
	    StudentService.prototype.updateStudentStatus = function (studentId, data) {
	        var requestUrl = this.apiUrl + this.studentUrl + "/" + studentId;
	        // Post content
	        var body = JSON.stringify(data);
	        return this.apiService.patch(requestUrl, body);
	    };
	    // Edit student
	    StudentService.prototype.editHolidayStudent = function (studentDetail) {
	        var requestUrl = this.apiUrl + this.holidayStudentUrl;
	        var body = JSON.stringify(studentDetail);
	        return this.apiService.patch(requestUrl, body);
	    };
	    //generate list season with day
	    StudentService.prototype.showClassBySeasonAndDay = function (season, weekdays) {
	        var iWeekdaysLength = weekdays.length;
	        var tempCompareName;
	        for (var i = 0; i < iWeekdaysLength; i++) {
	            tempCompareName = "" + weekdays[i].day;
	            if (_.parseInt(weekdays[i].season_id) === season.id && tempCompareName.toLowerCase() === season.displayName.toLowerCase()) {
	                return weekdays[i].class || weekdays[i].class_info.name;
	            }
	        }
	        return '';
	    };
	    return StudentService;
	}());
	StudentService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [ApiService_1.ApiService,
	        SettingService_1.SettingService])
	], StudentService);
	exports.StudentService = StudentService;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	// Menu for application
	var Menu_1 = __webpack_require__(71);
	var CampusInfo_1 = __webpack_require__(72);
	// Lodash
	var _ = __webpack_require__(64);
	var MenuService = (function () {
	    function MenuService() {
	    }
	    /**
	     * Find in the menu type list the menu list that has
	     * the name matched with menuType input
	     * @param {string} menuType - the name of the menu list
	     * @return { Menu[] | [] } - list of menu or empty list
	     */
	    MenuService.prototype.getMenuList = function (menuType) {
	        var result = _.find(Menu_1.MENUS, { 'name': menuType });
	        return result ? result.menuList : [];
	    };
	    MenuService.prototype.getCampusInfo = function () {
	        return CampusInfo_1.CAMPUS_INFOS;
	    };
	    return MenuService;
	}());
	MenuService = __decorate([
	    core_1.Injectable()
	], MenuService);
	exports.MenuService = MenuService;


/***/ }),
/* 71 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Menu = (function () {
	    function Menu() {
	    }
	    return Menu;
	}());
	exports.Menu = Menu;
	var MenuType = (function () {
	    function MenuType() {
	    }
	    return MenuType;
	}());
	exports.MenuType = MenuType;
	var MenuStatus = (function () {
	    function MenuStatus() {
	    }
	    return MenuStatus;
	}());
	exports.MenuStatus = MenuStatus;
	exports.MENUS = [
	    // Top menu list
	    {
	        name: 'top',
	        menuList: [
	            {
	                id: 'news-event',
	                label: 'News & Events',
	                url: 'https://www.aisvietnam.com/community/news-events/',
	                type: 'link',
	                target: '',
	                icon: '',
	                role: []
	            },
	            {
	                id: 'photo-gallery',
	                label: 'Photo Gallery',
	                url: 'https://www.aisvietnam.com/about-us/our-campuses/',
	                type: 'link',
	                target: '',
	                icon: '',
	                role: []
	            },
	            {
	                id: 'login-mail',
	                label: 'Login Mail',
	                url: 'https://portal.office.com',
	                type: 'link',
	                target: '_blank',
	                icon: '',
	                role: []
	            },
	            {
	                id: 'my-ais',
	                label: 'myAIS',
	                url: 'http://www.myais.vn',
	                type: 'link',
	                target: '_blank',
	                icon: '',
	                role: []
	            },
	            {
	                id: 'sitemap',
	                label: 'Sitemap',
	                url: 'https://www.aisvietnam.com/contact/',
	                type: 'link',
	                target: '',
	                icon: '',
	                role: []
	            }
	        ]
	    },
	    // Social connect top menu list
	    {
	        name: 'social-top',
	        menuList: [
	            {
	                id: 'facebook',
	                label: 'Facebook',
	                url: 'https://www.facebook.com/AustralianInternationalSchoolVietnam/',
	                type: 'link',
	                target: '_blank',
	                icon: '',
	                role: []
	            },
	            {
	                id: 'twitter',
	                label: 'Twitter',
	                url: 'https://twitter.com/#!/aisvietnam',
	                type: 'link',
	                target: '_blank',
	                icon: '',
	                role: []
	            },
	            {
	                id: 'google',
	                label: 'Google',
	                url: 'https://plus.google.com/u/0/+AustralianInternationalSchoolVietnamTT/posts',
	                type: 'link',
	                target: '_blank',
	                icon: '',
	                role: []
	            },
	            {
	                id: 'youtube',
	                label: 'Youtube',
	                url: 'https://www.youtube.com/user/aisvietnam',
	                type: 'link',
	                target: '_blank',
	                icon: '',
	                role: []
	            },
	            {
	                id: 'envelope-o',
	                label: 'Email',
	                url: 'http://portal.office.com/',
	                type: 'link',
	                target: '_blank',
	                icon: '',
	                role: []
	            }
	        ]
	    },
	    // Login main menu
	    {
	        name: 'login-main',
	        menuList: [
	            {
	                id: 'register',
	                label: 'Register',
	                url: '/hol-register',
	                type: 'route',
	                target: '',
	                icon: '',
	                role: []
	            },
	            {
	                id: 'login',
	                label: 'Login',
	                url: '/hol-login',
	                type: 'route',
	                target: '',
	                icon: '',
	                role: []
	            }
	        ]
	    },
	    // Login main menu
	    {
	        name: 'hol-login',
	        menuList: [
	            {
	                id: 'register',
	                label: 'Register',
	                url: '/hol-register',
	                type: 'route',
	                target: '',
	                icon: '',
	                role: []
	            },
	            {
	                id: 'login',
	                label: 'Login',
	                url: '/hol-login',
	                type: 'route',
	                target: '',
	                icon: '',
	                role: []
	            }
	        ]
	    },
	    // Camp module main menu list
	    {
	        name: 'camp-main',
	        menuList: []
	    },
	    // ASA module main menu list
	    {
	        name: 'asa-main',
	        menuList: []
	    },
	    // ASA module sub menu list
	    {
	        name: 'asa-sub',
	        menuList: [
	            {
	                id: 'bookingClasses',
	                label: 'Booking Classes',
	                url: '/booking/students',
	                type: 'route',
	                target: '',
	                icon: '',
	                role: []
	            },
	            // {
	            //     "id": "manageBooking",
	            //     "label": "Manage Booking",
	            //     "url":	"",
	            //     "type":	"route",
	            //     "target": "",
	            //     "icon": "",
	            //     "role": []
	            // },
	            {
	                id: 'attendance',
	                label: 'Attendance',
	                url: '/parent/attendance',
	                type: 'route',
	                target: '',
	                icon: '',
	                role: []
	            },
	            {
	                id: 'schedule',
	                label: 'Schedule',
	                url: '/schedule/list',
	                type: 'route',
	                target: '',
	                icon: '',
	                role: []
	            }
	        ]
	    },
	    // Camp module admin sidebar list
	    {
	        name: 'camp-admin-sidebar',
	        menuList: [
	            {
	                id: 'camp-program',
	                label: 'Camp Programmes',
	                url: '/camps/list',
	                type: 'route',
	                target: '',
	                icon: 'nature_people',
	                role: []
	            },
	            {
	                id: 'student',
	                label: 'Students',
	                url: '/students/list',
	                type: 'route',
	                target: '',
	                icon: 'people',
	                role: []
	            },
	            {
	                id: 'camp-report',
	                label: 'Camp Reports',
	                url: '/camps/report',
	                type: 'route',
	                target: '',
	                icon: 'rate_review',
	                role: []
	            }
	        ]
	    },
	    // Asa module admin sidebar list
	    {
	        name: 'asa-admin-sidebar',
	        menuList: [
	            {
	                id: 'classes',
	                label: 'Classes',
	                url: '/classes/list',
	                type: 'route',
	                target: '',
	                icon: 'store',
	                role: []
	            },
	            {
	                id: 'student',
	                label: 'Students',
	                url: '/students/list',
	                type: 'route',
	                target: '',
	                icon: 'people',
	                role: []
	            },
	            {
	                id: 'booking',
	                label: 'Bookings',
	                url: '/booking/list',
	                type: 'route',
	                target: '',
	                icon: 'bookmark',
	                role: []
	            },
	            {
	                id: 'email',
	                label: 'Email',
	                url: '/email/list',
	                type: 'route',
	                target: '',
	                icon: 'mail',
	                role: []
	            },
	            {
	                id: 'attendances',
	                label: 'Attendances',
	                url: '/attendances',
	                type: 'route',
	                target: '',
	                icon: 'spellcheck',
	                role: []
	            },
	            {
	                id: 'settings',
	                label: 'Settings',
	                url: '/settings',
	                type: 'route',
	                target: '',
	                icon: 'settings',
	                role: []
	            }
	        ]
	    },
	    // Bus module parent sidebar list
	    {
	        name: 'bus-parent-sidebar',
	        menuList: [
	            {
	                id: 'bus-attendance',
	                label: 'Bus attendance',
	                url: '',
	                type: 'route',
	                target: '',
	                icon: 'store',
	                role: []
	            },
	            {
	                id: 'bus-profile',
	                label: 'Profile',
	                url: '',
	                type: 'route',
	                target: '',
	                icon: 'people',
	                role: []
	            }
	        ]
	    },
	    // Bus module parent sidebar list
	    {
	        name: 'bus-admin-sidebar',
	        menuList: [
	            {
	                id: 'bus-schedule',
	                label: 'Daily transport list',
	                url: 'bus-schedules',
	                type: 'route',
	                target: '',
	                icon: 'directions_bus',
	                role: ['system', 'manager']
	            },
	            {
	                id: 'bus-student-management',
	                label: 'Student report',
	                url: 'students/list',
	                type: 'route',
	                target: '',
	                icon: 'assignment_ind',
	                role: ['system']
	            },
	            {
	                id: 'bus-report',
	                label: 'Bus report',
	                url: 'report',
	                type: 'route',
	                target: '',
	                icon: 'assessment',
	                role: ['system']
	            },
	            {
	                id: 'bus-settings',
	                label: 'Settings',
	                url: 'settings',
	                type: 'route',
	                target: '',
	                icon: 'settings',
	                role: ['system']
	            }
	        ]
	    },
	    // Holiday module main menu list
	    {
	        name: 'holiday-main',
	        menuList: []
	    },
	    // holiday module admin sidebar list
	    {
	        name: 'holiday-admin-sidebar',
	        menuList: [
	            {
	                id: 'booking',
	                label: 'Bookings',
	                url: '/booking/list',
	                type: 'route',
	                target: '',
	                icon: 'bookmark',
	                role: ['system']
	            },
	            {
	                id: 'courses',
	                label: 'Courses',
	                url: '/courses/list',
	                type: 'route',
	                target: '',
	                icon: 'book',
	                role: ['system']
	            },
	            {
	                id: 'classes',
	                label: 'Classes',
	                url: '/classes/list',
	                type: 'route',
	                target: '',
	                icon: 'store',
	                role: ['system', 'manager']
	            },
	            {
	                id: 'student',
	                label: 'Students',
	                url: '/students/list',
	                type: 'route',
	                target: '',
	                icon: 'people',
	                role: ['system']
	            },
	            {
	                id: 'email',
	                label: 'Email',
	                url: '/email/list',
	                type: 'route',
	                target: '',
	                icon: 'mail',
	                role: ['system', 'manager']
	            },
	            {
	                id: 'attendances',
	                label: 'Attendances',
	                url: '/attendances',
	                type: 'route',
	                target: '',
	                icon: 'spellcheck',
	                role: ['system', 'manager']
	            },
	            {
	                id: 'parents',
	                label: 'Parents',
	                url: '/parents',
	                type: 'route',
	                target: '',
	                icon: 'people',
	                role: ['system']
	            },
	            {
	                id: 'setting',
	                label: 'Setting',
	                url: '/setting',
	                type: 'route',
	                target: '',
	                icon: 'widgets',
	                role: ['system']
	            }
	        ]
	    },
	    {
	        name: 'holiday-staff-sidebar',
	        menuList: [
	            {
	                id: 'attendances',
	                label: 'Attendances',
	                url: '/attendances',
	                type: 'route',
	                target: '',
	                icon: 'spellcheck',
	                role: []
	            }
	        ]
	    },
	    // Holiday parent sub menu
	    {
	        name: 'holiday-sub',
	        menuList: [
	            {
	                id: 'holidayBooking',
	                label: 'Booking',
	                url: '/booking/students',
	                type: 'route',
	                target: '',
	                icon: '',
	                role: []
	            },
	            {
	                id: 'holidayAttendance',
	                label: 'Attendance',
	                url: '/view-attendance',
	                type: 'route',
	                target: '',
	                icon: '',
	                role: []
	            }
	        ]
	    },
	    // re-enrollment module admin sidebar list
	    {
	        name: 'reen-admin-sidebar',
	        menuList: [
	            {
	                id: 'response',
	                label: 'Responses',
	                url: '/response/list',
	                type: 'route',
	                target: '',
	                icon: 'bookmark',
	                role: ['system']
	            },
	            {
	                id: 'email',
	                label: 'Email',
	                url: '/email/list',
	                type: 'route',
	                target: '',
	                icon: 'email',
	                role: ['system']
	            },
	            {
	                id: 'student',
	                label: 'Students',
	                url: '/reen-student',
	                type: 'route',
	                target: '',
	                icon: 'store',
	                role: ['system']
	            },
	            {
	                id: 'report',
	                label: 'Report',
	                url: '/report',
	                type: 'route',
	                target: '',
	                icon: 'assessment',
	                role: ['system']
	            }
	        ]
	    },
	    // conference booking system module admin sidebar list
	    // role example : 'system', 'manager', 'parent'
	    {
	        name: 'conference-admin-sidebar',
	        menuList: [
	            {
	                id: 'interviews',
	                label: 'Booking rounds',
	                url: '/interviews',
	                type: 'route',
	                target: '',
	                icon: 'dashboard',
	                role: ['system'],
	            },
	            {
	                id: 'setting',
	                label: 'Settings',
	                url: '/setting',
	                type: 'route',
	                target: '',
	                icon: 'build',
	                role: ['system']
	            },
	            {
	                id: 'master-data',
	                label: 'Master Data',
	                url: '/master-data',
	                type: 'route',
	                target: '',
	                icon: 'storage',
	                role: ['system']
	            },
	            {
	                id: 'manage-time-slots',
	                label: 'Manage Time Slots',
	                url: '/manage-time-slots',
	                type: 'route',
	                target: '',
	                icon: 'timeline',
	                role: ['system', 'teacher']
	            },
	            {
	                id: 'booking-interview-master',
	                label: 'Parent Booking',
	                url: '/manage-interview',
	                type: 'route',
	                target: '',
	                icon: 'date_range',
	                role: ['system']
	            },
	            {
	                id: 'booking-interview-teacher',
	                label: 'Manage Interview',
	                url: '/manage-interview/my-interview',
	                type: 'route',
	                target: '',
	                icon: 'date_range',
	                role: ['teacher']
	            },
	            {
	                id: 'user-management',
	                label: 'User Management',
	                url: '/user-management',
	                type: 'route',
	                target: '',
	                icon: 'group',
	                role: ['system']
	            },
	            {
	                id: 'report',
	                label: 'Report',
	                url: '/report',
	                type: 'route',
	                target: '',
	                icon: 'insert_chart',
	                role: ['system']
	            }
	        ]
	    }
	];


/***/ }),
/* 72 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var CampusInfo = (function () {
	    function CampusInfo() {
	    }
	    return CampusInfo;
	}());
	exports.CampusInfo = CampusInfo;
	// Campus Info
	exports.CAMPUS_INFOS = [
	    {
	        id: 1,
	        name: "THU THIEM",
	        info: "Thu Thiem Campus (Kindergarten – Year 13)<br>264 Mai Chi Tho (East-West Highway), Binh Trung Ward | Ho Chi Minh City | Vietnam<br>T: +84 28 3742 4040",
	    },
	    {
	        id: 1,
	        name: "THAO DIEN",
	        info: "Thao Dien Campus (Kindergarten – Year 6)<br>APSC Compound 36 Thao Dien Road, An Khanh Ward | Ho Chi Minh City | Vietnam<br>T: +84 28 3744 6960 <br><br> Lotus Campus (Kindergarten) | Lotus Road<br> Cherry Blossom Campus (Year 1 – Year 6) | Cherry Blossom Road<br>T: +84 28 3744 6960",
	    },
	];


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	// Services
	var ApiService_1 = __webpack_require__(59);
	var SettingService_1 = __webpack_require__(62);
	var LocalNetworkService = (function () {
	    function LocalNetworkService(apiService, settingService) {
	        this.apiService = apiService;
	        this.settingService = settingService;
	        // Api Domain Url
	        this.apiUrl = '';
	        // Get API service domain for communate.
	        this.apiUrl = this.settingService.getSetting('api_service_domain');
	    }
	    LocalNetworkService.prototype.getLocalNetWork = function () {
	        this.hostName = window.location.hostname;
	        if (this.hostName === "auth.aisvietnam.com") {
	            var requestUrl = 'http://auth.aisvietnam.com/negotiate';
	            return this.apiService.get(requestUrl);
	        }
	        else {
	            var requestUrl = 'http://auth.eca.dev.nascorp.vn/negotiate';
	            return this.apiService.get(requestUrl);
	        }
	    };
	    return LocalNetworkService;
	}());
	LocalNetworkService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [ApiService_1.ApiService,
	        SettingService_1.SettingService])
	], LocalNetworkService);
	exports.LocalNetworkService = LocalNetworkService;


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var MenuService_1 = __webpack_require__(70);
	var FooterComponent = (function () {
	    function FooterComponent(menuService) {
	        this.menuService = menuService;
	    }
	    FooterComponent.prototype.ngOnInit = function () {
	        /** TO DO
	         * Get current language from cookie/session
	         * If no language data from it, set default language as English
	         */
	        this.currentLang = 'en';
	        // Get top menu list
	        this.menuList = this.menuService.getMenuList('top');
	        // Get campus info list
	        this.campusList = this.menuService.getCampusInfo();
	    };
	    return FooterComponent;
	}());
	FooterComponent = __decorate([
	    core_1.Component({
	        selector: 'footer',
	        template: __webpack_require__(75),
	        styles: [__webpack_require__(79)],
	        providers: [MenuService_1.MenuService]
	    }),
	    __metadata("design:paramtypes", [MenuService_1.MenuService])
	], FooterComponent);
	exports.FooterComponent = FooterComponent;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div id=\"app-footer\">\n    <!-- Trường quốc tế Úc -->\n    <div class=\"campus-info-list row small-up-1 medium-up-2 large-up-3\">\n        <!-- Campus Information -->\n        <div class=\"column\" *ngFor=\"let campus of campusList\">\n            <h5 class=\"campus-title\">{{campus.name}}</h5>\n            <div class=\"campus-text\" [innerHTML]=\"campus.info\"></div>\n        </div>\n\t\t<!-- CIS Member -->\n        <div class=\"column\">\n            <p align=\"center\">\n                <a href=\"http://www.ibo.org/\" target=\"_blank\"><img src=\"" + __webpack_require__(76) + "\"></a>\n            </p>\n            <p align=\"center\">\n                <a href=\"https://www.cam.ac.uk/\" target=\"_blank\"><img src=\"" + __webpack_require__(77) + "\"></a>\n            </p>\n            <p align=\"center\" class=\"cis-membership\">\n                <a href=\"http://www.cois.org/\" target=\"_blank\"><img src=\"" + __webpack_require__(78) + "\"></a>\n                <br>\n            </p>\n        </div>\n    </div>\n\t<div class=\"info-mail-container\">\n        <p class=\"info-mail-text\">enrolments@aisvietnam.com<br>www.aisvietnam.com</p>\n    </div>\n    <!-- Bottom Bar -->\n    <div class=\"bottom-bar\">\n        <div class=\"copyright\">\n            <span>Our website is best viewed using Chrome, Firefox, Safari.</span>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/ib_logo.88ef45dabda5b2bbe32eb13597007f28.png";

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/cambridge_university_logo.859556d1e042809d4e685d9a2cc5d205.png";

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/cis_member_logo.a242bba236677d42272753977e9911d3.png";

/***/ }),
/* 79 */
/***/ (function(module, exports) {

	module.exports = "#app-footer{background-color:#225da8;font-size:0.7rem;bottom:0;bottom-position:absolute;bottom-width:100%}#app-footer .campus-info-list{max-width:100%;padding:2rem 4rem}#app-footer .campus-info-list .column .campus-title{text-transform:uppercase;font-weight:bold;font-size:1rem;color:#fff}#app-footer .campus-info-list .column .campus-text,#app-footer .campus-info-list .column .cis-membership{color:#dadada;line-height:1.375rem}#app-footer .bottom-bar{display:table;width:100%;background-color:#043d7a;padding:15px 4rem}#app-footer .bottom-bar .copyright{float:right;display:table-cell;vertical-align:middle}#app-footer .bottom-bar .copyright span{font-weight:bold;color:#faa635}#app-footer .bottom-bar .top-bar-right{float:right}#app-footer .bottom-bar .top-bar-right .menu>li>a{color:#faa635;padding:0.6rem 0.3rem}#app-footer .bottom-bar .top-bar-right .menu>li>a:hover{color:#fff}#app-footer .info-mail-container{text-align:left;padding-left:5rem;padding-top:1rem;padding-bottom:1rem}#app-footer .info-mail-text{color:white}@media only screen and (max-width: 40em){#app-footer{font-size:0.8rem}#app-footer .campus-info-list .column{padding:1rem 0}#app-footer .campus-info-list .column .campus-title{font-size:1rem}#app-footer .bottom-bar .copyright{padding:0.5rem;text-align:center}#app-footer .bottom-bar .top-bar-right{display:none}}\n"

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var InspiredComponent = (function () {
	    function InspiredComponent() {
	    }
	    InspiredComponent.prototype.ngOnInit = function () {
	        this.isShowContent = {
	            isShowContentEurope: false,
	            isShowContentAfrica: false,
	            isShowContentAsia: false,
	            isShowContentLatin: false,
	        };
	    };
	    InspiredComponent.prototype.showContent = function (key) {
	        for (var k in this.isShowContent) {
	            if ("" + k === Object.keys(this.isShowContent)[key]) {
	                this.isShowContent[k] = !this.isShowContent[k];
	            }
	            else {
	                this.isShowContent[k] = false;
	            }
	        }
	    };
	    return InspiredComponent;
	}());
	InspiredComponent = __decorate([
	    core_1.Component({
	        selector: 'inspired',
	        template: __webpack_require__(81),
	        styles: [__webpack_require__(82)],
	        animations: [
	            core_1.trigger('openClose', [
	                core_1.state('open', core_1.style({
	                    display: 'block',
	                    position: 'relative',
	                    zIndex: '10',
	                    opacity: '1',
	                })),
	                core_1.state('closed', core_1.style({
	                    height: '0',
	                    display: 'none',
	                    opacity: '0',
	                    overflow: 'hidden',
	                })),
	                core_1.transition('open <=> closed', [
	                    core_1.animate('300ms')
	                ])
	            ]),
	        ],
	    }),
	    __metadata("design:paramtypes", [])
	], InspiredComponent);
	exports.InspiredComponent = InspiredComponent;


/***/ }),
/* 81 */
/***/ (function(module, exports) {

	module.exports = "<!-- Inspried -->\n<div class=\"inspired\">\n\t<div class=\"member-inspried\">\n\t\t<!--Start Inspried logo -->\n\t\t<a class=\"inspried-logo\" href=\"#\">\n\t\t\t<img src=\"https://services.aisvietnam.com/upload/footer_img_logo.jpg\" alt=\"footer_logo\" />\n\t\t</a>\n\t\t<!--End Inspried logo -->\n\n\t\t<!--Start Inspried content -->\n\t\t<div class=\"inspried-content-wrap\">\n\t\t\t<div tabindex=\"0\" class=\"inspried-content\"\n\t\t\t\t[@openClose]=\"isShowContent.isShowContentEurope ? 'open' : 'closed'\">\n\t\t\t\t<a href=\"http://fulham.school\">Fulham School</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"http://reddamhouse.org.uk/\">Reddam House Berkshire</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://stgeorges.ch\">St. George's International School</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://ecole-riviera.ch/\">Ecole Riviera</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://inspirededu.com/school/st-george-s-international-school-preview\">St. George's\n\t\t\t\t\tInternational School Preview</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://www.isticino.com/\">International School of Europe Ticino</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://sis.ac/\">Sotogrande International School</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://www.sanpatricio.es/\">Colegio San Patricio El Soto</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://www.sanpatricio.es/\">Colegio San Patricio La Moraleja</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://www.sanpatricio.es/\">Colegio San Patricio Serrano</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://www.sanpatricio.es/\">Colegio San Patricio Toledo</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://www.park-is.com/\">PaRK International School Alfragide</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://www.park-is.com/\">PaRK International School Cascais</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://www.park-is.com/\">PaRK International School Praca de Espanha</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://www.park-is.com/\">PaRK International School Restelo</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://www.isbergamo.com\">International School of Europe Bergamo</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"http://www.internationalschoolofmilan.it\">International School of Europe Milan</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"http://isekiddyenglish.it\">International School of Europe Kiddy English</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://www.stlouisschool.com/early-years/colanna-campus\">St. Louis School Via Colonna</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://www.stlouisschool.com/early-years/caviglia-campus\">St. Louis School Via Caviglia</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://www.stlouisschool.com/high-school/pantano-campus\">St. Louis School Via Patano</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://www.internationalschoolofmodena.it/\">International School of Europe Modena</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"http://internationalschoolsgroup.it/school/monza/\">International School of Europe Monza</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://www.internationalschoolofsiena.it/\">International School of Europe Siena</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"http://internationalschoolsgroup.it/school/como/\">International School of Europe Como</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://stjohns.be/\">St. John's International School</a>\n\t\t\t\t<span>|</span>\n\t\t\t</div>\n\t\t\t<div tabindex=\"0\" class=\"inspried-content\"\n\t\t\t\t[@openClose]=\"isShowContent.isShowContentAfrica ? 'open' : 'closed'\">\n\t\t\t\t<a href=\"https://britishschoolbahrain.com\">British School of Bahrain</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"http://ballito.reddamhouse.com\">Reddam House Ballito</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"http://asb.reddamhouse.com\">Reddam House Atlantic Seaboard</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"http://constantia.reddamhouse.com\">Reddam House Constantia</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"http://durbanville.reddamhouse.com\">Reddam House Durbanville</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"http://somerset.reddamhouse.com\">Reddam House Somerset</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"http://umhlanga.reddamhouse.com\">Reddam House Umhlanga</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"http://helderfontein.reddamhouse.com\">Reddam House Helderfontein</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"http://bedfordview.reddamhouse.com\">Reddam House Bedfordview</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"http://waterfall.reddamhouse.com\">Reddam House Waterfall</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"http://bluehills.reddford.co.za/\">Reddford House Blue Hills</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"http://northcliff.reddford.co.za/\">Reddford House Northcliff</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"http://thehills.reddford.co.za/\">Reddford House The Hills</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"http://brookhouse.ac.ke/school/runda/\">Brookhouse School Runda</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"http://brookhouse.ac.ke/school/karen\">Brookhouse School Karen</a>\n\t\t\t\t<span>|</span>\n\t\t\t</div>\n\t\t\t<div tabindex=\"0\" class=\"inspried-content\"\n\t\t\t\t[@openClose]=\"isShowContent.isShowContentAsia ? 'open' : 'closed'\">\n\t\t\t\t<a href=\"http://reddamels.com.au/school/woollahra/\">Reddam ELS Woollahra</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"http://reddamels.com.au/school/lindfield/\">Reddam ELS Lindfield</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"http://reddamels.com.au/school/st-leonards/\">Reddam ELS St Leonards</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://www.aisvietnam.com/\">ACG Strathallan*</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://www.aisvietnam.com/\">ACG Parnell College*</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://www.aisvietnam.com/\">ACG Sunderland School & College*</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://www.aisvietnam.com/\">ACG Penguins School ELS*</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://www.aisvietnam.com/\">ACG Tauranga*</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://www.aisvietnam.com/\">ACG Zig Zag Zoo ELS*</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://www.aisvietnam.com/\">ACG Australian International School K-6*</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://www.aisvietnam.com/\">ACG Australian International School K-13*</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://www.aisvietnam.com/\">Blue Valley School</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://www.aisvietnam.com/\">Colegio San Mateo</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://www.aisvietnam.com/\">ACG School Jakarta*</a>\n\t\t\t\t<span>|</span>\n\t\t\t</div>\n\t\t\t<div tabindex=\"0\" class=\"inspried-content\"\n\t\t\t\t[@openClose]=\"isShowContent.isShowContentLatin ? 'open' : 'closed'\">\n\t\t\t\t<a href=\"https://www.bluevalley.ed.cr/eng/\">Blue Valley School</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"http://csma.edu.co\">Colegio San Mateo </a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"http://cambridge.edu.pe\">Cambridge College Lima</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://www.altair.edu.pe/\">Colegio Altair</a>\n\t\t\t\t<span>|</span>\n\t\t\t</div>\n\t\t\t<!--Start Inspried title -->\n\t\t\t<ul class=\"inspried-title\">\n\t\t\t\t<li tabindex=\"0\" class=\"aurope\" (click)=\"showContent(0)\"\n\t\t\t\t\t[style.color]=\"isShowContent.isShowContentEurope ? '#2F7EBB' : '#fff'\">\n\t\t\t\t\tEUROPE\n\t\t\t\t\t<div class=\"bubblewhite\"></div>\n\t\t\t\t\t<div class=\"bubbleblue\" *ngIf=\"isShowContent.isShowContentEurope\"></div>\n\t\t\t\t</li>\n\n\t\t\t\t<div class=\"inline\"> | </div>\n\n\t\t\t\t<li tabindex=\"0\" class=\"africa\" (click)=\"showContent(1)\"\n\t\t\t\t\t[style.color]=\"isShowContent.isShowContentAfrica ? '#2F7EBB' : '#fff'\">\n\t\t\t\t\tAFRICA & MIDDLE EAST\n\t\t\t\t\t<div class=\"bubblewhite\"></div>\n\t\t\t\t\t<div class=\"bubbleblue\" *ngIf=\"isShowContent.isShowContentAfrica\"></div>\n\t\t\t\t</li>\n\n\t\t\t\t<div class=\"inline\"> | </div>\n\n\t\t\t\t<li tabindex=\"0\" class=\"asia-pacific\" (click)=\"showContent(2)\"\n\t\t\t\t\t[style.color]=\"isShowContent.isShowContentAsia ? '#2F7EBB' : '#fff'\">\n\t\t\t\t\tASIA PACIFIC\n\t\t\t\t\t<div class=\"bubblewhite\"></div>\n\t\t\t\t\t<div class=\"bubbleblue\" *ngIf=\"isShowContent.isShowContentAsia\"></div>\n\n\t\t\t\t</li>\n\n\t\t\t\t<div class=\"inline\"> | </div>\n\n\t\t\t\t<li tabindex=\"0\" class=\"latin-america\" (click)=\"showContent(3)\"\n\t\t\t\t\t[style.color]=\"isShowContent.isShowContentLatin ? '#2F7EBB' : '#fff'\">\n\t\t\t\t\tLATIN AMERICA\n\t\t\t\t\t<div class=\"bubblewhite\"></div>\n\t\t\t\t\t<div class=\"bubbleblue\" *ngIf=\"isShowContent.isShowContentLatin\"></div>\n\t\t\t\t</li>\n\t\t\t</ul>\n\t\t\t<!--End Inspried title -->\n\t\t</div>\n\t\t<!--End Inspried content -->\n\t</div>\n</div>\n<!-- Inspried -->";

/***/ }),
/* 82 */
/***/ (function(module, exports) {

	module.exports = ".inspired .member-inspried{z-index:1000;position:fixed;left:0;bottom:-3px;width:100%}.inspired .member-inspried:hover .inspried-content-wrap{transition-delay:0.5s;max-height:500px}.inspired .member-inspried .inspried-logo img{width:150px;height:34px}.inspired .member-inspried .inspried-content-wrap{transition:1.5s max-height linear;transition-delay:-0.8s;max-height:0px;overflow:hidden;width:100%;padding:0.55rem 0 0.2rem 0.55rem;background-color:#122147;margin-bottom:-1px}.inspired .member-inspried .inspried-content-wrap .inspried-content{font-size:.9em;display:block;background-color:#122147}.inspired .member-inspried .inspried-content-wrap .inspried-content span{color:#2F7EBB}.inspired .member-inspried .inspried-content-wrap .inspried-content a{color:#fff;font-size:14px}.inspired .member-inspried .inspried-content-wrap .inspried-content a:hover{text-decoration:underline}.inspired .member-inspried .inspried-content-wrap .inspried-title{width:100%;cursor:pointer;list-style:none;margin:5px 0 3px 0;padding:0px 0 30px 0;display:block;position:relative;z-index:20;background-color:#122147}.inspired .member-inspried .inspried-content-wrap .inspried-title li{position:relative;font-size:.9em;text-transform:uppercase;font-weight:700;float:left;outline:none}.inspired .member-inspried .inspried-content-wrap .inspried-title li:hover .bubblewhite{background:#fff;bottom:-25}.inspired .member-inspried .inspried-content-wrap .inspried-title li a{color:#fff}.inspired .member-inspried .inspried-content-wrap .inspried-title li .bubblewhite{position:absolute;left:50%;bottom:-40;transform:translate(-50%);padding:11.55px;width:12px;height:12px;background:#fff;border-radius:50%}.inspired .member-inspried .inspried-content-wrap .inspried-title li .bubbleblue{position:absolute;left:50%;bottom:-25;transform:translate(-50%);padding:12px;width:12px;height:12px;background:#2F7EBB;border-radius:50%;z-index:999}.inspired .member-inspried .inspried-content-wrap .inspried-title .inline{float:left;margin:0 10px;font-size:.9rem;float:left;color:#2F7EBB;vertical-align:middle}\n"

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var Subject_1 = __webpack_require__(6);
	var MenuService_1 = __webpack_require__(70);
	var UserService_1 = __webpack_require__(84);
	var SessionService_1 = __webpack_require__(85);
	var router_1 = __webpack_require__(26);
	var HolidayService_1 = __webpack_require__(86);
	var services_1 = __webpack_require__(58);
	var AdminService_1 = __webpack_require__(87);
	var MainMenuComponent = (function () {
	    function MainMenuComponent(menuService, router, holidayService, userService, sessionService, sessionStorageService, adminService) {
	        this.menuService = menuService;
	        this.router = router;
	        this.holidayService = holidayService;
	        this.userService = userService;
	        this.sessionService = sessionService;
	        this.sessionStorageService = sessionStorageService;
	        this.adminService = adminService;
	        this.menuStatusChanged = new Subject_1.Subject();
	        this.userMenuClassVisible = 'menu-list-visible';
	        this.devEnv = ['services.eca.dev.nascorp.vn', 'camp.eca.dev.nascorp.vn', 'asa.eca.dev.nascorp.vn', 'holiday.eca.dev.nascorp.vn', 'bus.eca.dev.nascorp.vn', 'reen.eca.dev.nascorp.vn', 'conference.eca.dev.nascorp.vn'];
	        this.testEnv = ['services.eca.test.nascorp.vn', 'camp.eca.test.nascorp.vn', 'asa.eca.test.nascorp.vn', 'holiday.eca.test.nascorp.vn', 'bus.eca.test.nascorp.vn', 'reen.eca.test.nascorp.vn', 'conference.eca.test.nascorp.vn'];
	        this.stagingEnv = ['auth.eca.uat.nascorp.vn', 'services.eca.uat.nascorp.vn', 'asa.eca.uat.nascorp.vn', 'holidayschool.eca.uat.nascorp.vn', 'bus.eca.uat.nascorp.vn', 'outdooreducation.eca.uat.nascorp.vn', 'reen.eca.uat.nascorp.vn', 'acs.eca.uat.nascorp.vn', 'pcbs.eca.uat.nascorp.vn'];
	        this.procEnv = ['services.aisvietnam.com', 'outdooreducation.aisvietnam.com', 'asa.aisvietnam.com', 'holidayschool.aisvietnam.com', 'bus.aisvietnam.com', 'reen.aisvietnam.com', 'pcbs.aisvietnam.com'];
	    }
	    MainMenuComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.parent = new Object;
	        this.getSessionData();
	        this.hostName = window.location.hostname;
	        // Get main menu List
	        this.menuList = this.getMainMenuList();
	        //  Get sub menu list
	        this.subMenuList = this.getSubMenuList();
	        this.menuStatus = this.getMenuStatus();
	        // Subscription to catch the session changed to change the menu list content
	        this.subscription = this.userService.userDataChanged$.subscribe(function (user) {
	            _this.onSessionChanged(user);
	        });
	    };
	    MainMenuComponent.prototype.checkAccountIsAisParent = function () {
	        return this.sessionStorageService.getData('isAisParent');
	    };
	    MainMenuComponent.prototype.ngOnDestroy = function () {
	        // Destroy the subscription for session changes
	        this.subscription.unsubscribe();
	    };
	    /**
	     * Action that fired when the session change event is catched.
	     * Update the userData & the menuList.
	     */
	    MainMenuComponent.prototype.onSessionChanged = function (user) {
	        //TO DO: update menu content when session changed
	        this.userData = user;
	        // Get Menu List
	        this.menuList = this.getMainMenuList();
	        this.subMenuList = this.getSubMenuList();
	    };
	    MainMenuComponent.prototype.onMenuStatusChanged = function () {
	        this.menuStatus = this.getMenuStatus();
	    };
	    MainMenuComponent.prototype.getMenuStatus = function () {
	        if (document.URL === 'http://services.eca.dev.nascorp.vn/' ||
	            document.URL === 'http://services.local.eca.dev.nascorp.vn/' ||
	            document.URL === 'http://services.eca.test.nascorp.vn/' ||
	            document.URL === 'http://services.eca.uat.nascorp.vn/' ||
	            document.URL === 'https://services.aisvietnam.com/') {
	            return false;
	        }
	        else {
	            return true;
	        }
	    };
	    /**
	     * Return a module 's menu list content for the main menu.
	     * Return login main menu list if no user data is detected.
	     * @returns {Menu[]|[]} - module's menu list or empty list.
	     */
	    MainMenuComponent.prototype.getMainMenuList = function () {
	        var menuList = [];
	        if (!this.userData && (this.hostName === "holidayschool.aisvietnam.com"
	            || this.hostName === "holiday.eca.dev.nascorp.vn"
	            || this.hostName === "holiday.local.eca.dev.nascorp.vn"
	            || this.hostName === "holiday.eca.test.nascorp.vn"
	            || this.hostName === "holidayschool.eca.uat.nascorp.vn")) {
	            menuList = this.menuService.getMenuList('hol-login');
	        }
	        else if (!this.userData) {
	            menuList = this.menuService.getMenuList('login-main');
	        }
	        else {
	            menuList = this.menuService.getMenuList(this.module + '-main');
	        }
	        return menuList;
	    };
	    /**
	     * Return a module 's SUB menu list content for the main menu.
	     * Return login main menu list if no user data is detected.
	     * @returns {Menu[]|[]} - module's menu list or empty list.
	     */
	    MainMenuComponent.prototype.getSubMenuList = function () {
	        return this.menuService.getMenuList(this.module + '-sub');
	    };
	    MainMenuComponent.prototype.toLogOut = function () {
	        this.userData = this.userService.getUserSessionData();
	        this.deleteSession();
	    };
	    /**
	 * Delete user session data.
	 */
	    MainMenuComponent.prototype.deleteSession = function () {
	        var _this = this;
	        this.sessionService.deleteSession()
	            .subscribe(function (complete) {
	            // Clear user session
	            _this.userService.clearUserSessionData();
	            _this.adminService.clearInterSession();
	            // Fire user session data changed event
	            _this.userService.userDataChanged(null);
	            // Redirect to desired URL                    
	            if (_this.devEnv.indexOf(_this.hostName) !== -1) {
	                return window.location.href = 'http://services.eca.dev.nascorp.vn';
	            }
	            else if (_this.testEnv.indexOf(_this.hostName) !== -1) {
	                return window.location.href = 'http://services.eca.test.nascorp.vn';
	            }
	            else if (_this.stagingEnv.indexOf(_this.hostName) !== -1) {
	                return window.location.href = 'http://services.eca.uat.nascorp.vn';
	            }
	            else if (_this.procEnv.indexOf(_this.hostName) !== -1) {
	                return window.location.href = 'https://services.aisvietnam.com';
	            }
	            else {
	                return window.location.href = 'http://services.local.eca.dev.nascorp.vn';
	            }
	        });
	    };
	    MainMenuComponent.prototype.getSessionData = function () {
	        var _this = this;
	        this.sessionService.getSession()
	            .subscribe(function (user) {
	            _this.userData = user;
	            if (_this.userData.role !== 'system' && _this.userData.role !== 'manager') {
	                _this.getParent();
	            }
	        });
	    };
	    MainMenuComponent.prototype.toHomePage = function () {
	        // Redirect to desired URL
	        if (this.userData.role === 'parent' || this.parent.type === 'ais') {
	            if (this.devEnv.indexOf(this.hostName) !== -1) {
	                return window.location.href = 'http://services.eca.dev.nascorp.vn/parents';
	            }
	            else if (this.testEnv.indexOf(this.hostName) !== -1) {
	                return window.location.href = 'http://services.eca.test.nascorp.vn/parents';
	            }
	            else if (this.stagingEnv.indexOf(this.hostName) !== -1) {
	                return window.location.href = 'http://services.eca.uat.nascorp.vn/parents';
	            }
	            else if (this.procEnv.indexOf(this.hostName) !== -1) {
	                return window.location.href = 'https://services.aisvietnam.com/parents';
	            }
	            else {
	                return window.location.href = 'http://services.local.eca.dev.nascorp.vn/parents';
	            }
	        }
	        // Redirect to desired URL
	        if (this.userData.role === 'hol-parent' || this.parent.type === 'other') {
	            if (this.devEnv.indexOf(this.hostName) !== -1) {
	                return window.location.href = 'http://services.eca.dev.nascorp.vn/other-parents';
	            }
	            else if (this.testEnv.indexOf(this.hostName) !== -1) {
	                return window.location.href = 'http://services.eca.test.nascorp.vn/other-parents';
	            }
	            else if (this.stagingEnv.indexOf(this.hostName) !== -1) {
	                return window.location.href = 'http://services.eca.uat.nascorp.vn/other-parents';
	            }
	            else if (this.procEnv.indexOf(this.hostName) !== -1) {
	                return window.location.href = 'https://services.aisvietnam.com/other-parents';
	            }
	            else {
	                return window.location.href = 'http://services.local.eca.dev.nascorp.vn/other-parents';
	            }
	        }
	        if (!this.userData && !this.parent) {
	            if (this.devEnv.indexOf(this.hostName) !== -1) {
	                return window.location.href = 'http://services.eca.dev.nascorp.vn';
	            }
	            else if (this.testEnv.indexOf(this.hostName) !== -1) {
	                return window.location.href = 'http://services.eca.test.nascorp.vn';
	            }
	            else if (this.stagingEnv.indexOf(this.hostName) !== -1) {
	                return window.location.href = 'http://services.eca.uat.nascorp.vn';
	            }
	            else if (this.procEnv.indexOf(this.hostName) !== -1) {
	                return window.location.href = 'https://services.aisvietnam.com';
	            }
	            else {
	                return window.location.href = 'http://services.local.eca.dev.nascorp.vn';
	            }
	        }
	    };
	    MainMenuComponent.prototype.toRegister = function () {
	        if (this.hostName === "holidayschool.aisvietnam.com"
	            || this.hostName === "holiday.eca.dev.nascorp.vn"
	            || this.hostName === "holiday.local.eca.dev.nascorp.vn") {
	            this.router.navigateByUrl('/hol-register');
	        }
	        else {
	            this.router.navigate(['/register']);
	        }
	    };
	    MainMenuComponent.prototype.toChangePassword = function () {
	        if (this.hostName === "holidayschool.aisvietnam.com"
	            || this.hostName === "holiday.eca.dev.nascorp.vn"
	            || this.hostName === "holiday.local.eca.dev.nascorp.vn") {
	            this.router.navigateByUrl('/hol-change-password');
	        }
	        else {
	            this.router.navigate(['/change-password']);
	        }
	    };
	    MainMenuComponent.prototype.menuStatusDataChanged = function (menu) {
	        this.menuStatusChanged.next(menu);
	    };
	    MainMenuComponent.prototype.getParent = function () {
	        var _this = this;
	        this.holidayService.getParent()
	            .subscribe(function (parent) {
	            _this.parent = parent;
	            if (_this.parent.status === "fill-info") {
	                _this.router.navigate(['/profile/add-parent']);
	            }
	            else if (_this.parent.status == "full") {
	                _this.router.navigate(['/booking/students']);
	            }
	            else {
	                _this.router.navigate(['/add-student']);
	            }
	        }, function (error) {
	            //TO DO: Handle any error if needed in the furture
	            _this.message = "";
	            _this.messageType = "alert";
	        });
	    };
	    MainMenuComponent.prototype.toProfile = function () {
	        if (this.hostName === "holidayschool.aisvietnam.com"
	            || this.hostName === "holiday.eca.dev.nascorp.vn"
	            || this.hostName === "holiday.local.eca.dev.nascorp.vn") {
	            this.router.navigateByUrl('/profile/edit-parent');
	        }
	        else {
	            this.router.navigate(['/profile/edit-parent']);
	        }
	    };
	    return MainMenuComponent;
	}());
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], MainMenuComponent.prototype, "module", void 0);
	MainMenuComponent = __decorate([
	    core_1.Component({
	        selector: 'main-menu',
	        template: __webpack_require__(88),
	        styles: [__webpack_require__(90)],
	    }),
	    __metadata("design:paramtypes", [MenuService_1.MenuService,
	        router_1.Router,
	        HolidayService_1.HolidayService,
	        UserService_1.UserService,
	        SessionService_1.SessionService,
	        services_1.SessionStorageService,
	        AdminService_1.AdminService])
	], MainMenuComponent);
	exports.MainMenuComponent = MainMenuComponent;


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var Subject_1 = __webpack_require__(6);
	var services_1 = __webpack_require__(58);
	var UserService = (function () {
	    function UserService(sessionStorageService) {
	        this.sessionStorageService = sessionStorageService;
	        // Observable User source
	        this.userDataChangedSource = new Subject_1.Subject();
	        // Observable User streams
	        this.userDataChanged$ = this.userDataChangedSource.asObservable();
	    }
	    UserService.prototype.getUserSessionData = function () {
	        return this.sessionStorageService.getData('eca-user');
	    };
	    UserService.prototype.setUserSessionData = function (user) {
	        return this.sessionStorageService.setData('eca-user', user);
	    };
	    UserService.prototype.clearUserSessionData = function () {
	        return this.sessionStorageService.removeData('eca-user');
	    };
	    UserService.prototype.userDataChanged = function (user) {
	        this.userDataChangedSource.next(user);
	    };
	    return UserService;
	}());
	UserService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [services_1.SessionStorageService])
	], UserService);
	exports.UserService = UserService;


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var services_1 = __webpack_require__(58);
	var SessionService = (function () {
	    function SessionService(settingService, apiService) {
	        this.settingService = settingService;
	        this.apiService = apiService;
	        this.sessionUrl = '/session';
	        this.cafeteriaUrl = '/caterer-service/';
	        this.apiUrl = '';
	        this.apiUrl = this.settingService.getSetting('api_service_domain');
	    }
	    /**
	     * Get Session from API
	     * @params: none
	     * @return: status 200 - User observable object if session is provied succesfully.
	     *          status 401 - Unauthorized if user credentials are invalid.
	     * */
	    SessionService.prototype.getSession = function () {
	        var requestUrl = this.apiUrl + this.sessionUrl;
	        // Call Get Method from Api Service
	        return this.apiService.get(requestUrl);
	    };
	    /**
	     * Get Session from API
	     * @params: User Observable Object
	     * @return: status 200 - User observable object if session is created.
	     *          status 401 - Unauthorized if no session is found.
	     * */
	    SessionService.prototype.postSession = function (credential) {
	        var requestUrl = this.apiUrl + this.sessionUrl;
	        var body = JSON.stringify({
	            'role': credential.role,
	            'email': credential.email,
	            'password': credential.password
	        });
	        // Call Get Method from Api Service
	        return this.apiService.post(requestUrl, body);
	    };
	    SessionService.prototype.deleteSession = function () {
	        var requestUrl = this.apiUrl + this.sessionUrl;
	        return this.apiService.delete(requestUrl);
	    };
	    SessionService.prototype.getCafeteriaUrl = function () {
	        var requestUrl = this.apiUrl + this.cafeteriaUrl + 'daisyLink';
	        // Call Get Method from Api Service
	        return this.apiService.get(requestUrl);
	    };
	    SessionService.prototype.getSessionDaisy = function () {
	        var requestUrl = this.apiUrl + this.cafeteriaUrl + 'getTokenByCookie';
	        // Call Get Method from Api Service
	        return this.apiService.get(requestUrl);
	    };
	    return SessionService;
	}());
	SessionService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [services_1.SettingService,
	        services_1.ApiService])
	], SessionService);
	exports.SessionService = SessionService;


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	// Services
	var services_1 = __webpack_require__(58);
	var HolidayService = (function () {
	    function HolidayService(apiService, settingService) {
	        this.apiService = apiService;
	        this.settingService = settingService;
	        // Api Domain Url
	        this.apiUrl = '';
	        this.courseUrl = '/hol/course';
	        this.courseClassUrl = '/hol/class/';
	        this.courseStudentUrl = '/hol/student/';
	        this.parentUrl = '/hol/parent';
	        this.convertParentUrl = '/hol/parent/convert';
	        this.parentPassword = '/hol/parent/password';
	        this.weekUrl = '/hol/week';
	        this.excursionUrl = '/hol/excursion';
	        this.questionnarie = "/hol/questionnaire";
	        this.parentEmail = '/hol/parent/email';
	        // Get API service domain for communate.
	        this.apiUrl = this.settingService.getSetting('api_service_domain');
	    }
	    HolidayService.prototype.createCourse = function (courseItem) {
	        var requestUrl = this.apiUrl + this.courseUrl;
	        // Post content
	        var body = JSON.stringify(courseItem);
	        return this.apiService.post(requestUrl, body);
	    };
	    HolidayService.prototype.createCourseClass = function (courseClassItem) {
	        var requestUrl = this.apiUrl + this.courseClassUrl;
	        // Post content
	        var body = JSON.stringify(courseClassItem);
	        return this.apiService.post(requestUrl, body);
	    };
	    HolidayService.prototype.getCourseList = function (filter) {
	        var requestUrl = this.apiUrl + this.courseUrl;
	        var hasFilter = false;
	        // Setup filter conditions
	        for (var condition in filter) {
	            if (filter[condition]) {
	                if (hasFilter) {
	                    requestUrl += '&';
	                }
	                else {
	                    requestUrl += '?';
	                    hasFilter = true;
	                }
	                requestUrl += condition + '=' + filter[condition];
	            }
	        }
	        return this.apiService.get(requestUrl);
	    };
	    HolidayService.prototype.getCourseDetail = function (courseId) {
	        var requestUrl = this.apiUrl + this.courseUrl + '?id=' + courseId;
	        return this.apiService.get(requestUrl);
	    };
	    HolidayService.prototype.getFullCourseList = function () {
	        var requestUrl = this.apiUrl + this.courseUrl;
	        return this.apiService.get(requestUrl);
	    };
	    HolidayService.prototype.editCourse = function (courseItem) {
	        var requestUrl = this.apiUrl + this.courseUrl;
	        var body = JSON.stringify({
	            id: courseItem.id,
	            name: courseItem.name,
	            type: courseItem.type,
	            school_year: courseItem.school_year,
	            start_date: courseItem.start_date,
	            end_date: courseItem.end_date,
	            description: courseItem.description,
	            status: courseItem.status
	        });
	        return this.apiService.patch(requestUrl, body);
	    };
	    HolidayService.prototype.updateParent = function (nonAisParent) {
	        var requestUrl = this.apiUrl + this.parentUrl;
	        var body = JSON.stringify(nonAisParent);
	        return this.apiService.patch(requestUrl, body);
	    };
	    HolidayService.prototype.getParent = function (filter) {
	        if (filter === void 0) { filter = []; }
	        var requestUrl = this.apiUrl + this.parentUrl;
	        var hasFilter = false;
	        // Setup filter conditions
	        for (var condition in filter) {
	            if (filter[condition]) {
	                if (hasFilter) {
	                    requestUrl += '&';
	                }
	                else {
	                    requestUrl += '?';
	                    hasFilter = true;
	                }
	                requestUrl += condition + '=' + filter[condition];
	            }
	        }
	        return this.apiService.get(requestUrl);
	    };
	    HolidayService.prototype.changeParentPassword = function (query) {
	        var requestUrl = this.apiUrl + this.parentPassword;
	        var body = JSON.stringify(query);
	        return this.apiService.patch(requestUrl, body);
	    };
	    HolidayService.prototype.changeParentEmail = function (query) {
	        var requestUrl = this.apiUrl + this.parentEmail;
	        var body = JSON.stringify(query);
	        return this.apiService.put(requestUrl, body);
	    };
	    HolidayService.prototype.convertParent = function () {
	        var requestUrl = this.apiUrl + this.convertParentUrl;
	        var body = JSON.stringify({});
	        return this.apiService.post(requestUrl, body);
	    };
	    HolidayService.prototype.getCourseClassList = function (filter) {
	        var requestUrl = this.apiUrl + this.courseClassUrl;
	        var hasFilter = false;
	        // Setup filter conditions
	        for (var condition in filter) {
	            if (filter[condition]) {
	                if (hasFilter) {
	                    requestUrl += '&';
	                }
	                else {
	                    requestUrl += '?';
	                    hasFilter = true;
	                }
	                requestUrl += condition + '=' + filter[condition];
	            }
	        }
	        return this.apiService.get(requestUrl);
	    };
	    HolidayService.prototype.getClassDetail = function (classId) {
	        var requestUrl = this.apiUrl + this.courseClassUrl + '?id=' + classId + '&page=1';
	        return this.apiService.get(requestUrl);
	    };
	    HolidayService.prototype.getFullCourseClassList = function () {
	        var requestUrl = this.apiUrl + this.courseClassUrl;
	        return this.apiService.get(requestUrl);
	    };
	    HolidayService.prototype.editClass = function (classItem) {
	        var requestUrl = this.apiUrl + this.courseClassUrl;
	        var body = JSON.stringify({
	            id: classItem.id,
	            thumbnail_id: classItem.thumbnail_id,
	            name: classItem.name,
	            room: classItem.room,
	            campus_id: classItem.campus_id,
	            teacher: classItem.teacher,
	            max_number: classItem.max_number,
	            suitable_from: classItem.suitable_from,
	            suitable_to: classItem.suitable_to,
	            total_cost: +classItem.total_cost,
	            cost_per_week: classItem.cost_per_week,
	            activities: classItem.activities,
	            status: classItem.status,
	            prices: classItem.prices
	        });
	        return this.apiService.patch(requestUrl, body);
	    };
	    // ───  ───────────────────────────────────────────────────────────────────────────
	    // Get week
	    HolidayService.prototype.getWeekService = function () {
	        var requestUrl = this.apiUrl + this.weekUrl;
	        return this.apiService.get(requestUrl);
	    };
	    // ───  ───────────────────────────────────────────────────────────────────────────
	    // Add week
	    HolidayService.prototype.addWeekService = function (weeks) {
	        var requestUrl = this.apiUrl + this.weekUrl;
	        var body = JSON.stringify(weeks);
	        return this.apiService.post(requestUrl, body);
	    };
	    //Edit week
	    HolidayService.prototype.editWeekService = function (weeks) {
	        var requestUrl = this.apiUrl + this.weekUrl;
	        var body = JSON.stringify(weeks);
	        return this.apiService.patch(requestUrl, body);
	    };
	    // ───  ───────────────────────────────────────────────────────────────────────────
	    // Get excursion
	    HolidayService.prototype.getExcursionService = function (filter) {
	        var requestUrl = this.apiUrl + this.excursionUrl;
	        var hasFilter = false;
	        // Setup filter conditions
	        for (var condition in filter) {
	            if (filter[condition]) {
	                if (hasFilter) {
	                    requestUrl += '&';
	                }
	                else {
	                    requestUrl += '?';
	                    hasFilter = true;
	                }
	                requestUrl += condition + '=' + filter[condition];
	            }
	        }
	        return this.apiService.get(requestUrl);
	    };
	    // ───  ───────────────────────────────────────────────────────────────────────────
	    // Add excursion
	    HolidayService.prototype.addExcursionService = function (excursion) {
	        var requestUrl = this.apiUrl + this.excursionUrl;
	        var body = JSON.stringify(excursion);
	        return this.apiService.post(requestUrl, body);
	    };
	    //Edit week
	    HolidayService.prototype.editExcursionService = function (excursion) {
	        var requestUrl = this.apiUrl + this.excursionUrl;
	        var body = JSON.stringify(excursion);
	        return this.apiService.patch(requestUrl, body);
	    };
	    // ───  ───────────────────────────────────────────────────────────────────────────
	    // Remove student in class
	    HolidayService.prototype.removeStudentInClass = function (studentId, classId) {
	        var requestUrl = this.apiUrl + this.courseStudentUrl + studentId + '/class/' + classId;
	        var body = {
	            "holStudentId": studentId,
	            "holClassId": classId
	        };
	        return this.apiService.deletePost(requestUrl, body);
	    };
	    // ───  ───────────────────────────────────────────────────────────────────────────
	    // Transfer waiting student in class
	    HolidayService.prototype.transferStudentInClass = function (studentId, classId, status) {
	        var requestUrl = this.apiUrl + this.courseClassUrl + classId + '/student/' + studentId;
	        var body = {
	            "holStudentId": studentId,
	            "holClassId": classId,
	            "status": status
	        };
	        return this.apiService.patch(requestUrl, body);
	    };
	    HolidayService.prototype.getParentById = function (id) {
	        var requestUrl = this.apiUrl + this.parentUrl + '/' + id;
	        return this.apiService.get(requestUrl);
	    };
	    HolidayService.prototype.getQuestionnarie = function () {
	        var requestUrl = this.apiUrl + this.questionnarie;
	        return this.apiService.get(requestUrl);
	    };
	    ;
	    HolidayService.prototype.getQuestionnarieById = function (id) {
	        var requestUrl = this.apiUrl + this.questionnarie + '/' + id;
	        return this.apiService.get(requestUrl);
	    };
	    HolidayService.prototype.upsertQuestionnarie = function (question) {
	        var body = JSON.stringify(question);
	        var requestUrl = this.apiUrl + this.questionnarie;
	        return this.apiService.put(requestUrl, body);
	    };
	    ;
	    return HolidayService;
	}());
	HolidayService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [services_1.ApiService,
	        services_1.SettingService])
	], HolidayService);
	exports.HolidayService = HolidayService;


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var Subject_1 = __webpack_require__(6);
	var services_1 = __webpack_require__(58);
	var AdminService = (function () {
	    function AdminService(sessionStorageService) {
	        this.sessionStorageService = sessionStorageService;
	        this.adminDataChangedSource = new Subject_1.Subject();
	        this.logger = new Subject_1.Subject();
	        // Observable Admin streams
	        this.adminDataChanged$ = this.adminDataChangedSource.asObservable();
	    }
	    AdminService.prototype.getAdminSessionData = function () {
	        return this.sessionStorageService.getData('asa-admin');
	    };
	    AdminService.prototype.getInterSesstion = function () {
	        return this.sessionStorageService.getData('curId');
	    };
	    AdminService.prototype.setAdminSessionData = function (admin) {
	        return this.sessionStorageService.setData('asa-admin', admin);
	    };
	    AdminService.prototype.clearAdminSessionData = function () {
	        return this.sessionStorageService.removeData('asa-admin');
	    };
	    AdminService.prototype.clearInterSession = function () {
	        return this.sessionStorageService.removeData('curId');
	    };
	    AdminService.prototype.adminDataChanged = function (admin) {
	        return this.adminDataChangedSource.next(admin);
	    };
	    return AdminService;
	}());
	AdminService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [services_1.SessionStorageService])
	], AdminService);
	exports.AdminService = AdminService;


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div id=\"app-main-menu\">\n\t<!-- Hamburger Menu -->\n\t<div class=\"hamburger-menu\">\n\t\t<a href=\"#\">\n\t\t\t<i class=\"material-icons\">menu</i>\n\t\t</a>\n\t</div>\n\t<div class=\"container\">\n\t\t<div class=\"top-bar\">\n\t\t\t<!--Top bar left-->\n\t\t\t<div class=\"top-bar-left\">\n\t\t\t\t<!-- Logo -->\n\t\t\t\t<div class=\"logo\">\n\t\t\t\t\t<a (click)=\"toHomePage()\"><img src=\"" + __webpack_require__(89) + "\"></a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!--End of Top bar left-->\n\n\t\t\t<!--Top bar right-->\n\t\t\t<div class=\"top-bar-right\">\n\t\t\t\t<!-- Menu Items -->\n\t\t\t\t<div class=\"main-right-menu\">\n\t\t\t\t\t<ul class=\"menu\" *ngIf=\"menuStatus\">\n\t\t\t\t\t\t<!--Main Menu list-->\n\t\t\t\t\t\t<li *ngFor=\"let menu of menuList;\">\n\t\t\t\t\t\t\t<div *ngIf=\"!userData\">\n\t\t\t\t\t\t\t\t<!-- Show if menu is a route -->\n\t\t\t\t\t\t\t\t<a *ngIf=\"menu.type==='route'\" routerLink=\"{{menu.url}}\" routerLinkActive=\"active\">\n\t\t\t\t\t\t\t\t\t{{menu.label}}\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t<!-- Show if menu is a static menu -->\n\t\t\t\t\t\t\t\t<a *ngIf=\"menu.type==='link'\" href=\"{{menu.url}}\" target=\"{{menu.target}}\">\n\t\t\t\t\t\t\t\t\t{{menu.label}}\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t\t<!-- Show user menu item if have user data from session -->\n\t\t\t\t\t\t<li *ngIf=\"userData\" class=\"user-profile-menu\" [menuHover]=\"userMenuClassVisible\">\n\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t<a>\n\t\t\t\t\t\t\t\t\t<span>Hi, {{userData.name.split('@')[0]}}</span>\n\t\t\t\t\t\t\t\t\t<i class=\"material-icons\">keyboard_arrow_down</i>\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<ul class=\"\">\n\t\t\t\t\t\t\t\t<li>\n\t\t\t\t\t\t\t\t\t<a (click)=\"toChangePassword()\">Change Password</a>\n\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t<li *ngIf=\"!checkAccountIsAisParent()\">\n\t\t\t\t\t\t\t\t\t<a (click)=\"toProfile()\">Profile</a>\n\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t<li>\n\t\t\t\t\t\t\t\t\t<a (click)=\"toLogOut()\">Logout</a>\n\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t</ul>\n\t\t\t\t</div>\n\t\t\t\t<!--New sub menu for module-->\n\t\t\t\t<ul class=\"sub-menu\" *ngIf=\"userData\" >\n\t\t\t\t\t<!--Main Menu list-->\n\t\t\t\t\t<li *ngFor=\"let menu of subMenuList\">\n\t\t\t\t\t\t<!-- Show if menu is a route -->\n\t\t\t\t\t\t<a *ngIf=\"menu.type === 'route'\" routerLink=\"{{menu.url}}\" routerLinkActive=\"active\">\n\t\t\t\t\t\t\t{{menu.label}}\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<!-- Show if menu is a static menu -->\n\t\t\t\t\t\t<a *ngIf=\"menu.type === 'link'\" href=\"{{menu.url}}\" target=\"{{menu.target}}\">\n\t\t\t\t\t\t\t{{menu.label}}\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</li>\n\t\t\t\t</ul>\n\t\t\t\t<!--End of sub menu-->\n\t\t\t</div>\n\t\t\t<!--End of top bar right-->\n\t\t</div>\n\t\t<!--End of top bar-->\n\t</div>\n</div>";

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/logo.d5018a0115cf3749750fa4da0ec46459.png";

/***/ }),
/* 90 */
/***/ (function(module, exports) {

	module.exports = "#app-main-menu{background-color:#043d7a;position:relative;padding:0rem 5%}#app-main-menu .hamburger-menu{display:none}#app-main-menu .top-bar{background:transparent}#app-main-menu .top-bar .top-bar-left{flex:0.5 0.5 0px}#app-main-menu .top-bar .top-bar-right{padding-top:1rem}#app-main-menu .logo>a{display:inline-block}#app-main-menu .logo>a img{height:100px}#app-main-menu .sub-menu{float:right;background:transparent;font-size:0.9rem}#app-main-menu .sub-menu li{list-style:none;display:inline-block;text-transform:uppercase}#app-main-menu .sub-menu li a{display:block;color:#fff;padding:0.5rem;margin:0 0.3rem}#app-main-menu .sub-menu li a.active{border-bottom:solid 2px #ffae00}#app-main-menu .main-right-menu{float:right}#app-main-menu .main-right-menu .menu{background-color:#043d7a}#app-main-menu .main-right-menu .menu>li>div>a{padding:0.5rem 1rem;border-radius:0.2rem;margin-left:1rem;min-width:6.25rem;border:1px solid #7b95b0;color:#fff;text-align:center}#app-main-menu .main-right-menu .menu>li>div>a:hover,#app-main-menu .main-right-menu .menu>li>div>a.active{background-color:#faa635;border:1px solid #faa635;color:#043d7a}#app-main-menu .main-right-menu .menu>li>div>a>i{margin:0}#app-main-menu .main-right-menu .menu>li.user-profile-menu{position:relative}#app-main-menu .main-right-menu .menu>li.user-profile-menu div>a{margin-bottom:0.5rem;line-height:23px;display:inline-block;padding-top:0}#app-main-menu .main-right-menu .menu>li.user-profile-menu div>a span{display:inline-block}#app-main-menu .main-right-menu .menu>li.user-profile-menu div>a i{display:inline-block;position:relative;top:6px}#app-main-menu .main-right-menu .menu>li.user-profile-menu>ul{list-style:none;border-radius:0.2rem;position:absolute;z-index:2;right:0;width:130%;display:none}#app-main-menu .main-right-menu .menu>li.user-profile-menu.menu-list-visible>ul{display:block;box-shadow:0 8px 10px 1px rgba(0,0,0,0.14),0 3px 14px 2px rgba(0,0,0,0.12),0 5px 5px -3px rgba(0,0,0,0.2)}#app-main-menu .main-right-menu .menu>li.user-profile-menu.menu-list-visible>ul>li>a{display:block;padding:0.4rem 1rem;border-radius:0.2rem}#app-main-menu .main-right-menu .menu>li.user-profile-menu.menu-list-visible>ul>li>a:hover{background-color:#faa635;color:#043d7a}@media only screen and (max-width: 40em){#app-main-menu{height:auto;min-height:4rem}#app-main-menu .hamburger-menu{position:absolute;display:none;left:0;top:50%;transform:translateY(-50%);-ms-transform:translateY(-50%);-webkit-transform:translateY(-50%)}#app-main-menu .hamburger-menu>a{color:#fff;font-size:2rem}#app-main-menu .hamburger-menu>a>i{padding:1rem}#app-main-menu .logo{padding:0.4rem;margin:0 auto}#app-main-menu .logo>a{margin:0 auto;min-height:3rem}#app-main-menu .main-right-menu{display:none}#app-main-menu .top-bar-left{flex:none !important}}\n"

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var MenuService_1 = __webpack_require__(70);
	var TopMenuComponent = (function () {
	    function TopMenuComponent(menuService) {
	        this.menuService = menuService;
	    }
	    TopMenuComponent.prototype.ngOnInit = function () {
	        /** TO DO
	         * Get current language from cookie/session
	         * If no language data from it, set default language as English
	         */
	        this.currentLang = 'en';
	        // Get Top Menu List
	        this.menuList = this.menuService.getMenuList('top');
	        // Get Social Connect Menu List
	        this.socialMenuList = this.menuService.getMenuList('social-top');
	    };
	    return TopMenuComponent;
	}());
	TopMenuComponent = __decorate([
	    core_1.Component({
	        selector: 'top-menu',
	        template: __webpack_require__(92),
	        styles: [__webpack_require__(93)],
	        providers: [
	            MenuService_1.MenuService
	        ]
	    }),
	    __metadata("design:paramtypes", [MenuService_1.MenuService])
	], TopMenuComponent);
	exports.TopMenuComponent = TopMenuComponent;


/***/ }),
/* 92 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"app-top-menu\" class=\"top-bar\">\n    <!-- Left Menu List -->\n\t<div class=\"top-bar-left\" *ngIf=\"currentLang=='en'\">\n\t\t<ul class=\"menu\">\n\t\t\t<li *ngFor=\"let menu of menuList\">\n\t\t\t\t<a href=\"{{menu.url}}\" target=\"{{menu.target}}\">{{menu.label}}</a>\n\t\t\t</li>\n\t\t</ul>\n\t</div>\n\t<!-- Right Menu List -->\n\t<div class=\"top-bar-right\">\n\t\t<ul class=\"menu\">\n\t\t\t<li *ngFor=\"let sMenu of socialMenuList\">\n\t\t\t\t<a href=\"{{sMenu.url}}\" target=\"{{sMenu.target}}\">\n\t\t\t\t<i class=\"fa fa-{{sMenu.id}}\"></i></a>\n\t\t\t</li>\n\t\t</ul>\n\t</div>\n</div>";

/***/ }),
/* 93 */
/***/ (function(module, exports) {

	module.exports = "#app-top-menu{background-color:#064180;padding:0rem 4rem}#app-top-menu .menu{background-color:#064180}#app-top-menu .menu>li>a{padding:0.5rem;color:#fff}#app-top-menu .menu>li>a:hover{color:#faa635}#app-top-menu .top-bar-left .menu>li>a{padding:0.6rem 0.3rem;font-size:0.8rem}#app-top-menu .top-bar-right{flex:0 0 0px !important}@media only screen and (max-width: 40em){#app-top-menu{padding:0;overflow-x:hidden}#app-top-menu .menu{height:0}}\n"

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var MenuHoverDirective = (function () {
	    function MenuHoverDirective(el, renderer) {
	        this.el = el;
	        this.renderer = renderer;
	    }
	    MenuHoverDirective.prototype.onMouseEnter = function () {
	        this.setClass(this.className, true);
	    };
	    MenuHoverDirective.prototype.onMouseLeave = function () {
	        this.setClass(this.className, false);
	    };
	    MenuHoverDirective.prototype.setClass = function (className, isAdd) {
	        this.renderer.setElementClass(this.el.nativeElement, className, isAdd);
	    };
	    return MenuHoverDirective;
	}());
	__decorate([
	    core_1.Input('menuHover'),
	    __metadata("design:type", String)
	], MenuHoverDirective.prototype, "className", void 0);
	__decorate([
	    core_1.HostListener('mouseenter'),
	    __metadata("design:type", Function),
	    __metadata("design:paramtypes", []),
	    __metadata("design:returntype", void 0)
	], MenuHoverDirective.prototype, "onMouseEnter", null);
	__decorate([
	    core_1.HostListener('mouseleave'),
	    __metadata("design:type", Function),
	    __metadata("design:paramtypes", []),
	    __metadata("design:returntype", void 0)
	], MenuHoverDirective.prototype, "onMouseLeave", null);
	MenuHoverDirective = __decorate([
	    core_1.Directive({
	        selector: '[menuHover]'
	    }),
	    __metadata("design:paramtypes", [core_1.ElementRef, core_1.Renderer])
	], MenuHoverDirective);
	exports.MenuHoverDirective = MenuHoverDirective;


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var AdminService_1 = __webpack_require__(87);
	var SessionService_1 = __webpack_require__(96);
	var AdminHeaderComponent = (function () {
	    function AdminHeaderComponent(adminService, sessionService, router) {
	        this.adminService = adminService;
	        this.sessionService = sessionService;
	        this.router = router;
	        // For logout navigate
	        this.devEnv = ['auth.eca.dev.nascorp.vn', 'camp.eca.dev.nascorp.vn', 'asa.eca.dev.nascorp.vn', 'holiday.eca.dev.nascorp.vn', 'bus.eca.dev.nascorp.vn', 'reen.eca.dev.nascorp.vn', 'conference.eca.dev.nascorp.vn'];
	        this.testEnv = ['auth.eca.test.nascorp.vn', 'camp.eca.test.nascorp.vn', 'asa.eca.test.nascorp.vn', 'holiday.eca.test.nascorp.vn', 'bus.eca.test.nascorp.vn', 'reen.eca.test.nascorp.vn', 'conference.eca.test.nascorp.vn'];
	        this.stagingEnv = ['auth.eca.uat.nascorp.vn', 'services.eca.uat.nascorp.vn', 'asa.eca.uat.nascorp.vn', 'holidayschool.eca.uat.nascorp.vn', 'bus.eca.uat.nascorp.vn', 'outdooreducation.eca.uat.nascorp.vn', 'reen.eca.uat.nascorp.vn', 'acs.eca.uat.nascorp.vn', 'pcbs.eca.uat.nascorp.vn'];
	        this.procEnv = ['auth.aisvietnam.com', 'outdooreducation.aisvietnam.com', 'asa.aisvietnam.com', 'holidayschool.aisvietnam.com', 'bus.aisvietnam.com', 'reen.aisvietnam.com', 'pcbs.aisvietnam.com'];
	    }
	    AdminHeaderComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.getSession();
	        this.hostName = window.location.hostname;
	        this.headerName = this.getHeaderName(this.module);
	        this.subscription = this.adminService.adminDataChanged$.subscribe(function (admin) {
	            _this.onSessionChanged(admin);
	        });
	        // Get Admin session
	        this.adminData = this.adminService.getAdminSessionData();
	    };
	    AdminHeaderComponent.prototype.ngOnDestroy = function () {
	        // Destroy the subscription for session changes
	        this.subscription.unsubscribe();
	    };
	    AdminHeaderComponent.prototype.onSessionChanged = function (admin) {
	        //TO DO: update menu content when session changed
	        this.adminData = admin;
	        this.sidebarStatus = this.getSidebarStatus();
	    };
	    AdminHeaderComponent.prototype.getSession = function () {
	        var _this = this;
	        this.sessionService.getSession()
	            .subscribe(function (admin) {
	            _this.adminData = admin;
	            _this.sidebarStatus = _this.getSidebarStatus();
	        }, function (error) {
	        });
	    };
	    AdminHeaderComponent.prototype.toHomePage = function () {
	        // Redirect to desired URL                    
	        if (this.devEnv.indexOf(this.hostName) !== -1) {
	            return window.location.href = 'http://services.eca.dev.nascorp.vn';
	        }
	        else if (this.testEnv.indexOf(this.hostName) !== -1) {
	            return window.location.href = 'http://services.eca.test.nascorp.vn';
	        }
	        else if (this.stagingEnv.indexOf(this.hostName) !== -1) {
	            return window.location.href = 'http://services.eca.uat.nascorp.vn';
	        }
	        else if (this.procEnv.indexOf(this.hostName) !== -1) {
	            return window.location.href = 'https://services.aisvietnam.com';
	        }
	        else {
	            return window.location.href = 'http://services.local.eca.dev.nascorp.vn';
	        }
	    };
	    // Detect sidebar vibibility
	    AdminHeaderComponent.prototype.getSidebarStatus = function () {
	        return !this.adminData ? false : true;
	    };
	    AdminHeaderComponent.prototype.getHeaderName = function (moduleName) {
	        var headerName = "";
	        switch (this.module) {
	            case "camp":
	                headerName = "Camp Programmes Management";
	                break;
	            case "asa":
	                headerName = "Extra-Curricular Activities (ECAs) Management";
	                break;
	            case "bus":
	                headerName = "Bus Management";
	                break;
	            case "reen":
	                headerName = "Re-enrolment";
	                break;
	            case "conference":
	                headerName = "Conference Booking System";
	                break;
	            default:
	                break;
	        }
	        return headerName;
	    };
	    // Log our function
	    AdminHeaderComponent.prototype.deleteSession = function () {
	        var _this = this;
	        // In case system login and booking for parent. Then, logout and login again with role parent to booking. We need to remove sessionStorage 
	        if (this.module === 'conference') {
	            window.sessionStorage.removeItem('info-parent-booking');
	            window.sessionStorage.removeItem('interview-description');
	        }
	        this.sessionService.deleteAdminSession()
	            .subscribe(function (complete) {
	            // Clear user session
	            _this.adminService.clearAdminSessionData();
	            _this.adminService.clearInterSession();
	            // Fire user session data changed event
	            _this.adminService.adminDataChanged(null);
	            // Redirect to desired URL
	            if (_this.devEnv.indexOf(_this.hostName) !== -1) {
	                return window.location.href = 'http://auth.eca.dev.nascorp.vn/logout';
	            }
	            else if (_this.testEnv.indexOf(_this.hostName) !== -1) {
	                return window.location.href = 'http://auth.eca.test.nascorp.vn/logout';
	            }
	            else if (_this.stagingEnv.indexOf(_this.hostName) !== -1) {
	                return window.location.href = 'http://auth.eca.uat.nascorp.vn/logout';
	            }
	            else if (_this.procEnv.indexOf(_this.hostName) !== -1) {
	                return window.location.href = 'https://auth.aisvietnam.com/logout';
	            }
	            else {
	                return window.location.href = 'http://auth.local.eca.dev.nascorp.vn/logout';
	            }
	        }, function (error) { return _this.errorMessage = error; });
	    };
	    return AdminHeaderComponent;
	}());
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], AdminHeaderComponent.prototype, "module", void 0);
	AdminHeaderComponent = __decorate([
	    core_1.Component({
	        selector: 'admin-header',
	        template: __webpack_require__(97),
	        styles: [__webpack_require__(98)]
	    }),
	    __metadata("design:paramtypes", [AdminService_1.AdminService,
	        SessionService_1.SessionService,
	        router_1.Router])
	], AdminHeaderComponent);
	exports.AdminHeaderComponent = AdminHeaderComponent;


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var services_1 = __webpack_require__(58);
	var SessionService = (function () {
	    function SessionService(settingService, apiService) {
	        this.settingService = settingService;
	        this.apiService = apiService;
	        this.sessionUrl = '/session';
	        this.apiUrl = '';
	        this.apiUrl = this.settingService.getSetting('api_service_domain');
	    }
	    SessionService.prototype.getSession = function () {
	        var requestUrl = this.apiUrl + this.sessionUrl;
	        // Call Get Method from Api Service
	        return this.apiService.get(requestUrl);
	    };
	    SessionService.prototype.postAdminSession = function (adminCredential) {
	        var requestUrl = '/ldap?' + 'username=' + adminCredential.username + '&password=' + adminCredential.password;
	        var body = JSON.stringify({
	            'role': adminCredential.role,
	            'username': adminCredential.username,
	            'password': adminCredential.password
	        });
	        // Call Get Method from Api Service
	        return this.apiService.post(requestUrl, body);
	    };
	    SessionService.prototype.deleteAdminSession = function () {
	        // const requestUrl = 'http://auth.eca.dev.nascorp.vn/logout';
	        var requestUrl = this.apiUrl + this.sessionUrl;
	        return this.apiService.delete(requestUrl);
	    };
	    return SessionService;
	}());
	SessionService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [services_1.SettingService,
	        services_1.ApiService])
	], SessionService);
	exports.SessionService = SessionService;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"header row\">\n    <h1 class=\"large-2\"><img src=\"" + __webpack_require__(89) + "\" (click)=\"toHomePage()\"></h1>\n    <div class=\"header-info large-10\">\n        <div class=\"component-name\">\n            <h3>{{headerName}}</h3>\n        </div>\n        <ul *ngIf=\"sidebarStatus\">\n            <li><a (click)=\"deleteSession()\">Logout</a></li>\n        </ul>\n    </div>";

/***/ }),
/* 98 */
/***/ (function(module, exports) {

	module.exports = ".header.row{height:78px;border-bottom:1px solid #e1e4e9;position:fixed;left:0;top:0;width:100%;z-index:5;max-width:100%}.header.row h1{background:#043d7a;display:inline-block;text-align:center;margin-bottom:0;padding:0 1.3125rem}.header.row h1 img{width:160px;cursor:pointer}.header.row .header-info{background:#0b5db5;padding:0 2rem;overflow:hidden;width:calc(100% - 160px - 1.3125rem * 2)}.header.row .header-info .component-name{float:left}.header.row .header-info .component-name h3{font-size:0.875rem;color:#fff;line-height:78px;margin-bottom:0;display:inline-block}.header.row .header-info ul{float:right;margin:0;font-size:0.875rem;line-height:77px;list-style:none}.header.row .header-info ul li a{color:#fff}\n"

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var AdminService_1 = __webpack_require__(87);
	var SessionService_1 = __webpack_require__(96);
	var AdminHeaderAuthComponent = (function () {
	    function AdminHeaderAuthComponent(adminService, sessionService, router) {
	        this.adminService = adminService;
	        this.sessionService = sessionService;
	        this.router = router;
	        // For logout navigate
	        this.devEnv = ['auth.eca.dev.nascorp.vn', 'camp.eca.dev.nascorp.vn', 'asa.eca.dev.nascorp.vn', 'holiday.eca.dev.nascorp.vn', 'bus.eca.dev.nascorp.vn', 'reen.eca.dev.nascorp.vn', 'conference.eca.dev.nascorp.vn'];
	        this.testEnv = ['auth.eca.test.nascorp.vn', 'camp.eca.test.nascorp.vn', 'asa.eca.test.nascorp.vn', 'holiday.eca.test.nascorp.vn', 'bus.eca.test.nascorp.vn', 'reen.eca.test.nascorp.vn', 'conference.eca.test.nascorp.vn'];
	        this.stagingEnv = ['auth.eca.uat.nascorp.vn', 'services.eca.uat.nascorp.vn', 'asa.eca.uat.nascorp.vn', 'holidayschool.eca.uat.nascorp.vn', 'bus.eca.uat.nascorp.vn', 'outdooreducation.eca.uat.nascorp.vn', 'reen.eca.uat.nascorp.vn', 'acs.eca.uat.nascorp.vn', 'pcbs.eca.uat.nascorp.vn'];
	        this.procEnv = ['auth.aisvietnam.com', 'outdooreducation.aisvietnam.com', 'asa.aisvietnam.com', 'holidayschool.aisvietnam.com', 'bus.aisvietnam.com', 'reen.aisvietnam.com', 'pcbs.aisvietnam.com'];
	    }
	    AdminHeaderAuthComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.getSession();
	        this.hostName = window.location.hostname;
	        this.headerName = this.getHeaderName(this.module);
	        this.subscription = this.adminService.adminDataChanged$.subscribe(function (admin) {
	            _this.onSessionChanged(admin);
	        });
	        // Get Admin session
	        this.adminData = this.adminService.getAdminSessionData();
	    };
	    AdminHeaderAuthComponent.prototype.ngOnDestroy = function () {
	        // Destroy the subscription for session changes
	        this.subscription.unsubscribe();
	    };
	    AdminHeaderAuthComponent.prototype.onSessionChanged = function (admin) {
	        //TO DO: update menu content when session changed
	        this.adminData = admin;
	        this.sidebarStatus = this.getSidebarStatus();
	    };
	    AdminHeaderAuthComponent.prototype.getSession = function () {
	        var _this = this;
	        this.sessionService.getSession()
	            .subscribe(function (admin) {
	            _this.adminData = admin;
	            _this.sidebarStatus = _this.getSidebarStatus();
	        }, function (error) {
	        });
	    };
	    AdminHeaderAuthComponent.prototype.toHomePage = function () {
	        // Redirect to desired URL                    
	        if (this.devEnv.indexOf(this.hostName) !== -1) {
	            return window.location.href = 'http://services.eca.dev.nascorp.vn';
	        }
	        else if (this.testEnv.indexOf(this.hostName) !== -1) {
	            return window.location.href = 'http://services.eca.test.nascorp.vn';
	        }
	        else if (this.stagingEnv.indexOf(this.hostName) !== -1) {
	            return window.location.href = 'http://services.eca.uat.nascorp.vn';
	        }
	        else if (this.procEnv.indexOf(this.hostName) !== -1) {
	            return window.location.href = 'https://services.aisvietnam.com';
	        }
	        else {
	            return window.location.href = 'http://services.local.eca.dev.nascorp.vn';
	        }
	    };
	    // Detect sidebar vibibility
	    AdminHeaderAuthComponent.prototype.getSidebarStatus = function () {
	        return !this.adminData ? false : true;
	    };
	    AdminHeaderAuthComponent.prototype.getHeaderName = function (moduleName) {
	        var headerName = "";
	        switch (this.module) {
	            case "camp":
	                headerName = "Camp Programmes Management";
	                break;
	            case "asa":
	                headerName = "Extra-Curricular Activities (ECAs) Management";
	                break;
	            case "bus":
	                headerName = "Bus Management";
	                break;
	            case "reen":
	                headerName = "Re-enrolment";
	                break;
	            case "conference":
	                headerName = "Conference Booking System";
	                break;
	            default:
	                break;
	        }
	        return headerName;
	    };
	    // Log our function
	    AdminHeaderAuthComponent.prototype.deleteSession = function () {
	        var _this = this;
	        // In case system login and booking for parent. Then, logout and login again with role parent to booking. We need to remove sessionStorage 
	        if (this.module === 'conference') {
	            window.sessionStorage.removeItem('info-parent-booking');
	            window.sessionStorage.removeItem('interview-description');
	        }
	        this.sessionService.deleteAdminSession()
	            .subscribe(function (complete) {
	            // Clear user session
	            _this.adminService.clearAdminSessionData();
	            _this.adminService.clearInterSession();
	            // Fire user session data changed event
	            _this.adminService.adminDataChanged(null);
	            // Redirect to desired URL
	            if (_this.devEnv.indexOf(_this.hostName) !== -1) {
	                return window.location.href = 'http://auth.eca.dev.nascorp.vn/logout';
	            }
	            else if (_this.testEnv.indexOf(_this.hostName) !== -1) {
	                return window.location.href = 'http://auth.eca.test.nascorp.vn/logout';
	            }
	            else if (_this.stagingEnv.indexOf(_this.hostName) !== -1) {
	                return window.location.href = 'http://auth.eca.uat.nascorp.vn/logout';
	            }
	            else if (_this.procEnv.indexOf(_this.hostName) !== -1) {
	                return window.location.href = 'https://auth.aisvietnam.com/logout';
	            }
	            else {
	                return window.location.href = 'http://auth.local.eca.dev.nascorp.vn/logout';
	            }
	        }, function (error) { return _this.errorMessage = error; });
	    };
	    return AdminHeaderAuthComponent;
	}());
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], AdminHeaderAuthComponent.prototype, "module", void 0);
	AdminHeaderAuthComponent = __decorate([
	    core_1.Component({
	        selector: 'admin-header-auth',
	        template: __webpack_require__(100),
	        styles: [__webpack_require__(101)]
	    }),
	    __metadata("design:paramtypes", [AdminService_1.AdminService,
	        SessionService_1.SessionService,
	        router_1.Router])
	], AdminHeaderAuthComponent);
	exports.AdminHeaderAuthComponent = AdminHeaderAuthComponent;


/***/ }),
/* 100 */
88,
/* 101 */
90,
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var MenuService_1 = __webpack_require__(70);
	var AdminService_1 = __webpack_require__(87);
	var SessionService_1 = __webpack_require__(96);
	var AdminSidebarComponent = (function () {
	    function AdminSidebarComponent(menuService, adminService, sessionService, router) {
	        this.menuService = menuService;
	        this.adminService = adminService;
	        this.sessionService = sessionService;
	        this.router = router;
	    }
	    AdminSidebarComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.getSession();
	        // Get Sidebar menu list
	        var sidebarName = this.getSidebarName(this.module);
	        this.sidebar = this.menuService.getMenuList(sidebarName);
	        this.subscription = this.adminService.adminDataChanged$.subscribe(function (admin) {
	            _this.onSessionChanged(admin);
	        });
	    };
	    AdminSidebarComponent.prototype.ngOnDestroy = function () {
	        // Destroy the subscription for session changes
	        this.subscription.unsubscribe();
	    };
	    /**
	     * Action that fired when the session change event is catched.
	     * Update the adminData & the menuList.
	     */
	    AdminSidebarComponent.prototype.onSessionChanged = function (admin) {
	        //TO DO: update menu content when session changed
	        this.adminData = admin;
	    };
	    AdminSidebarComponent.prototype.getSidebarStatus = function () {
	        if (!this.adminData) {
	            return false;
	        }
	        else {
	            return true;
	        }
	    };
	    AdminSidebarComponent.prototype.getSidebarName = function (moduleName) {
	        var sidebarName = '';
	        switch (moduleName) {
	            case 'camp':
	                sidebarName = 'camp-admin-sidebar';
	                break;
	            case 'asa':
	                sidebarName = 'asa-admin-sidebar';
	                break;
	            case 'bus':
	                sidebarName = 'bus-admin-sidebar';
	                break;
	            case 'holiday':
	                sidebarName = 'holiday-admin-sidebar';
	                break;
	            case 'reen':
	                sidebarName = 'reen-admin-sidebar';
	                break;
	            case 'conference':
	                sidebarName = 'conference-admin-sidebar';
	                break;
	            default:
	                break;
	        }
	        return sidebarName;
	    };
	    // Check user role to show/hide option
	    AdminSidebarComponent.prototype.accessible = function (role, id) {
	        if (!role.length) {
	            return true;
	        }
	        //check exists curId => show/hide interview.
	        if (this.module == 'conference') {
	            if (this.adminData.pcbsRole == 'system') {
	                var curId = window.sessionStorage.getItem('curId') || '0';
	                var showInterviews = (id === 'interviews') == (curId === '0');
	                var hasPCBSRole = role.indexOf(this.adminData.pcbsRole) !== -1;
	                return hasPCBSRole && showInterviews;
	            }
	            else if (this.adminData.pcbsRole == 'teacher') {
	                return role.indexOf(this.adminData.pcbsRole) !== -1;
	                ;
	            }
	        }
	        return role.indexOf(this.adminData.role) !== -1 ? true : false;
	    };
	    AdminSidebarComponent.prototype.getSession = function () {
	        var _this = this;
	        this.sessionService.getSession().subscribe(function (admin) {
	            _this.adminData = admin;
	            _this.sidebarStatus = _this.getSidebarStatus();
	        }, function (error) {
	            //TO DO: Handle any error if needed in the furture
	            _this.message = '';
	            _this.messageType = 'alert';
	        });
	    };
	    AdminSidebarComponent.prototype.showLinkBackInt = function () {
	        var sessionUser = this.adminService.getAdminSessionData();
	        return !(window.sessionStorage.getItem('curId') && this.module == 'conference' && sessionUser.pcbsRole == 'system');
	    };
	    AdminSidebarComponent.prototype.clearInterSession = function () {
	        window.sessionStorage.removeItem('curId');
	        this.router.navigate(['interviews']);
	    };
	    return AdminSidebarComponent;
	}());
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], AdminSidebarComponent.prototype, "module", void 0);
	AdminSidebarComponent = __decorate([
	    core_1.Component({
	        selector: 'admin-sidebar',
	        template: __webpack_require__(103),
	        styles: [__webpack_require__(104)]
	    }),
	    __metadata("design:paramtypes", [MenuService_1.MenuService,
	        AdminService_1.AdminService,
	        SessionService_1.SessionService,
	        router_1.Router])
	], AdminSidebarComponent);
	exports.AdminSidebarComponent = AdminSidebarComponent;


/***/ }),
/* 103 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sidebar\" *ngIf=\"sidebarStatus\">\n    <ul>\n        <li *ngFor=\"let item of sidebar\" [hidden]=\"!accessible(item.role, item.id)\">\n            <a routerLink=\"{{item.url}}\" routerLinkActive=\"active\">\n                <span>{{item.label}}</span>\n                <i class=\"material-icons\">{{item.icon}}</i>\n            </a>\n        </li>\n    </ul>\n    <div class=\"linkInt\">\n        <a (click)=\"clearInterSession()\" [hidden]=\"showLinkBackInt()\" >\n            <tr>\n                <td class=\"material-icons\">reply</td>\n                <td> Go back interviews</td>\n            </tr>\n        </a>\n    </div>\n</div>";

/***/ }),
/* 104 */
/***/ (function(module, exports) {

	module.exports = ".sidebar{background:#fff;min-height:100%;width:100%;border-right:1px solid #e1e4e9;overflow:auto;z-index:1}.sidebar ul{list-style:none;margin-left:0}.sidebar ul li{font-size:0.875rem;font-weight:600}.sidebar ul li a{color:#6e6e6e;display:block;overflow:hidden;padding:1.375rem}.sidebar ul li a span{display:inline-block;vertical-align:middle}.sidebar ul li a i{float:right}.sidebar ul li .active{background:#e6e6e6}.linkInt{position:fixed;bottom:60px;text-align:center;z-index:100;left:20px;font-size:0.91rem;font-weight:600;margin:0 auto}.linkInt a:hover,.linkInt a:focus{color:rgba(255,0,0,0.8);text-decoration:none;cursor:pointer;text-decoration:underline}\n"

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(96));


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(107));


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	var common_1 = __webpack_require__(22);
	var forms_1 = __webpack_require__(108);
	var http_1 = __webpack_require__(60);
	var components_1 = __webpack_require__(110);
	var SharedModule = (function () {
	    /**
	     * The SharedModule which will define the modules, components & directives that will
	     * be used again in other feature modules. It 's different with the CoreModule which
	     * will define the components, directives that only use one time in the main AppModule.
	     */
	    function SharedModule() {
	    }
	    return SharedModule;
	}());
	SharedModule = __decorate([
	    core_1.NgModule({
	        imports: [
	            common_1.CommonModule,
	            forms_1.FormsModule,
	            http_1.HttpModule,
	            http_1.JsonpModule,
	        ],
	        declarations: [
	            components_1.AlertBoxComponent,
	            components_1.PaginatorComponent,
	            components_1.CalendarComponent
	        ],
	        exports: [
	            // Modules
	            common_1.CommonModule,
	            forms_1.FormsModule,
	            http_1.HttpModule,
	            http_1.JsonpModule,
	            // Components
	            components_1.AlertBoxComponent,
	            components_1.PaginatorComponent,
	            components_1.CalendarComponent
	        ]
	    })
	    /**
	     * The SharedModule which will define the modules, components & directives that will
	     * be used again in other feature modules. It 's different with the CoreModule which
	     * will define the components, directives that only use one time in the main AppModule.
	     */
	], SharedModule);
	exports.SharedModule = SharedModule;


/***/ }),
/* 108 */,
/* 109 */,
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(111));
	__export(__webpack_require__(114));
	__export(__webpack_require__(117));


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var AlertBoxComponent = (function () {
	    function AlertBoxComponent() {
	    }
	    AlertBoxComponent.prototype.ngOnInit = function () {
	        // Set default message type if no type input received.
	        if (!this.type) {
	            this.type = "warning";
	        }
	    };
	    AlertBoxComponent.prototype.onClose = function () {
	        // Set message to "" to hide the box.
	        this.message = "";
	    };
	    return AlertBoxComponent;
	}());
	__decorate([
	    core_1.Input('message'),
	    __metadata("design:type", String)
	], AlertBoxComponent.prototype, "message", void 0);
	__decorate([
	    core_1.Input('type'),
	    __metadata("design:type", String)
	], AlertBoxComponent.prototype, "type", void 0);
	AlertBoxComponent = __decorate([
	    core_1.Component({
	        selector: 'alert-box',
	        template: __webpack_require__(112),
	        styles: [__webpack_require__(113)]
	    }),
	    core_1.Injectable()
	], AlertBoxComponent);
	exports.AlertBoxComponent = AlertBoxComponent;


/***/ }),
/* 112 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"callout\" [ngClass]=\"type\" [class.hidden]=\"!message\">\n    {{message}}\n    <button class=\"close-button\" type=\"button\" (click)=\"onClose()\">\n        <span aria-hidden=\"true\">&times;</span>\n    </button>\n</div>";

/***/ }),
/* 113 */
/***/ (function(module, exports) {

	module.exports = ".callout{padding:0.5rem 1.5rem 0.5rem 0.5rem;opacity:1;visibility:visible;transition:all ease-in-out 0.2s}.callout.hidden{visibility:hidden;opacity:0;padding:0;margin:0}.callout button.close-button{right:0.5rem;line-height:0.7}\n"

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var PaginatorComponent = (function () {
	    function PaginatorComponent() {
	        this.currentPageUpdated = new core_1.EventEmitter();
	    }
	    PaginatorComponent.prototype.ngOnInit = function () {
	        if (this.currentPage > this.totalPage) {
	            this.currentPage = 1;
	        }
	        this.oldTotalPage = this.totalPage;
	        // Generate page number range list that will be used to display.
	        this.pageList = this.generatePageNumberList(this.numberDisplay, this.currentPage, this.totalPage);
	    };
	    PaginatorComponent.prototype.ngOnChanges = function (changes) {
	        for (var propName in changes) {
	            if (propName === 'totalPage' && changes[propName].currentValue > 0) {
	                // Re-generate page number range list that will be used to display.
	                this.pageList = this.generatePageNumberList(this.numberDisplay, this.currentPage, this.totalPage);
	            }
	            if (propName === 'currentPage') {
	                if (this.pageList && this.pageList.indexOf(changes[propName].currentValue) === -1) {
	                    // Re-generate page number range list that will be used to display.
	                    this.pageList = this.generatePageNumberList(this.numberDisplay, this.currentPage, this.totalPage);
	                }
	            }
	        }
	    };
	    PaginatorComponent.prototype.generatePageNumberList = function (numberDisplay, currentPage, totalPage) {
	        var pageNumberList = [];
	        var range = Math.floor(numberDisplay / 2);
	        var start = 0;
	        var end = currentPage + range > totalPage ? totalPage : currentPage + range;
	        // Generate start number
	        if (currentPage - range > 0) {
	            start = currentPage + range > totalPage ? totalPage - numberDisplay + 1 : currentPage - range;
	            start = start < 1 ? start = 1 : start;
	        }
	        else {
	            start = 1;
	        }
	        // Generate end number
	        end = start + numberDisplay - 1 > totalPage ? totalPage : start + numberDisplay - 1;
	        for (start; start <= end; start++) {
	            pageNumberList.push(start);
	        }
	        return pageNumberList;
	    };
	    PaginatorComponent.prototype.updateSelectedPage = function (page) {
	        if (page > 0 && page <= this.totalPage) {
	            // Update current Page
	            this.currentPage = page;
	            // generate new page list
	            this.pageList = this.generatePageNumberList(this.numberDisplay, this.currentPage, this.totalPage);
	            // Fire event for parent component to know current page had been changed
	            this.currentPageUpdated.emit(page);
	        }
	    };
	    return PaginatorComponent;
	}());
	__decorate([
	    core_1.Input('currentPage'),
	    __metadata("design:type", Number)
	], PaginatorComponent.prototype, "currentPage", void 0);
	__decorate([
	    core_1.Input('totalPage'),
	    __metadata("design:type", Number)
	], PaginatorComponent.prototype, "totalPage", void 0);
	__decorate([
	    core_1.Input('numberDisplay'),
	    __metadata("design:type", Number)
	], PaginatorComponent.prototype, "numberDisplay", void 0);
	__decorate([
	    core_1.Output(),
	    __metadata("design:type", Object)
	], PaginatorComponent.prototype, "currentPageUpdated", void 0);
	PaginatorComponent = __decorate([
	    core_1.Component({
	        selector: 'pagination',
	        template: __webpack_require__(115),
	        styles: [__webpack_require__(116)]
	    }),
	    core_1.Injectable()
	], PaginatorComponent);
	exports.PaginatorComponent = PaginatorComponent;


/***/ }),
/* 115 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"text-center\" *ngIf=\"totalPage>1\">\n    <ul class=\"paginator\">\n        <!-- First Page -->\n        <li [class.disabled]=\"currentPage === 1\" title=\"First page\" (click)=\"updateSelectedPage(1)\">\n            <i class=\"material-icons\">first_page</i>\n        </li>\n        <!-- Previous Page -->\n        <li [class.disabled]=\"currentPage === 1\" title=\"Previous page\" (click)=\"updateSelectedPage(currentPage - 1)\">\n            <i class=\"material-icons\">keyboard_arrow_left</i>\n        </li>\n        <!-- Pages -->\n        <li *ngFor=\"let page of pageList\" [class.current]=\"page === currentPage\" (click)=\"updateSelectedPage(page)\">\n            {{page}}\n        </li>\n\n        <!-- Next Page -->\n        <li title=\"Next page\" (click)=\"updateSelectedPage(currentPage + 1)\" [class.disabled]=\"currentPage === totalPage\">\n            <i class=\"material-icons\">keyboard_arrow_right</i>\n        </li>\n        <!-- Last Page -->\n        <li title=\"Last page\" (click)=\"updateSelectedPage(totalPage)\" [class.disabled]=\"currentPage === totalPage\">\n            <i class=\"material-icons\">last_page</i>\n        </li>\n    </ul>\n</div>";

/***/ }),
/* 116 */
/***/ (function(module, exports) {

	module.exports = "ul.paginator{display:inline-flex;display:-webkit-inline-flex;margin:1rem}ul.paginator li{margin:0 0.2rem;border:1px #043d7a solid;border-radius:0.2rem;padding:0.2rem;vertical-align:middle;display:inline-block;color:#043d7a;text-align:center;width:2rem;cursor:pointer}ul.paginator li.disabled{opacity:0.25;cursor:not-allowed}ul.paginator li:not(.disabled):hover{background-color:#043d7a;color:#fff}ul.paginator li.current{background-color:#043d7a;color:#fff;cursor:default}\n"

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	// import { User, UserService } from "../../../user";
	var CalendarComponent = (function () {
	    // private userData: User;
	    function CalendarComponent(router) {
	        this.router = router;
	    }
	    CalendarComponent.prototype.ngOnInit = function () {
	        //check auth later
	        // this.userData = this.userService.getUserSessionData();
	        // if (!this.userData) {
	        //   this.router.navigate(["/"]);
	        // }
	    };
	    return CalendarComponent;
	}());
	CalendarComponent = __decorate([
	    core_1.Component({
	        selector: "calendar-ais",
	        template: __webpack_require__(118),
	        styles: [__webpack_require__(119)],
	    }),
	    __metadata("design:paramtypes", [router_1.Router])
	], CalendarComponent);
	exports.CalendarComponent = CalendarComponent;


/***/ }),
/* 118 */
/***/ (function(module, exports) {

	module.exports = "<main>\n  <div class=\"component-title\">\n    <h1 style=\"text-align: center\">AIS EVENTS CALENDAR</h1>\n  </div>\n  <div class=\"container\">\n    <div class=\"list-activity\">\n      <ul class=\"tabs\">\n        <li class=\"tabs-title\" style = \"width: 100%\">\n          <h3>AIS Primary Key</h3>\n          <!--Tab content-->\n          <ul class=\"tab-content\">\n            <div>\n              <iframe\n                src=\"https://outlook.office365.com/calendar/published/8bbd188021a84c35acecf687b51a7650@aisvietnam.com/f9e0af964a3e4c0592230601cb9d840a15610149895430689436/calendar.html\"\n                scrolling=\"no\"\n                width=\"100%\"\n                height=\"700\"\n                frameborder=\"0\"\n                webkitallowfullscreen mozallowfullscreen allowfullscreen\n              ></iframe>\n            </div>\n          </ul>\n          <!--End of Tab content-->\n        </li>\n        <li class=\"tabs-title secondary\" style=\"width: 100%;margin-left: 0px;\">\n          <h3>AIS Secondary Key</h3>\n          <!--Tab content-->\n          <ul class=\"tab-content\">\n            <div>\n              <iframe\n                src=\"https://outlook.office365.com/calendar/published/8bbd188021a84c35acecf687b51a7650@aisvietnam.com/9f34949e334b48858c4227cd20ccc9ed7215315901799778642/calendar.html\"\n                scrolling=\"no\"\n                width=\"100%\"\n                height=\"700\"\n                frameborder=\"0\"\n                webkitallowfullscreen mozallowfullscreen allowfullscreen\n              ></iframe>\n            </div>\n          </ul>\n          <!--End of Tab content-->\n        </li>\n      </ul>\n    </div>\n  </div>\n\n  <div id=\"daisy_from\" style=\"display: none\"></div>\n</main>\n";

/***/ }),
/* 119 */
/***/ (function(module, exports) {

	module.exports = ".btn-popup{padding:15px;width:142px}.clickable{cursor:pointer}li{padding:0 1rem}form{padding:0;border:none;box-shadow:none;background:none}.component-title{color:#043d7a;background-color:#f8f8f8;padding:1.5rem 0;border-bottom:1px solid #eaeaea}.component-title h1{width:80%;margin:0 auto;padding:0 1.25rem;font-size:1.5256rem}.container{width:98%;margin:0 auto;padding:0}.container li{margin:0}.container .list-activity{padding:0}.container .list-activity ul{margin:0 auto;margin-bottom:3rem}.container .list-activity ul .secondary{margin-left:50px}.container .list-activity ul h3{padding:10px;font-size:2rem}@media only screen and (min-width: 769px) and (max-width: 1024px){.container{overflow-x:hidden}.container .secondary{margin-left:0 !important}}@media only screen and (max-width: 768px){li{flex:0 0 50%}.component-title{width:100% !important}.container{width:768px !important;overflow-x:hidden}.container .secondary{margin-left:0 !important}}\n"

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(121));
	__export(__webpack_require__(84));
	__export(__webpack_require__(85));
	__export(__webpack_require__(311));
	__export(__webpack_require__(124));
	__export(__webpack_require__(129));
	__export(__webpack_require__(168));


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var shared_1 = __webpack_require__(106);
	var HolLoginComponent_1 = __webpack_require__(122);
	var HolRegisterComponent_1 = __webpack_require__(127);
	var HolChoosePasswordComponent_1 = __webpack_require__(132);
	var HolForgotPasswordComponent_1 = __webpack_require__(135);
	var HolChangePasswordComponent_1 = __webpack_require__(139);
	var HolSetNewPasswordComponent_1 = __webpack_require__(142);
	var LoginComponent_1 = __webpack_require__(145);
	var LogoutComponent_1 = __webpack_require__(148);
	var RegisterComponent_1 = __webpack_require__(149);
	var ChoosePasswordComponent_1 = __webpack_require__(152);
	var ForgotPasswordComponent_1 = __webpack_require__(155);
	var SetNewPasswordComponent_1 = __webpack_require__(158);
	var ChangePasswordComponent_1 = __webpack_require__(161);
	var AddParentComponent_1 = __webpack_require__(164);
	var AddStudentComponent_1 = __webpack_require__(167);
	var UserRouting_1 = __webpack_require__(310);
	var UserService_1 = __webpack_require__(84);
	var PasswordService_1 = __webpack_require__(136);
	var RegisterService_1 = __webpack_require__(128);
	var SessionService_1 = __webpack_require__(85);
	var HolidayService_1 = __webpack_require__(86);
	var UserModule = (function () {
	    function UserModule() {
	    }
	    return UserModule;
	}());
	UserModule = __decorate([
	    core_1.NgModule({
	        imports: [
	            shared_1.SharedModule,
	            UserRouting_1.userRouting,
	        ],
	        declarations: [
	            HolLoginComponent_1.HolLoginComponent,
	            HolRegisterComponent_1.HolRegisterComponent,
	            HolForgotPasswordComponent_1.HolForgotPasswordComponent,
	            HolChangePasswordComponent_1.HolChangePasswordComponent,
	            HolSetNewPasswordComponent_1.HolSetNewPasswordComponent,
	            HolChoosePasswordComponent_1.HolChoosePasswordComponent,
	            LoginComponent_1.LoginComponent,
	            LogoutComponent_1.LogoutComponent,
	            RegisterComponent_1.RegisterComponent,
	            ChoosePasswordComponent_1.ChoosePasswordComponent,
	            ForgotPasswordComponent_1.ForgotPasswordComponent,
	            SetNewPasswordComponent_1.SetNewPasswordComponent,
	            ChangePasswordComponent_1.ChangePasswordComponent,
	            AddParentComponent_1.AddParentComponent,
	            AddStudentComponent_1.AddStudentComponent,
	        ],
	        providers: [
	            UserService_1.UserService,
	            SessionService_1.SessionService,
	            PasswordService_1.PasswordService,
	            RegisterService_1.RegisterService,
	            HolidayService_1.HolidayService
	        ]
	    })
	], UserModule);
	exports.UserModule = UserModule;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	// Services
	var SessionService_1 = __webpack_require__(85);
	var UserService_1 = __webpack_require__(84);
	var HolidayService_1 = __webpack_require__(86);
	var Parent_1 = __webpack_require__(123);
	var Credential_1 = __webpack_require__(124);
	var services_1 = __webpack_require__(58);
	var HolLoginComponent = (function () {
	    function HolLoginComponent(holidayService, sessionService, userService, router, sessionStorageService) {
	        this.holidayService = holidayService;
	        this.sessionService = sessionService;
	        this.userService = userService;
	        this.router = router;
	        this.sessionStorageService = sessionStorageService;
	        this.formSubmitted = false;
	        this.credential = new Credential_1.Credential('', '', '');
	        this.parent = new Parent_1.Parent();
	    }
	    HolLoginComponent.prototype.ngOnInit = function () {
	        this.hostName = window.location.hostname;
	        // Use Session Service to get session and check if user had already logged in.
	        this.getSession();
	        this.schools = [
	            {
	                name: 'Australian International School',
	                value: 1,
	            },
	            {
	                name: 'Others',
	                value: 2,
	            },
	        ];
	        this.schools.value = 1;
	        this.selectedTab = 1;
	    };
	    ;
	    HolLoginComponent.prototype.onSubmit = function () {
	        this.credential.role = 'parent';
	        this.formSubmitted = true;
	        // Reset message content
	        this.message = "";
	        // Post user login data to create session
	        this.postSession(this.credential);
	    };
	    HolLoginComponent.prototype.onSubmitNonAis = function () {
	        this.credential.role = 'hol-parent';
	        this.formSubmitted = true;
	        // Reset message content
	        this.message = "";
	        // Post user login data to create session
	        this.postSessionNonAis(this.credential);
	    };
	    /**
	     * Get Session from API service to make sure that user had logged in.
	     * Update User Data on local storage and redirect to the desired URL
	     * if request responses session data.
	     * @param none
	     * @return none
	     */
	    HolLoginComponent.prototype.getSession = function () {
	        var _this = this;
	        this.sessionService.getSession()
	            .subscribe(function (user) {
	            _this.userService.setUserSessionData(user);
	        }, function (error) {
	            //TO DO: Handle any error if needed in the furture
	            _this.message = "";
	            _this.messageType = "alert";
	        });
	    };
	    /**
	     * Post Session to API service to create new session.
	     * Update User Data on local storage and redirect to desired URL
	     * if request responses session data.
	     * @param {Credential} - user credential input
	     * @return none
	     */
	    HolLoginComponent.prototype.postSession = function (credential) {
	        var _this = this;
	        this.sessionService.postSession(credential)
	            .subscribe(function (user) {
	            _this.sessionStorageService.setData('isAisParent', true);
	            // Set user session data
	            _this.userService.setUserSessionData(user);
	            // Fire user session data changed event
	            _this.userService.userDataChanged(user);
	            _this.router.navigate(['/parents']);
	        }, function (error) {
	            _this.formSubmitted = false;
	            _this.message = "Invalid email address or password.";
	            _this.messageType = "alert";
	        });
	    };
	    HolLoginComponent.prototype.postSessionNonAis = function (credential) {
	        var _this = this;
	        this.sessionService.postSession(credential)
	            .subscribe(function (user) {
	            _this.sessionStorageService.setData('isAisParent', false);
	            // Set user session data
	            _this.userService.setUserSessionData(user);
	            // Fire user session data changed event
	            _this.userService.userDataChanged(user);
	            // this.checkStatus();
	            _this.router.navigate(['/other-parents']);
	        }, function (error) {
	            _this.formSubmitted = false;
	            _this.message = "Invalid email address or password.";
	            _this.messageType = "alert";
	        });
	    };
	    HolLoginComponent.prototype.toHoliday = function () {
	        switch (this.hostName) {
	            case "services.aisvietnam.com":
	                window.location.href = 'https://holidayschool.aisvietnam.com';
	                break;
	            case "services.eca.dev.nascorp.vn":
	                window.location.href = 'http://holiday.eca.dev.nascorp.vn/';
	                break;
	            case "services.eca.test.nascorp.vn":
	                window.location.href = 'http://holiday.eca.test.nascorp.vn/';
	                break;
	            case "services.eca.uat.nascorp.vn":
	                window.location.href = 'http://holidayschool.eca.uat.nascorp.vn';
	                break;
	            case "services.local.eca.dev.nascorp.vn":
	                window.location.href = 'http://holiday.local.eca.dev.nascorp.vn';
	                break;
	        }
	        ;
	    };
	    HolLoginComponent.prototype.activateTab = function (tabId) {
	        this.selectedTab = tabId;
	    };
	    return HolLoginComponent;
	}());
	HolLoginComponent = __decorate([
	    core_1.Component({
	        selector: 'user-login',
	        template: __webpack_require__(125),
	        styles: [__webpack_require__(126)],
	    }),
	    __metadata("design:paramtypes", [HolidayService_1.HolidayService,
	        SessionService_1.SessionService,
	        UserService_1.UserService,
	        router_1.Router,
	        services_1.SessionStorageService])
	], HolLoginComponent);
	exports.HolLoginComponent = HolLoginComponent;


/***/ }),
/* 123 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Parent = (function () {
	    function Parent() {
	    }
	    return Parent;
	}());
	exports.Parent = Parent;
	var ParentItem = (function () {
	    function ParentItem() {
	    }
	    return ParentItem;
	}());
	exports.ParentItem = ParentItem;
	var HolParentDetails = (function () {
	    function HolParentDetails() {
	    }
	    return HolParentDetails;
	}());
	exports.HolParentDetails = HolParentDetails;
	var HolStudents = (function () {
	    function HolStudents() {
	    }
	    return HolStudents;
	}());
	exports.HolStudents = HolStudents;
	var HolStudentParents = (function () {
	    function HolStudentParents() {
	    }
	    return HolStudentParents;
	}());
	exports.HolStudentParents = HolStudentParents;
	var ParentChangeEmail = (function () {
	    function ParentChangeEmail() {
	        this.oldEmail = '';
	        this.newEmail = '';
	        this.reNewEmail = '';
	    }
	    return ParentChangeEmail;
	}());
	exports.ParentChangeEmail = ParentChangeEmail;
	;


/***/ }),
/* 124 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Credential = (function () {
	    function Credential(role, email, password) {
	        this.role = role;
	        this.email = email;
	        this.password = password;
	    }
	    return Credential;
	}());
	exports.Credential = Credential;


/***/ }),
/* 125 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"user-login-component\" class=\"eca-background\">\n    <div class=\"component-title\">\n        <h1>WELCOME TO AIS</h1>\n    </div>\n    <div class=\"component-content\">\n\t\t<div class=\"top-content\">\n\t\t\t<h3 class=\"text-center\">Login to your account</h3>\n\t\t\t<div class=\"row columns\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<h4 class=\"text-center\">Student is studying at :</h4>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<div class=\"wrap-select\">\n\t\t\t\t\t\t<select #school (change)=\"activateTab(school.value)\">\n\t\t\t\t\t\t\t<option *ngFor=\"let school of schools\" value={{school.value}}>{{school.name}}</option>\n\t\t\t\t\t\t</select>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<!-- Form Title -->\n        <form #loginForm=\"ngForm\" *ngIf=\"selectedTab == 1\">\n\t\t\t<div>\n\t\t\t\t<!-- Alert Box -->\n\t\t\t\t<div class=\"row\">\n\t\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t\t<alert-box [message]=\"message\" [type]=\"messageType\"></alert-box>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<!-- Email Input Field -->\n\t\t\t\t<div class=\"row\">\n\t\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t\t<label for=\"email\">Email</label>\n\t\t\t\t\t\t<input type=\"email\" placeholder=\"Type your email address\" id=\"email\" \n\t\t\t\t\t\t\t[(ngModel)]=\"credential.email\" name=\"email\" #email=\"ngModel\" required>\n\t\t\t\t\t\t<div [hidden]=\"email.valid || email.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\t\tEmail is required.\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<!-- Password Input Field -->\n\t\t\t\t<div class=\"row\">\n\t\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t\t<label for=\"password\">Password</label>\n\t\t\t\t\t\t<input type=\"password\" placeholder=\"Type your password\" id=\"password\" \n\t\t\t\t\t\t\t[(ngModel)]=\"credential.password\" name=\"password\" #password=\"ngModel\" required>\n\t\t\t\t\t\t<div [hidden]=\"password.valid || password.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\t\tPassword is required.\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<!-- Remember Me & Forgot Password -->\n\t\t\t\t<div class=\"row\">\n\t\t\t\t\t<div class=\"medium-12 columns remember-block\">\n\t\t\t\t\t\t<a target=\"_blank\" href=\"https://services.aisvietnam.com/upload/AIS-Service-GuidelineforParents.pdf\" class=\"forgot-password text-left\">Introductions to create an account</a><br/>\n\t\t\t\t\t\t<a routerLink=\"/forgot-password\" class=\"forgot-password\">Forgot Password?</a>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<!-- Submit Button -->\n\t\t\t\t<div class=\"row\">\n\t\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t\t<button type=\"submit\" name=\"submit\" [disabled]=\"!loginForm.form.valid || formSubmitted\" (click)=\"onSubmit()\">\n\t\t\t\t\t\t\t<span *ngIf=\"!formSubmitted\">Login</span>\n\t\t\t\t\t\t\t<span *ngIf=\"formSubmitted\">\n\t\t\t\t\t\t\t\t<span class=\"spinner\"></span> Logging in...\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</button>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<!-- Register Link -->\n\t\t\t\t<div class=\"row\">\n\t\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t\t<label class=\"register-link\">Do not have an account yet? <a routerLink=\"/hol-register\">REGISTER NOW</a></label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n        </form>\n        <form #holloginForm=\"ngForm\" *ngIf=\"selectedTab == 2\">\n\t\t\t<!-- Alert Box -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<alert-box [message]=\"message\" [type]=\"messageType\"></alert-box>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Email Input Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"email\">Email</label>\n\t\t\t\t\t<input type=\"email\" placeholder=\"Type your email address\" id=\"email\" \n\t\t\t\t\t\t[(ngModel)]=\"credential.email\" name=\"email\" #email=\"ngModel\" required>\n\t\t\t\t\t<div [hidden]=\"email.valid || email.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tEmail is required.\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Password Input Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"password\">Password</label>\n\t\t\t\t\t<input type=\"password\" placeholder=\"Type your password\" id=\"password\" \n\t\t\t\t\t\t[(ngModel)]=\"credential.password\" name=\"password\" #password=\"ngModel\" required>\n\t\t\t\t\t<div [hidden]=\"password.valid || password.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tPassword is required.\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Remember Me & Forgot Password -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns remember-block\">\n\t\t\t\t\t<a target=\"_blank\" href=\"https://services.aisvietnam.com/upload/CPM-GettingStartedasNonAISParentManual.pdf\" class=\"forgot-password text-left\">Introductions to create an account</a><br/>\n\t\t\t\t\t<a routerLink=\"/forgot-password\" class=\"forgot-password\">Forgot Password?</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Submit Button -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<button type=\"submit\" name=\"submit\" [disabled]=\"!holloginForm.form.valid || formSubmitted\" (click)=\"onSubmitNonAis()\">\n\t\t\t\t\t\t<span *ngIf=\"!formSubmitted\">Login</span>\n\t\t\t\t\t\t<span *ngIf=\"formSubmitted\">\n\t\t\t\t\t\t\t<span class=\"spinner\"></span> Logging in...\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Register Link -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n            \t\t<label class=\"register-link\">Do not have an account yet? <a routerLink=\"/hol-register\">REGISTER NOW</a></label>\n\t\t\t\t</div>\n\t\t\t</div>\n        </form>\n    </div>\n</div>";

/***/ }),
/* 126 */
/***/ (function(module, exports) {

	module.exports = "select{border:1px solid #dddddd;border-radius:0.2rem;-moz-border-radius:0.2rem;-webkit-border-radius:0.2rem;box-sizing:border-box;width:100%;height:2.4375rem;border:1px solid #cacaca;margin:0 0 1rem;font-family:inherit;font-size:1rem;color:#616060;background-color:#fefefe}h4{font-size:1rem;padding:1rem 0;color:#043d7a;text-align:left}.tabs{margin-bottom:-7px;position:relative;z-index:29;border-top-right-radius:5px;border-top-left-radius:5px;border:none}.tabs li{width:50%}.tabs li a{background:#043d7a;color:#fff;font-weight:normal;font-size:1rem}.tabs li:first-child{border-top-left-radius:5px}.tabs li:last-child{border-top-right-radius:5px}.tabs li>.is-active{background:#fff;color:#043d7a;font-weight:bold;border-top-right-radius:5px;border-top-left-radius:5px}#user-login-component{padding:1rem}#user-login-component .component-title{margin:3rem auto;color:#fff;text-align:center}#user-login-component .component-content{margin:3rem auto;width:31.25%;background:#fff;border-radius:0.5rem;padding-bottom:1.5rem}#user-login-component .component-content .top-content h3{padding:1rem;background:#043d7a;color:#fff;border-top-right-radius:6px;border-top-left-radius:6px}#user-login-component .component-content form{padding:0 1rem;box-shadow:none}#user-login-component .component-content form div.remember-block{position:relative;font-size:0.8rem;margin-bottom:0.5rem}#user-login-component .component-content form div.remember-block input[type=\"checkbox\"]{position:absolute;height:1.1rem;width:1.1rem;top:0.5rem;cursor:pointer}#user-login-component .component-content form div.remember-block label{margin-left:1.5rem}#user-login-component .component-content form .register-link{font-size:0.65rem;font-weight:bold;text-align:center}#user-login-component .component-content form .forgot-password{font-size:0.8rem;display:inline-block;line-height:30px}#user-login-component .component-content form button:not(.close-button){width:100%}#user-login-component .component-content form button:not(.close-button) .spinner{display:inline-block;width:14px;height:14px;border:2px solid rgba(255,255,255,0.3);border-top-color:#fff;border-radius:50%;animation:spin 0.8s linear infinite;vertical-align:middle;margin-right:5px}#user-login-component .component-content form button.close-button{line-height:1.2}@keyframes spin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}@media (min-width: 1025px){#user-login-component .component-title{max-width:450px}#user-login-component .component-content{max-width:450px}}@media (min-width: 768px) and (max-width: 1024px){#user-login-component .component-title{width:50%;max-width:450px}#user-login-component .component-content{width:50%;max-width:450px}}@media (min-width: 320px) and (max-width: 767px){#user-login-component{padding:0}#user-login-component .component-title{display:none}#user-login-component .component-content{margin:0;width:100%}#user-login-component .component-content form{border:none;border-radius:0rem}}\n"

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	//Libraries
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	// Services
	var SessionService_1 = __webpack_require__(85);
	var UserService_1 = __webpack_require__(84);
	var RegisterService_1 = __webpack_require__(128);
	//Models
	var Credential_1 = __webpack_require__(124);
	var NonAisParent_1 = __webpack_require__(129);
	var HolRegisterComponent = (function () {
	    function HolRegisterComponent(sessionService, userService, registerService, router) {
	        this.sessionService = sessionService;
	        this.userService = userService;
	        this.registerService = registerService;
	        this.router = router;
	        this.formSubmitted = false;
	    }
	    HolRegisterComponent.prototype.ngOnInit = function () {
	        this.redirectUrl = '/booking/students';
	        this.nonAisParent = new NonAisParent_1.NonAisParent();
	        this.credential = new Credential_1.Credential('', '', '');
	        // Use Session Service to get session and check if user had already logged in.
	        this.getSession();
	        this.schools = [
	            {
	                name: 'Australian Internation School',
	                value: 1,
	            },
	            {
	                name: 'Others',
	                value: 2,
	            },
	        ];
	        this.schools.value = 1;
	        this.selectedTab = 1;
	    };
	    HolRegisterComponent.prototype.onSubmit = function () {
	        this.credential.role = 'parent';
	        this.formSubmitted = true;
	        // Reset message content
	        this.message = "";
	        // Post user login data to create session
	        this.register();
	    };
	    HolRegisterComponent.prototype.onSubmitNonAis = function () {
	        this.credential = new Credential_1.Credential('hol-parent', '', '');
	        this.formSubmitted = true;
	        // Reset message content
	        this.message = "";
	        // Post user login data to create session
	        this.registerNonAis(this.nonAisParent);
	    };
	    /**
	     * Get Session from API service to make sure that user had logged in.
	     * Update User Data on local storage and redirect to the desired URL
	     * if request responses session data.
	     * @param none
	     * @return none
	     */
	    HolRegisterComponent.prototype.getSession = function () {
	        var _this = this;
	        this.sessionService.getSession()
	            .subscribe(function (user) {
	            _this.userService.setUserSessionData(user);
	            _this.redirect();
	        }, function (error) {
	            //TO DO: Handle any error if needed in the furture
	            _this.message = "";
	            _this.messageType = "alert";
	        });
	    };
	    HolRegisterComponent.prototype.register = function () {
	        var _this = this;
	        this.registerService.postActivationEmail(this.credential.role, this.credential.email)
	            .subscribe(function (complete) {
	            _this.messageType = "success",
	                _this.message = "An activation email had been sent.";
	            _this.formSubmitted = false;
	        }, function (error) {
	            _this.messageType = "alert";
	            _this.message = "Please input the email you provided to AIS.";
	            _this.formSubmitted = false;
	        });
	    };
	    HolRegisterComponent.prototype.registerNonAis = function (nonAisParent) {
	        var _this = this;
	        this.registerService.postNoneAisAccount(nonAisParent)
	            .subscribe(function (complete) {
	            _this.messageType = "success",
	                _this.message = "An activation email had been sent.";
	            _this.formSubmitted = false;
	        }, function (error) {
	            var errorObj = JSON.parse(error['_body']);
	            _this.messageType = "alert";
	            _this.message = errorObj.message;
	            _this.formSubmitted = false;
	        });
	    };
	    HolRegisterComponent.prototype.redirect = function () {
	        // Redirect to stored url
	        this.router.navigate([this.redirectUrl]);
	    };
	    HolRegisterComponent.prototype.activateTab = function (tabId) {
	        this.selectedTab = tabId;
	    };
	    return HolRegisterComponent;
	}());
	HolRegisterComponent = __decorate([
	    core_1.Component({
	        selector: 'user-register',
	        template: __webpack_require__(130),
	        styles: [__webpack_require__(131)]
	    }),
	    __metadata("design:paramtypes", [SessionService_1.SessionService,
	        UserService_1.UserService,
	        RegisterService_1.RegisterService,
	        router_1.Router])
	], HolRegisterComponent);
	exports.HolRegisterComponent = HolRegisterComponent;


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	// Import Setting Service and User, Credential Model
	var services_1 = __webpack_require__(58);
	var RegisterService = (function () {
	    function RegisterService(settingService, apiService) {
	        this.settingService = settingService;
	        this.apiService = apiService;
	        this.activationUrl = '/activations';
	        this.holParentUrl = '/hol/parent';
	        this.holStudenttUrl = '/hol/student';
	        this.holPasswordUrl = '/hol/parent/password';
	        this.apiUrl = '';
	        this.apiUrl = this.settingService.getSetting('api_service_domain');
	    }
	    RegisterService.prototype.postActivationEmail = function (role, email) {
	        var requestUrl = this.apiUrl + this.activationUrl;
	        var body = JSON.stringify({
	            'role': role,
	            'email': email
	        });
	        return this.apiService.post(requestUrl, body);
	    };
	    RegisterService.prototype.verifyActivationToken = function (token) {
	        var requestUrl = this.apiUrl + this.activationUrl + "/" + token;
	        return this.apiService.get(requestUrl);
	    };
	    // verifyActivationRecovery(recovery: string): Observable<any> {
	    //     const requestUrl = this.apiUrl + this.holPasswordUrl;
	    //     return this.apiService.get(requestUrl);
	    // }
	    RegisterService.prototype.setPasswordWithActivationToken = function (token, password) {
	        var requestUrl = this.apiUrl + this.activationUrl + "/" + token;
	        // TODO: update body content
	        var body = JSON.stringify({ password: password });
	        return this.apiService.patch(requestUrl, body);
	    };
	    RegisterService.prototype.setPasswordWithActivationRecovery = function (recovery, email, password) {
	        var requestUrl = this.apiUrl + this.holPasswordUrl;
	        // TODO: update body content
	        var body = JSON.stringify({
	            'email': email,
	            'recovery': recovery,
	            'password': password
	        });
	        return this.apiService.post(requestUrl, body);
	    };
	    RegisterService.prototype.postNoneAisAccount = function (nonAisParent) {
	        var requestUrl = this.apiUrl + this.holParentUrl + "/register";
	        var body = JSON.stringify(nonAisParent);
	        return this.apiService.post(requestUrl, body);
	    };
	    RegisterService.prototype.postNonAisStudent = function (nonAisStudent) {
	        var requestUrl = this.apiUrl + this.holStudenttUrl;
	        var body = JSON.stringify(nonAisStudent);
	        return this.apiService.post(requestUrl, body);
	    };
	    RegisterService.prototype.updateParent = function (nonAisParent) {
	        var requestUrl = this.apiUrl + this.holParentUrl;
	        var body = JSON.stringify(nonAisParent);
	        return this.apiService.patch(requestUrl, body);
	    };
	    return RegisterService;
	}());
	RegisterService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [services_1.SettingService,
	        services_1.ApiService])
	], RegisterService);
	exports.RegisterService = RegisterService;


/***/ }),
/* 129 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var NonAisParent = (function () {
	    function NonAisParent() {
	    }
	    return NonAisParent;
	}());
	exports.NonAisParent = NonAisParent;


/***/ }),
/* 130 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"user-register-component\" class=\"eca-background\">\n    <div class=\"component-title\">\n        <h1>WELCOME TO AIS</h1>\n    </div>\n    <div class=\"component-content\">\n\t\t<div class=\"top-content\">\n\t\t\t<h3 class=\"text-center\">Register Account</h3>\n\t\t\t<div class=\"row columns\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<h4 class=\"text-center\">Student is studying at :</h4>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<div class=\"wrap-select\">\n\t\t\t\t\t\t<select #school (change)=\"activateTab(school.value)\">\n\t\t\t\t\t\t\t<option *ngFor=\"let school of schools\" value={{school.value}}>{{school.name}}</option>\n\t\t\t\t\t\t</select>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n        <form #registerForm=\"ngForm\" *ngIf=\"selectedTab == 1\">\n\t\t\t<!-- Alert Box -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<alert-box [message]=\"message\" [type]=\"messageType\"></alert-box>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Email Input Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"email\">Please type the email you registered with AIS</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Email\" id=\"email\" name=\"email\" \n\t\t\t\t\t\t\t[(ngModel)]=\"credential.email\" #email=\"ngModel\" required pattern=\"^\\w+([\\.-]?\\w+)*@\\w+([\\.-]?\\w+)*(\\.\\w{2,3})+$\">\n\t\t\t\t\t<div [hidden]=\"email.valid || email.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tPlease enter a valid email address.\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Submit Button -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n            \t\t<button type=\"submit\" [disabled]=\"!registerForm.form.valid || formSubmitted\" (click)=\"onSubmit()\">Register</button>\n\t\t\t\t</div>\n\t\t\t</div>\n        </form>\n\t\t\n        <form #registerNonAisForm=\"ngForm\" *ngIf=\"selectedTab == 2\">\n\t\t\t<!-- Alert Box -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<alert-box [message]=\"message\" [type]=\"messageType\"></alert-box>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Email Input Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<h3 class=\"fz1125\">Parent Details</h3>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"relationship\">Relationship to student</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Type your Relationship to student\" id=\"nonais-relationship\" name=\"nonais-relationship\" required [(ngModel)]=\"nonAisParent.relationship\"\n\t\t\t\t\t #nonaisRelationship=\"ngModel\" required>\n\t\t\t\t\t<div [hidden]=\"nonaisRelationship.valid || nonaisRelationship.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tRelationship is required.\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"family-name\">Family Name</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Type your Family Name\" id=\"nonais-family-name\" name=\"nonais-family-name\" required [(ngModel)]=\"nonAisParent.family_name\"\n\t\t\t\t\t #nonaisFamilyName=\"ngModel\" required>\n\t\t\t\t\t<div [hidden]=\"nonaisFamilyName.valid || nonaisFamilyName.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tFamily Name is required.\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\n\t\t\t</div>\n\t\t\t<!-- Email Input Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"given-name\">Given Name</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Type your Given Name\" id=\"nonais-given-name\" name=\"nonais-given-name\" required\n\t\t\t\t\t\t[(ngModel)]=\"nonAisParent.given_name\" #nonaisGivenName=\"ngModel\" required>\n\t\t\t\t\t<div [hidden]=\"nonaisGivenName.valid || nonaisGivenName.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tGiven Name is required.\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Email Input Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"nonais-email\">Email</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Email\" id=\"nonais-email\" name=\"nonais-email\" \n\t\t\t\t\t\t\t[(ngModel)]=\"nonAisParent.email\" #nonaisEmail=\"ngModel\" required pattern=\"^\\w+([\\.-]?\\w+)*@\\w+([\\.-]?\\w+)*(\\.\\w{2,3})+$\">\n\t\t\t\t\t<div [hidden]=\"nonaisEmail.valid || nonaisEmail.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tPlease enter a valid email address.\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Phone Number Input Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"phone\">Phone Number</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"No international phone number please\" id=\"nonais-phone\" name=\"nonais-phone\"\n\t\t\t\t\t\t[(ngModel)]=\"nonAisParent.phone\" #nonaisPhone=\"ngModel\" required>\n\t\t\t\t\t<div [hidden]=\"nonaisPhone.valid || nonaisPhone.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tPhone number is required.\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n           \n\t\t\t<!-- Submit Button -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<button type=\"submit\" name=\"submit\" (click)=\"onSubmitNonAis()\" [disabled]=\"!registerNonAisForm.form.valid || formSubmitted\">Register</button>\n\t\t\t\t</div>\n\t\t\t</div>\n        </form>\n    </div>\n</div>";

/***/ }),
/* 131 */
/***/ (function(module, exports) {

	module.exports = ".fz1125{font-size:1.125rem;margin-bottom:0.5rem}select{border:1px solid #dddddd;border-radius:0.2rem;-moz-border-radius:0.2rem;-webkit-border-radius:0.2rem;box-sizing:border-box;width:100%;height:2.4375rem;border:1px solid #cacaca;margin:0 0 1rem;font-family:inherit;font-size:1rem;color:#616060;background-color:#fefefe}h4{font-size:1rem;padding:1rem 0;color:#043d7a;text-align:left}.tabs{margin-bottom:-7px;position:relative;z-index:29;border-top-right-radius:5px;border-top-left-radius:5px;border:none}.tabs li{width:50%}.tabs li a{background:#043d7a;color:#fff;font-weight:normal;font-size:1rem}.tabs li:first-child{border-top-left-radius:5px}.tabs li:last-child{border-top-right-radius:5px}.tabs li>.is-active{background:#fff;color:#043d7a;font-weight:bold;border-top-right-radius:5px;border-top-left-radius:5px}#user-register-component{padding:1rem}#user-register-component .component-title{margin:3rem auto;width:31.25%;color:#fff;text-align:center}#user-register-component .component-content{margin:3rem auto;width:31.25%;background:#fff;border-radius:0.5rem;padding-bottom:1.5rem}#user-register-component .component-content .top-content h3{padding:1rem;background:#043d7a;color:#fff;border-top-right-radius:6px;border-top-left-radius:6px}#user-register-component .component-content form{padding:0 1rem;box-shadow:none}#user-register-component .component-content form .terms-conditions{font-size:0.65rem;font-weight:bold;text-align:center}#user-register-component .component-content form button{width:100%}@media (min-width: 1025px){#user-register-component .component-title{max-width:400px}#user-register-component .component-content{max-width:400px}}@media (min-width: 768px) and (max-width: 1024px){#user-register-component .component-title{width:50%;max-width:400px}#user-register-component .component-content{width:50%;max-width:400px}}@media (min-width: 320px) and (max-width: 767px){#user-register-component{padding:0}#user-register-component .component-title{display:none}#user-register-component .component-content{margin:0;width:100%}#user-register-component .component-content form{border:none;border-radius:0rem}}\n"

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	//Services
	var RegisterService_1 = __webpack_require__(128);
	var HolChoosePasswordComponent = (function () {
	    function HolChoosePasswordComponent(router, route, registerService) {
	        this.router = router;
	        this.route = route;
	        this.registerService = registerService;
	        this.redirectUrl = "hol-login";
	        this.formSubmitted = false;
	    }
	    HolChoosePasswordComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        // Get token string from URL.
	        this.route.params.forEach(function (params) {
	            _this.recovery = params['recovery'];
	        });
	        // Verify if recpvery is valid or not.
	        // this.verifyRecovery();
	    };
	    // Called when user submit form
	    HolChoosePasswordComponent.prototype.onSubmit = function () {
	        // Mark form as submitted to disable submit button
	        this.formSubmitted = true;
	        // Reset form alert message 
	        this.message = "";
	        this.messageType = "";
	        // Process set new password
	        this.setNewPassword();
	    };
	    HolChoosePasswordComponent.prototype.setNewPassword = function () {
	        var _this = this;
	        this.registerService.setPasswordWithActivationRecovery(this.recovery, this.oldEmail, this.newPassword)
	            .subscribe(function (complete) {
	            _this.message = "Set password successfully. You will be redirected to Login Page in 5 seconds.";
	            _this.messageType = "success";
	            // Delay 5s before redirect to login page
	            setTimeout(function () {
	                _this.redirect();
	            }, 5000);
	        }, function (error) {
	            if (error.json().message == 'parent-invalid') {
	                _this.message = "The email address is invalid";
	            }
	            if (error.json().message == 'recovery-invalid') {
	                _this.message = "The password was already set up";
	            }
	            _this.messageType = "alert";
	            _this.formSubmitted = false;
	        });
	    };
	    HolChoosePasswordComponent.prototype.redirect = function () {
	        // Redirect to stored url
	        this.router.navigate([this.redirectUrl]);
	    };
	    return HolChoosePasswordComponent;
	}());
	HolChoosePasswordComponent = __decorate([
	    core_1.Component({
	        selector: 'user-set-password',
	        template: __webpack_require__(133),
	        styles: [__webpack_require__(134)],
	    }),
	    __metadata("design:paramtypes", [router_1.Router,
	        router_1.ActivatedRoute,
	        RegisterService_1.RegisterService])
	], HolChoosePasswordComponent);
	exports.HolChoosePasswordComponent = HolChoosePasswordComponent;


/***/ }),
/* 133 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"user-choose-password-component\" class=\"eca-background\">\n\t<div class=\"component-title\">\n\t\t<h1>WELCOME TO AIS</h1>\n\t</div>\n\t<div class=\"component-content\">\n\t\t<form (ngSubmit)=\"onSubmit()\" #forgotPasswordForm=\"ngForm\">\n\t\t\t<h3 class=\"text-center\">Set new password</h3>\n\t\t\t<!-- Alert Box -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<alert-box [message]=\"message\" [type]=\"messageType\"></alert-box>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Email Input Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"email\">Please Re-type the email</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Email\" id=\"email\" name=\"email\" \n\t\t\t\t\t\t\t[(ngModel)]=\"oldEmail\" #email=\"ngModel\" required>\n\t\t\t\t\t<!--<div [hidden]=\"email.valid || email.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tEmail is required.\n\t\t\t\t\t</div>-->\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t\n\t\t\t<!-- Password Input Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"password\">New Password</label>\n\t\t\t\t\t<input type=\"password\" placeholder=\"Type your new password\" id=\"password\" \n\t\t\t\t\t\t[(ngModel)]=\"newPassword\" name=\"password\" #password=\"ngModel\" required minlength=\"6\">\n\t\t\t\t\t<div [hidden]=\"password.valid || password.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tPassword is required and must have at least 6 characters.\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Confirm Password Input Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"confirm-password\">Confirm New Password</label>\n\t\t\t\t\t<input type=\"password\" placeholder=\"Confirm your new password\" id=\"confirm-password\" \n\t\t\t\t\t\t[(ngModel)]=\"confirmNewPassword\" name=\"confirm-password\" #confirmPassword=\"ngModel\" required minlength=\"6\">\n\t\t\t\t\t<div [hidden]=\"confirmPassword.value === password.value || confirmPassword.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tConfirm Password must match with the new password.\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Submit Button -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<button type=\"submit\" name=\"submit\" [disabled]=\"!forgotPasswordForm.form.valid || formSubmitted\">Submit</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</form>\n\t</div>\n</div>";

/***/ }),
/* 134 */
/***/ (function(module, exports) {

	module.exports = "#user-choose-password-component{padding:1rem}#user-choose-password-component .component-title{margin:3rem auto;width:31.25%;color:#fff;text-align:center}#user-choose-password-component .component-content{margin:3rem auto;width:31.25%}#user-choose-password-component .component-content form button{width:100%}@media (min-width: 1025px){#user-choose-password-component .component-title{max-width:450px}#user-choose-password-component .component-content{max-width:450px}}@media (min-width: 768px) and (max-width: 1024px){#user-choose-password-component .component-title{width:50%;max-width:450px}#user-choose-password-component .component-content{width:50%;max-width:450px}}@media (min-width: 320px) and (max-width: 767px){#user-choose-password-component{padding:0}#user-choose-password-component .component-title{display:none}#user-choose-password-component .component-content{margin:0;width:100%}#user-choose-password-component .component-content form{border:none;border-radius:0rem}}\n"

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var Credential_1 = __webpack_require__(124);
	var PasswordService_1 = __webpack_require__(136);
	var HolForgotPasswordComponent = (function () {
	    function HolForgotPasswordComponent(passwordService) {
	        this.passwordService = passwordService;
	        this.formSubmitted = false;
	    }
	    HolForgotPasswordComponent.prototype.ngOnInit = function () {
	        this.credential = new Credential_1.Credential('hol-parent', '', '');
	    };
	    HolForgotPasswordComponent.prototype.onSubmit = function () {
	        // Call API service to send a reset password email
	        // when user submit the email address
	        this.formSubmitted = true;
	        this.sendResetPasswordEmail(this.credential);
	    };
	    /**
	     * Call API service to send the credential and request for a reset password email.
	     * @param {Credential} - user credential
	     * @complete - Update message & messageType for display, reset credential.
	     * @error - Set message & messageType as error. Reset form submit.
	     */
	    HolForgotPasswordComponent.prototype.sendResetPasswordEmail = function (credential) {
	        var _this = this;
	        this.passwordService.sendResetPasswordEmail(credential.role, credential.email)
	            .subscribe(function (complete) {
	            _this.messageType = "success",
	                _this.message = "A reset password email had been sent.";
	            _this.formSubmitted = false;
	        }, function (error) {
	            _this.messageType = "alert";
	            _this.message = "Cannot send reset password email.";
	            _this.formSubmitted = false;
	        });
	    };
	    return HolForgotPasswordComponent;
	}());
	HolForgotPasswordComponent = __decorate([
	    core_1.Component({
	        selector: 'user-forgot-password',
	        template: __webpack_require__(137),
	        styles: [__webpack_require__(138)],
	    }),
	    __metadata("design:paramtypes", [PasswordService_1.PasswordService])
	], HolForgotPasswordComponent);
	exports.HolForgotPasswordComponent = HolForgotPasswordComponent;


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	//Libraries
	var core_1 = __webpack_require__(3);
	// Services
	var services_1 = __webpack_require__(58);
	var PasswordService = (function () {
	    function PasswordService(settingService, apiService) {
	        this.settingService = settingService;
	        this.apiService = apiService;
	        this.passwordUrl = '/password';
	        this.passwordResetUrl = '/password-resets';
	        this.apiUrl = '';
	        this.apiUrl = this.settingService.getSetting('api_service_domain');
	    }
	    /**
	     * Call API service to request for a reset password email.
	     * @param {string} role - role of the user.
	     * @param {string} email - email to send the reset password.
	     * @returns {Observable<any>} - Status code 202: Accepted.
	     */
	    PasswordService.prototype.sendResetPasswordEmail = function (role, email) {
	        var requestUrl = this.apiUrl + this.passwordResetUrl;
	        var body = JSON.stringify({
	            'role': role,
	            'email': email
	        });
	        return this.apiService.post(requestUrl, body);
	    };
	    /**
	     * Call API service to verify the token sent in the reset password email.
	     * @param {string} token - token string.
	     * @returns {Observable<any>}
	     *  - Status code 200: OK
	     *  - Status code 404: Not Found or Expired
	     */
	    PasswordService.prototype.verifyPasswordResetToken = function (token) {
	        var requestUrl = this.apiUrl + this.passwordResetUrl + "/" + token;
	        return this.apiService.get(requestUrl);
	    };
	    /**
	     * Call API service to set new password with the token sent in the reset
	     * password email.
	     * @param {string} token
	     * @param {string} password
	     * @returns {Observable<any>}
	     *  - Status code 204: Password Assigned
	     *  - Status code 404: Not Found or Expired
	     */
	    PasswordService.prototype.setPasswordWithResetToken = function (token, password) {
	        var requestUrl = this.apiUrl + this.passwordResetUrl + "/" + token;
	        // TODO: update body content
	        var body = JSON.stringify({ password: password });
	        return this.apiService.patch(requestUrl, body);
	    };
	    /**
	     * Call API service to request for new password update.
	     * @param {string} oldPassword - old password input
	     * @param {string} newPassword - new password input
	     * @returns {Observable<any>}
	     *  - Status code 204: Password Changed
	     *  - Status code 401: Unauthorized or Incorrect Password
	     */
	    PasswordService.prototype.setNewPassword = function (oldPassword, newPassword) {
	        var requestUrl = this.apiUrl + this.passwordUrl;
	        var body = JSON.stringify({
	            'old': oldPassword,
	            'new': newPassword
	        });
	        return this.apiService.post(requestUrl, body);
	    };
	    return PasswordService;
	}());
	PasswordService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [services_1.SettingService,
	        services_1.ApiService])
	], PasswordService);
	exports.PasswordService = PasswordService;


/***/ }),
/* 137 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"user-forgot-password-component\" class=\"eca-background\">\n\t<div class=\"component-title\">\n\t\t<h1>WELCOME TO AIS</h1>\n\t</div>\n\t<div class=\"component-content\">\n\t\t<form (ngSubmit)=\"onSubmit()\" #forgotPasswordForm=\"ngForm\">\n\t\t\t<h3 class=\"text-center\">Forgot your password</h3>\n\t\t\t<!-- Alert Box -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<alert-box [message]=\"message\" [type]=\"messageType\"></alert-box>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Email Input Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"email\">Email</label>\n\t\t\t\t\t<input type=\"email\" placeholder=\"Type your email to reset password\" id=\"email\" \n\t\t\t\t\t\t[(ngModel)]=\"credential.email\" name=\"email\" #email=\"ngModel\" required>\n\t\t\t\t\t<div [hidden]=\"email.valid || email.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tEmail is required.\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Submit Button -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<button type=\"submit\" name=\"submit\" [disabled]=\"!forgotPasswordForm.form.valid || formSubmitted\">Submit</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</form>\n\t</div>\n</div>";

/***/ }),
/* 138 */
/***/ (function(module, exports) {

	module.exports = "#user-forgot-password-component{padding:1rem}#user-forgot-password-component .component-title{margin:3rem auto;width:31.25%;color:#fff;text-align:center}#user-forgot-password-component .component-content{margin:3rem auto;width:31.25%}#user-forgot-password-component .component-content form button{width:100%}@media (min-width: 1025px){#user-forgot-password-component .component-title{max-width:450px}#user-forgot-password-component .component-content{max-width:450px}}@media (min-width: 768px) and (max-width: 1024px){#user-forgot-password-component .component-title{width:50%;max-width:450px}#user-forgot-password-component .component-content{width:50%;max-width:450px}}@media (min-width: 320px) and (max-width: 767px){#user-forgot-password-component{padding:0}#user-forgot-password-component .component-title{display:none}#user-forgot-password-component .component-content{margin:0;width:100%}#user-forgot-password-component .component-content form{border:none;border-radius:0rem}}\n"

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var PasswordService_1 = __webpack_require__(136);
	var HolChangePasswordComponent = (function () {
	    function HolChangePasswordComponent(passwordService, router) {
	        this.passwordService = passwordService;
	        this.router = router;
	        this.redirectUrl = "booking/students";
	        this.formSubmitted = false;
	    }
	    HolChangePasswordComponent.prototype.ngOnInit = function () {
	        this.message = "";
	        this.messageType = "";
	    };
	    HolChangePasswordComponent.prototype.onSubmit = function () {
	        // Mark form as submitted to disable submit button
	        this.formSubmitted = true;
	        // Reset form alert message 
	        this.message = "";
	        this.messageType = "";
	        this.changePassword(this.oldPassword, this.newPassword);
	    };
	    HolChangePasswordComponent.prototype.changePassword = function (oldPassword, newPassword) {
	        var _this = this;
	        this.passwordService.setNewPassword(oldPassword, newPassword)
	            .subscribe(function (complete) {
	            _this.message = "Changed password successfully. You will be redirected to Children List Page in 5 seconds.";
	            _this.messageType = "success";
	            // Delay 5s before redirect to children list page
	            setTimeout(function () {
	                _this.redirect(_this.redirectUrl);
	            }, 5000);
	        }, function (error) {
	            _this.message = "Invalid old password input.";
	            _this.messageType = "alert";
	            _this.formSubmitted = false;
	        });
	    };
	    HolChangePasswordComponent.prototype.redirect = function (redirectUrl) {
	        this.router.navigate([redirectUrl]);
	    };
	    return HolChangePasswordComponent;
	}());
	HolChangePasswordComponent = __decorate([
	    core_1.Component({
	        selector: 'user-change-password',
	        template: __webpack_require__(140),
	        styles: [__webpack_require__(141)],
	    }),
	    __metadata("design:paramtypes", [PasswordService_1.PasswordService,
	        router_1.Router])
	], HolChangePasswordComponent);
	exports.HolChangePasswordComponent = HolChangePasswordComponent;


/***/ }),
/* 140 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"user-change-password-component\" class=\"eca-background\">\n\t<div class=\"component-title\"></div>\n\t<div class=\"component-content\">\n\t\t<form (ngSubmit)=\"onSubmit()\" #changePasswordForm=\"ngForm\">\n\t\t\t<h3 class=\"text-center\">Change password</h3>\n\t\t\t<!-- Alert Box -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<alert-box [message]=\"message\" [type]=\"messageType\"></alert-box>\n\t\t\t\t</div>\n\t\t\t</div>\n            <!-- Old Password Input Field -->\n            <div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"old-password\">Old Password</label>\n\t\t\t\t\t<input type=\"password\" placeholder=\"Type your current password\" id=\"old-password\" name=\"oldPassword\"\n\t\t\t\t\t\t[(ngModel)]=\"oldPassword\" #oldPasswordControl=\"ngModel\" required minlength=\"6\">\n\t\t\t\t\t<div [hidden]=\"oldPasswordControl.valid || oldPasswordControl.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tThis field is required and must be at least 6 characters long.\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- New Password Input Field -->\n            <div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"new-password\">New Password</label>\n\t\t\t\t\t<input type=\"password\" placeholder=\"Type your new password\" id=\"new-password\" name=\"newPassword\"\n\t\t\t\t\t\t[(ngModel)]=\"newPassword\" #newPasswordControl=\"ngModel\" required minlength=\"6\">\n\t\t\t\t\t<div [hidden]=\"newPasswordControl.valid || newPasswordControl.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tThis field is required and must be at least 6 characters long.\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Confirm Password Input Field -->\n            <div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"confirm-new-password\">Confirm New Password</label>\n\t\t\t\t\t<input type=\"password\" placeholder=\"Confirm your new password\" id=\"confirm-new-password\" name=\"confirmNewPassword\" \n\t\t\t\t\t\t[(ngModel)]=\"confirmNewPassword\" #confirmNewPasswordControl=\"ngModel\" required>\n\t\t\t\t\t<div [hidden]=\"confirmNewPasswordControl.value === newPasswordControl.value || confirmNewPasswordControl.pristine\" \n\t\t\t\t\t\tclass=\"help-text text-alert\">\n\t\t\t\t\t\tConfirm password does not matched.\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Submit Button -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<button type=\"submit\" name=\"submit\" [disabled]=\"!changePasswordForm.form.valid || formSubmitted\">Submit</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</form>\n\t</div>\n</div>";

/***/ }),
/* 141 */
/***/ (function(module, exports) {

	module.exports = "#user-change-password-component{padding:1rem}#user-change-password-component .component-title{margin:3rem auto;width:31.25%;color:#fff;text-align:center}#user-change-password-component .component-content{margin:3rem auto;width:31.25%}#user-change-password-component .component-content form button{width:100%}@media (min-width: 1025px){#user-change-password-component .component-title{max-width:450px}#user-change-password-component .component-content{max-width:450px}}@media (min-width: 768px) and (max-width: 1024px){#user-change-password-component .component-title{width:50%;max-width:450px}#user-change-password-component .component-content{width:50%;max-width:450px}}@media (min-width: 320px) and (max-width: 767px){#user-change-password-component{padding:0}#user-change-password-component .component-title{display:none}#user-change-password-component .component-content{margin:0;width:100%}#user-change-password-component .component-content form{border:none;border-radius:0rem}}\n"

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var PasswordService_1 = __webpack_require__(136);
	var HolSetNewPasswordComponent = (function () {
	    function HolSetNewPasswordComponent(router, route, passwordService) {
	        this.router = router;
	        this.route = route;
	        this.passwordService = passwordService;
	        this.redirectUrl = "hol-login";
	        this.formSubmitted = false;
	    }
	    HolSetNewPasswordComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        // Get token string from URL.
	        this.route.params.forEach(function (params) {
	            _this.token = params['token'];
	        });
	        // Verify if token is valid or not.
	        this.verifyToken();
	    };
	    // Called when user submit form
	    HolSetNewPasswordComponent.prototype.onSubmit = function () {
	        // Mark form as submitted to disable submit button
	        this.formSubmitted = true;
	        // Reset form alert message 
	        this.message = "";
	        this.messageType = "";
	        // Process set new password
	        this.setNewPassword(this.token, this.newPassword);
	    };
	    // Verify reset password token with servie
	    HolSetNewPasswordComponent.prototype.verifyToken = function () {
	        var _this = this;
	        this.passwordService.verifyPasswordResetToken(this.token)
	            .subscribe(function (complete) {
	            _this.formSubmitted = false;
	        }, function (error) {
	            // Set message type as error and message error content
	            _this.message = "Token not found or expired.";
	            _this.messageType = "alert";
	            // Set form as submitted to prevent user post their new password
	            _this.formSubmitted = true;
	        });
	    };
	    // Set new password with new password input and verified token
	    HolSetNewPasswordComponent.prototype.setNewPassword = function (token, newPassword) {
	        var _this = this;
	        this.passwordService.setPasswordWithResetToken(token, newPassword)
	            .subscribe(function (complete) {
	            // Update message on success
	            _this.message = "Changed password successfully. You will be redirected to Login Page in 5 seconds.";
	            _this.messageType = "success";
	            // Delay 5s before redirect to login page
	            setTimeout(function () {
	                _this.redirect(_this.redirectUrl);
	            }, 5000);
	        }, function (error) {
	            // Set message type as error and error message content
	            _this.message = "There is an issue when setting new password.";
	            _this.messageType = "alert";
	            // Reset form submit status
	            _this.formSubmitted = false;
	        });
	    };
	    // Redirect to desired url
	    HolSetNewPasswordComponent.prototype.redirect = function (url) {
	        this.router.navigate([this.redirectUrl]);
	    };
	    return HolSetNewPasswordComponent;
	}());
	HolSetNewPasswordComponent = __decorate([
	    core_1.Component({
	        selector: 'user-set-new-password',
	        template: __webpack_require__(143),
	        styles: [__webpack_require__(144)],
	    }),
	    __metadata("design:paramtypes", [router_1.Router,
	        router_1.ActivatedRoute,
	        PasswordService_1.PasswordService])
	], HolSetNewPasswordComponent);
	exports.HolSetNewPasswordComponent = HolSetNewPasswordComponent;


/***/ }),
/* 143 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"user-set-new-password-component\" class=\"eca-background\">\n\t<div class=\"component-title\">\n\t\t<h1>WELCOME TO AIS</h1>\n\t</div>\n\t<div class=\"component-content\">\n\t\t<form (ngSubmit)=\"onSubmit()\" #forgotPasswordForm=\"ngForm\">\n\t\t\t<h3 class=\"text-center\">Set new password</h3>\n\t\t\t<!-- Alert Box -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<alert-box [message]=\"message\" [type]=\"messageType\"></alert-box>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Password Input Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"password\">New Password</label>\n\t\t\t\t\t<input type=\"password\" placeholder=\"Type your new password\" id=\"password\" \n\t\t\t\t\t\t[(ngModel)]=\"newPassword\" name=\"password\" #password=\"ngModel\" required minlength=\"6\">\n\t\t\t\t\t<div [hidden]=\"password.valid || password.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tPassword is required and must have at least 6 characters.\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Confirm Password Input Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"confirm-password\">Confirm New Password</label>\n\t\t\t\t\t<input type=\"password\" placeholder=\"Confirm your new password\" id=\"confirm-password\" \n\t\t\t\t\t\t[(ngModel)]=\"confirmNewPassword\" name=\"confirm-password\" #confirmPassword=\"ngModel\" required minlength=\"6\">\n\t\t\t\t\t<div [hidden]=\"confirmPassword.value === password.value || confirmPassword.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tConfirm Password must match with the new password.\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Submit Button -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<button type=\"submit\" name=\"submit\" [disabled]=\"!forgotPasswordForm.form.valid || formSubmitted\">Submit</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</form>\n\t</div>\n</div>";

/***/ }),
/* 144 */
/***/ (function(module, exports) {

	module.exports = "#user-set-new-password-component{padding:1rem}#user-set-new-password-component .component-title{margin:3rem auto;width:31.25%;color:#fff;text-align:center}#user-set-new-password-component .component-content{margin:3rem auto;width:31.25%}#user-set-new-password-component .component-content form button{width:100%}@media (min-width: 1025px){#user-set-new-password-component .component-title{max-width:450px}#user-set-new-password-component .component-content{max-width:450px}}@media (min-width: 768px) and (max-width: 1024px){#user-set-new-password-component .component-title{width:50%;max-width:450px}#user-set-new-password-component .component-content{width:50%;max-width:450px}}@media (min-width: 320px) and (max-width: 767px){#user-set-new-password-component{padding:0}#user-set-new-password-component .component-title{display:none}#user-set-new-password-component .component-content{margin:0;width:100%}#user-set-new-password-component .component-content form{border:none;border-radius:0rem}}\n"

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	// Services
	var HolidayService_1 = __webpack_require__(86);
	var SessionService_1 = __webpack_require__(85);
	var UserService_1 = __webpack_require__(84);
	var Credential_1 = __webpack_require__(124);
	var LoginComponent = (function () {
	    function LoginComponent(holidayService, sessionService, userService, router) {
	        this.holidayService = holidayService;
	        this.sessionService = sessionService;
	        this.userService = userService;
	        this.router = router;
	        this.formSubmitted = false;
	        this.holidayDomain = ['holiday.eca.dev.nascorp.vn', 'holiday.eca.test.nascorp.vn', 'holidayschool.eca.uat.nascorp.vn', 'holidayschool.aisvietnam.com', 'holiday.local.eca.nascorp.vn'];
	    }
	    LoginComponent.prototype.ngOnInit = function () {
	        // this.redirectUrl = '/booking/students';
	        this.redirectUrl = '/parents';
	        this.credential = new Credential_1.Credential('parent', '', '');
	        // Use Session Service to get session and check if user had already logged in.
	        this.getSession();
	        this.hostName = window.location.hostname;
	    };
	    ;
	    LoginComponent.prototype.onSubmit = function () {
	        this.formSubmitted = true;
	        // Reset message content
	        this.message = "";
	        // Post user login data to create session
	        this.postSession(this.credential);
	    };
	    /**
	     * Get Session from API service to make sure that user had logged in.
	     * Update User Data on local storage and redirect to the desired URL
	     * if request responses session data.
	     * @param none
	     * @return none
	     */
	    LoginComponent.prototype.getSession = function () {
	        var _this = this;
	        this.sessionService.getSession()
	            .subscribe(function (user) {
	            _this.userService.setUserSessionData(user);
	            _this.redirect(_this.redirectUrl);
	        }, function (error) {
	            //TO DO: Handle any error if needed in the furture
	            _this.message = "";
	            _this.messageType = "alert";
	        });
	    };
	    /**
	     * Post Session to API service to create new session.
	     * Update User Data on local storage and redirect to desired URL
	     * if request responses session data.
	     * @param {Credential} - user credential input
	     * @return none
	     */
	    LoginComponent.prototype.postSession = function (credential) {
	        var _this = this;
	        this.sessionService.postSession(credential)
	            .subscribe(function (user) {
	            // Set user session data
	            _this.userService.setUserSessionData(user);
	            // Fire user session data changed event
	            _this.userService.userDataChanged(user);
	            // Redirect to desired URL
	            _this.redirect(_this.redirectUrl);
	        }, function (error) {
	            _this.formSubmitted = false;
	            _this.message = "Invalid email address or password.";
	            _this.messageType = "alert";
	        });
	    };
	    // Redirect to desired url
	    LoginComponent.prototype.redirect = function (redirectUrl) {
	        this.router.navigate([redirectUrl]);
	    };
	    return LoginComponent;
	}());
	LoginComponent = __decorate([
	    core_1.Component({
	        selector: 'user-login',
	        template: __webpack_require__(146),
	        styles: [__webpack_require__(147)],
	    }),
	    __metadata("design:paramtypes", [HolidayService_1.HolidayService,
	        SessionService_1.SessionService,
	        UserService_1.UserService,
	        router_1.Router])
	], LoginComponent);
	exports.LoginComponent = LoginComponent;


/***/ }),
/* 146 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"user-login-component\" class=\"eca-background\">\n    <div class=\"component-title\">\n        <h1>WELCOME TO AIS</h1>\n    </div>\n    <div class=\"component-content\">\n        <form (ngSubmit)=\"onSubmit()\" #loginForm=\"ngForm\">\n\t\t\t<!-- Form Title -->\n            <h3 class=\"text-center\">Login to your account</h3>\n\t\t\t<!-- Alert Box -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<alert-box [message]=\"message\" [type]=\"messageType\"></alert-box>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Email Input Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"email\">Email</label>\n\t\t\t\t\t<input type=\"email\" placeholder=\"Type your email address\" id=\"email\" \n\t\t\t\t\t\t[(ngModel)]=\"credential.email\" name=\"email\" #email=\"ngModel\" required>\n\t\t\t\t\t<div [hidden]=\"email.valid || email.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tEmail is required.\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Password Input Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"password\">Password</label>\n\t\t\t\t\t<input type=\"password\" placeholder=\"Type your password\" id=\"password\" \n\t\t\t\t\t\t[(ngModel)]=\"credential.password\" name=\"password\" #password=\"ngModel\" required>\n\t\t\t\t\t<div [hidden]=\"password.valid || password.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tPassword is required.\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Remember Me & Forgot Password -->\n            <div class=\"row\">\n\t\t\t\t<div class=\"medium-6 columns remember-block\">\n\t\t\t\t\t<a target=\"_blank\" href=\"https://services.aisvietnam.com/upload/AIS-Service-GuidelineforParents.pdf\" class=\"forgot-password text-left\">Guideline</a>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"medium-6 columns\">\n\t\t\t\t\t<a routerLink=\"/forgot-password\" class=\"forgot-password text-right\">Forgot Password?</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Submit Button -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<button type=\"submit\" name=\"submit\" [disabled]=\"!loginForm.form.valid || formSubmitted\">Login</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Register Link -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n            \t\t<label class=\"register-link\">Do not have an account yet? <a routerLink=\"/register\">REGISTER NOW</a></label>\n\t\t\t\t</div>\n\t\t\t</div>\n        </form>\n    </div>\n</div>";

/***/ }),
/* 147 */
/***/ (function(module, exports) {

	module.exports = ".tabs{margin-bottom:-7px;position:relative;z-index:29;border-top-right-radius:5px;border-top-left-radius:5px;border:none}.tabs li{width:50%}.tabs li a{background:#043d7a;color:#fff;font-weight:normal;font-size:1rem}.tabs li:first-child{border-top-left-radius:5px}.tabs li:last-child{border-top-right-radius:5px}.tabs li>.is-active{background:#fff;color:#043d7a;font-weight:bold;border-top-right-radius:5px;border-top-left-radius:5px}#user-login-component{padding:1rem}#user-login-component .component-title{margin:3rem auto;width:31.25%;color:#fff;text-align:center}#user-login-component .component-content{margin:3rem auto;width:31.25%}#user-login-component .component-content form div.remember-block{position:relative;font-size:0.8rem;margin-bottom:0.5rem}#user-login-component .component-content form div.remember-block input[type=\"checkbox\"]{position:absolute;height:1.1rem;width:1.1rem;top:0.5rem;cursor:pointer}#user-login-component .component-content form div.remember-block label{margin-left:1.5rem}#user-login-component .component-content form .register-link{font-size:0.65rem;font-weight:bold;text-align:center}#user-login-component .component-content form .forgot-password{display:block;font-size:0.8rem}#user-login-component .component-content form button:not(.close-button){width:100%}#user-login-component .component-content form button.close-button{line-height:1.2}@media (min-width: 1025px){#user-login-component .component-title{max-width:450px}#user-login-component .component-content{max-width:450px}}@media (min-width: 768px) and (max-width: 1024px){#user-login-component .component-title{width:50%;max-width:450px}#user-login-component .component-content{width:50%;max-width:450px}}@media (min-width: 320px) and (max-width: 767px){#user-login-component{padding:0}#user-login-component .component-title{display:none}#user-login-component .component-content{margin:0;width:100%}#user-login-component .component-content form{border:none;border-radius:0rem}}\n"

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	// Services
	var SessionService_1 = __webpack_require__(85);
	var UserService_1 = __webpack_require__(84);
	var services_1 = __webpack_require__(58);
	var AdminService_1 = __webpack_require__(87);
	var LogoutComponent = (function () {
	    function LogoutComponent(router, sessionService, localStorageService, userService, adminService) {
	        this.router = router;
	        this.sessionService = sessionService;
	        this.localStorageService = localStorageService;
	        this.userService = userService;
	        this.adminService = adminService;
	        // For logout navigate
	        this.devEnv = ['camp.eca.dev.nascorp.vn', 'asa.eca.dev.nascorp.vn', 'holiday.eca.dev.nascorp.vn', 'bus.eca.dev.nascorp.vn', 'reen.eca.dev.nascorp.vn'];
	        this.testEnv = ['camp.eca.test.nascorp.vn', 'asa.eca.test.nascorp.vn', 'holiday.eca.test.nascorp.vn', 'bus.eca.test.nascorp.vn', 'reen.eca.test.nascorp.vn'];
	        this.stagingEnv = ['auth.eca.uat.nascorp.vn', 'services.eca.uat.nascorp.vn', 'asa.eca.uat.nascorp.vn', 'holidayschool.eca.uat.nascorp.vn', 'bus.eca.uat.nascorp.vn', 'outdooreducation.eca.uat.nascorp.vn', 'reen.eca.uat.nascorp.vn', 'acs.eca.uat.nascorp.vn', 'pcbs.eca.uat.nascorp.vn'];
	        this.procEnv = ['outdooreducation.aisvietnam.com', 'asa.aisvietnam.com', 'holidayschool.aisvietnam.com', 'bus.aisvietnam.com', 'reen.aisvietnam.com'];
	    }
	    LogoutComponent.prototype.ngOnInit = function () {
	        this.hostName = window.location.hostname;
	        // Delete session from system
	        this.deleteSession();
	    };
	    /**
	     * Delete user session data.
	     */
	    LogoutComponent.prototype.deleteSession = function () {
	        var _this = this;
	        this.sessionService.deleteSession()
	            .subscribe(function (complete) {
	            // Clear user session
	            _this.userService.clearUserSessionData();
	            _this.adminService.clearInterSession();
	            // Fire user session data changed event
	            _this.userService.userDataChanged(null);
	            // Redirect to desired URL                    
	            if (_this.devEnv.indexOf(_this.hostName) !== -1) {
	                return window.location.href = 'http://services.eca.dev.nascorp.vn';
	            }
	            else if (_this.testEnv.indexOf(_this.hostName) !== -1) {
	                return window.location.href = 'http://services.eca.test.nascorp.vn';
	            }
	            else if (_this.stagingEnv.indexOf(_this.hostName) !== -1) {
	                return window.location.href = 'http://services.eca.uat.nascorp.vn';
	            }
	            else if (_this.procEnv.indexOf(_this.hostName) !== -1) {
	                return window.location.href = 'https://services.aisvietnam.com';
	            }
	            else {
	                return window.location.href = 'http://services.local.eca.dev.nascorp.vn';
	            }
	        }, function (error) { return _this.errorMessage = error; });
	    };
	    // Redirect to desired url
	    LogoutComponent.prototype.redirect = function (redirectUrl) {
	        this.router.navigate([redirectUrl]);
	    };
	    return LogoutComponent;
	}());
	LogoutComponent = __decorate([
	    core_1.Component({
	        selector: 'user-logout',
	        template: '',
	        styles: [],
	    }),
	    __metadata("design:paramtypes", [router_1.Router,
	        SessionService_1.SessionService,
	        services_1.LocalStorageService,
	        UserService_1.UserService,
	        AdminService_1.AdminService])
	], LogoutComponent);
	exports.LogoutComponent = LogoutComponent;


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	//Libraries
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	// Services
	var SessionService_1 = __webpack_require__(85);
	var UserService_1 = __webpack_require__(84);
	var RegisterService_1 = __webpack_require__(128);
	//Models
	var Credential_1 = __webpack_require__(124);
	var NonAisParent_1 = __webpack_require__(129);
	var RegisterComponent = (function () {
	    function RegisterComponent(sessionService, userService, registerService, router) {
	        this.sessionService = sessionService;
	        this.userService = userService;
	        this.registerService = registerService;
	        this.router = router;
	        this.formSubmitted = false;
	    }
	    RegisterComponent.prototype.ngOnInit = function () {
	        this.redirectUrl = '/booking/students';
	        this.selectedTab = 1;
	        this.nonAisParent = new NonAisParent_1.NonAisParent();
	        this.credential = new Credential_1.Credential('parent', '', '');
	        // Use Session Service to get session and check if user had already logged in.
	        this.getSession();
	    };
	    RegisterComponent.prototype.onSubmit = function () {
	        this.formSubmitted = true;
	        // Reset message content
	        this.message = "";
	        // Post user login data to create session
	        this.register(this.credential);
	    };
	    /**
	     * Get Session from API service to make sure that user had logged in.
	     * Update User Data on local storage and redirect to the desired URL
	     * if request responses session data.
	     * @param none
	     * @return none
	     */
	    RegisterComponent.prototype.getSession = function () {
	        var _this = this;
	        this.sessionService.getSession()
	            .subscribe(function (user) {
	            _this.userService.setUserSessionData(user);
	            _this.redirect();
	        }, function (error) {
	            //TO DO: Handle any error if needed in the furture
	            _this.message = "";
	            _this.messageType = "alert";
	        });
	    };
	    RegisterComponent.prototype.register = function (credential) {
	        var _this = this;
	        this.registerService.postActivationEmail(credential.role, credential.email)
	            .subscribe(function (complete) {
	            _this.messageType = "success",
	                _this.message = "An activation email had been sent.";
	            _this.formSubmitted = false;
	        }, function (error) {
	            _this.messageType = "alert";
	            _this.message = "Please input the email you provided to AIS.";
	            _this.formSubmitted = false;
	        });
	    };
	    RegisterComponent.prototype.registerNonAis = function (nonAisParent) {
	        var _this = this;
	        this.registerService.postNoneAisAccount(nonAisParent)
	            .subscribe(function (complete) {
	            _this.messageType = "success",
	                _this.message = "An activation email had been sent.";
	            _this.formSubmitted = false;
	        }, function (error) {
	            _this.messageType = "alert";
	            _this.message = "Please input the email you provided to AIS.";
	            _this.formSubmitted = false;
	        });
	    };
	    RegisterComponent.prototype.redirect = function () {
	        // Redirect to stored url
	        this.router.navigate([this.redirectUrl]);
	    };
	    return RegisterComponent;
	}());
	RegisterComponent = __decorate([
	    core_1.Component({
	        selector: 'user-register',
	        template: __webpack_require__(150),
	        styles: [__webpack_require__(151)]
	    }),
	    __metadata("design:paramtypes", [SessionService_1.SessionService,
	        UserService_1.UserService,
	        RegisterService_1.RegisterService,
	        router_1.Router])
	], RegisterComponent);
	exports.RegisterComponent = RegisterComponent;


/***/ }),
/* 150 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"user-register-component\" class=\"eca-background\">\n    <div class=\"component-title\">\n        <h1>WELCOME TO AIS</h1>\n    </div>\n    <div class=\"component-content\">\n        <form #registerForm=\"ngForm\">\n\t\t\t<!-- Form Title -->\n            <h3 class=\"text-center\">Register Account</h3>\n\t\t\t<!-- Alert Box -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<alert-box [message]=\"message\" [type]=\"messageType\"></alert-box>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Email Input Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"email\">Please type the email you registered with AIS</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Email\" id=\"email\" name=\"email\" \n\t\t\t\t\t\t\t[(ngModel)]=\"credential.email\" #email=\"ngModel\" required>\n\t\t\t\t\t<div [hidden]=\"email.valid || email.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tEmail is required.\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Submit Button -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n            \t\t<button type=\"submit\" [disabled]=\"!registerForm.form.valid || formSubmitted\" (click)=\"onSubmit()\">Register</button>\n\t\t\t\t</div>\n\t\t\t</div>\n        </form>\n    </div>\n</div>";

/***/ }),
/* 151 */
/***/ (function(module, exports) {

	module.exports = ".tabs{margin-bottom:-7px;position:relative;z-index:29;border-top-right-radius:5px;border-top-left-radius:5px;border:none}.tabs li{width:50%}.tabs li a{background:#043d7a;color:#fff;font-weight:normal;font-size:1rem}.tabs li:first-child{border-top-left-radius:5px}.tabs li:last-child{border-top-right-radius:5px}.tabs li>.is-active{background:#fff;color:#043d7a;font-weight:bold;border-top-right-radius:5px;border-top-left-radius:5px}#user-register-component{padding:1rem}#user-register-component .component-title{margin:3rem auto;width:31.25%;color:#fff;text-align:center}#user-register-component .component-content{margin:3rem auto;width:31.25%}#user-register-component .component-content form .terms-conditions{font-size:0.65rem;font-weight:bold;text-align:center}#user-register-component .component-content form button{width:100%}@media (min-width: 1025px){#user-register-component .component-title{max-width:400px}#user-register-component .component-content{max-width:400px}}@media (min-width: 768px) and (max-width: 1024px){#user-register-component .component-title{width:50%;max-width:400px}#user-register-component .component-content{width:50%;max-width:400px}}@media (min-width: 320px) and (max-width: 767px){#user-register-component{padding:0}#user-register-component .component-title{display:none}#user-register-component .component-content{margin:0;width:100%}#user-register-component .component-content form{border:none;border-radius:0rem}}\n"

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	//Services
	var RegisterService_1 = __webpack_require__(128);
	var ChoosePasswordComponent = (function () {
	    function ChoosePasswordComponent(router, route, registerService) {
	        this.router = router;
	        this.route = route;
	        this.registerService = registerService;
	        this.redirectUrl = "login";
	        this.formSubmitted = false;
	    }
	    ChoosePasswordComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        // Get token string from URL.
	        this.route.params.forEach(function (params) {
	            _this.token = params['token'];
	        });
	        // Verify if token is valid or not.
	        this.verifyToken();
	    };
	    // Called when user submit form
	    ChoosePasswordComponent.prototype.onSubmit = function () {
	        // Mark form as submitted to disable submit button
	        this.formSubmitted = true;
	        // Reset form alert message 
	        this.message = "";
	        this.messageType = "";
	        // Process set new password
	        this.setNewPassword();
	    };
	    ChoosePasswordComponent.prototype.verifyToken = function () {
	        var _this = this;
	        this.registerService.verifyActivationToken(this.token)
	            .subscribe(function (complete) {
	            _this.formSubmitted = false;
	        }, function (error) {
	            _this.message = "Token not found or expired.";
	            _this.messageType = "alert";
	            // Set form as submitted to prevent user post their new password
	            _this.formSubmitted = true;
	        });
	    };
	    ChoosePasswordComponent.prototype.setNewPassword = function () {
	        var _this = this;
	        this.registerService.setPasswordWithActivationToken(this.token, this.newPassword)
	            .subscribe(function (complete) {
	            _this.message = "Set password successfully. You will be redirected to Login Page in 5 seconds.";
	            _this.messageType = "success";
	            // Delay 5s before redirect to login page
	            setTimeout(function () {
	                _this.redirect();
	            }, 5000);
	        }, function (error) {
	            _this.message = "There is an issue when setting new password.";
	            _this.messageType = "alert";
	            _this.formSubmitted = false;
	        });
	    };
	    ChoosePasswordComponent.prototype.redirect = function () {
	        // Redirect to stored url
	        this.router.navigate([this.redirectUrl]);
	    };
	    return ChoosePasswordComponent;
	}());
	ChoosePasswordComponent = __decorate([
	    core_1.Component({
	        selector: 'user-set-password',
	        template: __webpack_require__(153),
	        styles: [__webpack_require__(154)],
	    }),
	    __metadata("design:paramtypes", [router_1.Router,
	        router_1.ActivatedRoute,
	        RegisterService_1.RegisterService])
	], ChoosePasswordComponent);
	exports.ChoosePasswordComponent = ChoosePasswordComponent;


/***/ }),
/* 153 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"user-choose-password-component\" class=\"eca-background\">\n\t<div class=\"component-title\">\n\t\t<h1>WELCOME TO AIS</h1>\n\t</div>\n\t<div class=\"component-content\">\n\t\t<form (ngSubmit)=\"onSubmit()\" #forgotPasswordForm=\"ngForm\">\n\t\t\t<h3 class=\"text-center\">Set new password</h3>\n\t\t\t<!-- Alert Box -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<alert-box [message]=\"message\" [type]=\"messageType\"></alert-box>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Password Input Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"password\">New Password</label>\n\t\t\t\t\t<input type=\"password\" placeholder=\"Type your new password\" id=\"password\" \n\t\t\t\t\t\t[(ngModel)]=\"newPassword\" name=\"password\" #password=\"ngModel\" required minlength=\"6\">\n\t\t\t\t\t<div [hidden]=\"password.valid || password.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tPassword is required and must have at least 6 characters.\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Confirm Password Input Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"confirm-password\">Confirm New Password</label>\n\t\t\t\t\t<input type=\"password\" placeholder=\"Confirm your new password\" id=\"confirm-password\" \n\t\t\t\t\t\t[(ngModel)]=\"confirmNewPassword\" name=\"confirm-password\" #confirmPassword=\"ngModel\" required minlength=\"6\">\n\t\t\t\t\t<div [hidden]=\"confirmPassword.value === password.value || confirmPassword.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tConfirm Password must match with the new password.\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Submit Button -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<button type=\"submit\" name=\"submit\" [disabled]=\"!forgotPasswordForm.form.valid || formSubmitted\">Submit</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</form>\n\t</div>\n</div>";

/***/ }),
/* 154 */
134,
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var Credential_1 = __webpack_require__(124);
	var PasswordService_1 = __webpack_require__(136);
	var ForgotPasswordComponent = (function () {
	    function ForgotPasswordComponent(passwordService) {
	        this.passwordService = passwordService;
	        this.formSubmitted = false;
	    }
	    ForgotPasswordComponent.prototype.ngOnInit = function () {
	        this.credential = new Credential_1.Credential('parent', '', '');
	    };
	    ForgotPasswordComponent.prototype.onSubmit = function () {
	        // Call API service to send a reset password email
	        // when user submit the email address
	        this.formSubmitted = true;
	        this.sendResetPasswordEmail(this.credential);
	    };
	    /**
	     * Call API service to send the credential and request for a reset password email.
	     * @param {Credential} - user credential
	     * @complete - Update message & messageType for display, reset credential.
	     * @error - Set message & messageType as error. Reset form submit.
	     */
	    ForgotPasswordComponent.prototype.sendResetPasswordEmail = function (credential) {
	        var _this = this;
	        this.passwordService.sendResetPasswordEmail(credential.role, credential.email)
	            .subscribe(function (complete) {
	            _this.messageType = "success",
	                _this.message = "A reset password email had been sent.";
	            _this.formSubmitted = false;
	        }, function (error) {
	            _this.messageType = "alert";
	            if (error.status && error.status == 404)
	                _this.message = 'email not exist, please contact admin for support.';
	            else
	                _this.message = "Cannot send reset password email.";
	            _this.formSubmitted = false;
	        });
	    };
	    return ForgotPasswordComponent;
	}());
	ForgotPasswordComponent = __decorate([
	    core_1.Component({
	        selector: 'user-forgot-password',
	        template: __webpack_require__(156),
	        styles: [__webpack_require__(157)],
	    }),
	    __metadata("design:paramtypes", [PasswordService_1.PasswordService])
	], ForgotPasswordComponent);
	exports.ForgotPasswordComponent = ForgotPasswordComponent;


/***/ }),
/* 156 */
137,
/* 157 */
138,
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var PasswordService_1 = __webpack_require__(136);
	var SetNewPasswordComponent = (function () {
	    function SetNewPasswordComponent(router, route, passwordService) {
	        this.router = router;
	        this.route = route;
	        this.passwordService = passwordService;
	        this.redirectUrl = "hol-login";
	        this.formSubmitted = false;
	    }
	    SetNewPasswordComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        // Get token string from URL.
	        this.route.params.forEach(function (params) {
	            _this.token = params['token'];
	        });
	        // Verify if token is valid or not.
	        this.verifyToken();
	    };
	    // Called when user submit form
	    SetNewPasswordComponent.prototype.onSubmit = function () {
	        // Mark form as submitted to disable submit button
	        this.formSubmitted = true;
	        // Reset form alert message 
	        this.message = "";
	        this.messageType = "";
	        // Process set new password
	        this.setNewPassword(this.token, this.newPassword);
	    };
	    // Verify reset password token with servie
	    SetNewPasswordComponent.prototype.verifyToken = function () {
	        var _this = this;
	        this.passwordService.verifyPasswordResetToken(this.token)
	            .subscribe(function (complete) {
	            _this.formSubmitted = false;
	        }, function (error) {
	            // Set message type as error and message error content
	            _this.message = "Token not found or expired.";
	            _this.messageType = "alert";
	            // Set form as submitted to prevent user post their new password
	            _this.formSubmitted = true;
	        });
	    };
	    // Set new password with new password input and verified token
	    SetNewPasswordComponent.prototype.setNewPassword = function (token, newPassword) {
	        var _this = this;
	        this.passwordService.setPasswordWithResetToken(token, newPassword)
	            .subscribe(function (complete) {
	            // Update message on success
	            _this.message = "Changed password successfully. You will be redirected to Login Page in 5 seconds.";
	            _this.messageType = "success";
	            // Delay 5s before redirect to login page
	            setTimeout(function () {
	                _this.redirect(_this.redirectUrl);
	            }, 5000);
	        }, function (error) {
	            // Set message type as error and error message content
	            _this.message = "There is an issue when setting new password.";
	            _this.messageType = "alert";
	            // Reset form submit status
	            _this.formSubmitted = false;
	        });
	    };
	    // Redirect to desired url
	    SetNewPasswordComponent.prototype.redirect = function (url) {
	        this.router.navigate([this.redirectUrl]);
	    };
	    return SetNewPasswordComponent;
	}());
	SetNewPasswordComponent = __decorate([
	    core_1.Component({
	        selector: 'user-set-new-password',
	        template: __webpack_require__(159),
	        styles: [__webpack_require__(160)],
	    }),
	    __metadata("design:paramtypes", [router_1.Router,
	        router_1.ActivatedRoute,
	        PasswordService_1.PasswordService])
	], SetNewPasswordComponent);
	exports.SetNewPasswordComponent = SetNewPasswordComponent;


/***/ }),
/* 159 */
143,
/* 160 */
144,
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var PasswordService_1 = __webpack_require__(136);
	var ChangePasswordComponent = (function () {
	    function ChangePasswordComponent(passwordService, router) {
	        this.passwordService = passwordService;
	        this.router = router;
	        this.redirectUrl = "booking/students";
	        this.formSubmitted = false;
	        this.devEnv = ['services.eca.dev.nascorp.vn', 'camp.eca.dev.nascorp.vn', 'asa.eca.dev.nascorp.vn', 'holiday.eca.dev.nascorp.vn', 'bus.eca.dev.nascorp.vn'];
	        this.testEnv = ['services.eca.test.nascorp.vn', 'camp.eca.test.nascorp.vn', 'asa.eca.test.nascorp.vn', 'holiday.eca.test.nascorp.vn', 'bus.eca.test.nascorp.vn'];
	        this.stagingEnv = ['auth.eca.uat.nascorp.vn', 'services.eca.uat.nascorp.vn', 'asa.eca.uat.nascorp.vn', 'holidayschool.eca.uat.nascorp.vn', 'bus.eca.uat.nascorp.vn', 'outdooreducation.eca.uat.nascorp.vn', 'reen.eca.uat.nascorp.vn', 'acs.eca.uat.nascorp.vn', 'pcbs.eca.uat.nascorp.vn'];
	        this.procEnv = ['services.aisvietnam.com', 'outdooreducation.aisvietnam.com', 'asa.aisvietnam.com', 'holidayschool.aisvietnam.com', 'bus.aisvietnam.com'];
	    }
	    ChangePasswordComponent.prototype.ngOnInit = function () {
	        this.message = "";
	        this.messageType = "";
	        this.hostName = window.location.hostname;
	        console.log(this.hostName);
	    };
	    ChangePasswordComponent.prototype.onSubmit = function () {
	        // Mark form as submitted to disable submit button
	        this.formSubmitted = true;
	        // Reset form alert message 
	        this.message = "";
	        this.messageType = "";
	        this.changePassword(this.oldPassword, this.newPassword);
	    };
	    ChangePasswordComponent.prototype.changePassword = function (oldPassword, newPassword) {
	        var _this = this;
	        this.passwordService.setNewPassword(oldPassword, newPassword)
	            .subscribe(function (complete) {
	            if (_this.devEnv.indexOf(_this.hostName) !== -1) {
	                return window.location.href = 'http://services.eca.dev.nascorp.vn/';
	            }
	            else if (_this.testEnv.indexOf(_this.hostName) !== -1) {
	                return window.location.href = 'http://services.eca.test.nascorp.vn/';
	            }
	            else if (_this.stagingEnv.indexOf(_this.hostName) !== -1) {
	                return window.location.href = 'http://services.eca.uat.nascorp.vn/';
	            }
	            else if (_this.procEnv.indexOf(_this.hostName) !== -1) {
	                return window.location.href = 'https://services.aisvietnam.com/';
	            }
	            else {
	                return window.location.href = 'http://services.local.eca.dev.nascorp.vn/';
	            }
	        }, function (error) {
	            _this.message = "Invalid old password input.";
	            _this.messageType = "alert";
	            _this.formSubmitted = false;
	        });
	    };
	    ChangePasswordComponent.prototype.redirect = function (redirectUrl) {
	        this.router.navigate([redirectUrl]);
	    };
	    return ChangePasswordComponent;
	}());
	ChangePasswordComponent = __decorate([
	    core_1.Component({
	        selector: 'user-change-password',
	        template: __webpack_require__(162),
	        styles: [__webpack_require__(163)],
	    }),
	    __metadata("design:paramtypes", [PasswordService_1.PasswordService,
	        router_1.Router])
	], ChangePasswordComponent);
	exports.ChangePasswordComponent = ChangePasswordComponent;


/***/ }),
/* 162 */
140,
/* 163 */
/***/ (function(module, exports) {

	module.exports = "#user-change-password-component{padding:1rem;margin:0.7rem}#user-change-password-component .component-title{margin:3rem auto;width:31.25%;color:#fff;text-align:center}#user-change-password-component .component-content{margin:3rem auto;width:31.25%}#user-change-password-component .component-content form button{width:100%}@media (min-width: 1025px){#user-change-password-component .component-title{max-width:450px}#user-change-password-component .component-content{max-width:450px}}@media (min-width: 768px) and (max-width: 1024px){#user-change-password-component .component-title{width:50%;max-width:450px}#user-change-password-component .component-content{width:50%;max-width:450px}}@media (min-width: 320px) and (max-width: 767px){#user-change-password-component{padding:0}#user-change-password-component .component-title{display:none}#user-change-password-component .component-content{margin:0;width:100%}#user-change-password-component .component-content form{border:none;border-radius:0rem}}\n"

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	// Services
	var SessionService_1 = __webpack_require__(85);
	var UserService_1 = __webpack_require__(84);
	var HolidayService_1 = __webpack_require__(86);
	var Parent_1 = __webpack_require__(123);
	var Credential_1 = __webpack_require__(124);
	var AddParentComponent = (function () {
	    function AddParentComponent(holidayService, sessionService, userService, router) {
	        this.holidayService = holidayService;
	        this.sessionService = sessionService;
	        this.userService = userService;
	        this.router = router;
	        this.formSubmitted = false;
	        this.parent = new Parent_1.Parent();
	    }
	    AddParentComponent.prototype.ngOnInit = function () {
	        this.redirectUrl = '/booking/students';
	        this.credential = new Credential_1.Credential('parent', '', '');
	        // Use Session Service to get session and check if user had already logged in.
	        this.getSession();
	        this.getParent();
	    };
	    ;
	    AddParentComponent.prototype.onSubmit = function () {
	        this.formSubmitted = true;
	        // Reset message content
	        this.message = "";
	        // Post user login data to create session
	        this.postSession(this.credential);
	    };
	    /**
	     * Get Session from API service to make sure that user had logged in.
	     * Update User Data on local storage and redirect to the desired URL
	     * if request responses session data.
	     * @param none
	     * @return none
	     */
	    AddParentComponent.prototype.getSession = function () {
	        var _this = this;
	        this.sessionService.getSession()
	            .subscribe(function (user) {
	            _this.userService.setUserSessionData(user);
	            _this.redirect(_this.redirectUrl);
	        }, function (error) {
	            //TO DO: Handle any error if needed in the furture
	            _this.message = "";
	            _this.messageType = "alert";
	        });
	    };
	    /**
	     * Post Session to API service to create new session.
	     * Update User Data on local storage and redirect to desired URL
	     * if request responses session data.
	     * @param {Credential} - user credential input
	     * @return none
	     */
	    AddParentComponent.prototype.postSession = function (credential) {
	        var _this = this;
	        this.sessionService.postSession(credential)
	            .subscribe(function (user) {
	            // Set user session data
	            _this.userService.setUserSessionData(user);
	            // Fire user session data changed event
	            _this.userService.userDataChanged(user);
	            // Redirect to desired URL
	            _this.router.navigate['/add-student'];
	        }, function (error) {
	            _this.formSubmitted = false;
	            _this.message = "Invalid email address or password.";
	            _this.messageType = "alert";
	        });
	    };
	    // Redirect to desired url
	    AddParentComponent.prototype.redirect = function (redirectUrl) {
	        this.router.navigate([redirectUrl]);
	    };
	    AddParentComponent.prototype.getParent = function () {
	        var _this = this;
	        this.holidayService.getParent()
	            .subscribe(function (parent) {
	            _this.parent = parent;
	            _this.router.navigate['/add-student'];
	        }, function (error) {
	            //TO DO: Handle any error if needed in the furture
	            _this.message = "";
	            _this.messageType = "alert";
	        });
	    };
	    return AddParentComponent;
	}());
	AddParentComponent = __decorate([
	    core_1.Component({
	        selector: 'add-parent',
	        template: __webpack_require__(165),
	        styles: [__webpack_require__(166)],
	    }),
	    __metadata("design:paramtypes", [HolidayService_1.HolidayService,
	        SessionService_1.SessionService,
	        UserService_1.UserService,
	        router_1.Router])
	], AddParentComponent);
	exports.AddParentComponent = AddParentComponent;


/***/ }),
/* 165 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"user-login-component\" class=\"eca-background\">\n    <div class=\"component-title\">\n        <h1>WELCOME TO AIS</h1>\n    </div>\n    <div class=\"component-content\">\n        <form (ngSubmit)=\"onSubmit()\" #loginForm=\"ngForm\">\n\t\t\t<!-- Form Title -->\n            <h3 class=\"text-center\">Parent Detail</h3>\n\t\t\t<!-- Alert Box -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<alert-box [message]=\"message\" [type]=\"messageType\"></alert-box>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Email Input Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"family-name\">Family Name</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Type your Family Name\" id=\"family-name\" name=\"family-name\" required>\n\t\t\t\t\t<!--<div [hidden]=\"email.valid || email.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tFamily Name is required.\n\t\t\t\t\t</div>-->\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Email Input Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"given-name\">Given Name</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Type your Given Name\" id=\"given-name\" name=\"given-name\" required>\n\t\t\t\t\t<!--<div [hidden]=\"email.valid || email.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tGiven Name is required.\n\t\t\t\t\t</div>-->\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Email Input Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"email\">Email</label>\n\t\t\t\t\t<input type=\"email\" placeholder=\"Type your email address\" id=\"email\" \n\t\t\t\t\t\t[(ngModel)]=\"credential.email\" name=\"email\" #email=\"ngModel\" required>\n\t\t\t\t\t<div [hidden]=\"email.valid || email.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tEmail is required.\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Phone Number Input Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"phone\">Phone Number</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Type your Phone number\" id=\"phone\" name=\"phone\" required>\n\t\t\t\t\t<!--<div [hidden]=\"password.valid || password.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tPhone number is required.\n\t\t\t\t\t</div>-->\n\t\t\t\t</div>\n\t\t\t</div>\n           \n\t\t\t<!-- Submit Button -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<button type=\"submit\" name=\"submit\" [disabled]=\"!loginForm.form.valid || formSubmitted\">Register</button>\n\t\t\t\t</div>\n\t\t\t</div>\n        </form>\n    </div>\n</div>";

/***/ }),
/* 166 */
/***/ (function(module, exports) {

	module.exports = "#user-login-component{padding:1rem}#user-login-component .component-title{margin:3rem auto;width:31.25%;color:#fff;text-align:center}#user-login-component .component-content{margin:3rem auto;width:31.25%}#user-login-component .component-content form div.remember-block{position:relative;font-size:0.8rem;margin-bottom:0.5rem}#user-login-component .component-content form div.remember-block input[type=\"checkbox\"]{position:absolute;height:1.1rem;width:1.1rem;top:0.5rem;cursor:pointer}#user-login-component .component-content form div.remember-block label{margin-left:1.5rem}#user-login-component .component-content form .register-link{font-size:0.65rem;font-weight:bold;text-align:center}#user-login-component .component-content form .forgot-password{display:block;font-size:0.8rem}#user-login-component .component-content form button:not(.close-button){width:100%}#user-login-component .component-content form button.close-button{line-height:1.2}@media (min-width: 1025px){#user-login-component .component-title{max-width:450px}#user-login-component .component-content{max-width:450px}}@media (min-width: 768px) and (max-width: 1024px){#user-login-component .component-title{width:50%;max-width:450px}#user-login-component .component-content{width:50%;max-width:450px}}@media (min-width: 320px) and (max-width: 767px){#user-login-component{padding:0}#user-login-component .component-title{display:none}#user-login-component .component-content{margin:0;width:100%}#user-login-component .component-content form{border:none;border-radius:0rem}}\n"

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	// Services
	var SessionService_1 = __webpack_require__(85);
	var UserService_1 = __webpack_require__(84);
	var RegisterService_1 = __webpack_require__(128);
	var NonAisStudent_1 = __webpack_require__(168);
	var moment = __webpack_require__(169);
	var AddStudentComponent = (function () {
	    function AddStudentComponent(registerService, sessionService, userService, router) {
	        this.registerService = registerService;
	        this.sessionService = sessionService;
	        this.userService = userService;
	        this.router = router;
	        this.formSubmitted = false;
	    }
	    AddStudentComponent.prototype.ngOnInit = function () {
	        this.resetField = "";
	        this.nonAisStudent = new NonAisStudent_1.NonAisStudent();
	        // Use Session Service to get session and check if user had already logged in.
	        this.getSession();
	    };
	    AddStudentComponent.prototype.resetMedicalFields = function () {
	        if (this.doctorCareValue === "doctorCareNo") {
	            this.nonAisStudent.medical[0].under_doctor_care = "";
	        }
	        if (this.medicationValue === "medicationNo") {
	            this.nonAisStudent.medical[0].medication = "";
	        }
	        if (this.allergicValue === "allergicNo") {
	            this.nonAisStudent.medical[0].allergic = "";
	        }
	        if (this.limitsValue === "limitsNo") {
	            this.nonAisStudent.medical[0].limit_paticipation_athlentic = "";
	        }
	        if (this.senValue === "senNo") {
	            this.nonAisStudent.medical[0].special_education_needs = "";
	        }
	        if (this.senSupportValue === "senSupportNo") {
	            this.nonAisStudent.medical[0].special_education_support = "";
	        }
	    };
	    AddStudentComponent.prototype.onSubmit = function () {
	        this.resetMedicalFields();
	        this.formSubmitted = true;
	        // Reset message content
	        this.message = "";
	        // Post user login data to create session
	        this.registerNonAis(this.nonAisStudent);
	    };
	    /**
	     * Get Session from API service to make sure that user had logged in.
	     * Update User Data on local storage and redirect to the desired URL
	     * if request responses session data.
	     * @param none
	     * @return none
	     */
	    AddStudentComponent.prototype.getSession = function () {
	        var _this = this;
	        this.sessionService.getSession().subscribe(function (user) {
	            _this.userService.setUserSessionData(user);
	        }, function (error) {
	            //TO DO: Handle any error if needed in the furture
	            _this.message = "";
	            _this.messageType = "alert";
	        });
	    };
	    /**
	     * Post Session to API service to create new session.
	     * Update User Data on local storage and redirect to desired URL
	     * if request responses session data.
	     * @param {Credential} - user credential input
	     * @return none
	     */
	    AddStudentComponent.prototype.postSession = function (credential) {
	        var _this = this;
	        this.sessionService.postSession(credential).subscribe(function (user) {
	            // Set user session data
	            _this.userService.setUserSessionData(user);
	            // Fire user session data changed event
	            _this.userService.userDataChanged(user);
	        }, function (error) {
	            _this.formSubmitted = false;
	            _this.message = "Invalid email address or password.";
	            _this.messageType = "alert";
	        });
	    };
	    AddStudentComponent.prototype.registerNonAis = function (nonAisStudent) {
	        var _this = this;
	        var form = Object.assign({}, nonAisStudent);
	        form.date_of_birth = moment(form.date_of_birth, "DD/MM/YYYY").format("YYYY-MM-DD");
	        // console.log(nonAisStudent);
	        this.registerService.postNonAisStudent(form).subscribe(function (complete) {
	            (_this.messageType = "success"),
	                (_this.message = "Adding student successfully");
	            _this.formSubmitted = false;
	            _this.router.navigateByUrl('/booking/students');
	        }, function (error) {
	            _this.formSubmitted = false;
	            _this.messageType = "alert";
	            var msg = JSON.parse(error._body);
	            if (msg.message == "student wasn't created")
	                _this.message = "The student already exist in the system";
	            else
	                _this.message = msg.message;
	        });
	    };
	    AddStudentComponent.prototype.resetMedicalField = function (medicalField) {
	        medicalField = "";
	    };
	    return AddStudentComponent;
	}());
	AddStudentComponent = __decorate([
	    core_1.Component({
	        selector: 'add-student',
	        template: __webpack_require__(308),
	        styles: [__webpack_require__(309)],
	    }),
	    __metadata("design:paramtypes", [RegisterService_1.RegisterService,
	        SessionService_1.SessionService,
	        UserService_1.UserService,
	        router_1.Router])
	], AddStudentComponent);
	exports.AddStudentComponent = AddStudentComponent;


/***/ }),
/* 168 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var NonAisStudent = (function () {
	    function NonAisStudent() {
	        this.family_name = '';
	        this.given_name = '';
	        this.known_name = '';
	        this.gender = '';
	        this.date_of_birth = '';
	        this.country = '';
	        this.medical = [];
	        this.medical[0] = {
	            under_doctor_care: "",
	            medication: "",
	            allergic: "",
	            limit_paticipation_athlentic: "",
	            special_education_needs: "",
	            special_education_support: "",
	        };
	    }
	    return NonAisStudent;
	}());
	exports.NonAisStudent = NonAisStudent;
	var StudentMedical = (function () {
	    function StudentMedical() {
	        this.under_doctor_care = "";
	        this.medication = "";
	        this.allergic = "";
	        this.limit_paticipation_athlentic = "";
	        this.special_education_needs = "";
	        this.special_education_support = "";
	    }
	    return StudentMedical;
	}());
	exports.StudentMedical = StudentMedical;


/***/ }),
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"user-login-component\" class=\"eca-background\">\n    <div class=\"component-title\">\n        <h1>WELCOME TO AIS</h1>\n    </div>\n    <div class=\"component-content\">\n        <form (ngSubmit)=\"onSubmit()\" #loginForm=\"ngForm\">\n\t\t\t<!-- Form Title -->\n            <h3 class=\"text-center\">Student Details</h3>\n\t\t\t<!-- Alert Box -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<alert-box [message]=\"message\" [type]=\"messageType\"></alert-box>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Family Name Input Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"family-name\">Family Name</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Type your Family Name\" id=\"family-name\" name=\"family-name\" required\n\t\t\t\t\t[(ngModel)]=\"nonAisStudent.family_name\" #nonaisFamilyName=\"ngModel\">\n\t\t\t\t\t<div [hidden]=\"nonaisFamilyName.valid || nonaisFamilyName.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tFamily Name is required.\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Given Name Input Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"given-name\">Given Name</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Type your Given Name\" id=\"given-name\" name=\"given-name\" required\n\t\t\t\t\t\t[(ngModel)]=\"nonAisStudent.given_name\" #nonaisGivenName=\"ngModel\">\n\t\t\t\t\t<div [hidden]=\"nonaisGivenName.valid || nonaisGivenName.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tGiven Name is required.\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Known Name Input Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"known-name\">Known Name</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Type your Known Name\" id=\"known-name\" name=\"known-name\" required\n\t\t\t\t\t[(ngModel)]=\"nonAisStudent.known_name\" #nonaisKnowName=\"ngModel\">\n\t\t\t\t\t<div [hidden]=\"nonaisKnowName.valid || nonaisKnowName.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tGiven Name is required.\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Gender Option Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"gender\">Gender</label>\n\t\t\t\t\t<select [(ngModel)]=\"nonAisStudent.gender\" name=\"gender\">\n\t\t\t\t\t\t<option value=\"M\" selected>Male</option>\n\t\t\t\t\t\t<option value=\"F\">Female</option>\n\t\t\t\t\t</select>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- DOB Input Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"dob\">DOB (dd/mm/yyyy)</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"dd/mm/yyyy\" id=\"dob\" name=\"dob\" required\n\t\t\t\t\tpattern=\"^(?:(?:31(\\/)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{4})$\"\n\t\t\t\t\t[(ngModel)]=\"nonAisStudent.date_of_birth\" #nonaisDOB=\"ngModel\" required>\n\t\t\t\t\t<div [hidden]=\"nonaisDOB.valid || nonaisDOB.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\t<div *ngIf=\"nonaisDOB.errors?.required\">Day of birth is required.</div>\n\t\t\t\t\t\t<div *ngIf=\"nonaisDOB.errors?.pattern\">Please correct format date.</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- National Option Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"email\">National</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Type your Country\" id=\"country\" name=\"country\" required\n\t\t\t\t\t\t[(ngModel)]=\"nonAisStudent.country\" #nonaisCountry=\"ngModel\" required>\n\t\t\t\t\t<div [hidden]=\"nonaisCountry.valid || nonaisCountry.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tCountry is required.\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"detail-medical\">\n\t\t\t\t\t<h5>Detailed Medical History</h5>\n\t\t\t\t\t<ol>\n\t\t\t\t\t\t<li>Is your child currently under a doctor's care for any reason ? <br/>\n\t\t\t\t\t\t\t<!--<input type=\"radio\" name=\"doctor-care\" value=\"yes\"> Yes\n\t\t\t\t\t\t\t<input type=\"radio\" name=\"doctor-care\" value=\"no\"> No-->\n\t\t\t\t\t\t\t<input type=\"radio\" [(ngModel)]=\"doctorCareValue\"  name=\"doctor-care\" value=\"doctorCareYes\" />Yes\n    \t\t\t\t\t\t<input type=\"radio\" [(ngModel)]=\"doctorCareValue\"  name=\"doctor-care\" value=\"doctorCareNo\"/>No\n\t\t\t\t\t\t\t<input type=\"text\" [(ngModel)]=\"nonAisStudent.medical[0].under_doctor_care\" name=\"doctor_care\" *ngIf=\"doctorCareValue === 'doctorCareYes'\">\n\t\t\t\t\t\t\t<!--<input type=\"text\" [(ngModel)]=\"nonAisStudent.medical[0].under_doctor_care\" name=\"medication\" *ngIf=\"doctorCareValue === 'doctorCareNo'\" class=\"hide\">-->\n\t\t\t\t\t\t</li>\n\t\t\t\t\t\t<li>Is your child taking any kind of medication ?<br/>\n\t\t\t\t\t\t\t<input type=\"radio\" [(ngModel)]=\"medicationValue\"  name=\"medication\" value=\"medicationYes\" />Yes\n    \t\t\t\t\t\t<input type=\"radio\" [(ngModel)]=\"medicationValue\"  name=\"medication\" value=\"medicationNo\"/>No\n\t\t\t\t\t\t\t<input type=\"text\" [(ngModel)]=\"nonAisStudent.medical[0].medication\" name=\"medication\" *ngIf=\"medicationValue === 'medicationYes'\">\n\t\t\t\t\t\t\t<!--<input type=\"text\" [(ngModel)]=\"nonAisStudent.medical[0].medication\" name=\"medication\" *ngIf=\"medicationValue === 'medicationNo'\" class=\"hide\">-->\n\t\t\t\t\t\t</li>\n\t\t\t\t\t\t<li>Is your child allergic to any food or medication ?<br/>\n\t\t\t\t\t\t\t<input type=\"radio\" [(ngModel)]=\"allergicValue\"  name=\"allergic\" value=\"allergicYes\" />Yes\n    \t\t\t\t\t\t<input type=\"radio\" [(ngModel)]=\"allergicValue\"  name=\"allergic\" value=\"allergicNo\" />No\n\t\t\t\t\t\t\t<input type=\"text\" [(ngModel)]=\"nonAisStudent.medical[0].allergic\" name=\"allergic\" *ngIf=\"allergicValue === 'allergicYes'\">\n\t\t\t\t\t\t\t<!--<input type=\"text\" [(ngModel)]=\"medicalField\" name=\"medication\" *ngIf=\"allergicValue === 'allergicNo'\" class=\"hide\">-->\n\t\t\t\t\t\t</li>\n\t\t\t\t\t\t<li>Does your child have any problem that limits his/her paticipation in athletics ?<br/>\n\t\t\t\t\t\t\t<input type=\"radio\" [(ngModel)]=\"limitsValue\"  name=\"limits\" value=\"limitsYes\" />Yes\n    \t\t\t\t\t\t<input type=\"radio\" [(ngModel)]=\"limitsValue\"  name=\"limits\" value=\"limitsNo\" />No\n\t\t\t\t\t\t\t<input type=\"text\" [(ngModel)]=\"nonAisStudent.medical[0].limit_paticipation_athlentic\" name=\"limit_paticipation_athlentic\"  *ngIf=\"limitsValue === 'limitsYes'\">\n\t\t\t\t\t\t\t<!--<input type=\"text\" [(ngModel)]=\"medicalField\" name=\"medication\" *ngIf=\"limitsValue === 'limitsNo'\" class=\"hide\">-->\n\t\t\t\t\t\t</li>\n\t\t\t\t\t\t<li>Does your child have any special educational needs (SEN)?<br/>\n\t\t\t\t\t\t\t<input type=\"radio\" [(ngModel)]=\"senValue\" name=\"sen\" value=\"senYes\" />Yes\n\t\t\t\t\t\t\t<input type=\"radio\" [(ngModel)]=\"senValue\" name=\"sen\" value=\"senNo\" />No\n\t\t\t\t\t\t\t<input type=\"text\" [(ngModel)]=\"nonAisStudent.medical[0].special_education_needs\" name=\"special_education_needs\" *ngIf=\"senValue === 'senYes'\">\n\t\t\t\t\t\t</li>\n\t\t\t\t\t\t<li>Does your child receive any special educational needs support in their current school?<br/>\n\t\t\t\t\t\t\t<input type=\"radio\" [(ngModel)]=\"senSupportValue\" name=\"senSupport\" value=\"senSupportYes\" />Yes\n\t\t\t\t\t\t\t<input type=\"radio\" [(ngModel)]=\"senSupportValue\" name=\"senSupport\" value=\"senSupportNo\" />No\n\t\t\t\t\t\t\t<input type=\"text\" [(ngModel)]=\"nonAisStudent.medical[0].special_education_support\" name=\"special_education_support\" *ngIf=\"senSupportValue === 'senSupportYes'\">\n\t\t\t\t\t\t</li>\n\t\t\t\t\t\t<p class=\"alert-message\">\n\t\t\t\t\t\t\t<strong>\n\t\t\t\t\t\t\t\tIf you answered yes or no to either of the above, please provide details.\n\t\t\t\t\t\t\t</strong>\n\t\t\t\t\t\t\t<br/>\n\t\t\t\t\t\t\t<strong>\n\t\t\t\t\t\t\t\tThe school may reject your child to join Summer School in case your special educational needs information \n\t\t\t\t\t\t\t\tthat you fill in above is untrue, and the summer fee will not be refunded for any reason.\n\t\t\t\t\t\t\t</strong>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</ol>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Submit Button -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<button type=\"submit\" name=\"submit\" [disabled]=\"!loginForm.form.valid || formSubmitted\">Register</button>\n\t\t\t\t</div>\n\t\t\t</div>\n        </form>\n    </div>\n</div>";

/***/ }),
/* 309 */
/***/ (function(module, exports) {

	module.exports = ".detail-medical{padding:1.25rem}.detail-medical h5{font-size:1.125rem;color:#043d7a;margin-bottom:1rem}.detail-medical li{font-size:0.875rem;color:#666;padding-bottom:0.5rem}.detail-medical li input{margin-bottom:0;vertical-align:-2px;margin-top:10px;margin-left:10px;margin-right:5px}.detail-medical li .hide{display:none}.alert-message{margin-top:15px;font-size:14px;color:#333;background-color:#f9f9f9;padding:10px;border-left:4px solid #ff6600;border-radius:5px;text-align:justify}#user-login-component{padding:1rem}#user-login-component .component-title{margin:3rem auto;width:40%;color:#fff;text-align:center}#user-login-component .component-content{margin:3rem auto;width:40%}#user-login-component .component-content form div.remember-block{position:relative;font-size:0.8rem;margin-bottom:0.5rem}#user-login-component .component-content form div.remember-block input[type=\"checkbox\"]{position:absolute;height:1.1rem;width:1.1rem;top:0.5rem;cursor:pointer}#user-login-component .component-content form div.remember-block label{margin-left:1.5rem}#user-login-component .component-content form .register-link{font-size:0.65rem;font-weight:bold;text-align:center}#user-login-component .component-content form .forgot-password{display:block;font-size:0.8rem}#user-login-component .component-content form button:not(.close-button){width:100%}#user-login-component .component-content form button.close-button{line-height:1.2}.alert-message{margin-top:15px;font-size:16px;color:#333;background-color:#f9f9f9;padding:10px;border-left:4px solid #ff6600;border-radius:5px}@media (min-width: 1025px){#user-login-component .component-title{max-width:600px}#user-login-component .component-content{max-width:600px}}@media (min-width: 768px) and (max-width: 1024px){#user-login-component .component-title{width:50%;max-width:600px}#user-login-component .component-content{width:50%;max-width:600px}}@media (min-width: 320px) and (max-width: 767px){#user-login-component{padding:0}#user-login-component .component-title{display:none}#user-login-component .component-content{margin:0;width:100%}#user-login-component .component-content form{border:none;border-radius:0rem}}\n"

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var router_1 = __webpack_require__(26);
	var HolLoginComponent_1 = __webpack_require__(122);
	var HolRegisterComponent_1 = __webpack_require__(127);
	var HolChoosePasswordComponent_1 = __webpack_require__(132);
	var HolForgotPasswordComponent_1 = __webpack_require__(135);
	var HolChangePasswordComponent_1 = __webpack_require__(139);
	var LoginComponent_1 = __webpack_require__(145);
	var LogoutComponent_1 = __webpack_require__(148);
	var RegisterComponent_1 = __webpack_require__(149);
	var ChoosePasswordComponent_1 = __webpack_require__(152);
	var ForgotPasswordComponent_1 = __webpack_require__(155);
	var SetNewPasswordComponent_1 = __webpack_require__(158);
	var ChangePasswordComponent_1 = __webpack_require__(161);
	var AddParentComponent_1 = __webpack_require__(164);
	var AddStudentComponent_1 = __webpack_require__(167);
	var userRoutes = [
	    {
	        path: 'register',
	        component: RegisterComponent_1.RegisterComponent
	    },
	    {
	        path: 'hol-register',
	        component: HolRegisterComponent_1.HolRegisterComponent
	    },
	    {
	        path: 'choose-password/:token',
	        component: ChoosePasswordComponent_1.ChoosePasswordComponent
	    },
	    {
	        path: 'hol-choose-password/:recovery',
	        component: HolChoosePasswordComponent_1.HolChoosePasswordComponent
	    },
	    {
	        path: 'login',
	        component: LoginComponent_1.LoginComponent
	    },
	    {
	        path: 'hol-login',
	        component: HolLoginComponent_1.HolLoginComponent
	    },
	    {
	        path: 'logout',
	        component: LogoutComponent_1.LogoutComponent
	    },
	    {
	        path: 'forgot-password',
	        component: ForgotPasswordComponent_1.ForgotPasswordComponent
	    },
	    {
	        path: 'hol-forgot-password',
	        component: HolForgotPasswordComponent_1.HolForgotPasswordComponent
	    },
	    {
	        path: 'hol-forgot-password/:token',
	        component: HolForgotPasswordComponent_1.HolForgotPasswordComponent
	    },
	    {
	        path: 'forgot-password/:token',
	        component: SetNewPasswordComponent_1.SetNewPasswordComponent
	    },
	    {
	        path: 'change-password',
	        component: ChangePasswordComponent_1.ChangePasswordComponent
	    },
	    {
	        path: 'hol-change-password',
	        component: HolChangePasswordComponent_1.HolChangePasswordComponent
	    },
	    {
	        path: 'add-parent',
	        component: AddParentComponent_1.AddParentComponent
	    },
	    {
	        path: 'add-student',
	        component: AddStudentComponent_1.AddStudentComponent
	    },
	];
	exports.userRouting = router_1.RouterModule.forChild(userRoutes);


/***/ }),
/* 311 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var User = (function () {
	    function User() {
	    }
	    return User;
	}());
	exports.User = User;


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var shared_1 = __webpack_require__(106);
	var ChildrenListComponent_1 = __webpack_require__(313);
	var ActivitesListComponent_1 = __webpack_require__(328);
	var ExcursionsComponent_1 = __webpack_require__(333);
	var BusOptionComponent_1 = __webpack_require__(336);
	var PaymentComponent_1 = __webpack_require__(339);
	var FinishComponent_1 = __webpack_require__(374);
	var ViewBookingComponent_1 = __webpack_require__(377);
	var AttendanceComponent_1 = __webpack_require__(380);
	var primeng_1 = __webpack_require__(383);
	var BookingRouting_1 = __webpack_require__(454);
	var QuestionAnswerComponent_1 = __webpack_require__(455);
	var BookingModule = (function () {
	    function BookingModule() {
	    }
	    return BookingModule;
	}());
	BookingModule = __decorate([
	    core_1.NgModule({
	        imports: [
	            shared_1.SharedModule,
	            primeng_1.DialogModule,
	            primeng_1.CalendarModule,
	            BookingRouting_1.bookingRouting,
	        ],
	        declarations: [
	            ChildrenListComponent_1.ChildrenListComponent,
	            ActivitesListComponent_1.ActivitesListComponent,
	            QuestionAnswerComponent_1.QuestionAnswerComponent,
	            ExcursionsComponent_1.ExcursionsComponent,
	            BusOptionComponent_1.BusOptionComponent,
	            PaymentComponent_1.PaymentComponent,
	            FinishComponent_1.FinishComponent,
	            ViewBookingComponent_1.ViewBookingComponent,
	            AttendanceComponent_1.AttendanceComponent
	        ]
	    })
	], BookingModule);
	exports.BookingModule = BookingModule;


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var BookingComponent_1 = __webpack_require__(314);
	var common_1 = __webpack_require__(22);
	var _ = __webpack_require__(64);
	// Services
	var services_1 = __webpack_require__(315);
	var services_2 = __webpack_require__(58);
	var ChildrenListComponent = (function (_super) {
	    __extends(ChildrenListComponent, _super);
	    function ChildrenListComponent(router, services, sessionStorageService, local, catalogService, location) {
	        var _this = _super.call(this, router, services, sessionStorageService, catalogService) || this;
	        _this.router = router;
	        _this.services = services;
	        _this.sessionStorageService = sessionStorageService;
	        _this.local = local;
	        _this.catalogService = catalogService;
	        _this.location = location;
	        //chỗ này chỉnh tạm dù cho là S1 hay S2 thì đều chuyển hướng tói màn hình Activity list thay vì Questionaire 
	        _this.isWinterSemester = true;
	        // Remove session data
	        local.removeData('classReservation');
	        local.removeData('bookingItem');
	        return _this;
	    }
	    ChildrenListComponent.prototype.ngOnInit = function () {
	        // Get classChildren from API.
	        this.getChildren();
	        this.getSemesterList();
	        // Remove old data on init
	        this.sessionStorageService.removeData("answerList");
	        this.sessionStorageService.removeData('holidayBooking');
	    };
	    ChildrenListComponent.prototype.getSemesterList = function () {
	        var _this = this;
	        this.catalogService.getSemesters()
	            .subscribe(function (semesterList) {
	            _this.currentSemester = _.find(semesterList, 'is_current');
	            if (_this.currentSemester.is_current && _this.currentSemester.name == 'Semester 1') {
	                _this.isWinterSemester = true;
	            }
	        }, function (error) {
	            console.log("Cannot get semester list from API.");
	        });
	    };
	    // Add chilren for non ais parent
	    ChildrenListComponent.prototype.addChildren = function () {
	        this.router.navigateByUrl('/add-student');
	    };
	    // Get all children of logged parent
	    ChildrenListComponent.prototype.getChildren = function () {
	        var _this = this;
	        // Loading data indicator
	        this.loading = true;
	        this.services.getChildren().subscribe(function (result) {
	            _this.parent = result.type;
	            // Get all children
	            if (result.holStudents) {
	                _this.children = _.filter(result.holStudents, { 'status': 'active' });
	            }
	            // Set session children to avoid re-request
	            _this.setHolidayChildren(result);
	            // Hide loading
	            _this.loading = false;
	        }, function (error) {
	        });
	    };
	    /**
	     * Navigate to class list
	     */
	    ChildrenListComponent.prototype.toNextStep = function (child) {
	        // Set selected child
	        this.setSelectedChild(child);
	        // Start booking session countdown
	        this.services.startCountdown(true);
	        // Navigate to activities page
	        this.isWinterSemester ? this.toActivitiesListPage() : this.toQuestionAnswerPage();
	    };
	    // View booking info
	    ChildrenListComponent.prototype.toViewBooking = function (child) {
	        var booking = _.find(child.hol_bookings, function (o) { return o.status == 'accepted' || o.status == 'waited'; });
	        return this.router.navigate(['booking', booking.id]);
	    };
	    // To Edit booking
	    ChildrenListComponent.prototype.toEditBooking = function (child) {
	        var _this = this;
	        var query = {
	            id: child.hol_bookings[0].id,
	            page: 1
	        };
	        this.services.getBooking(query)
	            .subscribe(function (result) {
	            var booking = result.data[0];
	            // Reinit periodWeeks
	            booking.periodWeeks = [];
	            booking.period = [];
	            // If max weeks allow in history
	            if (booking.hol_weeks.length == 5) {
	                booking.period[booking.hol_class_id] = 'full';
	            }
	            else {
	                booking.period[booking.hol_class_id] = 'period';
	            }
	            // Reinit bus info
	            if (booking.hol_booking_buses.length) {
	                // Detect bus type
	                booking.busType = booking.hol_booking_buses[0].price ? 'paid' : 'free';
	                // Set bus info
	                booking.bus = {
	                    id: booking.hol_booking_buses[0].id,
	                    district: booking.hol_booking_buses[0].district,
	                    address: booking.hol_booking_buses[0].address,
	                    price: booking.hol_booking_buses[0].price
	                };
	            }
	            // Reinit tempBooking
	            if (booking.status == 'created') {
	                booking.temp = booking.id;
	            }
	            if (booking.status == 'waited') {
	                booking.waiting = booking.id;
	            }
	            // Reinit periodWeeks
	            _.forEach(booking.hol_weeks, function (val, key) {
	                booking.periodWeeks.push(val.id);
	            });
	            _this.setBooking(booking);
	            return _this.toNextStep(child);
	        }, function (error) {
	        });
	    };
	    return ChildrenListComponent;
	}(BookingComponent_1.BookingComponent));
	ChildrenListComponent = __decorate([
	    core_1.Component({
	        selector: 'children-list',
	        template: __webpack_require__(324),
	        styles: [__webpack_require__(327)]
	    }),
	    __metadata("design:paramtypes", [router_1.Router,
	        services_1.BookingHolidayService,
	        services_2.SessionStorageService,
	        services_2.LocalStorageService,
	        services_2.CatalogService,
	        common_1.Location])
	], ChildrenListComponent);
	exports.ChildrenListComponent = ChildrenListComponent;


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var moment = __webpack_require__(169);
	var _ = __webpack_require__(64);
	var BookingComponent = (function () {
	    function BookingComponent(router, service, sessionStorageService, catalogService) {
	        this.router = router;
	        this.service = service;
	        this.sessionStorageService = sessionStorageService;
	        this.catalogService = catalogService;
	        this.loading = true;
	    }
	    /**
	     * Find selected child object in the classesChildren list based on child Id.
	     * @param {number} childId
	     * @param {ClasesChild[]} childList
	     * @returns {ClasesChild || null} class child object or null;
	     */
	    BookingComponent.prototype.findSelectedChild = function (childId, childList) {
	        var result = _.find(childList, { 'id': childId });
	        return result ? result : null;
	    };
	    // Set holiday children to session
	    BookingComponent.prototype.setHolidayChildren = function (children) {
	        this.sessionStorageService.setData('holChildren', children);
	        // check is ias parent hide profile on menu
	        if (children.type == 'ais') {
	            this.sessionStorageService.setData('isAisParent', true);
	        }
	        else {
	            this.sessionStorageService.setData('isAisParent', false);
	        }
	    };
	    // Get holiday child from session
	    BookingComponent.prototype.getHolidayChildren = function () {
	        return this.sessionStorageService.getData('holChildren');
	    };
	    // Set selected child to session
	    BookingComponent.prototype.setSelectedChild = function (childId) {
	        this.sessionStorageService.setData('selectedChild', childId);
	    };
	    // Get selected child from session
	    BookingComponent.prototype.getSelectedChild = function () {
	        return this.sessionStorageService.getData('selectedChild');
	    };
	    // Set Q&A Infomation to session
	    BookingComponent.prototype.setQuestionAnswer = function (answerList) {
	        this.sessionStorageService.setData('answerList', answerList);
	    };
	    // get Q&A Infomation from session
	    BookingComponent.prototype.getQuestionAnswer = function () {
	        return this.sessionStorageService.getData('answerList');
	    };
	    // Set booking information to session
	    BookingComponent.prototype.setBooking = function (booking) {
	        this.sessionStorageService.setData('holidayBooking', booking);
	    };
	    // Get booking information from session
	    BookingComponent.prototype.getBooking = function () {
	        return this.sessionStorageService.getData('holidayBooking');
	    };
	    BookingComponent.prototype.backToStudentList = function () {
	        this.router.navigate(['booking/students']);
	    };
	    /**
	     * Go to 'Step 2' of booking - classes list page.
	     */
	    BookingComponent.prototype.toQuestionAnswerPage = function () {
	        this.router.navigate(['booking/question-answer']);
	    };
	    /**
	     * Go to 'Step 2' of booking - classes list page.
	     */
	    BookingComponent.prototype.toActivitiesListPage = function () {
	        this.router.navigate(['booking/activites-list']);
	    };
	    /**
	     * Go to 'Step 2.1' of booking - Selected classes.
	     */
	    BookingComponent.prototype.toSelectedClasses = function (studentId) {
	        this.router.navigate(['booking/review-schedule']);
	    };
	    // Back to activities
	    BookingComponent.prototype.backToActivitiesList = function () {
	        this.router.navigate(['booking/activites-list']);
	    };
	    // Return to excursion
	    BookingComponent.prototype.backToExcursion = function () {
	        return this.router.navigate(['booking/excursions']);
	    };
	    // Return to bus
	    BookingComponent.prototype.backToBusOption = function () {
	        this.router.navigate(['booking/bus']);
	    };
	    // Time format
	    BookingComponent.prototype.timeDataFormat = function (data, format) {
	        return moment(data).format(format);
	    };
	    // Time UTC format
	    BookingComponent.prototype.timeUTCFormat = function (date, format) {
	        return moment(date).utc().format(format);
	    };
	    return BookingComponent;
	}());
	exports.BookingComponent = BookingComponent;


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(58));
	__export(__webpack_require__(316));
	__export(__webpack_require__(317));
	__export(__webpack_require__(318));
	__export(__webpack_require__(319));
	__export(__webpack_require__(320));
	__export(__webpack_require__(321));
	__export(__webpack_require__(322));
	__export(__webpack_require__(86));
	__export(__webpack_require__(323));


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	// Services
	var services_1 = __webpack_require__(58);
	var AttendanceService = (function () {
	    function AttendanceService(apiService, settingService) {
	        this.apiService = apiService;
	        this.settingService = settingService;
	        // Api Domain Url
	        this.apiUrl = '';
	        // Url List for attendances Site 
	        this.attendancesListUrl = '/hol-attendances';
	        this.checkAttendancesUrl = '/hol-check-attendance';
	        // Get API service domain for communate.
	        this.apiUrl = this.settingService.getSetting('api_service_domain');
	    }
	    /**
	     * Get all attendances list
	     * @returns {AttendancesList[]} : list of the attendances.
	     */
	    AttendanceService.prototype.getAttendancesList = function (filter) {
	        var requestUrl = this.apiUrl + this.attendancesListUrl;
	        var hasFilter = false;
	        // Setup filter conditions
	        for (var condition in filter) {
	            if (filter[condition]) {
	                if (hasFilter) {
	                    requestUrl += '&';
	                }
	                else {
	                    requestUrl += '?';
	                    hasFilter = true;
	                }
	                requestUrl += condition + '=' + filter[condition];
	            }
	        }
	        return this.apiService.get(requestUrl);
	    };
	    AttendanceService.prototype.checkAttendances = function (checkAttendances) {
	        var requestUrl = this.apiUrl + this.checkAttendancesUrl;
	        // Post command
	        var body = JSON.stringify(checkAttendances);
	        return this.apiService.patch(requestUrl, body);
	    };
	    return AttendanceService;
	}());
	AttendanceService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [services_1.ApiService,
	        services_1.SettingService])
	], AttendanceService);
	exports.AttendanceService = AttendanceService;


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	// Services
	var services_1 = __webpack_require__(58);
	var BookingService = (function () {
	    function BookingService(apiService, settingService) {
	        this.apiService = apiService;
	        this.settingService = settingService;
	        // Api Domain Url
	        this.apiUrl = '';
	        // Url List for Booking Site 
	        this.bookingListUrl = '/hol/booking';
	        this.bookingNoteUrl = '/hol/booking/note';
	        this.classUrl = '/asa-classes';
	        // Get API service domain for communate.
	        this.apiUrl = this.settingService.getSetting('api_service_domain');
	    }
	    /**
	     * Get all booking list
	     * @returns {BookingList[]} : list of the booking.
	     */
	    // getBookingList(): Observable<BookingList> {
	    //     const requestUrl = this.apiUrl + this.bookingListUrl;
	    //     return this.apiService.get<BookingList>(requestUrl);
	    // }
	    BookingService.prototype.getBookingList = function (filter) {
	        var requestUrl = this.apiUrl + this.bookingListUrl;
	        var hasFilter = false;
	        // Setup filter conditions
	        for (var condition in filter) {
	            if (filter[condition]) {
	                if (hasFilter) {
	                    requestUrl += '&';
	                }
	                else {
	                    requestUrl += '?';
	                    hasFilter = true;
	                }
	                requestUrl += condition + '=' + filter[condition];
	            }
	        }
	        return this.apiService.get(requestUrl);
	    };
	    BookingService.prototype.getBookingInfo = function () {
	        var requestUrl = this.apiUrl + this.bookingListUrl;
	        return this.apiService.get(requestUrl);
	    };
	    BookingService.prototype.getBookingDetail = function (bookingId) {
	        var requestUrl = this.apiUrl + this.bookingListUrl + '?id=' + bookingId + '&page=1';
	        return this.apiService.get(requestUrl);
	    };
	    BookingService.prototype.getBookingTransaction = function (bookingId) {
	        var requestUrl = this.apiUrl + this.bookingListUrl + '/' + bookingId;
	        return this.apiService.get(requestUrl);
	    };
	    BookingService.prototype.makeHolTransactions = function (makeHolTransaction) {
	        var requestUrl = this.apiUrl + this.bookingListUrl + '/' + makeHolTransaction.command.hol_booking_id + '/transaction';
	        var body = JSON.stringify(makeHolTransaction.command);
	        return this.apiService.post(requestUrl, body);
	    };
	    BookingService.prototype.updateHolTransactions = function (updateTransaction) {
	        var requestUrl = this.apiUrl + this.bookingListUrl + '/' + updateTransaction.command.hol_booking_id + '/transaction';
	        var body = JSON.stringify(updateTransaction.command);
	        return this.apiService.patch(requestUrl, body);
	    };
	    BookingService.prototype.deleteHolTransactions = function (deleteHolTransaction) {
	        var requestUrl = this.apiUrl + this.bookingListUrl + '/' + deleteHolTransaction.hol_booking_id + '/transaction';
	        var body = JSON.stringify(deleteHolTransaction);
	        return this.apiService.deletePost(requestUrl, body);
	    };
	    // ────────────────────────────────────────────────────────────────────────────────
	    // Update Booking Holiday Class
	    BookingService.prototype.updateBooking = function (query) {
	        var requestUrl = this.apiUrl + this.bookingListUrl;
	        var body = JSON.stringify(query);
	        return this.apiService.patch(requestUrl, body);
	    };
	    // ────────────────────────────────────────────────────────────────────────────────
	    // Update Booking Note
	    BookingService.prototype.updateBookingNote = function (query) {
	        var requestUrl = this.apiUrl + this.bookingNoteUrl;
	        var body = JSON.stringify(query);
	        return this.apiService.patch(requestUrl, body);
	    };
	    return BookingService;
	}());
	BookingService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [services_1.ApiService,
	        services_1.SettingService])
	], BookingService);
	exports.BookingService = BookingService;


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	// Services
	var services_1 = __webpack_require__(58);
	var LocalService = (function () {
	    function LocalService(apiService, settingService) {
	        this.apiService = apiService;
	        this.settingService = settingService;
	        // Api Domain Url
	        this.apiUrl = '';
	        // Get API service domain for communate.
	        this.apiUrl = this.settingService.getSetting('api_service_domain');
	    }
	    LocalService.prototype.getLocalNetWork = function () {
	        var requestUrl = '/auth/negotiate';
	        return this.apiService.get(requestUrl);
	    };
	    return LocalService;
	}());
	LocalService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [services_1.ApiService,
	        services_1.SettingService])
	], LocalService);
	exports.LocalService = LocalService;


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	// Services
	var services_1 = __webpack_require__(58);
	var ClassService = (function () {
	    function ClassService(apiService, settingService) {
	        this.apiService = apiService;
	        this.settingService = settingService;
	        // Api Domain Url
	        this.apiUrl = '';
	        this.classUrl = '/asa-classes';
	        // Url List for Class Parent Site
	        this.classesChildrenUrl = '/asa-children';
	        this.availableClassesUrl = '/asa-students';
	        this.reservationUrl = '/asa-students';
	        this.paymentUrl = '/asa-bookings';
	        // Get API service domain for communate.
	        this.apiUrl = this.settingService.getSetting('api_service_domain');
	    }
	    /**
	     * Get children list of logged in parent on Class modules.
	     * @returns {ClassChild[]} : list of ClassChild item.
	     */
	    ClassService.prototype.getClassesChildrenList = function () {
	        var requestUrl = this.apiUrl + this.classesChildrenUrl;
	        return this.apiService.get(requestUrl);
	    };
	    ClassService.prototype.getClassList = function (filter) {
	        var requestUrl = this.apiUrl + this.classUrl;
	        var hasFilter = false;
	        // Setup filter conditions
	        for (var condition in filter) {
	            if (filter[condition]) {
	                if (hasFilter) {
	                    requestUrl += '&';
	                }
	                else {
	                    requestUrl += '?';
	                    hasFilter = true;
	                }
	                requestUrl += condition + '=' + filter[condition];
	            }
	        }
	        return this.apiService.get(requestUrl);
	    };
	    ClassService.prototype.getFullClassList = function () {
	        var requestUrl = this.apiUrl + this.classUrl;
	        return this.apiService.get(requestUrl);
	    };
	    /**
	     * Get open Classes list that are available for a specific student.
	     * @param {number} studentId : Id of the student.
	     * @returns {AvailableClass[]} : list of open classes.
	     */
	    ClassService.prototype.getAvailableClassesList = function (studentId) {
	        var requestUrl = this.apiUrl + this.availableClassesUrl + "/" + studentId + "/" + "classes";
	        return this.apiService.get(requestUrl);
	    };
	    /**
	     * Add new reservation into a specific class.
	     * @param {ClassReservation} classReservation : class reservation data.
	     * @returns {Observable<any>} : request response result (string).
	     */
	    ClassService.prototype.addClassReservation = function (classReservation) {
	        var requestUrl = this.apiUrl + this.reservationUrl + "/" + classReservation.studentId + "/reservations";
	        // Post command
	        var body = JSON.stringify(classReservation.command);
	        return this.apiService.post(requestUrl, body);
	    };
	    /**
	     * Cancel reservation into a specific class.
	     * @param {CancelReservation} cancelReservation : cancel reservation.
	     * @returns {Observable<any>} : request response result (string).
	     */
	    ClassService.prototype.cancelClassReservation = function (cancelReservation) {
	        var requestUrl = this.apiUrl + this.reservationUrl + "/" + cancelReservation.studentId + "/reservations" + "/" + cancelReservation.classId;
	        return this.apiService.delete(requestUrl);
	    };
	    ClassService.prototype.createClass = function (classItem) {
	        var requestUrl = this.apiUrl + this.classUrl;
	        // Post content
	        var body = JSON.stringify(classItem);
	        return this.apiService.post(requestUrl, body);
	    };
	    ClassService.prototype.editClass = function (classItem) {
	        var requestUrl = this.apiUrl + this.classUrl + '/' + classItem.id;
	        var body = JSON.stringify(classItem);
	        return this.apiService.patch(requestUrl, body);
	    };
	    ClassService.prototype.getClassDetail = function (classId) {
	        var requestUrl = this.apiUrl + this.classUrl + '/' + classId;
	        return this.apiService.get(requestUrl);
	    };
	    ClassService.prototype.bookingClassSubmit = function (booking) {
	        var requestUrl = this.apiUrl + this.paymentUrl;
	        // Post content
	        var body = JSON.stringify(booking);
	        return this.apiService.post(requestUrl, body);
	    };
	    // Update Booking class
	    ClassService.prototype.bookingClassUpdate = function (booking) {
	        var requestUrl = this.apiUrl + this.paymentUrl;
	        // update content
	        var body = JSON.stringify(booking);
	        return this.apiService.patch(requestUrl, body);
	    };
	    /**
	     * Get booking class detail for a specific student.
	     * @param {number} studentId : Id of the student.
	     * @returns {BookingItem[]} : list of open classes.
	     */
	    ClassService.prototype.bookingClassDetail = function (studentId) {
	        var requestUrl = this.apiUrl + '/' + 'asa-students' + '/' + studentId + '/' + 'bookings';
	        return this.apiService.get(requestUrl);
	    };
	    // Get specific booking detail
	    ClassService.prototype.getBookingDetail = function (bookingId) {
	        var requestUrl = this.apiUrl + this.paymentUrl + '/' + bookingId;
	        return this.apiService.get(requestUrl);
	    };
	    // Update sepecific booking detail
	    ClassService.prototype.updateBookingDetail = function (booking) {
	        var requestUrl = this.apiUrl + this.paymentUrl + '/' + booking.id;
	        var body = JSON.stringify(booking.command);
	        return this.apiService.patch(requestUrl, body);
	    };
	    ClassService.prototype.getStudentListInClass = function (classId) {
	        var requestUrl = this.apiUrl + this.classUrl + "/" + classId + "/students";
	        return this.apiService.get(requestUrl);
	    };
	    ClassService.prototype.deleteStudentInClass = function (classId, studentId) {
	        var requestUrl = this.apiUrl + this.classUrl + "/" + classId + "/students" + "/" + studentId;
	        return this.apiService.delete(requestUrl);
	    };
	    // For payment classes
	    ClassService.prototype.paymentClass = function (paymentInfo) {
	        var requestUrl = this.apiUrl + this.paymentUrl + '/' + paymentInfo.bookingId + '/payments';
	        // Post content
	        var body = JSON.stringify(paymentInfo.command);
	        return this.apiService.post(requestUrl, body);
	    };
	    return ClassService;
	}());
	ClassService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [services_1.ApiService,
	        services_1.SettingService])
	], ClassService);
	exports.ClassService = ClassService;


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	// Services
	var services_1 = __webpack_require__(58);
	var EmailService = (function () {
	    function EmailService(apiService, settingService) {
	        this.apiService = apiService;
	        this.settingService = settingService;
	        // Api Domain Url
	        this.apiUrl = '';
	        // Url send email
	        this.emailUrl = '/hol-email';
	        this.emaiStudentslUrl = '/hol-email-students';
	        this.emailSetting = '/booking-settings';
	        this.settingType = '/setting_type';
	        // Get API service domain for communate.
	        this.apiUrl = this.settingService.getSetting('api_service_domain');
	    }
	    EmailService.prototype.getEmail = function (filter) {
	        var requestUrl = this.apiUrl + this.emailUrl;
	        var hasFilter = false;
	        // Setup filter conditions
	        for (var condition in filter) {
	            if (filter[condition]) {
	                if (hasFilter) {
	                    requestUrl += '&';
	                }
	                else {
	                    requestUrl += '?';
	                    hasFilter = true;
	                }
	                requestUrl += condition + '=' + filter[condition];
	            }
	        }
	        return this.apiService.get(requestUrl);
	    };
	    EmailService.prototype.getEmailStudents = function (filter) {
	        var requestUrl = this.apiUrl + this.emaiStudentslUrl;
	        var hasFilter = false;
	        // Setup filter conditions
	        for (var condition in filter) {
	            if (filter[condition]) {
	                if (hasFilter) {
	                    requestUrl += '&';
	                }
	                else {
	                    requestUrl += '?';
	                    hasFilter = true;
	                }
	                requestUrl += condition + '=' + filter[condition];
	            }
	        }
	        return this.apiService.get(requestUrl);
	    };
	    EmailService.prototype.getEmailDetail = function (emailId) {
	        var requestUrl = this.apiUrl + this.emailUrl + '/' + emailId;
	        return this.apiService.get(requestUrl);
	    };
	    EmailService.prototype.sendEmail = function (sendEmail) {
	        var requestUrl = this.apiUrl + this.emailUrl;
	        // Post command
	        var body = JSON.stringify(sendEmail);
	        return this.apiService.post(requestUrl, body);
	    };
	    EmailService.prototype.updateEmail = function (saveEmail) {
	        var requestUrl = this.apiUrl + this.emailUrl;
	        // Post command
	        var body = JSON.stringify(saveEmail);
	        return this.apiService.patch(requestUrl, body);
	    };
	    EmailService.prototype.getSettingEmail = function () {
	        var requestUrl = this.apiUrl + this.emailSetting + '?' + this.settingType + '=payment-reminder-setting';
	        return this.apiService.get(requestUrl);
	    };
	    EmailService.prototype.upsertSettingEmail = function (data) {
	        var requestUrl = this.apiUrl + this.emailSetting;
	        var body = JSON.stringify(data);
	        return this.apiService.patch(requestUrl, body);
	    };
	    return EmailService;
	}());
	EmailService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [services_1.ApiService,
	        services_1.SettingService])
	], EmailService);
	exports.EmailService = EmailService;


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var _ = __webpack_require__(64);
	// Libraries
	var core_1 = __webpack_require__(3);
	var Subject_1 = __webpack_require__(6);
	// Services
	var services_1 = __webpack_require__(58);
	var BookingHolidayService = (function () {
	    function BookingHolidayService(apiService, settingService) {
	        this.apiService = apiService;
	        this.settingService = settingService;
	        // Api Domain Url
	        this.apiUrl = '';
	        // For Countdown function
	        this.isStartCountdown = new Subject_1.Subject();
	        // Observable string streams
	        this.countdownAnnounced$ = this.isStartCountdown.asObservable();
	        // Url List for Booking Site 
	        this.children = '/parent';
	        this.course = '/course';
	        this.class = '/class';
	        this.week = '/week';
	        this.booking = '/booking';
	        this.questionnaire = '/questionnaire';
	        this.excursion = '/excursion';
	        this.paymentUrl = '/booking/payment/do';
	        this.studentListUrl = '/students';
	        this.contents = '/contents';
	        this.configuration = 'configuration';
	        // Get API service domain for communate.
	        this.apiUrl = this.settingService.getSetting('api_service_domain') + '/hol';
	    }
	    // Get contents
	    BookingHolidayService.prototype.getContents = function (contents) {
	        var requestUrl = this.settingService.getSetting('api_service_domain') + this.contents + '?' + 'key=' + contents;
	        return this.apiService.get(requestUrl);
	    };
	    BookingHolidayService.prototype.payment = function (payment) {
	        var requestUrl = this.apiUrl + this.paymentUrl + '?amount=' + payment.amount + '&zone=' + payment.zone + '&booking_id=' + payment.booking_id + '&currency=VND';
	        return this.apiService.get(requestUrl);
	    };
	    // Activate countdown function on AppComponent
	    BookingHolidayService.prototype.startCountdown = function (start) {
	        return this.isStartCountdown.next(start);
	    };
	    // Get all children of logged parent
	    BookingHolidayService.prototype.getChildren = function () {
	        var requestUrl = this.apiUrl + this.children;
	        return this.apiService.get(requestUrl);
	    };
	    // Get all children of logged parent by name
	    BookingHolidayService.prototype.getStudents = function (filter) {
	        var requestUrl = this.apiUrl + this.studentListUrl + '?';
	        var i = 0;
	        _.forEach(filter, function (val, key) {
	            if (val !== '') {
	                requestUrl = !i ? requestUrl + key + '=' + val : requestUrl + '&' + key + '=' + val;
	                i++;
	            }
	        });
	        return this.apiService.get(requestUrl);
	    };
	    // Get booking
	    BookingHolidayService.prototype.getBooking = function (filter) {
	        var requestUrl = this.apiUrl + this.booking + '?';
	        var i = 0;
	        _.forEach(filter, function (val, key) {
	            if (val !== '') {
	                requestUrl = !i ? requestUrl + key + '=' + val : requestUrl + '&' + key + '=' + val;
	                i++;
	            }
	        });
	        return this.apiService.get(requestUrl);
	    };
	    // Get Booking by id
	    BookingHolidayService.prototype.getBookingById = function (aisId) {
	        var requestUrl = this.apiUrl + this.booking + '?' + 'student=' + aisId + '&page=1';
	        return this.apiService.get(requestUrl);
	    };
	    // Retrieve all clasess base on child's dob
	    BookingHolidayService.prototype.getClasses = function (filter) {
	        var requestUrl = this.apiUrl + this.class + '?';
	        var i = 0;
	        _.forEach(filter, function (val, key) {
	            if (val !== '') {
	                requestUrl = !i ? requestUrl + key + '=' + val : requestUrl + '&' + key + '=' + val;
	                i++;
	            }
	        });
	        return this.apiService.get(requestUrl);
	    };
	    // Get all holiday weeks
	    BookingHolidayService.prototype.getWeeks = function () {
	        var requestUrl = this.apiUrl + this.week;
	        return this.apiService.get(requestUrl);
	    };
	    // Get all holiday excursion
	    BookingHolidayService.prototype.getExcursions = function () {
	        var requestUrl = this.apiUrl + this.excursion;
	        return this.apiService.get(requestUrl);
	    };
	    // Get all holiday questionnaire
	    BookingHolidayService.prototype.getQuestionnaire = function (status) {
	        var requestUrl = this.apiUrl + this.questionnaire + '?' + ("status=" + status);
	        return this.apiService.get(requestUrl);
	    };
	    // ────────────────────────────────────────────────────────────────────────────────
	    // Post Booking Holiday Class
	    BookingHolidayService.prototype.postBooking = function (query) {
	        var requestUrl = this.apiUrl + this.booking;
	        var body = JSON.stringify(query);
	        return this.apiService.post(requestUrl, body);
	    };
	    // ────────────────────────────────────────────────────────────────────────────────
	    // Update Booking Holiday Class
	    BookingHolidayService.prototype.updateBooking = function (query) {
	        var requestUrl = this.apiUrl + this.booking;
	        var body = JSON.stringify(query);
	        return this.apiService.patch(requestUrl, body);
	    };
	    //get Booking Discount config
	    BookingHolidayService.prototype.getDiscountConfig = function (config) {
	        var requestUrl = this.apiUrl + "/" + this.configuration + "/" + config;
	        return this.apiService.get(requestUrl);
	    };
	    return BookingHolidayService;
	}());
	BookingHolidayService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [services_1.ApiService,
	        services_1.SettingService])
	], BookingHolidayService);
	exports.BookingHolidayService = BookingHolidayService;


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	// Services
	var services_1 = __webpack_require__(58);
	var ScheduleService = (function () {
	    function ScheduleService(apiService, settingService) {
	        this.apiService = apiService;
	        this.settingService = settingService;
	        this.importScheduleUrl = '/students-schedule';
	        this.apiUrl = '';
	        this.apiUrl = this.settingService.getSetting('api_service_domain');
	    }
	    ScheduleService.prototype.importSchedule = function (data) {
	        var requestUrl = this.apiUrl + this.importScheduleUrl;
	        return this.apiService.patch(requestUrl, data);
	    };
	    return ScheduleService;
	}());
	ScheduleService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [services_1.ApiService,
	        services_1.SettingService])
	], ScheduleService);
	exports.ScheduleService = ScheduleService;


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	// Import Setting Service and User, Credential Model
	var services_1 = __webpack_require__(58);
	var HolRegisterService = (function () {
	    function HolRegisterService(settingService, apiService) {
	        this.settingService = settingService;
	        this.apiService = apiService;
	        this.activationUrl = '/activations';
	        this.holParentUrl = '/hol/parent';
	        this.apiUrl = '';
	        this.apiUrl = this.settingService.getSetting('api_service_domain');
	    }
	    HolRegisterService.prototype.postActivationEmail = function (role, email) {
	        var requestUrl = this.apiUrl + this.activationUrl;
	        var body = JSON.stringify({
	            'role': role,
	            'email': email
	        });
	        return this.apiService.post(requestUrl, body);
	    };
	    HolRegisterService.prototype.verifyActivationToken = function (token) {
	        var requestUrl = this.apiUrl + this.activationUrl + "/" + token;
	        return this.apiService.get(requestUrl);
	    };
	    HolRegisterService.prototype.postNoneAisAccount = function (email) {
	        var requestUrl = this.apiUrl + this.holParentUrl + "/register";
	        var body = JSON.stringify({
	            'email': email,
	            'family_name': "",
	            'given_name': "",
	            'phone': ""
	        });
	        return this.apiService.post(requestUrl, body);
	    };
	    HolRegisterService.prototype.setPasswordWithActivationToken = function (token, password) {
	        var requestUrl = this.apiUrl + this.activationUrl + "/" + token;
	        // TODO: update body content
	        var body = JSON.stringify({ password: password });
	        return this.apiService.patch(requestUrl, body);
	    };
	    return HolRegisterService;
	}());
	HolRegisterService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [services_1.SettingService,
	        services_1.ApiService])
	], HolRegisterService);
	exports.HolRegisterService = HolRegisterService;


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<main>\n\t<div class=\"component-title\">\n        <h1>Step 1 : Booking</h1>\n    </div>\n    <div class=\"class_section\">\n        <img src=\"" + __webpack_require__(325) + "\" alt=\"\">\n        <p>Please click \"Select\" to choose your child who you want to register classes\n        </p>\n        \n        <ul [hidden]=\"loading\">\n            <li *ngFor=\"let child of children\">\n                <p class=\"child_img\"><img src=\"" + __webpack_require__(326) + "\"></p>\n                <p class=\"child_info\">\n                    <span>{{ child.code }} - </span>\n                    <span>{{ child.given_name }}</span>\n                    <span>{{ child.family_name }} - </span>\n                    <span>{{ timeDataFormat(child.date_of_birth, 'YYYY-MM-DD') }}</span>\n                </p>\n                <!--To Edit button-->\n                <!--<button *ngIf=\"child.hol_bookings.length\" (click)=\"toEditBooking(child)\" style=\"background: #faa635; height: 50px\">Manage Booking</button>-->\n                <button *ngIf=\"child.hol_bookings.length\" (click)=\"toViewBooking(child)\" style=\"background: #faa635; height: 50px\">View Booking</button>\n                <!--<button *ngIf=\"child.hol_bookings.length\" style=\"background: #ddd; height: 50px\">Manage Booking</button>-->\n                <!--To create button-->\n                <button *ngIf=\"!child.hol_bookings.length\" (click)=\"toNextStep(child)\">Select</button>\n            </li>\n        </ul>\n        <button (click)=\"addChildren()\" [hidden]=\"parent === 'ais'\" class=\"btn-addChildren\">Add Children</button>\n        <div class=\"text-center loading\" [hidden]=\"!loading\">\n            <span>Loading Children ...<i class=\"fa fa-cog fa-spin fa-3x fa-fw\"></i></span>\n        </div>\n    </div>\n</main>";

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/class_list_children.235ad424d36e0c7f3183dd7e3a78c219.png";

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/camp_children_icon.9ccf1c39ba33deab3a314da9ee63f888.png";

/***/ }),
/* 327 */
/***/ (function(module, exports) {

	module.exports = ".component-title{color:#043d7a;background-color:#f8f8f8;padding:1.5rem 0;border-bottom:1px solid #eaeaea}.component-title h1{width:80%;margin:0 auto;padding:0 1.25rem;font-size:1.5256rem}.loading{padding:20px 0px}.class_section{min-height:420px;text-align:center}.class_section table{width:50%;margin:1rem auto}.class_section table caption{text-align:left;color:#054181;padding:1rem 0}.class_section table tbody{text-align:center}.class_section table tbody tr:first-child{background:#054181;color:#fff}.class_section>img{margin-top:60px;margin-bottom:40px}.class_section h3{color:#282828}.class_section ul{margin-top:33px;margin-bottom:33px;margin-left:0}.class_section ul li{width:50%;border:1px solid #ddd;border-bottom:none;height:auto;margin:0 auto;box-sizing:border-box;padding:20px;overflow:hidden}.class_section ul li>*{float:left}.class_section ul li>p{margin-bottom:0}.class_section ul>li:first-child{border-top-left-radius:5px;border-top-right-radius:5px}.class_section ul>li:last-child{border-bottom-left-radius:5px;border-bottom-right-radius:5px;border-bottom:1px solid #ddd}.class_section .child_info{line-height:36px;margin-left:25px;color:#282828;text-align:left;max-width:60%}.class_section button{float:right !important;border:none;height:39px;width:96px;font-weight:bold;border-radius:4px;color:#fff;background:#054181;margin:0;padding:0}.class_section button:hover{background:#faa635;color:#054181}.class_section button.btn-addChildren{font-weight:bold;border-radius:4px;color:#fff;background:#054181;margin:0;padding:0;padding:0.45rem;margin-bottom:2rem;float:none !important;height:auto}@media only screen and (max-width: 40em){.class_section table{width:80%;font-size:0.875rem}.class_section img{width:90px}.class_section p{font-size:0.875rem;width:90%;margin:0 auto}.class_section ul{width:100%;margin-right:0;margin-left:0;padding-left:1.25rem;padding-right:1.25rem}.class_section ul li{width:100%;padding-left:3.5%;padding-right:3.5%}.class_section ul li .child_img{margin-left:0}.class_section ul li .child_img img{display:none}.class_section ul li .child_info{width:80%;margin-left:0}.class_section ul li .child_info span{float:left}.class_section ul li button{width:70px;font-size:0.875rem;width:20%}}\n"

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var BookingComponent_1 = __webpack_require__(314);
	var _ = __webpack_require__(64);
	var moment = __webpack_require__(169);
	// Services
	var services_1 = __webpack_require__(315);
	var services_2 = __webpack_require__(58);
	var ActivitesListComponent = (function (_super) {
	    __extends(ActivitesListComponent, _super);
	    function ActivitesListComponent(fileService, route, router, catalogService, services, sessionStorageService, local) {
	        var _this = _super.call(this, router, services, sessionStorageService) || this;
	        _this.fileService = fileService;
	        _this.route = route;
	        _this.router = router;
	        _this.catalogService = catalogService;
	        _this.services = services;
	        _this.sessionStorageService = sessionStorageService;
	        _this.local = local;
	        _this.showLackInfoModal = false;
	        _this.showWaitingModal = false;
	        _this.period = [];
	        _this.showWeekModal = false;
	        _this.showDesModal = false;
	        // For period select
	        _this.weeks = [];
	        _this.weekSelect = [];
	        // Booking
	        _this.tempBooking = '';
	        _this.waiting = '';
	        _this.booking = [];
	        _this.isWinterSemester = false;
	        _this.currentSemester = {
	            name: ''
	        };
	        _this.currentYear = moment().year();
	        return _this;
	    }
	    ActivitesListComponent.prototype.ngOnInit = function () {
	        this.countdown = moment(this.sessionStorageService.getData('countdown')).format('mm:ss');
	        // Retrieve holiday children from session
	        this.children = this.getHolidayChildren();
	        // Get selected child
	        this.selectedChild = this.getSelectedChild();
	        // Get weeks
	        this.getWeeks();
	        // Get available courses
	        // this.getAvailableClasses();
	        // Init booking from session if have
	        this.initBooking();
	        this.getSemester();
	        this.getDiscountConfiguration();
	    };
	    ActivitesListComponent.prototype.checkReturnerYear = function () {
	        var yearArr = [];
	        var condition = Number(this.olderConfig.condition);
	        if (this.olderConfig.condition) {
	            for (var i = 1; i <= condition; i++)
	                yearArr = yearArr.concat([this.currentYear - i]);
	        }
	        // return yearArr.sort().join(' or ');
	        return yearArr.sort()[0];
	    };
	    ActivitesListComponent.prototype.getDiscountConfiguration = function () {
	        var _this = this;
	        this.services.getDiscountConfig('sibling')
	            .subscribe(function (config) {
	            _this.siblingConfig = config;
	        });
	        this.services.getDiscountConfig('older')
	            .subscribe(function (config) {
	            _this.olderConfig = config;
	        });
	        this.services.getDiscountConfig('early-bird')
	            .subscribe(function (config) {
	            _this.earlyBirdConfig = config;
	            _this.earlyBirdConfig.condition = moment(config.condition).format('DD MMM YYYY');
	        });
	        this.services.getDiscountConfig('ais')
	            .subscribe(function (config) {
	            _this.aisStudentConfig = config;
	        });
	    };
	    ActivitesListComponent.prototype.getSemester = function () {
	        var _this = this;
	        this.catalogService.getSemesters()
	            .subscribe(function (semesterList) {
	            _this.currentSemester = _.find(semesterList, 'is_current');
	            if (_this.currentSemester.is_current && _this.currentSemester.name == 'Semester 2') {
	                _this.isWinterSemester = true;
	            }
	        }, function (error) {
	            console.log("Cannot get semester list from API.");
	        });
	    };
	    // Initial booking info from session
	    ActivitesListComponent.prototype.initBooking = function () {
	        var _this = this;
	        if (this.getBooking()) {
	            this.booking = this.getBooking();
	            // Set selected class id
	            this.selectedClassId = this.booking.hol_class_id;
	            // Set selected weeks
	            this.weekSelect[this.selectedClassId] = [];
	            _.forEach(this.booking.periodWeeks, function (val, key) {
	                _this.weekSelect[_this.selectedClassId][val] = true;
	            });
	            //set Q&A
	            if (this.getQuestionAnswer()) {
	                this.booking.question_answer = this.getQuestionAnswer();
	            }
	            // Temp booking
	            this.tempBooking = this.booking.temp ? this.booking.temp : '';
	            this.waiting = this.booking.waiting ? this.booking.waiting : '';
	            // Set period selected
	            setTimeout(function () {
	                _this.period[_this.selectedClassId] = _this.booking.period[_this.selectedClassId];
	            }, 100);
	        }
	        else {
	            //if class booking created , get 
	            this.showRemindModal = true;
	        }
	    };
	    // Retrieve all available classes for selected child by his dob
	    ActivitesListComponent.prototype.getAvailableClasses = function () {
	        var _this = this;
	        var query = {
	            "date_of_birth": this.timeDataFormat(this.selectedChild.date_of_birth, 'YYYY-MM-DD'),
	            "limit": 100,
	            "page": 1
	        };
	        // Get courses arcordingly to selected child dob
	        this.services.getClasses(query).subscribe(function (result) {
	            // Get clases
	            _this.clases = _.filter(result.data, { 'status': 'opened' });
	            // Default set full period
	            if (_this.clases && _this.clases.length) {
	                _.forEach(_this.clases, function (val, key) {
	                    _this.period[val.id] = 'full';
	                    _this.setFullWeek(val.id);
	                });
	            }
	            else {
	                //if dont have class,clear answerList in session
	                _this.sessionStorageService.removeData("answerList");
	            }
	        }, function (error) {
	        });
	    };
	    // Retrieve all holiday's weeks
	    ActivitesListComponent.prototype.getWeeks = function () {
	        var _this = this;
	        this.service.getWeeks().subscribe(function (result) {
	            // Get weeks
	            _this.weeks = result;
	            // Sort weeks
	            _this.weeks = _.sortBy(_this.weeks, function (o) { return o.name; });
	            _this.getAvailableClasses();
	        }, function (error) {
	        });
	    };
	    // Calculate reservation when make change on class
	    // calculateReservation(singleClass: ClassChild) {
	    // }
	    // Select another child then refresh open classes 
	    ActivitesListComponent.prototype.changeChild = function () {
	        var child = _.find(this.children.holStudents, { 'code': this.selectedChild.code });
	        this.selectedChild = child;
	        // Update child id in session storage
	        this.setSelectedChild(child);
	    };
	    // Set full week period for a class
	    ActivitesListComponent.prototype.setFullWeek = function (classId) {
	        var _this = this;
	        // Check if exist week selected for class        
	        if (!this.weekSelect[classId]) {
	            this.weekSelect[classId] = [];
	        }
	        // Set all week
	        _.forEach(this.weeks, function (val, key) {
	            _this.weekSelect[classId][val.id] = true;
	        });
	        // Update booking info if selected class
	        if (classId == this.selectedClassId) {
	            this.onCloseWeekModal('');
	        }
	    };
	    /**
	     * Get file url based on fileId.
	     * @param {string} fileId - Id of the file
	     * @returns {string} file URL string
	     */
	    ActivitesListComponent.prototype.getFileUrl = function (fileId) {
	        return this.fileService.getFile(fileId);
	    };
	    //Pop up modal description
	    ActivitesListComponent.prototype.showClassDescription = function (title, content) {
	        var modalTitle = title;
	        var modalContent = content;
	        document.getElementById("descriptionModal").style.display = "block";
	        document.getElementById("classDescriptionModalTitle").innerHTML = modalTitle;
	        document.getElementById("classDescriptionModalBody").innerHTML = modalContent;
	    };
	    //Close pop-up
	    ActivitesListComponent.prototype.closeModal = function () {
	        document.getElementById("descriptionModal").style.display = "none";
	    };
	    // On open week modal
	    ActivitesListComponent.prototype.openWeekModal = function (classId) {
	        // Set current select class id
	        this.currentSelectClassId = classId;
	        // Check if exist week selected for class        
	        if (!this.weekSelect[classId]) {
	            this.weekSelect[classId] = [];
	        }
	        // Show week modal
	        this.toggleWeekModal();
	    };
	    // Show/hide select week modal
	    ActivitesListComponent.prototype.toggleWeekModal = function () {
	        return this.showWeekModal = !this.showWeekModal;
	    };
	    // Event onAfterHide select week dialog
	    // Detect change week to update booking
	    ActivitesListComponent.prototype.onCloseWeekModal = function (event) {
	        // If current class select week is the same as selected class
	        if (this.currentSelectClassId == this.selectedClassId) {
	            var isWaiting = _.find(this.weekSelect[this.selectedClassId], function (o) { return o == false; });
	            // If week select is suitable for waiting status
	            if (isWaiting === false) {
	                // Check if there is waiting booking reservation
	                if (!this.waiting) {
	                    // Reserve a class
	                    this.sendClassReserve(this.currentSelectClassId);
	                }
	                else {
	                    // Update current waiting booking
	                    this.updateClassReserve(this.waiting, this.selectedClassId);
	                }
	            }
	            else {
	                // Check if there is waiting booking reservation
	                if (!this.tempBooking) {
	                    // Reserve a class
	                    this.sendClassReserve(this.currentSelectClassId);
	                }
	                else {
	                    // Update current waiting booking
	                    this.updateClassReserve(this.tempBooking, this.selectedClassId);
	                }
	            }
	        }
	    };
	    // Toggle class selection
	    ActivitesListComponent.prototype.toggleSelectClass = function (classId) {
	        // Check if class id is exist in temp array
	        if (!this.tempBooking && !this.waiting) {
	            // Reserve a class
	            this.sendClassReserve(classId);
	        }
	        else {
	            var isWaiting = _.find(this.weekSelect[classId], function (o) { return o == false; });
	            // If week select is suitable for waiting status
	            if (isWaiting === false) {
	                // Check if there is waiting booking reservation
	                if (!this.waiting) {
	                    // Reserve a class
	                    this.sendClassReserve(classId);
	                }
	                else {
	                    // Update current waiting booking
	                    this.updateClassReserve(this.waiting, classId);
	                }
	            }
	            else {
	                // Check if there is waiting booking reservation
	                if (!this.tempBooking) {
	                    // Reserve a class
	                    this.sendClassReserve(classId);
	                }
	                else {
	                    // Update current temp booking
	                    this.updateClassReserve(this.tempBooking, classId);
	                }
	            }
	        }
	    };
	    // Reserve a class when select
	    ActivitesListComponent.prototype.sendClassReserve = function (classId) {
	        var _this = this;
	        this.booking = {
	            "name": "sample",
	            "payment_method": "cash",
	            "hol_class_id": classId,
	            "hol_student_id": this.selectedChild.id,
	            "question_answer": this.getQuestionAnswer()
	        };
	        this.booking.weeks = [];
	        // Add weeks
	        Object.keys(this.weekSelect[classId]).forEach(function (prop) {
	            if (_this.weekSelect[classId][prop]) {
	                _this.booking.weeks.push({
	                    hol_week_id: +prop,
	                    excursions: []
	                });
	            }
	        });
	        // Book sample info to make a reservation
	        this.service.postBooking(this.booking).subscribe(function (result) {
	            // Store id to booking info
	            _this.booking.id = result.data.id;
	            // If waiting status
	            if (result.data.status) {
	                if (result.data.status == 'waiting') {
	                    // Add to waiting list
	                    _this.waiting = result.data.id;
	                    // Show message
	                    // this.showWaitingModal = true;
	                }
	                else {
	                    // Save temp booking for full programme
	                    _this.tempBooking = result.data.id;
	                }
	            }
	            _this.booking.hol_class_id = classId;
	            // Toggle selected class
	            _this.selectedClassId = classId;
	        }, function (error) {
	        });
	    };
	    // Update Class reservation on re-select weeks or change class
	    ActivitesListComponent.prototype.updateClassReserve = function (bookingId, classId) {
	        var _this = this;
	        // Renew weeks array
	        this.booking.weeks = [];
	        // Add weeks if checked
	        Object.keys(this.weekSelect[classId]).forEach(function (prop) {
	            if (_this.weekSelect[classId][prop]) {
	                _this.booking.weeks.push({
	                    hol_week_id: +prop,
	                    excursions: []
	                });
	            }
	        });
	        if (bookingId == this.waiting) {
	            // this.showWaitingModal = true;
	        }
	        // Store id to booking info
	        this.booking.id = bookingId;
	        this.booking.hol_class_id = classId;
	        // Toggle selected class
	        this.selectedClassId = classId;
	        // Collect query data
	        // let query = {
	        //     id: bookingId,
	        //     name: this.booking.name,
	        //     hol_class_id: this.booking.hol_class_id,
	        //     hol_student_id: this.booking.hol_student_id
	        // }
	        // Update booking
	        // this.services.updateBooking(query).subscribe(
	        //     result => {
	        //         // If waiting status
	        //         if(result.data.status && result.data.status == 'waiting'){
	        //             // Show message
	        //             this.showWaitingModal = true;
	        //         }
	        //     },
	        //     error => {
	        //     }
	        // )
	    };
	    // Submit Class reservation
	    ActivitesListComponent.prototype.submitClassReservation = function (studentId) {
	        var _this = this;
	        if (this.selectedClassId == '' || !this.weekSelect[this.selectedClassId] || (this.period[this.selectedClassId] == 'period' && this.weekSelect[this.selectedClassId].indexOf(true) === -1)) {
	            return this.showLackInfoModal = true;
	        }
	        // Create weeks array
	        // this.booking.weeks = [];
	        // Check if exist period select
	        this.booking.periodWeeks = [];
	        // If period is full
	        // if(this.period[this.selectedClassId] == 'full'){
	        //     // Loop through week array
	        //     _.forEach(this.weeks, (val, key) => {
	        //         this.booking.periodWeeks.push(val.id)
	        //     })
	        // }
	        // If period is not full
	        // if(this.period[this.selectedClassId] == 'period'){
	        //     // Loop through selected week array with key is weekId
	        //     _.forEach(this.weekSelect[this.selectedClassId], (val, key) => {
	        //         // If val is true we push key to booking weeks array
	        //         if(val){
	        //             this.booking.periodWeeks.push(key)
	        //         }
	        //     })
	        // }
	        Object.keys(this.weekSelect[this.selectedClassId]).forEach(function (prop) {
	            if (_this.weekSelect[_this.selectedClassId][prop]) {
	                _this.booking.periodWeeks.push(+prop);
	            }
	        });
	        // Set discount
	        this.booking.discount = this.children.discount;
	        // Store class info
	        this.booking.class = _.find(this.clases, function (o) {
	            return o.id == _this.selectedClassId;
	        });
	        // Store period select
	        this.booking.period = this.period;
	        // Save week info for later use
	        this.booking.allWeek = this.weeks;
	        // Survey field, don't know what is it
	        // Check survey on editing
	        if (!this.booking.survey) {
	            this.booking.survey = '';
	        }
	        // Store booking info to session
	        this.booking.temp = this.tempBooking;
	        this.booking.waiting = this.waiting;
	        this.setBooking(this.booking);
	        // Navigate to next step
	        this.router.navigate(["booking/" + (this.isWinterSemester ? 'excursions' : 'bus')]);
	        this.services.getChildren().subscribe(function (result) {
	            // Get all children
	            if (result.holStudents) {
	                _this.children = _.filter(result.holStudents, { 'status': 'active' });
	            }
	            // Set session children to avoid re-request
	            _this.setHolidayChildren(result);
	        }, function (error) {
	        });
	    };
	    return ActivitesListComponent;
	}(BookingComponent_1.BookingComponent));
	ActivitesListComponent = __decorate([
	    core_1.Component({
	        selector: 'activites-list',
	        template: __webpack_require__(329),
	        styles: [__webpack_require__(332)]
	    }),
	    __metadata("design:paramtypes", [services_2.FileService,
	        router_1.ActivatedRoute,
	        router_1.Router,
	        services_2.CatalogService,
	        services_1.BookingHolidayService,
	        services_2.SessionStorageService,
	        services_2.LocalStorageService])
	], ActivitesListComponent);
	exports.ActivitesListComponent = ActivitesListComponent;


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<main>\n\t<div class=\"component-title\">\n        <h1>Step 2: Select a Programme</h1>\n    </div>\n    <div class=\"wrap-select-camp-header-inner\">\n        <img src=\"" + __webpack_require__(330) + "\" alt=\"camp-child-icon\" class=\"camp-child-icon\">\n        <div class=\"wrap-select-option-header\">\n            <select [(ngModel)]=\"selectedChild.code\" (ngModelChange)=\"changeChild()\" disabled>\n                <option *ngFor=\"let child of children.holStudents\" [attr.value]=\"child.code\">\n                    {{child.code}} - {{child.given_name}} {{child.family_name}} - ({{timeDataFormat(child.date_of_birth, 'YYYY-MM-DD')}})\n                </option>\n            </select>\n        </div>\n    </div>\n    <div class=\"container\">\n        <div class=\"list-activity\">\n            <h3>HOLIDAY CLASSES</h3>\n            <p style=\"color: red;text-align: center;\"><i>Please select Only one programme for your child</i></p>\n            <section>\n                <ul class=\"row\" *ngIf=\"clases && clases\">\n                    <li *ngIf=\"!clases.length\" class=\"text-center\">There are no booking suitable for your child</li>\n                    <!--Loop through clases-->\n                    <li *ngFor=\"let class of clases\" class=\"small-12 medium-6 large-4 column\">\n                        <div class=\"panel\" [ngClass]=\"{'other-class': class.type === 'required' || class.type === 'team'}\">\n                            <h4 class=\"activity-title\"><span class=\"title\">{{class.name}}</span></h4>\n                            <h5 class=\"campus-title\">\n                                <span class=\"title\">{{class.campus.name}} Campus</span><br/>\n                                <span>DOB from {{timeDataFormat(class.suitable_from, 'MMM DD YYYY')}} to {{timeDataFormat(class.suitable_to, 'MMM DD YYYY')}}</span>\n                            </h5>\n                            \n                            <div class=\"class-image\">\n                                <!--<img [ngStyle]=\"{'background-image': 'url(' + getFileUrl(class.thumbnail_id) + ')' }\" alt=\"{{class.name}}\" *ngIf=\"class.thumbnail_id\">-->\n                                \n                                <img src=\"{{getFileUrl(class.thumbnail_id)}}\" alt=\"{{class.name}}\" *ngIf=\"class.thumbnail_id\">\n                                <img src=\"" + __webpack_require__(331) + "\" alt=\"\" class=\"campImagePlaceholder\" *ngIf=\"!class.thumbnail_id\">\n                            </div>\n                            \n                            <table>\n                                <tr>\n                                    <td>Start Date</td>\n                                    <td>{{ timeDataFormat(class.hol_course.start_date, \"DD MMM YYYY\") }}</td>\n                                </tr>\n                                <tr>\n                                    <td>End Date</td>\n                                    <td>{{ timeDataFormat(class.hol_course.end_date, \"DD MMM YYYY\") }}</td>\n                                </tr>\n                            </table>\n                            <!--Period select-->\n                            <input type=\"radio\" name=\"period_{{class.id}}\" [(ngModel)]=\"period[class.id]\" (click)=\"setFullWeek(class.id)\" id=\"full_{{class.id}}\" value=\"full\">\n                            <label attr.for=\"full_{{class.id}}\">Full Programme</label><br>\n                            <input type=\"radio\" name=\"period_{{class.id}}\" [(ngModel)]=\"period[class.id]\" (click)=\"openWeekModal(class.id)\" id=\"period_{{class.id}}\" value=\"period\" *ngIf=\"currentSemester.name === 'Semester 2'\">\n                            <label attr.for=\"period_{{class.id}}\" *ngIf=\"currentSemester.name === 'Semester 2'\">Select Period</label><br>\n                            <!--End of Period select-->\n                            <a (click)=\"showClassDescription(class.name, class.activities)\" class=\"description\"><span class=\"i-icon\"></span> Click here for the description</a>\n                            <h4 class=\"activity-price\">\n                                {{class.total_cost | number :'1.0-0'}} VND<br>\n                                <span *ngIf=\"currentSemester.name === 'Semester 2'\">({{this.weeks.length}} Weeks)</span>\n                            </h4>\n\n                            <!--Select button when not editing-->\n                            <button type=\"button\" (click)=\"toggleSelectClass(class.id)\" [ngClass]=\"{'selected': selectedClassId === class.id}\">\n                                <span class=\"\">Select</span>\n                            </button>\n                        </div>\n                    </li>\n                </ul>\n                <div class=\"special-offer\">\n                    <h5>SPECIAL OFFER</h5>\n                    <p>Only one of the special offers below can be applied when you register for the {{currentYear}} {{ currentSemester.name === 'Semester 2' ? 'Summer Programme' : 'Winter Programme' }}:</p>\n                    <ul>\n                        <li *ngIf=\"earlyBirdConfig\">{{ earlyBirdConfig.value }}% early bird discount if payment is made by {{earlyBirdConfig.condition}}; or</li>\n                        <!-- <li>10% early bird discount if registered for full 5 weeks programme and payment is made by 08 May 2021; or</li> -->\n                        <li *ngIf=\"siblingConfig\">{{ siblingConfig.value }}% siblings discount for second and subsequent child/children; or</li>\n                        <!-- <li>10% siblings discount for second and subsequent child/children; or</li> -->\n                        <li *ngIf=\"aisStudentConfig\">{{ aisStudentConfig.value }}% AIS students discount for current AIS, EIS students; or</li>\n                        <!-- <li>10% AIS students discount for current AIS students; or</li> -->\n                        <!-- <li>Free Week 1 & 2, 10% discount from Week 3 for current AIS students</li> -->\n                        <li *ngIf=\"olderConfig\">{{ olderConfig.value }}% returners discount for students who attended either the AIS Summer school 2026 or Winter Programme {{checkReturnerYear()}}.</li>\n                        <!-- <li>10% returners discount for students who attended either the AIS Summer or Winter Programme 2020.</li> -->\n                    </ul>\n                </div>\n\n            </section>\n\n            <!-- Remind session Modal -->\n            <!--<div class=\"modal\" [hidden]=\"!showRemindModal\">-->\n                <!-- Modal content -->\n                <!--<div class=\"modal-content\">-->\n                    <!--<div class=\"modal-header\">-->\n                        <!--<span class=\"close\" (click)=\"showRemindModal = false\">×</span>-->\n                        <!--<h2>Notice</h2>-->\n                    <!--</div>-->\n                    <!--<div class=\"modal-body\">You have 10 minutes to finish your booking</div>-->\n                <!--</div>-->\n            <!--</div>-->\n            <!-- End of Remind session Modal -->\n\n            <!-- lack of info Modal -->\n            <div class=\"modal\" [hidden]=\"!showLackInfoModal\">\n                <!-- Modal content -->\n                <div class=\"modal-content\">\n                    <div class=\"modal-header\">\n                        <span class=\"close\" (click)=\"showLackInfoModal = false\">×</span>\n                        <h2>Lack of information</h2>\n                    </div>\n                    <div class=\"modal-body\">Please select a programme and period to continue to next step</div>\n                </div>\n            </div>\n            <!-- End of lack of info Modal -->\n\n            <!-- Waiting list Modal -->\n            <div class=\"modal\" [hidden]=\"!showWaitingModal\">\n                <!-- Modal content -->\n                <div class=\"modal-content\">\n                    <div class=\"modal-header\">\n                        <span class=\"close\" (click)=\"showWaitingModal = false\">×</span>\n                        <h2>Class is full</h2>\n                    </div>\n                    <div class=\"modal-body\">Your booking will be sort in waiting list</div>\n                </div>\n            </div>\n            <!-- End of Waiting list Modal -->\n\n            <!-- Description Modal -->\n            <div class=\"modal\" id=\"descriptionModal\">\n                <!-- Modal content -->\n                <div class=\"modal-content\">\n                    <div class=\"modal-header\">\n                        <span class=\"close\" (click)=\"closeModal()\">×</span>\n                        <h2 id=\"classDescriptionModalTitle\"></h2>\n                    </div>\n                    <div>\n                        <table>\n                            <tr class=\"table-header\">\n                                <td id=\"classDescriptionModalBody\"></td>\n                            </tr>\n                        </table>\n                    </div>\n                </div>\n            </div>\n            <!-- End of Description Modal -->\n            \n            <p-dialog #dialog header=\"Select Week\" [(visible)]=\"showWeekModal\" [draggable]=\"false\" [resizable]=\"false\" [modal]=\"true\" [closable]=\"true\" [responsive]=\"true\" [appendTo]=\"body\" [styleClass]=\"'medium'\" (onAfterHide)=\"onCloseWeekModal(event)\">\n                <ul class=\"list-unstyled\" *ngIf=\"weeks && weekSelect[currentSelectClassId]\">\n                    <li *ngFor=\"let week of weeks\">\n                        <div class=\"checkbox\">\n                            <input id=\"week_{{week.id}}\" name=\"week_{{week.id}}\" [(ngModel)]=\"weekSelect[currentSelectClassId][week.id]\" type=\"checkbox\">    <label attr.for=\"week_{{week.id}}\">{{week.name}}: from {{timeDataFormat(week.start_date, 'YYYY-MM-DD')}} to {{timeDataFormat(week.end_date, 'YYYY-MM-DD')}}</label>\n                        </div>\n                    </li>\n                </ul>\n                <footer class=\"text-center\">\n                    <button class=\"button\" (click)=\"dialog.hide($event)\">OK</button>                            \n                </footer>\n            </p-dialog>\n            \n            <!-- Select Week Modal -->\n            <!--<div class=\"modal\" [hidden]=\"!showWeekModal\">-->\n                <!-- Modal content -->\n                <!--<div class=\"modal-content\">\n                    <div class=\"modal-header\">\n                        <span class=\"close\" (click)=\"toggleWeekModal()\">×</span>\n                        <h2 id=\"classDescriptionModalTitle\">Select Week</h2>\n                    </div>\n                    <div class=\"modal-body\">\n                        <ul class=\"list-unstyled\" *ngIf=\"weeks && weekSelect[currentSelectClassId]\">\n                            <li class=\"checkbox\" *ngFor=\"let week of weeks\">\n                                <label>\n                                    <input id=\"week_{{week.id}}\" name=\"week_{{week.id}}\" [(ngModel)]=\"weekSelect[currentSelectClassId][week.id]\" type=\"checkbox\"> {{week.name}}: from {{timeDataFormat(week.start_date, 'YYYY-MM-DD')}} to {{timeDataFormat(week.end_date, 'YYYY-MM-DD')}}                            \n                                </label>\n                            </li>\n                        </ul>\n                        <div class=\"text-center\">\n                            <button class=\"button\" (click)=\"toggleWeekModal()\">OK</button>                            \n                        </div>\n                    </div>\n                </div>\n            </div>-->\n            <!-- End of Select Week Modal -->\n        </div>\n    </div>\n    <div id=\"submit\" class=\"row\" *ngIf=\"clases\">\n        <div class=\"large-4 l-btn\">\n            <button [hidden]=\"clases.length && !getQuestionAnswer() && !booking.question_answer\" class=\"l-btn\" (click)=\"toQuestionAnswerPage()\">Back</button>            \n        </div>\n        <div class=\"large-8 r-btn\">\n            <!--<button class=\"submit\" (click)=\"submitClassReservation()\" [disabled]=\"selectedClassId == '' || !weekSelect[selectedClassId]\">Submit</button>-->\n            <button [hidden]=\"!clases.length\" class=\"submit\" (click)=\"submitClassReservation()\">CONTINUE</button>\n        </div>\n    </div>\n</main>";

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/select_camp_child_icon.b8f75fbf810f2db55dbf73548992cfa2.png";

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/camp_item_default_image.5ca59e5e88de32b16d4fa0b7588a6b0f.jpg";

/***/ }),
/* 332 */
/***/ (function(module, exports) {

	module.exports = ".text-left{text-align:left}.countdown{text-align:right;font-size:18px;padding:10px 20px}.container{width:80%;margin:0 auto;padding:2rem 1.25rem}.container .headline{background:#faa635;border-bottom-left-radius:5px;border-bottom-right-radius:5px;padding:0.3rem 1.5rem;margin:2rem 0 1rem}.container .headline h2{font-size:1.5625rem;color:#043d7a;font-weight:bold;text-align:right}.container .headline .algn-l{text-align:left}.container div p{font-size:0.875rem;color:#6e6e6e;line-height:1.6}.component-title{color:#043d7a;background-color:#f8f8f8;padding:1.5rem 10%;border-bottom:1px solid #eaeaea}.component-title h1{margin:0 auto;padding:0 1.25rem;font-size:1.5256rem}.component-title small{padding:0 1.25rem;font-size:90%}.wrap-select-camp-header-inner{width:100%;padding:1rem calc(10% + 1.25rem) 0;background:#f8f8f8;border-top:1px solid white}.wrap-select-camp-header-inner .camp-child-icon{vertical-align:-3px;margin-right:10px}.wrap-select-camp-header-inner .wrap-select-option-header{display:inline-block;position:relative}.wrap-select-camp-header-inner .wrap-select-option-header:before{content:'';color:#ddd;width:2.5rem;height:1.5625rem;position:absolute;pointer-events:none;right:17px;top:17px;width:0;height:0;border-left:5px solid transparent;border-right:5px solid transparent;border-top:8px solid #ddd}.wrap-select-camp-header-inner .wrap-select-option-header:after{content:'';position:absolute;height:1.5625rem;width:1px;background:#ddd;top:8px;right:40px}.wrap-select-camp-header-inner .wrap-select-option-header select{padding:0 50px 0 13px;border-radius:5px;font-size:1rem;background:#f8f8f8;border:1px solid #ddd;height:2.5rem;color:#282828;outline:none}#submit{max-width:100%;width:100%;padding:2rem 10%;border-top:1px solid #ddd}#submit .l-btn{padding-left:1.25rem}#submit .l-btn button{text-align:left;padding:1.25rem 5.25rem;font-size:1.25rem;font-weight:bold;background:#eaeaea;color:#6e6e6e}#submit .r-btn{text-align:right;padding-right:1.25rem}#submit .r-btn p{text-align:right;font-size:0.875rem;padding-right:1.125rem;padding-top:1rem}#submit .r-btn p a{font-weight:bold}#submit .r-btn .submit{padding:1.25rem 3rem;text-align:center;font-size:1.25rem;font-weight:bold}.bus-registration-container{width:80%;margin:0 auto;padding:0px 1.25rem;margin-bottom:1.5rem}.bus-registration-container h3{font-size:1.525rem;font-weight:bold;color:#043d7a;text-align:center;margin:2rem auto 1rem}.bus-registration-container .total-amount{background:#faa635;border-bottom-left-radius:5px;border-bottom-right-radius:5px;padding:0.3rem 1.5rem}.bus-registration-container .total-amount h2{font-size:1.5625rem;color:#043d7a;font-weight:bold;text-align:right}.bus-registration-container .total-amount .algn-l{text-align:left}.bus-registration-container .total-amount p{font-size:0.875rem;color:#6e6e6e;text-align:justify;line-height:1.6}.bus-registration-container .bus-registration-section{padding:0 1.25rem;margin-top:1rem;justify-content:space-between}.bus-registration-container .bus-registration-section table{text-align:left}.bus-registration-container .bus-registration-section table tr:first-child{background:#043d7a;color:#fff}.bus-registration-container .bus-registration-section p{font-size:0.875rem;color:#6e6e6e;text-align:justify;line-height:1.6}.bus-registration-container .bus-registration-section h5{font-size:1.125rem;color:#043d7a;font-weight:bold;margin-bottom:0.375rem}.bus-registration-container .bus-registration-section ul{list-style-type:decimal}.bus-registration-container .bus-registration-section ul li{font-size:0.875rem;color:#6e6e6e;text-align:justify}.bus-registration-container .bus-registration-section .bus-registration-term{padding-right:3rem}.bus-registration-container .bus-registration-section .bus-registration-method form{box-shadow:none;padding:0;font-size:1rem}.bus-registration-container .bus-registration-section .bus-registration-method form input[type=\"radio\"]{display:none}.bus-registration-container .bus-registration-section .bus-registration-method form input[type=\"radio\"]+label{margin-bottom:0.5rem;font-size:1rem;font-weight:bold;color:#6e6e6e}.bus-registration-container .bus-registration-section .bus-registration-method form input[type=\"radio\"]:disabled+label:before{background:#eee}.bus-registration-container .bus-registration-section .bus-registration-method form input[type=\"radio\"]+label:before{color:#6e6e6e;content:\"\\00a0\";display:inline-block;font:1em sans-serif;margin-right:0.5rem;padding:0;vertical-align:middle;width:1.25rem;height:1.25rem;border-radius:10px;border:1px solid #b8b8b8}.bus-registration-container .bus-registration-section .bus-registration-method form input[type=\"radio\"]:checked+label:before{content:\"\\2022\";color:#b8b8b8;font-size:2.5rem;line-height:19px;text-align:center}.modal{position:fixed;z-index:1;left:0;top:0;width:100%;height:100%;overflow:auto;background-color:#000;background-color:rgba(0,0,0,0.4)}.modal table{display:block;padding:5px 10px;margin-bottom:0;background:#fff;border-bottom-right-radius:5px;border-bottom-left-radius:5px}.modal table tbody{border:none}.modal table tbody td{font-weight:bold;font-size:0.875rem;color:#6e6e6e}.modal .modal-content{margin:0;max-width:400px;position:absolute;top:50%;left:50%;-ms-transform:translateX(-50%) translateY(-50%);-webkit-transform:translate(-50%, -50%);transform:translate(-50%, -50%)}.modal .modal-content .close{color:#fff;float:right;font-size:20px;font-weight:bold;line-height:1}.modal .modal-content .close:hover,.modal .modal-content .close:focus{color:#eee;text-decoration:none;cursor:pointer}.modal .modal-header{text-align:center;padding:10px 20px;color:#fff;background:#043d7a;font-size:1.25rem;font-weight:bold;border-top-right-radius:5px;border-top-left-radius:5px}.modal .modal-header h2{text-align:left;font-size:1rem;font-weight:bold;margin-bottom:0}.modal .modal-body{padding:10px 20px;background:#fff;border-bottom-right-radius:5px;border-bottom-left-radius:5px}@media only screen and (max-width: 40em){.select-camp-header .select-camp-header-inner{padding:0}.select-camp-header .select-camp-header-inner h4{padding-left:10%;padding-right:10%}.select-camp-header .select-camp-header-inner .wrap-select-camp-header-inner{padding:0}.select-camp-header .select-camp-header-inner .wrap-select-camp-header-inner .camp-child-icon{display:none}.list-camp h3{margin:1.5rem auto 1.5rem;line-height:0.7;font-size:1.4rem}.list-camp .row li{padding:0}}form{padding:0;border:none;box-shadow:none;background:none}input[type=\"radio\"]{vertical-align:-2px;margin-bottom:0}label{color:#666;font-weight:bold}.component-title{color:#043d7a;background-color:#f8f8f8;padding:1.5rem 0;border-bottom:1px solid #eaeaea}.component-title h1{width:80%;margin:0 auto;padding:0 1.25rem;font-size:1.5256rem}.container{width:80%;margin:0 auto;padding:2rem 1.25rem}.container .list-activity .buttons{text-align:right}.container .list-activity .buttons button{min-width:10rem;background:transparent;border:1px solid;height:3.75rem;box-shadow:none;position:relative;color:#043d7a;margin-left:.5rem}.container .list-activity .buttons button span{color:#043d7a}.container .list-activity .buttons button:before{content:\"\";position:absolute;font-family:'Material Icons';font-size:1.125rem}.container .list-activity .buttons button:hover{box-shadow:0 8px 10px 1px rgba(0,0,0,0.14),0 3px 14px 2px rgba(0,0,0,0.12),0 5px 5px -3px rgba(0,0,0,0.2)}.container .list-activity .buttons button.previous:before{content:\"keyboard_arrow_left\";left:10px}.container .list-activity .buttons button.next:before{content:\"keyboard_arrow_right\";right:10px}.container .list-activity .buttons button:disabled{color:#b8b8b8}.container .list-activity h3{font-size:1.525rem;font-weight:bold;color:#043d7a;text-align:center}.container .list-activity .tabs{border:none;background:#f8f8f8;border-radius:5px}.container .list-activity .tabs .tabs-title{width:20%}.container .list-activity .tabs .tabs-title a{text-align:center;font-size:1.25rem;color:#a3a3a3}.container .list-activity .tabs .tabs-title a.is-active{border-bottom:5px solid #faa635;background:#f8f8f8;color:#282828}.container .list-activity .tabs .tabs-title a:hover{border-bottom:5px solid #faa635;background:#f8f8f8;color:#282828}.container .list-activity .tabs .tabs-title a span{position:relative;font-weight:bold}.container .list-activity .tabs .tabs-title a span.selected-icon:after{content:\"\";position:absolute;top:2px;left:-36px;border:2px solid;width:24px;height:24px;border-radius:50%}.container .list-activity .tabs .tabs-title a span.selected-icon:before{content:\"\";position:absolute;top:18px;left:-27px;width:5px;height:12px;border-width:0 2px 2px 0;border-style:solid;margin-top:-11px;-webkit-transform:rotate(30deg);-moz-transform:rotate(30deg);-ms-transform:rotate(30deg);-o-transform:rotate(30deg);transform:rotate(30deg)}.container .list-activity section .special-offer{padding-left:0.9375rem;padding-right:0.9375rem}.container .list-activity section .special-offer form{box-shadow:none;padding:0;font-size:1rem}.container .list-activity section .special-offer form input[type=\"radio\"]{display:none}.container .list-activity section .special-offer form input[type=\"radio\"]+label{margin-bottom:0.5rem;font-size:1rem;font-weight:bold;color:#6e6e6e}.container .list-activity section .special-offer form input[type=\"radio\"]:disabled+label:before{background:#eee}.container .list-activity section .special-offer form input[type=\"radio\"]+label:before{color:#6e6e6e;content:\"\\00a0\";display:inline-block;font:1em sans-serif;margin-right:0.5rem;padding:0;vertical-align:middle;width:1.25rem;height:1.25rem;border-radius:10px;border:1px solid #b8b8b8}.container .list-activity section .special-offer form input[type=\"radio\"]:checked+label:before{content:\"\\2022\";color:#b8b8b8;font-size:2.5rem;line-height:19px;text-align:center}.container .list-activity section .special-offer h5{font-size:1.125rem;color:#043d7a;font-weight:bold;margin-bottom:0.375rem;color:#043d7a}.container .list-activity section .special-offer p{font-size:1rem;font-weight:bold;margin-bottom:0.5rem}.container .list-activity section .special-offer ul li label{font-size:1rem}.container .list-activity section .row{padding-top:2rem;list-style:none}.container .list-activity section .row li{margin-bottom:1.5625rem}.container .list-activity section .row li .panel.other-class{background:#e1e1e1}.container .list-activity section .row li .panel.other-class>p{text-align:center;margin:8px 0;padding:12px 0;font-weight:bold}.container .list-activity section .row li .panel.other-class h4{color:#282828}.container .list-activity section .row li .panel.other-class h4 .activity-available{color:#666;font-size:1.125rem}.container .list-activity section .row li .panel.other-class table{color:#282828}.container .list-activity section .row li .panel.other-class .description{color:#043d7a}.container .list-activity section .row li .panel.waiting-list button{background:#043d7a;border:1px solid #fff;font-weight:normal;opacity:0.8}.container .list-activity section .row li .panel.waiting-list button:hover{color:#fff}.container .list-activity section .row li .panel{border-radius:5px;background:#fff;padding:5.8%;border:1px solid #ddd}.container .list-activity section .row li .panel h5{font-size:1rem;font-weight:bold;margin-bottom:2rem;color:#666}.container .list-activity section .row li .panel .full{margin-bottom:0;text-align:center;font-weight:bold;text-transform:uppercase;color:#faa635;letter-spacing:0.6px}.container .list-activity section .row li .panel .description{color:#043d7a;text-decoration:underline;margin-top:1rem;margin-bottom:1.5rem;display:block;position:relative;font-size:13px;padding-left:25px}.container .list-activity section .row li .panel .description .i-icon{font-size:12px;border-radius:50%;border:2px solid;position:absolute;left:0;top:2px;width:18px;height:18px;line-height:13px;text-align:center}.container .list-activity section .row li .panel .description .i-icon:before{content:\"i\";display:block;margin:0 auto}.container .list-activity section .row li .panel h4{text-align:left;font-size:1.25rem;color:#043d7a;margin-bottom:1rem;position:relative;min-height:3.6rem}.container .list-activity section .row li .panel h4 .title{width:calc(100% - 50px);font-weight:bold}.container .list-activity section .row li .panel h4 .i-icon{padding:0 0.5rem;font-size:14px;border-radius:50%;border:2px solid;position:absolute;right:0;top:2px}.container .list-activity section .row li .panel h4 .i-icon:before{content:\"i\"}.container .list-activity section .row li .panel .class-image img{border-radius:5px;overflow:hidden;width:100%;height:auto;background-size:cover;text-indent:-9999px}.container .list-activity section .row li .panel table{width:100%;color:#666;font-size:14px;margin-top:12px;line-height:24px;margin-bottom:12px}.container .list-activity section .row li .panel table tr>td:nth-child(2){text-align:right;font-weight:bold}.container .list-activity section .row li .panel table tbody{border:none;background:none}.container .list-activity section .row li .panel table tbody th,.container .list-activity section .row li .panel table tbody td{padding:0}.container .list-activity section .row li .panel table tbody tr:nth-child(even){background:none}.container .list-activity section .row li .panel .activity-price{color:#faa635;font-weight:bold;text-align:center;height:95px}.container .list-activity section .row li .panel .activity-price span{font-size:1rem}.container .list-activity section .row li .panel .activity-price .activity-available{font-size:1.125rem;color:#666;font-weight:normal}.container .list-activity section .row li .panel button{width:100%;background-color:#ebebeb;font-weight:bold;color:#043D7A}.container .list-activity section .row li .panel button.selected{background-color:#faa635}.container .list-activity section .row li .panel button.selected span.selected-icon{margin-left:2rem}.container .list-activity section .row li .panel button.selected span.selected-icon:after{content:\"\";position:absolute;top:-1px;left:-36px;border:2px solid;width:24px;height:24px;border-radius:50%}.container .list-activity section .row li .panel button.selected span.selected-icon:before{content:\"\";position:absolute;top:15px;left:-27px;width:5px;height:12px;border-width:0 2px 2px 0;border-style:solid;margin-top:-11px;-webkit-transform:rotate(30deg);-moz-transform:rotate(30deg);-ms-transform:rotate(30deg);-o-transform:rotate(30deg);transform:rotate(30deg)}.container .list-activity section .row li .panel button.selected.i-icon{font-weight:normal;margin-left:2rem;margin-right:0.75rem;padding:0 0.5rem;font-size:14px;border-radius:50%;right:0;top:2px}.container .list-activity section .row li .panel button.selected.i-icon:before{content:\"!\";position:absolute;left:-26px;top:1px}.container .list-activity section .row li .panel button.selected.i-icon:after{content:\"\";position:absolute;left:-36px;top:-4px;width:24px;height:24px;border-radius:50%;border:2px solid}.container .list-activity section .row li .panel button span{position:relative;font-weight:bold}.container form{border:none;box-shadow:none}.container form .form-button-group{text-align:center}.container form .form-button-group button{margin:1rem;min-width:7rem}@media only screen and (max-width: 75em){.container .tabs li a{padding:3rem 1.5rem 1.25rem}.container .tabs li a span.selected-icon:after{content:\"\" !important;position:absolute !important;left:50% !important;top:-25px !important;border:2px solid !important;width:24px !important;height:24px !important;border-radius:50% !important;margin-left:-12px !important}.container .tabs li a span.selected-icon:before{top:-10px !important;left:50% !important;margin-left:-3px !important}}@media only screen and (max-width: 40em){.container .tabs li a{padding:1.25rem 1.5rem}.container .tabs li a span{font-family:monospace;width:3ch;overflow:hidden;white-space:nowrap;font-size:20px;display:inline-block}.wrap-select-camp-header-inner .camp-child-icon{display:none}.list-camp h3{margin:1.5rem auto 1.5rem;line-height:0.7;font-size:1.4rem}.list-camp .row li{padding:0}}\n"

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var BookingComponent_1 = __webpack_require__(314);
	var _ = __webpack_require__(64);
	// Services
	var services_1 = __webpack_require__(315);
	var services_2 = __webpack_require__(58);
	var ExcursionsComponent = (function (_super) {
	    __extends(ExcursionsComponent, _super);
	    function ExcursionsComponent(route, router, services, sessionStorageService, local) {
	        var _this = _super.call(this, router, services, sessionStorageService) || this;
	        _this.route = route;
	        _this.router = router;
	        _this.services = services;
	        _this.sessionStorageService = sessionStorageService;
	        _this.local = local;
	        _this.booking = [];
	        _this.excursions = [];
	        // Select excursions
	        _this.selectedExcursion = [];
	        _this.agree = false;
	        _this.showAgreeWarning = false;
	        return _this;
	    }
	    ExcursionsComponent.prototype.ngOnInit = function () {
	        // Retrieve booking information from session
	        this.booking = this.getBooking();
	        // Get excursions
	        this.getAllExcursions();
	        // Init booking info
	        this.initBooking();
	    };
	    // Initial booking from session
	    ExcursionsComponent.prototype.initBooking = function () {
	        var _this = this;
	        if (this.booking.selectedExcursion && this.booking.selectedExcursion.length) {
	            this.selectedExcursion = this.booking.selectedExcursion;
	            this.agree = true;
	        }
	        else {
	            setTimeout(function () {
	                _.forEach(_this.booking.hol_weeks, function (val, key) {
	                    // If we have excursion on this week
	                    if (val.hol_booking_week.excursions.length) {
	                        // Find excursion with hol_week_id
	                        var ex = _.find(_this.excursions, { 'hol_week_id': val.id });
	                        // Set agreement
	                        _this.agree = true;
	                        // Set to selectedExcursion
	                        if (ex)
	                            _this.selectedExcursion[ex.id] = true;
	                    }
	                });
	            }, 100);
	        }
	    };
	    ExcursionsComponent.prototype.getAllExcursions = function () {
	        var _this = this;
	        this.services.getExcursions().subscribe(function (result) {
	            // Get excursions
	            _this.excursions = result;
	            _this.filteredExcursions = [];
	            // Loop through selected weeks in booking info
	            _.forEach(_this.booking.periodWeeks, function (wVal, wKey) {
	                // Loop through excursions array
	                _.forEach(_this.excursions, function (exVal, exKey) {
	                    // If week id and class id is the same of excursion
	                    if (wVal == exVal.hol_week_id && _this.booking.hol_class_id == exVal.hol_class_id) {
	                        // push an excursion to filtered array
	                        _this.filteredExcursions.push({
	                            week: _.find(_this.booking.allWeek, { 'id': wVal }),
	                            excursion: exVal
	                        });
	                    }
	                });
	            });
	        }, function (error) {
	        });
	    };
	    // Submit Excursion step
	    ExcursionsComponent.prototype.submitExcursion = function () {
	        var _this = this;
	        // Display Terms and conditions agreement when unclick
	        if (this.selectedExcursion.indexOf(true) !== -1) {
	            if (!this.agree) {
	                return this.showAgreeWarning = true;
	            }
	        }
	        // Renew weeks array
	        this.booking.weeks = [];
	        _.forEach(this.booking.periodWeeks, function (wVal, wKey) {
	            var ex = _.find(_this.excursions, { 'hol_week_id': wVal, 'hol_class_id': _this.booking.hol_class_id });
	            if (ex && _this.selectedExcursion[ex.id]) {
	                _this.booking.weeks.push({
	                    "hol_week_id": wVal,
	                    "excursions": [
	                        {
	                            "name": ex.name,
	                            "description": ex.description,
	                            "place": ex.place
	                        }
	                    ]
	                });
	            }
	            else {
	                _this.booking.weeks.push({
	                    "hol_week_id": wVal,
	                    "excursions": []
	                });
	            }
	        });
	        // Set selected excursions
	        this.booking.selectedExcursion = this.selectedExcursion;
	        // Store booking info to session
	        this.setBooking(this.booking);
	        // Navigate to next step
	        // If no excursion was selected
	        return this.router.navigate(['booking/bus']);
	    };
	    return ExcursionsComponent;
	}(BookingComponent_1.BookingComponent));
	ExcursionsComponent = __decorate([
	    core_1.Component({
	        selector: 'review-schedule',
	        template: __webpack_require__(334),
	        styles: [__webpack_require__(335)]
	    }),
	    __metadata("design:paramtypes", [router_1.ActivatedRoute,
	        router_1.Router,
	        services_1.BookingHolidayService,
	        services_2.SessionStorageService,
	        services_2.LocalStorageService])
	], ExcursionsComponent);
	exports.ExcursionsComponent = ExcursionsComponent;


/***/ }),
/* 334 */
/***/ (function(module, exports) {

	module.exports = "<main>\n\t<div class=\"component-title\">\n        <h1>Step 2: Select excursion below if you wish your child to join</h1>\n        <small><i>(Fee is included in tuition)</i></small>\n    </div>\n    <div class=\"container\">\n        <!--Excursion list-->\n        <div *ngIf=\"filteredExcursions\">\n            <div *ngFor=\"let ex of filteredExcursions\">\n                <label>\n                    <input type=\"checkbox\" name=\"ex_{{ex.id}}\" [(ngModel)]=\"selectedExcursion[ex.excursion.id]\"> {{ex.week.name}}: {{ex.excursion.name}} - {{ex.excursion.place}}\n                </label>\n            </div>\n        </div>\n        <div *ngIf=\"filteredExcursions && !filteredExcursions.length\">No excursion for this programme</div>\n        <!--End of Excursion list-->\n\n        <!--Terms and Conditions-->\n        <div *ngIf=\"filteredExcursions && filteredExcursions.length\">\n            <div class=\"headline large-12 medium-12 small-12\">\n                <h2 class=\"algn-l\">Terms and Conditions</h2>\n            </div>\n            <div class=\"large-12 medium-12 small-12\">\n                <p>We give permission for our child to participate in the above off-site activities while attending AIS Summer Programme 2021 (19 June 2021 - 23 July 2021).<br/><br/>\n                We agree that our child's photo may be taken and used in the weekly Summer Programme newspaper and school website. We give permission for School to use these photos.<br/><br/>\n                In the event that there is an accident or our child requires emergency medical treatment, and neither we nor my/our emergency contact can be notified, we authorise the School to initiate such emergency medical procedures as it deems necessary in the best interest of my child.\n                </p>\n                <label>\n                    <input type=\"checkbox\" name=\"agree\" [(ngModel)]=\"agree\">I agree to the above terms and conditions\n                </label>\n            </div>\n        </div>\n        <!--End of Terms and Conditions-->\n    </div>\n\n    <!-- Description Modal -->\n    <div class=\"modal\" [hidden]=\"!showAgreeWarning\">\n        <!-- Modal content -->\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <span class=\"close\" (click)=\"showAgreeWarning = false\">×</span>\n                <h2>Terms and conditions warning</h2>\n            </div>\n            <div class=\"modal-body\">\n                <span>You must agree with terms and conditions</span>\n            </div>\n        </div>\n    </div>\n    <!-- End of Description Modal -->\n\n    <div id=\"submit\" class=\"row\">\n        <div class=\"large-4 l-btn\">\n            <button class=\"back-btn\" (click)=\"backToActivitiesList()\">Back</button>\n        </div>\n        <div class=\"large-8 r-btn\">\n            <button class=\"submit large-5\" (click)=\"submitExcursion()\">CONTINUE</button>\n        </div>\n    </div>\n</main>";

/***/ }),
/* 335 */
/***/ (function(module, exports) {

	module.exports = ".text-left{text-align:left}.countdown{text-align:right;font-size:18px;padding:10px 20px}.container{width:80%;margin:0 auto;padding:2rem 1.25rem}.container .headline{background:#faa635;border-bottom-left-radius:5px;border-bottom-right-radius:5px;padding:0.3rem 1.5rem;margin:2rem 0 1rem}.container .headline h2{font-size:1.5625rem;color:#043d7a;font-weight:bold;text-align:right}.container .headline .algn-l{text-align:left}.container div p{font-size:0.875rem;color:#6e6e6e;line-height:1.6}.component-title{color:#043d7a;background-color:#f8f8f8;padding:1.5rem 10%;border-bottom:1px solid #eaeaea}.component-title h1{margin:0 auto;padding:0 1.25rem;font-size:1.5256rem}.component-title small{padding:0 1.25rem;font-size:90%}.wrap-select-camp-header-inner{width:100%;padding:1rem calc(10% + 1.25rem) 0;background:#f8f8f8;border-top:1px solid white}.wrap-select-camp-header-inner .camp-child-icon{vertical-align:-3px;margin-right:10px}.wrap-select-camp-header-inner .wrap-select-option-header{display:inline-block;position:relative}.wrap-select-camp-header-inner .wrap-select-option-header:before{content:'';color:#ddd;width:2.5rem;height:1.5625rem;position:absolute;pointer-events:none;right:17px;top:17px;width:0;height:0;border-left:5px solid transparent;border-right:5px solid transparent;border-top:8px solid #ddd}.wrap-select-camp-header-inner .wrap-select-option-header:after{content:'';position:absolute;height:1.5625rem;width:1px;background:#ddd;top:8px;right:40px}.wrap-select-camp-header-inner .wrap-select-option-header select{padding:0 50px 0 13px;border-radius:5px;font-size:1rem;background:#f8f8f8;border:1px solid #ddd;height:2.5rem;color:#282828;outline:none}#submit{max-width:100%;width:100%;padding:2rem 10%;border-top:1px solid #ddd}#submit .l-btn{padding-left:1.25rem}#submit .l-btn button{text-align:left;padding:1.25rem 5.25rem;font-size:1.25rem;font-weight:bold;background:#eaeaea;color:#6e6e6e}#submit .r-btn{text-align:right;padding-right:1.25rem}#submit .r-btn p{text-align:right;font-size:0.875rem;padding-right:1.125rem;padding-top:1rem}#submit .r-btn p a{font-weight:bold}#submit .r-btn .submit{padding:1.25rem 3rem;text-align:center;font-size:1.25rem;font-weight:bold}.bus-registration-container{width:80%;margin:0 auto;padding:0px 1.25rem;margin-bottom:1.5rem}.bus-registration-container h3{font-size:1.525rem;font-weight:bold;color:#043d7a;text-align:center;margin:2rem auto 1rem}.bus-registration-container .total-amount{background:#faa635;border-bottom-left-radius:5px;border-bottom-right-radius:5px;padding:0.3rem 1.5rem}.bus-registration-container .total-amount h2{font-size:1.5625rem;color:#043d7a;font-weight:bold;text-align:right}.bus-registration-container .total-amount .algn-l{text-align:left}.bus-registration-container .total-amount p{font-size:0.875rem;color:#6e6e6e;text-align:justify;line-height:1.6}.bus-registration-container .bus-registration-section{padding:0 1.25rem;margin-top:1rem;justify-content:space-between}.bus-registration-container .bus-registration-section table{text-align:left}.bus-registration-container .bus-registration-section table tr:first-child{background:#043d7a;color:#fff}.bus-registration-container .bus-registration-section p{font-size:0.875rem;color:#6e6e6e;text-align:justify;line-height:1.6}.bus-registration-container .bus-registration-section h5{font-size:1.125rem;color:#043d7a;font-weight:bold;margin-bottom:0.375rem}.bus-registration-container .bus-registration-section ul{list-style-type:decimal}.bus-registration-container .bus-registration-section ul li{font-size:0.875rem;color:#6e6e6e;text-align:justify}.bus-registration-container .bus-registration-section .bus-registration-term{padding-right:3rem}.bus-registration-container .bus-registration-section .bus-registration-method form{box-shadow:none;padding:0;font-size:1rem}.bus-registration-container .bus-registration-section .bus-registration-method form input[type=\"radio\"]{display:none}.bus-registration-container .bus-registration-section .bus-registration-method form input[type=\"radio\"]+label{margin-bottom:0.5rem;font-size:1rem;font-weight:bold;color:#6e6e6e}.bus-registration-container .bus-registration-section .bus-registration-method form input[type=\"radio\"]:disabled+label:before{background:#eee}.bus-registration-container .bus-registration-section .bus-registration-method form input[type=\"radio\"]+label:before{color:#6e6e6e;content:\"\\00a0\";display:inline-block;font:1em sans-serif;margin-right:0.5rem;padding:0;vertical-align:middle;width:1.25rem;height:1.25rem;border-radius:10px;border:1px solid #b8b8b8}.bus-registration-container .bus-registration-section .bus-registration-method form input[type=\"radio\"]:checked+label:before{content:\"\\2022\";color:#b8b8b8;font-size:2.5rem;line-height:19px;text-align:center}.modal{position:fixed;z-index:1;left:0;top:0;width:100%;height:100%;overflow:auto;background-color:#000;background-color:rgba(0,0,0,0.4)}.modal table{display:block;padding:5px 10px;margin-bottom:0;background:#fff;border-bottom-right-radius:5px;border-bottom-left-radius:5px}.modal table tbody{border:none}.modal table tbody td{font-weight:bold;font-size:0.875rem;color:#6e6e6e}.modal .modal-content{margin:0;max-width:400px;position:absolute;top:50%;left:50%;-ms-transform:translateX(-50%) translateY(-50%);-webkit-transform:translate(-50%, -50%);transform:translate(-50%, -50%)}.modal .modal-content .close{color:#fff;float:right;font-size:20px;font-weight:bold;line-height:1}.modal .modal-content .close:hover,.modal .modal-content .close:focus{color:#eee;text-decoration:none;cursor:pointer}.modal .modal-header{text-align:center;padding:10px 20px;color:#fff;background:#043d7a;font-size:1.25rem;font-weight:bold;border-top-right-radius:5px;border-top-left-radius:5px}.modal .modal-header h2{text-align:left;font-size:1rem;font-weight:bold;margin-bottom:0}.modal .modal-body{padding:10px 20px;background:#fff;border-bottom-right-radius:5px;border-bottom-left-radius:5px}@media only screen and (max-width: 40em){.select-camp-header .select-camp-header-inner{padding:0}.select-camp-header .select-camp-header-inner h4{padding-left:10%;padding-right:10%}.select-camp-header .select-camp-header-inner .wrap-select-camp-header-inner{padding:0}.select-camp-header .select-camp-header-inner .wrap-select-camp-header-inner .camp-child-icon{display:none}.list-camp h3{margin:1.5rem auto 1.5rem;line-height:0.7;font-size:1.4rem}.list-camp .row li{padding:0}}label{margin-bottom:0.5rem;font-size:1rem;font-weight:bold;color:#6e6e6e}input{vertical-align:-3px}\n"

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var BookingComponent_1 = __webpack_require__(314);
	var common_1 = __webpack_require__(22);
	var _ = __webpack_require__(64);
	var moment = __webpack_require__(169);
	// Services
	var services_1 = __webpack_require__(315);
	var services_2 = __webpack_require__(58);
	var BusOptionComponent = (function (_super) {
	    __extends(BusOptionComponent, _super);
	    function BusOptionComponent(route, router, services, sessionStorageService, local, location, catalogService) {
	        var _this = _super.call(this, router, services, sessionStorageService, catalogService) || this;
	        _this.route = route;
	        _this.router = router;
	        _this.services = services;
	        _this.sessionStorageService = sessionStorageService;
	        _this.local = local;
	        _this.location = location;
	        _this.catalogService = catalogService;
	        _this.freeBus = {};
	        _this.paidBus = {};
	        _this.paidBus2 = {};
	        _this.agree = '';
	        _this.showAgreeWarning = false;
	        _this.showWarning = false;
	        _this.minAge = 5;
	        _this.isAllowed = true;
	        // For update
	        _this.currentBusId = 0;
	        _this.currentSemester = {
	            name: ''
	        };
	        _this.freeBus.price = 0;
	        _this.freeBus.district = 'Quan 1';
	        _this.paidBus.district = 'Binh Thanh';
	        _this.paidBus2.district = 'Others';
	        return _this;
	        // this.paidBus.price = 1
	    }
	    BusOptionComponent.prototype.ngOnInit = function () {
	        this.selectedChild = this.getSelectedChild();
	        // Check if selected child is 5 years old or younger
	        if (moment().diff(moment(this.selectedChild.date_of_birth), 'years', true) <= 5) {
	            this.isAllowed = false;
	        }
	        // Get booking info from session
	        this.booking = this.getBooking();
	        this.getSemester();
	        // Initial booking
	        this.initBooking();
	    };
	    // Initial booking info from session
	    BusOptionComponent.prototype.initBooking = function () {
	        if (!_.isEmpty(this.booking.bus)) {
	            // Detect saved bus type
	            if (this.booking.busType == 'free') {
	                this.checkFreeBus = true;
	                this.freeBus = this.booking.bus;
	            }
	            if (this.booking.busType == 'paid' && this.booking.bus.district === 'Binh Thanh') {
	                this.checkPaidBus = true;
	                this.paidBus = this.booking.bus;
	            }
	            else if (this.booking.busType == 'paid' && this.booking.bus.district === 'Others') {
	                this.checkPaidBus2 = true;
	                this.paidBus2 = this.booking.bus;
	            }
	            // Set agreement
	            this.agree = true;
	            // Set update bus id
	            this.currentBusId = this.booking.bus.id;
	        }
	    };
	    // Download Bus registration form
	    BusOptionComponent.prototype.downloadBusRegistrationForm = function () {
	        var link = window.document.createElement('a');
	        link.href = '/assets/Holiday Bus Registration Form.pdf';
	        link['download'] = "Holiday Bus Registration Form.pdf";
	        document.body.appendChild(link);
	        link.click();
	        setTimeout(function () {
	            document.body.removeChild(link);
	        }, 100);
	    };
	    BusOptionComponent.prototype.handleChange = function (payment) {
	        if (this.checkBus === 'freeBus') {
	            this.checkFreeBus = 'freeBus';
	            this.checkPaidBus = undefined;
	            this.checkPaidBus2 = undefined;
	        }
	        if (this.checkBus === 'paidBus') {
	            this.checkFreeBus = undefined;
	            this.checkPaidBus = 'paidBus';
	            this.checkPaidBus2 = undefined;
	        }
	        if (this.checkBus === 'paidBus2') {
	            this.checkFreeBus = undefined;
	            this.checkPaidBus = undefined;
	            this.checkPaidBus2 = 'paidBus2';
	        }
	    };
	    // Submit function
	    BusOptionComponent.prototype.submitBusOption = function () {
	        // Set bus array
	        this.booking.bus = {};
	        this.booking.busType = '';
	        if (this.checkFreeBus) {
	            this.booking.bus = this.freeBus;
	            this.booking.busType = 'free';
	        }
	        if (this.checkPaidBus) {
	            this.booking.bus = this.paidBus;
	            this.booking.busType = 'paid';
	        }
	        if (this.checkPaidBus2) {
	            this.booking.bus = this.paidBus2;
	            this.booking.busType = 'paid';
	        }
	        if (this.checkFreeBus || this.checkPaidBus || this.checkPaidBus2) {
	            if (this.checkFreeBus && (!this.freeBus.district || !this.freeBus.address)) {
	                return this.showWarning = true;
	            }
	            if (this.checkPaidBus && (!this.paidBus.district || !this.paidBus.address)) {
	                return this.showWarning = true;
	            }
	            if (this.checkPaidBus2 && (!this.paidBus2.district || !this.paidBus2.address)) {
	                return this.showWarning = true;
	            }
	            if (!this.agree) {
	                return this.showAgreeWarning = true;
	            }
	            else {
	                // Depends on free or paid bus checked we collect information
	                // Set bus type in session
	                if (this.checkFreeBus) {
	                    this.booking.bus = this.freeBus;
	                    this.booking.busType = 'free';
	                }
	                if (this.checkPaidBus) {
	                    this.booking.bus = this.paidBus;
	                    this.booking.busType = 'paid';
	                }
	                if (this.checkPaidBus2) {
	                    this.booking.bus = this.paidBus2;
	                    this.booking.busType = 'paid';
	                }
	                // Set bus id
	                if (this.currentBusId) {
	                    this.booking.bus.id = this.currentBusId;
	                }
	                // Store booking information
	                this.setBooking(this.booking);
	                // Navigate to next page
	                this.router.navigate(['booking/payment']);
	            }
	        }
	        else {
	            // Store booking information
	            this.setBooking(this.booking);
	            // Navigate to next page
	            this.router.navigate(['booking/payment']);
	        }
	    };
	    /**
	    * @Jira task: ECA-1364: Hol-parent - update additional fee
	    * @author: Loc Nguyen
	    * @description: get current semester
	    */
	    BusOptionComponent.prototype.getSemester = function () {
	        var _this = this;
	        this.catalogService.getSemesters()
	            .subscribe(function (semesterList) {
	            _this.currentSemester = _.find(semesterList, 'is_current');
	        }, function (error) {
	            console.log("Cannot get semester list from API.");
	        });
	    };
	    return BusOptionComponent;
	}(BookingComponent_1.BookingComponent));
	BusOptionComponent = __decorate([
	    core_1.Component({
	        selector: 'class-payment',
	        template: __webpack_require__(337),
	        styles: [__webpack_require__(338)]
	    }),
	    __metadata("design:paramtypes", [router_1.ActivatedRoute,
	        router_1.Router,
	        services_1.BookingHolidayService,
	        services_2.SessionStorageService,
	        services_2.LocalStorageService,
	        common_1.Location,
	        services_2.CatalogService])
	], BusOptionComponent);
	exports.BusOptionComponent = BusOptionComponent;


/***/ }),
/* 337 */
/***/ (function(module, exports) {

	module.exports = "<main>\n  <div class=\"component-title\">\n    <h1>Step 3: Bus Registration</h1>\n  </div>\n  <div class=\"container\" *ngIf=\"isAllowed\">\n    <form>\n      <!--Free bus select-->\n      <div\n        *ngIf=\"booking.period[booking.hol_class_id] == 'full' || booking.periodWeeks.length == booking.allWeek.length\"\n      >\n        <label attr.for=\"complimentary\">\n          <input\n            type=\"radio\"\n            name=\"busPaymentType\"\n            value=\"freeBus\"\n            [(ngModel)]=\"checkBus\"\n            [checked]=\"checkFreeBus === 'freeBus' && (checkPaidBus == undefined && checkPaidBus2 == undefined)\"\n            (change)=\"handleChange('freeBus')\"\n          />\n          Bus Service (Complimentary)\n        </label>\n        <div class=\"bus-registration-info row\">\n          <p>\n            Complimentary bus for students aged 5 and above who sign up for the\n            full duration of a programme in district 1 (old), district 7 (old) and\n            designated parts of Thu Duc City (old) (AIS Sports Centre, HAGL Building,\n            Fideco Tower, Estella, Estella Heights, Imperia, The Vista, Vista\n            Verde, Feliz En Vista, Cantavil, Masteri, Tropic Garden, Xi\n            Riverview, Gateway, Thao Dien Pearl, Riverside, Villa Riviera, Sun\n            Avenue, Sala Sarimi, Sadora, Diamond Island, Vinhomes Binh Thanh).\n          </p>\n          <div class=\"wrap-select-option-header large-4\">\n            <select name=\"free_bus_district\" [(ngModel)]=\"freeBus.district\">\n              <option value=\"\" selected>-- Select District --</option>\n              <option value=\"Quan 1\">District 1</option>\n              <option value=\"Quan 7\">District 7</option>\n              <option value=\"Quan 2\">Thu Duc City</option>\n            </select>\n          </div>\n          <input\n            type=\"text\"\n            placeholder=\"Address\"\n            class=\"large-8\"\n            name=\"free_bus_address\"\n            [(ngModel)]=\"freeBus.address\"\n          />\n          <span>( The pick up and the drop off must be the same )</span>\n        </div>\n      </div>\n      <br />\n      <!--End of Free bus select-->\n      <div>\n        <!--Paid bus select && just display this option for Semester 1(Winter School)-->\n        <label attr.for=\"paid2\">\n          <input\n            type=\"radio\"\n            name=\"busPaymentType\"\n            [(ngModel)]=\"checkBus\"\n            value=\"paidBus2\"\n            [checked]=\"checkPaidBus2 === 'paidBus2' && (checkFreeBus == undefined && checkPaidBus == undefined)\"\n            (change)=\"handleChange('paidBus2')\"\n          />\n          Bus Service (Additional Fee)\n        </label>\n        <div class=\"bus-registration-info row\">\n          <p>\n            3,000,000 VND for full programme register. Transport\n            arrangements typically take up to one week to finalise. Our\n            Transport Department will inform you if your address is NOT\n            accessible. In that case, your request for bus refund will be\n            processed as soon as possible. Contact our Administration Team: +84\n            28 3742 4040 ext 6324 | <a>AIS.Admin@aisvietnam.com</a>\n          </p>\n          <div class=\"wrap-select-option-header large-4\">\n            <select name=\"paid_bus_district2\" [(ngModel)]=\"paidBus2.district\">\n              <option value=\"Others\" selected>Others</option>\n            </select>\n          </div>\n          <input\n            type=\"text\"\n            placeholder=\"Address\"\n            class=\"large-8\"\n            name=\"paid_bus_address2\"\n            [(ngModel)]=\"paidBus2.address\"\n          />\n          <span>(The pick up and the drop off must be the same)</span>\n        </div>\n      </div>\n      <!--End of Paid bus select-->\n    </form>\n    <div class=\"scroll-view\">\n      <div class=\"headline large-12 medium-12 small-12\">\n        <h2 class=\"algn-l\">STATEMENT OF AIM</h2>\n      </div>\n      <div class=\"large-12 medium-12 small-12\">\n        <p class=\"content\">\n          AIS aims to provide a safe and reliable School Bus service using\n          modern air-conditioned vehicles for the purpose of picking up and\n          dropping off School students on designated operational routes\n          determined by the School.<br /><br />\n          All vehicles will have regular safety and maintenance checks and will\n          be operated by a licensed driver.\n        </p>\n      </div>\n      <div class=\"headline large-12 medium-12 small-12\">\n        <h2 class=\"algn-l\">RATIONALE</h2>\n      </div>\n      <div class=\"large-12 medium-12 small-12\">\n        <ul>\n          <li>\n            <p class=\"content\">\n              The School wishes to service the transport needs of the student\n              and parent community in Ho Chi Minh City. For safety reasons\n              however, this service is not normally extended to students in\n              Kindergarten.\n            </p>\n          </li>\n          <li>\n            <p class=\"content\">\n              Transportation arrangements typically take up to one week to\n              finalise. This registration form must be submitted five days prior\n              to the start of service.\n            </p>\n          </li>\n          <li>\n            <p class=\"content\">\n              The School may change the Bus Schedule from time to time. In such\n              case, the School Bus Coordinator will notify parents by email.\n            </p>\n          </li>\n          <li>\n            <p class=\"content\">\n              To ensure on-time arrival at School, buses can wait no longer than\n              five minutes after the designated pick-up time before moving to\n              the next pick-up point.\n            </p>\n          </li>\n          <li>\n            <p class=\"content\">\n              To maintain an effective and efficient service, it is expected\n              that parents adhere to the agreed pick up and drop off details\n              agreed in the Bus Registration Form. In the event of repeated\n              lateness, the School reserves the right to withdraw the service.\n            </p>\n          </li>\n        </ul>\n      </div>\n      <div class=\"headline large-12 medium-12 small-12\">\n        <h2 class=\"algn-l\">THE ROLE OF PARENTS</h2>\n      </div>\n      <div class=\"large-12 medium-12 small-12\">\n        <p class=\"content\">\n          Parents who request and pay for the School Bus will:\n        </p>\n        <ul>\n          <li>\n            <p class=\"content\">\n              Inform the School of any required changes to the bus route at\n              least 1 week in advance of the required change.\n            </p>\n          </li>\n          <li>\n            <p class=\"content\">\n              Inform the Bus Coordinator prior to pick-up, if the child is not\n              catching the School bus on any given day.\n            </p>\n          </li>\n          <li>\n            <p class=\"content\">\n              Sign a Bus Registration Form which confirms the pick-up and\n              drop-off address and requirements. This is a service agreement\n              that parents, students and the School will use to their best\n              endeavours to adhere to.\n            </p>\n          </li>\n          <li>\n            <p class=\"content\">\n              Ensure that students are ready for pick up at the agreed time with\n              the Bus Coordinator.\n            </p>\n          </li>\n          <li>\n            <p class=\"content\">\n              Ensure that appropriate authorised personnel are at the drop-off\n              point with your son/daughter(s).\n            </p>\n          </li>\n          <li>\n            <p class=\"content\">\n              Ensure that your son/daughter(s) behave in an appropriate manner\n              at all times while on, or waiting for the School Bus.\n            </p>\n          </li>\n        </ul>\n      </div>\n      <div class=\"headline large-12 medium-12 small-12\">\n        <h2 class=\"algn-l\">THE ROLE OF STUDENTS</h2>\n      </div>\n      <div class=\"large-12 medium-12 small-12\">\n        <p class=\"content\">\n          Good conduct is necessary for a safe bus ride. Students must be prompt\n          for all collections and drop-offs.\n        </p>\n        <p class=\"content\">Students travelling on the bus must:</p>\n        <ul>\n          <li>\n            <p class=\"content\">\n              Listen and follow any instruction by the driver/guard/assistant at\n              all times as they would with a teacher.\n            </p>\n          </li>\n          <li>\n            <p class=\"content\">\n              Be pleasant, courteous and respectful to the driver and other\n              passengers.\n            </p>\n          </li>\n          <li>\n            <p class=\"content\">\n              Remain seated and wear a seat belt at all times until the bus\n              comes to a complete stop.\n            </p>\n          </li>\n          <li>\n            <p class=\"content\">Not talk to, or distract the driver.</p>\n          </li>\n          <li>\n            <p class=\"content\">\n              Behave in an appropriate manner at all times to ensure safety.\n            </p>\n          </li>\n          <li>\n            <p class=\"content\">\n              Keep the bus clean and respect the rights and property of other\n              passengers on the bus.\n            </p>\n          </li>\n          <li>\n            <p class=\"content\">\n              Keep head, arms, legs and hands inside the bus at all times.\n            </p>\n          </li>\n          <li>\n            <p class=\"content\">Keep feet off the seats.</p>\n          </li>\n          <li>\n            <p class=\"content\">\n              Never throw objects around the bus or outside the windows.\n            </p>\n          </li>\n          <li>\n            <p class=\"content\">\n              Never open the windows without the driver’s permission.\n            </p>\n          </li>\n          <li>\n            <p class=\"content\">Not push or shove.</p>\n          </li>\n          <li>\n            <p class=\"content\">\n              Sit in the seat allocated by the duty\n              teacher/guard/assistant/driver.\n            </p>\n          </li>\n          <li>\n            <p class=\"content\">\n              Get off the bus at their approved drop off point only.\n            </p>\n          </li>\n          <li>\n            <p class=\"content\">Not consume food or chewing gum.</p>\n          </li>\n        </ul>\n      </div>\n    </div>\n\n    <label style=\"margin-top: 1rem\">\n      <input\n        type=\"checkbox\"\n        name=\"agree\"\n        [(ngModel)]=\"agree\"\n        style=\"margin-bottom: 0\"\n      />The details I have provided above for the Bus Registration are accurate\n      and I have read, understood and agree to information and bus conditions. I\n      understand that neither the School nor any of its employees are\n      responsible for incidents or accidents that occur while a student is on a\n      School Bus or while waiting for a School Bus or while waiting to be\n      collected by a parent/guardian.\n    </label>\n  </div>\n\n  <div class=\"container\" *ngIf=\"!isAllowed\">\n    <p>Kindly note that Bus for students aged 5 and above.</p>\n  </div>\n\n  <!-- Information warning Modal -->\n  <div class=\"warning\" [hidden]=\"!showWarning\">\n    <!-- Modal content -->\n    <div class=\"modal-content\">\n      <div class=\"modal-header\">\n        <span class=\"close\" (click)=\"showWarning = false\">×</span>\n        <h2>Lack of Information</h2>\n      </div>\n      <div class=\"modal-body\">\n        <span>Please provide your address for Bus registration</span>\n      </div>\n    </div>\n  </div>\n  <!-- End of Information warning Modal -->\n\n  <!-- Agree warning Modal -->\n  <div class=\"warning\" [hidden]=\"!showAgreeWarning\">\n    <!-- Modal content -->\n    <div class=\"modal-content\">\n      <div class=\"modal-header\">\n        <span class=\"close\" (click)=\"showAgreeWarning = false\">×</span>\n        <h2>Terms and conditions warning</h2>\n      </div>\n      <div class=\"modal-body\">\n        <span\n          >To register bus service you must agree with bus service terms and\n          conditions</span\n        >\n      </div>\n    </div>\n  </div>\n  <!-- End of Agree warning Modal -->\n\n  <div id=\"submit\" class=\"row\">\n    <div class=\"large-4 l-btn\">\n      <button class=\"back-btn\" (click)=\"backToExcursion()\">Back</button>\n    </div>\n    <div class=\"large-8 r-btn\">\n      <button class=\"submit large-5\" (click)=\"submitBusOption()\">\n        CONTINUE\n      </button>\n    </div>\n  </div>\n</main>\n";

/***/ }),
/* 338 */
/***/ (function(module, exports) {

	module.exports = ".text-left{text-align:left}.countdown{text-align:right;font-size:18px;padding:10px 20px}.container{width:80%;margin:0 auto;padding:2rem 1.25rem}.container .headline{background:#faa635;border-bottom-left-radius:5px;border-bottom-right-radius:5px;padding:0.3rem 1.5rem;margin:2rem 0 1rem}.container .headline h2{font-size:1.5625rem;color:#043d7a;font-weight:bold;text-align:right}.container .headline .algn-l{text-align:left}.container div p{font-size:0.875rem;color:#6e6e6e;line-height:1.6}.component-title{color:#043d7a;background-color:#f8f8f8;padding:1.5rem 10%;border-bottom:1px solid #eaeaea}.component-title h1{margin:0 auto;padding:0 1.25rem;font-size:1.5256rem}.component-title small{padding:0 1.25rem;font-size:90%}.wrap-select-camp-header-inner{width:100%;padding:1rem calc(10% + 1.25rem) 0;background:#f8f8f8;border-top:1px solid white}.wrap-select-camp-header-inner .camp-child-icon{vertical-align:-3px;margin-right:10px}.wrap-select-camp-header-inner .wrap-select-option-header{display:inline-block;position:relative}.wrap-select-camp-header-inner .wrap-select-option-header:before{content:'';color:#ddd;width:2.5rem;height:1.5625rem;position:absolute;pointer-events:none;right:17px;top:17px;width:0;height:0;border-left:5px solid transparent;border-right:5px solid transparent;border-top:8px solid #ddd}.wrap-select-camp-header-inner .wrap-select-option-header:after{content:'';position:absolute;height:1.5625rem;width:1px;background:#ddd;top:8px;right:40px}.wrap-select-camp-header-inner .wrap-select-option-header select{padding:0 50px 0 13px;border-radius:5px;font-size:1rem;background:#f8f8f8;border:1px solid #ddd;height:2.5rem;color:#282828;outline:none}#submit{max-width:100%;width:100%;padding:2rem 10%;border-top:1px solid #ddd}#submit .l-btn{padding-left:1.25rem}#submit .l-btn button{text-align:left;padding:1.25rem 5.25rem;font-size:1.25rem;font-weight:bold;background:#eaeaea;color:#6e6e6e}#submit .r-btn{text-align:right;padding-right:1.25rem}#submit .r-btn p{text-align:right;font-size:0.875rem;padding-right:1.125rem;padding-top:1rem}#submit .r-btn p a{font-weight:bold}#submit .r-btn .submit{padding:1.25rem 3rem;text-align:center;font-size:1.25rem;font-weight:bold}.bus-registration-container{width:80%;margin:0 auto;padding:0px 1.25rem;margin-bottom:1.5rem}.bus-registration-container h3{font-size:1.525rem;font-weight:bold;color:#043d7a;text-align:center;margin:2rem auto 1rem}.bus-registration-container .total-amount{background:#faa635;border-bottom-left-radius:5px;border-bottom-right-radius:5px;padding:0.3rem 1.5rem}.bus-registration-container .total-amount h2{font-size:1.5625rem;color:#043d7a;font-weight:bold;text-align:right}.bus-registration-container .total-amount .algn-l{text-align:left}.bus-registration-container .total-amount p{font-size:0.875rem;color:#6e6e6e;text-align:justify;line-height:1.6}.bus-registration-container .bus-registration-section{padding:0 1.25rem;margin-top:1rem;justify-content:space-between}.bus-registration-container .bus-registration-section table{text-align:left}.bus-registration-container .bus-registration-section table tr:first-child{background:#043d7a;color:#fff}.bus-registration-container .bus-registration-section p{font-size:0.875rem;color:#6e6e6e;text-align:justify;line-height:1.6}.bus-registration-container .bus-registration-section h5{font-size:1.125rem;color:#043d7a;font-weight:bold;margin-bottom:0.375rem}.bus-registration-container .bus-registration-section ul{list-style-type:decimal}.bus-registration-container .bus-registration-section ul li{font-size:0.875rem;color:#6e6e6e;text-align:justify}.bus-registration-container .bus-registration-section .bus-registration-term{padding-right:3rem}.bus-registration-container .bus-registration-section .bus-registration-method form{box-shadow:none;padding:0;font-size:1rem}.bus-registration-container .bus-registration-section .bus-registration-method form input[type=\"radio\"]{display:none}.bus-registration-container .bus-registration-section .bus-registration-method form input[type=\"radio\"]+label{margin-bottom:0.5rem;font-size:1rem;font-weight:bold;color:#6e6e6e}.bus-registration-container .bus-registration-section .bus-registration-method form input[type=\"radio\"]:disabled+label:before{background:#eee}.bus-registration-container .bus-registration-section .bus-registration-method form input[type=\"radio\"]+label:before{color:#6e6e6e;content:\"\\00a0\";display:inline-block;font:1em sans-serif;margin-right:0.5rem;padding:0;vertical-align:middle;width:1.25rem;height:1.25rem;border-radius:10px;border:1px solid #b8b8b8}.bus-registration-container .bus-registration-section .bus-registration-method form input[type=\"radio\"]:checked+label:before{content:\"\\2022\";color:#b8b8b8;font-size:2.5rem;line-height:19px;text-align:center}.modal{position:fixed;z-index:1;left:0;top:0;width:100%;height:100%;overflow:auto;background-color:#000;background-color:rgba(0,0,0,0.4)}.modal table{display:block;padding:5px 10px;margin-bottom:0;background:#fff;border-bottom-right-radius:5px;border-bottom-left-radius:5px}.modal table tbody{border:none}.modal table tbody td{font-weight:bold;font-size:0.875rem;color:#6e6e6e}.modal .modal-content{margin:0;max-width:400px;position:absolute;top:50%;left:50%;-ms-transform:translateX(-50%) translateY(-50%);-webkit-transform:translate(-50%, -50%);transform:translate(-50%, -50%)}.modal .modal-content .close{color:#fff;float:right;font-size:20px;font-weight:bold;line-height:1}.modal .modal-content .close:hover,.modal .modal-content .close:focus{color:#eee;text-decoration:none;cursor:pointer}.modal .modal-header{text-align:center;padding:10px 20px;color:#fff;background:#043d7a;font-size:1.25rem;font-weight:bold;border-top-right-radius:5px;border-top-left-radius:5px}.modal .modal-header h2{text-align:left;font-size:1rem;font-weight:bold;margin-bottom:0}.modal .modal-body{padding:10px 20px;background:#fff;border-bottom-right-radius:5px;border-bottom-left-radius:5px}@media only screen and (max-width: 40em){.select-camp-header .select-camp-header-inner{padding:0}.select-camp-header .select-camp-header-inner h4{padding-left:10%;padding-right:10%}.select-camp-header .select-camp-header-inner .wrap-select-camp-header-inner{padding:0}.select-camp-header .select-camp-header-inner .wrap-select-camp-header-inner .camp-child-icon{display:none}.list-camp h3{margin:1.5rem auto 1.5rem;line-height:0.7;font-size:1.4rem}.list-camp .row li{padding:0}}.warning{position:fixed;z-index:1;left:0;top:0;width:100%;height:100%;overflow:auto;background-color:#000;background-color:rgba(0,0,0,0.4)}.warning table{display:block;padding:5px 10px;margin-bottom:0;background:#fff;border-bottom-right-radius:5px;border-bottom-left-radius:5px}.warning table tbody{border:none}.warning table tbody td{font-weight:bold;font-size:0.875rem;color:#6e6e6e}.warning .modal-content{margin:0;max-width:400px;position:absolute;top:50%;left:50%;-ms-transform:translateX(-50%) translateY(-50%);-webkit-transform:translate(-50%, -50%);transform:translate(-50%, -50%)}.warning .modal-content .close{color:#fff;float:right;font-size:20px;font-weight:bold;line-height:1}.warning .modal-content .close:hover,.warning .modal-content .close:focus{color:#eee;text-decoration:none;cursor:pointer}.warning .modal-header{text-align:center;padding:10px 20px;color:#fff;background:#043d7a;font-size:1.25rem;font-weight:bold;border-top-right-radius:5px;border-top-left-radius:5px}.warning .modal-header h2{text-align:left;font-size:1rem;font-weight:bold;margin-bottom:0}.warning .modal-body{padding:10px 20px;background:#fff;border-bottom-right-radius:5px;border-bottom-left-radius:5px}input{vertical-align:-3px}label{margin-bottom:0.5rem;font-size:1rem;font-weight:bold;color:#6e6e6e}.content{font-size:0.875rem;color:#6e6e6e;text-align:justify;line-height:1.6}.headline{background:#faa635;border-bottom-left-radius:5px;border-bottom-right-radius:5px;padding:0.3rem 1.5rem;margin:2rem 0 1rem}.headline h2{font-size:1.5625rem;color:#043d7a;font-weight:bold;text-align:right}.headline .algn-l{text-align:left}.bus-registration-info{padding-left:2.3rem}.bus-registration-info span{font-size:0.875rem;color:#666}.bus-registration-info .wrap-select-option-header{display:inline-block;position:relative;padding-right:15px}.bus-registration-info .wrap-select-option-header:before{content:'';color:#ddd;width:2.5rem;height:1.5625rem;position:absolute;pointer-events:none;right:32px;top:17px;width:0;height:0;border-left:5px solid transparent;border-right:5px solid transparent;border-top:8px solid #ddd}.bus-registration-info:after{content:'';position:absolute;height:1.5625rem;width:1px;background:#ddd;top:8px;right:40px}.bus-registration-info select{padding:0 50px 0 13px;border-radius:5px;font-size:0.875rem;background:#fff;border:1px solid #ddd;height:2.5rem;color:#666;outline:none}form{box-shadow:none;padding:0;font-size:1rem}form input[type=\"radio\"]+label{margin-bottom:0.5rem;font-size:1rem;font-weight:bold;color:#6e6e6e}form input[type=\"radio\"]:disabled+label:before{background:#eee}form input[type=\"radio\"]+label:before{color:#6e6e6e;content:\"\\00a0\";display:inline-block;font:1em sans-serif;margin-right:0.5rem;padding:0;vertical-align:middle;width:1.25rem;height:1.25rem;border-radius:10px;border:1px solid #b8b8b8}form input[type=\"radio\"]:checked+label:before{content:\"\\2022\";color:#b8b8b8;font-size:2.5rem;line-height:19px;text-align:center}form div p{font-size:0.875rem;color:#666}.algn-l{text-align:left}.scroll-view{height:500px;overflow-y:auto;margin-top:35px}\n"

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var BookingComponent_1 = __webpack_require__(314);
	var _ = __webpack_require__(64);
	var moment = __webpack_require__(169);
	var models_1 = __webpack_require__(340);
	// Services
	var services_1 = __webpack_require__(315);
	var services_2 = __webpack_require__(315);
	var services_3 = __webpack_require__(58);
	var PaymentComponent = (function (_super) {
	    __extends(PaymentComponent, _super);
	    function PaymentComponent(fileService, router, emailService, sessionStorageService, local, services, catalogService) {
	        var _this = _super.call(this, router, services, sessionStorageService, catalogService) || this;
	        _this.fileService = fileService;
	        _this.router = router;
	        _this.emailService = emailService;
	        _this.sessionStorageService = sessionStorageService;
	        _this.local = local;
	        _this.services = services;
	        _this.catalogService = catalogService;
	        _this.filteredExcursions = '';
	        _this.singleBusPrice = 750000;
	        _this.btBusCost = 0;
	        // private othersBusCost: number = 1950000;
	        _this.busCost = 0;
	        // private isAisParent: string = '';
	        _this.currentSemester = {
	            name: ''
	        };
	        // Lunch
	        _this.singleLunchPrice = 186000;
	        _this.lunchPrice = 0;
	        _this.checkLunch = '';
	        _this.checkBus = '';
	        _this.isDisableBusCheck = false;
	        _this.surveySelect = '';
	        _this.showSurveyMessage = false;
	        _this.totalAmount = [];
	        return _this;
	    }
	    PaymentComponent.prototype.ngOnInit = function () {
	        this.getSemester();
	        // this.isAisParent = this.sessionStorageService.getData("isAisParent").toString();
	        this.payment = new models_1.Payment;
	        this.loadingSubmit = false;
	        // Get booking info
	        this.booking = this.getBooking();
	        // If bus is registered
	        this.checkBus = !_.isEmpty(this.booking.bus) ? true : false;
	        this.isDisableBusCheck = !_.isEmpty(this.booking.bus) ? true : false;
	        // Check lunch on editing
	        if (this.booking.lunch) {
	            this.checkLunch = true;
	        }
	        // Check survey on editing
	        if (this.booking.survey) {
	            this.surveySelect = this.booking.survey;
	        }
	        // Sum lunch price
	        // this.countLunchPrice();
	        // Filter excursion
	        this.filterExcursion();
	        // Get start/end date of class
	        this.getStartEndDate();
	        this.getEarlyBirdConfiguration();
	        this.earlyBirdDiscount();
	        this.paymentType = "";
	        this.isLearnFullWeek = false;
	        if (this.booking.allWeek.length == this.booking.periodWeeks.length)
	            this.isLearnFullWeek = true;
	        this.calculatorTotalAmount();
	        this.calculatorBusCost();
	        this.calculatorLunchCost();
	        this.checkLunch = true;
	    };
	    PaymentComponent.prototype.getEarlyBirdConfiguration = function () {
	        var _this = this;
	        this.services.getDiscountConfig('early-bird')
	            .subscribe(function (config) {
	            _this.earlyBirdConfig = config;
	        });
	    };
	    // Retrieve start/end date base on week
	    PaymentComponent.prototype.getStartEndDate = function () {
	        var _this = this;
	        var start;
	        var end;
	        // Init start/end date
	        // if(this.booking.allWeek){
	        //     start = this.booking.allWeek[0].start_date;
	        //     end = this.booking.allWeek[0].end_date;
	        //     this.duration = this.booking.allWeek[0].name + ', ';
	        // }
	        // _.forEach(this.booking.periodWeeks, (pVal, pKey) => {
	        //     if(pKey){
	        //         let week : any = _.find(this.booking.allWeek, {'id': pVal});
	        //         this.duration = this.duration + week.name + ', ';
	        //         if(week){
	        //             // Compare start date
	        //             if(moment(week.start_date).isBefore(start)){
	        //                 start = week.start_date;
	        //             }
	        //             // Compare end date
	        //             if(moment(week.end_date).isAfter(end)){
	        //                 end = week.end_date;
	        //             }
	        //         }
	        //     }
	        // })
	        //this.duration = this.duration.slice(0, -2);
	        var weekSelected = this.booking.allWeek.filter(function (item) {
	            if (_this.booking.periodWeeks.filter(function (week) { return week == item.id; }).length > 0)
	                return true;
	            else
	                return false;
	        });
	        this.duration = weekSelected.map(function (item) { return item.name; }).join(',');
	        start = weekSelected.map(function (item) { return item.start_date; }).reduce(function (a, b) { return moment(a).isBefore(b) ? a : b; });
	        end = weekSelected.map(function (item) { return item.end_date; }).reduce(function (a, b) { return moment(a).isAfter(b) ? a : b; });
	        this.startDate = start;
	        this.endDate = end;
	    };
	    PaymentComponent.prototype.disabledSumit = function () {
	        if (this.paymentType === undefined || this.surveySelect === '') {
	            return true;
	        }
	        else {
	            return false;
	        }
	    };
	    // Filter to get excursion weeks
	    PaymentComponent.prototype.filterExcursion = function () {
	        var _this = this;
	        if (!_.isEmpty(this.booking.selectedExcursion)) {
	            _.forEach(this.booking.weeks, function (val, key) {
	                if (val.excursions.length) {
	                    var week = _.find(_this.booking.allWeek, { 'id': val.hol_week_id });
	                    _this.filteredExcursions = _this.filteredExcursions + week.name + ', ';
	                }
	            });
	        }
	        return this.filteredExcursions = _.trimEnd(this.filteredExcursions, ', ');
	    };
	    // Calculate lunch price based on selected week
	    PaymentComponent.prototype.countLunchPrice = function () {
	        return this.lunchPrice = this.booking.weeks.length * this.singleLunchPrice;
	    };
	    // Calculate total cost
	    PaymentComponent.prototype.countTotalCost = function () {
	        // Class cost by weeks
	        var classCost = this.totalAmountCourse;
	        if (this.booking.busType == 'paid') {
	            if (this.booking.bus.district === 'Binh Thanh') {
	                this.btBusCost = 1500000;
	            }
	            if (this.booking.bus.district === 'Others') {
	                this.calculatorBusCost();
	            }
	        }
	        else {
	            this.btBusCost = 0;
	        }
	        if (this.btBusCost > 0) {
	            this.booking.bus.price = this.btBusCost;
	        }
	        // basically total will be equal to class cost if no option was selected
	        this.totalCost = classCost;
	        // If have Bus fee
	        if (this.checkBus && this.booking.busType == 'paid') {
	            this.totalCost = this.totalCost + this.btBusCost;
	        }
	        // If have Lunch fee
	        if (this.checkLunch) {
	            this.totalCost = this.totalCost + this.lunchPrice;
	        }
	        return this.totalCost;
	    };
	    // // Download Lunch menu
	    // downloadLunchMenu(){
	    //     const link = window.document.createElement('a');
	    //     link.href = '/assets/AIS Summer Menu - 2017-18.xlsx';
	    //     link['download'] = "AIS Summer Menu - 2017-18.xlsx";
	    //     document.body.appendChild(link);
	    //     link.click();
	    //     setTimeout(function(){
	    //         document.body.removeChild(link);
	    //     }, 100);
	    // }
	    PaymentComponent.prototype.earlyBirdDiscount = function () {
	        var getCurrentDay = moment(new Date()).format('YYYY-MM-DD');
	        if (this.earlyBirdConfig) {
	            var deadline = this.earlyBirdConfig.condition;
	            if (new Date(getCurrentDay).getTime() <= new Date(deadline).getTime() && this.paymentType != "") {
	                return true;
	            }
	        }
	        return false;
	    };
	    PaymentComponent.prototype.getSemester = function () {
	        var _this = this;
	        this.catalogService.getSemesters()
	            .subscribe(function (semesterList) {
	            _this.currentSemester = _.find(semesterList, 'is_current');
	            //count total cost
	            _this.countTotalCost();
	        }, function (error) {
	            console.log("Cannot get semester list from API.");
	        });
	    };
	    // Submit payment
	    PaymentComponent.prototype.submitPayment = function () {
	        var _this = this;
	        // Notice when not select survey
	        if (!this.surveySelect) {
	            return this.showSurveyMessage = true;
	        }
	        // Active loading payment
	        this.loadingSubmit = true;
	        if (this.checkBus && this.booking.busType == 'paid') {
	            this.booking.bus.price = this.btBusCost;
	        }
	        // Collect query data
	        var query = {
	            id: this.booking.id,
	            name: this.booking.name,
	            payment_method: this.booking.payment_method,
	            weeks: this.booking.weeks,
	            survey: this.surveySelect,
	            lunch: this.checkLunch ? true : false,
	            hol_class_id: this.booking.hol_class_id,
	            hol_student_id: this.booking.hol_student_id,
	            send_email: 1,
	            question_answer: this.booking.question_answer
	        };
	        if (!_.isEmpty(this.booking.bus)) {
	            query['bus'] = this.booking.bus;
	        }
	        // Update booking to new real one
	        this.services.updateBooking(query).subscribe(function (result) {
	            _this.loadingSubmit = false;
	            if (result.data) {
	                _this.booking.code = _this.booking.id;
	                _this.payment.booking_id = _this.booking.code;
	                _this.payment.currency = 'VND';
	                _this.payment.zone = _this.paymentType;
	                _this.payment.amount = _this.countTotalCost();
	                // Payment information
	                if (_this.payment.zone === 'domestic' || _this.payment.zone === 'international') {
	                    _this.services.payment(_this.payment)
	                        .subscribe(function (result) {
	                        _this.local.setData('updateBookingDetail', result);
	                        _this.services.getChildren().subscribe(function (result) {
	                            _this.setHolidayChildren(result);
	                        }, function (error) {
	                        });
	                        window.location.href = result.url;
	                    }, function (error) {
	                    });
	                }
	                else if (_this.payment.zone === '') {
	                    _this.setBooking(_this.booking);
	                    _this.router.navigate(['booking/finish']);
	                }
	            }
	        }, function (error) {
	            _this.loadingSubmit = false;
	        });
	    };
	    PaymentComponent.prototype.calculatorTotalAmount = function () {
	        var _this = this;
	        var isEarlyBirdDiscount = this.earlyBirdDiscount();
	        // if(this.isAisParent === 'true')
	        //     this.totalAmountCourse = this.getTotalForAIS();
	        // else 
	        if (this.isLearnFullWeek)
	            this.totalAmountCourse = this.booking.class.total_cost;
	        else
	            this.totalAmountCourse = this.booking.class.prices.map(function (item) {
	                if (_this.booking.periodWeeks.filter(function (week) { return week == item.hol_week_id; }).length > 0) {
	                    return item.price;
	                }
	                else
	                    return 0;
	            }).reduce(function (current, next) { return current + next; }, 0);
	        if (this.booking.discount.discount || (isEarlyBirdDiscount && this.checkFullWeek())) {
	            var discountPercent = this.earlyBirdConfig ? Number(this.earlyBirdConfig.value) / 100 : 0.1;
	            this.totalAmountCourse = this.totalAmountCourse - (this.totalAmountCourse * discountPercent);
	        }
	        return this.totalAmountCourse;
	    };
	    // private getTotalForAIS () {
	    //     return this.booking.class.prices.map((item: any) => {
	    //         if (this.booking.periodWeeks.filter((week: any) => week == item.hol_week_id).length > 0) {
	    //             if([1,2].indexOf(item.hol_week_id) > -1){
	    //                 return 0; 
	    //             }
	    //             else
	    //                 return item.price;
	    //         }
	    //         else
	    //             return 0;
	    //     }).reduce((current: any, next: any) => current + next, 0);
	    // }
	    PaymentComponent.prototype.calculatorLunchCost = function () {
	        var _this = this;
	        this.lunchPrice = this.booking.allWeek.map(function (item) {
	            if (_this.booking.periodWeeks.filter(function (week) { return week == item.id; }).length > 0)
	                return item.lunch_cost;
	            else
	                return 0;
	        }).reduce(function (current, next) { return current + next; }, 0);
	    };
	    PaymentComponent.prototype.calculatorBusCost = function () {
	        var _this = this;
	        this.btBusCost = this.booking.allWeek.map(function (item) {
	            if (_this.booking.periodWeeks.filter(function (week) { return week == item.id; }).length > 0)
	                return item.bus_cost;
	            else
	                return 0;
	        }).reduce(function (current, next) { return current + next; }, 0);
	    };
	    PaymentComponent.prototype.checkFullWeek = function () {
	        if (this.booking.periodWeeks.length == this.booking.allWeek.length) {
	            return true;
	        }
	        return false;
	    };
	    return PaymentComponent;
	}(BookingComponent_1.BookingComponent));
	PaymentComponent = __decorate([
	    core_1.Component({
	        selector: 'complete',
	        template: __webpack_require__(372),
	        styles: [__webpack_require__(373)]
	    }),
	    __metadata("design:paramtypes", [services_3.FileService,
	        router_1.Router,
	        services_2.EmailService,
	        services_3.SessionStorageService,
	        services_3.LocalStorageService,
	        services_1.BookingHolidayService,
	        services_3.CatalogService])
	], PaymentComponent);
	exports.PaymentComponent = PaymentComponent;


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(341));
	__export(__webpack_require__(344));
	__export(__webpack_require__(345));
	__export(__webpack_require__(346));
	__export(__webpack_require__(347));
	__export(__webpack_require__(348));
	__export(__webpack_require__(349));
	__export(__webpack_require__(348));
	__export(__webpack_require__(350));
	__export(__webpack_require__(351));
	__export(__webpack_require__(352));
	__export(__webpack_require__(353));
	__export(__webpack_require__(354));
	__export(__webpack_require__(355));
	__export(__webpack_require__(356));
	__export(__webpack_require__(357));
	__export(__webpack_require__(358));
	__export(__webpack_require__(359));
	__export(__webpack_require__(360));
	__export(__webpack_require__(361));
	__export(__webpack_require__(362));
	__export(__webpack_require__(363));
	__export(__webpack_require__(364));
	__export(__webpack_require__(365));
	__export(__webpack_require__(366));
	__export(__webpack_require__(123));
	__export(__webpack_require__(367));
	__export(__webpack_require__(368));
	__export(__webpack_require__(369));
	__export(__webpack_require__(370));
	__export(__webpack_require__(371));


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(342));
	__export(__webpack_require__(343));


/***/ }),
/* 342 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Campus = (function () {
	    function Campus() {
	    }
	    return Campus;
	}());
	exports.Campus = Campus;
	var Homeroom = (function () {
	    function Homeroom() {
	    }
	    return Homeroom;
	}());
	exports.Homeroom = Homeroom;
	var Classes = (function () {
	    function Classes() {
	    }
	    return Classes;
	}());
	exports.Classes = Classes;
	var Schoolyear = (function () {
	    function Schoolyear() {
	    }
	    return Schoolyear;
	}());
	exports.Schoolyear = Schoolyear;
	var YearLevel = (function () {
	    function YearLevel() {
	    }
	    return YearLevel;
	}());
	exports.YearLevel = YearLevel;
	var CampusFullItem = (function () {
	    function CampusFullItem() {
	    }
	    return CampusFullItem;
	}());
	exports.CampusFullItem = CampusFullItem;
	var YearLevelWithHomerooms = (function () {
	    function YearLevelWithHomerooms() {
	    }
	    return YearLevelWithHomerooms;
	}());
	exports.YearLevelWithHomerooms = YearLevelWithHomerooms;
	var Semester = (function () {
	    function Semester() {
	    }
	    return Semester;
	}());
	exports.Semester = Semester;
	var Term = (function () {
	    function Term() {
	    }
	    return Term;
	}());
	exports.Term = Term;
	var Season = (function () {
	    function Season() {
	    }
	    return Season;
	}());
	exports.Season = Season;


/***/ }),
/* 343 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var StudentFilter = (function () {
	    function StudentFilter() {
	        this.campusId = 0;
	        this.yearLevelId = 0;
	        this.homeroomId = 0;
	        this.page = 1;
	        this.limit = 20;
	        this.name = "";
	        this.aisId = "";
	        this.active = true;
	        this.status = "active";
	        this.exportCSV = false;
	    }
	    return StudentFilter;
	}());
	exports.StudentFilter = StudentFilter;
	var StudentList = (function () {
	    function StudentList() {
	        this.count = 0;
	        this.rows = [];
	    }
	    return StudentList;
	}());
	exports.StudentList = StudentList;
	var Student = (function () {
	    function Student() {
	        this.homeroom = new Homeroom();
	    }
	    return Student;
	}());
	exports.Student = Student;
	var StudentImportResult = (function () {
	    function StudentImportResult() {
	        this.csv = "";
	        this.messages = null;
	        this.isError = false;
	        this.errorType = "";
	        this.errorMessages = [];
	    }
	    return StudentImportResult;
	}());
	exports.StudentImportResult = StudentImportResult;
	var Homeroom = (function () {
	    function Homeroom() {
	    }
	    return Homeroom;
	}());
	var StudentScheduleFilter = (function () {
	    function StudentScheduleFilter() {
	        this.campus = 0;
	        this.year_level = 0;
	        this.page = 1;
	        this.limit = 20;
	        this.student_name = "";
	        this.ais_id = "";
	        this.homeroom = 0;
	        this.season_id = 0;
	    }
	    return StudentScheduleFilter;
	}());
	exports.StudentScheduleFilter = StudentScheduleFilter;
	var StudentScheduleList = (function () {
	    function StudentScheduleList() {
	        this.total = 0;
	        this.data = [];
	    }
	    return StudentScheduleList;
	}());
	exports.StudentScheduleList = StudentScheduleList;
	var AllClassScheduleList = (function () {
	    function AllClassScheduleList() {
	        this.total = 0;
	        this.data = [];
	        this.count = 0;
	    }
	    return AllClassScheduleList;
	}());
	exports.AllClassScheduleList = AllClassScheduleList;
	var AllClassSchedule = (function () {
	    function AllClassSchedule() {
	    }
	    return AllClassSchedule;
	}());
	exports.AllClassSchedule = AllClassSchedule;
	var Schedule = (function () {
	    function Schedule() {
	    }
	    return Schedule;
	}());
	exports.Schedule = Schedule;
	var StudentScheduleImportResult = (function () {
	    function StudentScheduleImportResult() {
	        this.csv = "";
	        this.messages = null;
	        this.isError = false;
	        this.errorType = "";
	        this.errorMessages = [];
	    }
	    return StudentScheduleImportResult;
	}());
	exports.StudentScheduleImportResult = StudentScheduleImportResult;
	// Holiday Student
	var HolidayStudentFilter = (function () {
	    function HolidayStudentFilter() {
	        this.id = 0;
	        this.type = 0;
	        this.status = 0;
	        this.medical = 0;
	    }
	    return HolidayStudentFilter;
	}());
	exports.HolidayStudentFilter = HolidayStudentFilter;
	var HolidayStudentList = (function () {
	    function HolidayStudentList() {
	        this.count = 0;
	        this.data = [];
	    }
	    return HolidayStudentList;
	}());
	exports.HolidayStudentList = HolidayStudentList;
	var StudentDetail = (function () {
	    function StudentDetail() {
	        this.medical = new Array();
	        this.known_name = "";
	    }
	    return StudentDetail;
	}());
	exports.StudentDetail = StudentDetail;
	var HolidayStudents = (function () {
	    function HolidayStudents() {
	        this.hol_parents = new Array();
	        this.medical = new Array();
	    }
	    return HolidayStudents;
	}());
	exports.HolidayStudents = HolidayStudents;
	var HolidayParentDetails = (function () {
	    function HolidayParentDetails() {
	    }
	    return HolidayParentDetails;
	}());
	exports.HolidayParentDetails = HolidayParentDetails;
	var HolMedical = (function () {
	    function HolMedical() {
	    }
	    return HolMedical;
	}());
	exports.HolMedical = HolMedical;
	var HolidayParents = (function () {
	    function HolidayParents() {
	        this.hol_student_parents = new HolidayStudentParents();
	        this.hol_parent_details = new Array();
	    }
	    return HolidayParents;
	}());
	exports.HolidayParents = HolidayParents;
	var HolidayStudentParents = (function () {
	    function HolidayStudentParents() {
	    }
	    return HolidayStudentParents;
	}());
	exports.HolidayStudentParents = HolidayStudentParents;
	var StudentType = (function () {
	    function StudentType() {
	    }
	    return StudentType;
	}());
	exports.StudentType = StudentType;
	exports.STUDENT_TYPE = [
	    {
	        id: "ais",
	        name: "AIS Student",
	    },
	    {
	        id: "other",
	        name: "Non AIS Student",
	    },
	];
	exports.HOL_STUDENT_STATUS = [
	    {
	        id: "active",
	        name: "Active",
	    },
	    {
	        id: "inactive",
	        name: "Inactive",
	    },
	];
	var HolStudentStatus = (function () {
	    function HolStudentStatus() {
	    }
	    return HolStudentStatus;
	}());
	exports.HolStudentStatus = HolStudentStatus;
	exports.HOL_STUDENT_MEDICAL = [
	    {
	        id: "allergic",
	        name: "Allergic",
	    },
	    {
	        id: "medication",
	        name: "Medication",
	    },
	    {
	        id: "under_doctor_care",
	        name: "Under Doctor Care",
	    },
	    {
	        id: "limit_paticipation_athlentic",
	        name: "Limit paticipation athlentic",
	    },
	    {
	        id: "special_education_needs",
	        name: "Special Education Needs",
	    },
	    {
	        id: "special_education_support",
	        name: "Special Education Support",
	    },
	];
	var HolStudentMedical = (function () {
	    function HolStudentMedical() {
	    }
	    return HolStudentMedical;
	}());
	exports.HolStudentMedical = HolStudentMedical;


/***/ }),
/* 344 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ClassStatus = (function () {
	    function ClassStatus() {
	    }
	    return ClassStatus;
	}());
	exports.ClassStatus = ClassStatus;
	exports.ClASS_STATUS = [
	    {
	        id: 'opened',
	        name: 'Opened'
	    },
	    {
	        id: 'closed',
	        name: 'Closed'
	    }
	];


/***/ }),
/* 345 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ClassItem = (function () {
	    function ClassItem() {
	        this.name = "";
	        this.teacher = "";
	        this.room = "";
	        this.hol_course = new HolCourse;
	    }
	    return ClassItem;
	}());
	exports.ClassItem = ClassItem;
	var ClassInfoForEvent = (function () {
	    function ClassInfoForEvent() {
	        this.name = "";
	        this.room = "";
	        this.teacher = "";
	        this.duration = 60;
	        this.lessons = [];
	    }
	    return ClassInfoForEvent;
	}());
	exports.ClassInfoForEvent = ClassInfoForEvent;
	var ClassList = (function () {
	    function ClassList() {
	        this.count = 0;
	        this.data = [];
	    }
	    return ClassList;
	}());
	exports.ClassList = ClassList;
	var ListClassItem = (function () {
	    function ListClassItem() {
	    }
	    return ListClassItem;
	}());
	exports.ListClassItem = ListClassItem;
	var HolCourse = (function () {
	    function HolCourse() {
	    }
	    return HolCourse;
	}());
	exports.HolCourse = HolCourse;
	var ClassFilter = (function () {
	    function ClassFilter() {
	        this.campus_id = 0;
	        this.hol_course_id = 0;
	        this.status = '';
	        this.semester_id = 0;
	        this.schoolYear = 0;
	        this.type = 0;
	    }
	    return ClassFilter;
	}());
	exports.ClassFilter = ClassFilter;


/***/ }),
/* 346 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ClassType = (function () {
	    function ClassType() {
	    }
	    return ClassType;
	}());
	exports.ClassType = ClassType;
	exports.CLASS_TYPE = [
	    {
	        id: 'summer_school',
	        name: 'Summer School',
	        semesterId: 2,
	    },
	    {
	        id: 'winter_school',
	        name: 'Winter School',
	        semesterId: 1,
	    },
	];


/***/ }),
/* 347 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ClassChild = (function () {
	    function ClassChild() {
	    }
	    return ClassChild;
	}());
	exports.ClassChild = ClassChild;
	var Homeroom = (function () {
	    function Homeroom() {
	    }
	    return Homeroom;
	}());
	var HolStudentFilter = (function () {
	    function HolStudentFilter() {
	        this.name = '';
	        this.status = 'active';
	        this.limit = 5;
	    }
	    return HolStudentFilter;
	}());
	exports.HolStudentFilter = HolStudentFilter;
	var ListStudent = (function () {
	    function ListStudent() {
	        this.count = 0;
	        this.data = [];
	    }
	    return ListStudent;
	}());
	exports.ListStudent = ListStudent;
	var ListStudentItem = (function () {
	    function ListStudentItem() {
	    }
	    return ListStudentItem;
	}());
	exports.ListStudentItem = ListStudentItem;
	;
	var medical = (function () {
	    function medical() {
	    }
	    return medical;
	}());
	var holParentItem = (function () {
	    function holParentItem() {
	    }
	    return holParentItem;
	}());


/***/ }),
/* 348 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var AvailableClass = (function () {
	    function AvailableClass() {
	    }
	    return AvailableClass;
	}());
	exports.AvailableClass = AvailableClass;


/***/ }),
/* 349 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ClassPayment = (function () {
	    function ClassPayment() {
	    }
	    return ClassPayment;
	}());
	exports.ClassPayment = ClassPayment;


/***/ }),
/* 350 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Reservation = (function () {
	    function Reservation() {
	    }
	    return Reservation;
	}());
	exports.Reservation = Reservation;
	var CancelReservation = (function () {
	    function CancelReservation() {
	    }
	    return CancelReservation;
	}());
	exports.CancelReservation = CancelReservation;
	var BookingInfo = (function () {
	    function BookingInfo() {
	    }
	    return BookingInfo;
	}());
	exports.BookingInfo = BookingInfo;


/***/ }),
/* 351 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var BookingItem = (function () {
	    function BookingItem() {
	        this.hol_class = new HolidayClass;
	        this.hol_weeks = [];
	        this.hol_student = new HolidayStudent;
	        this.price = new BookingPrice;
	        this.hol_booking_buses = new Array();
	        this.transactions = new Array();
	    }
	    return BookingItem;
	}());
	exports.BookingItem = BookingItem;
	var BookingTransactions = (function () {
	    function BookingTransactions() {
	    }
	    return BookingTransactions;
	}());
	var HolidayBuses = (function () {
	    function HolidayBuses() {
	    }
	    return HolidayBuses;
	}());
	exports.HolidayBuses = HolidayBuses;
	var BookingList = (function () {
	    function BookingList() {
	        this.count = 0;
	        this.data = [];
	    }
	    return BookingList;
	}());
	exports.BookingList = BookingList;
	var ListBookingItem = (function () {
	    function ListBookingItem() {
	    }
	    return ListBookingItem;
	}());
	exports.ListBookingItem = ListBookingItem;
	;
	var HolidayClass = (function () {
	    function HolidayClass() {
	        this.campus = new CampusInfo;
	    }
	    return HolidayClass;
	}());
	exports.HolidayClass = HolidayClass;
	var CampusInfo = (function () {
	    function CampusInfo() {
	    }
	    return CampusInfo;
	}());
	exports.CampusInfo = CampusInfo;
	var BookingPrice = (function () {
	    function BookingPrice() {
	    }
	    return BookingPrice;
	}());
	exports.BookingPrice = BookingPrice;
	;
	var HolidayWeek = (function () {
	    function HolidayWeek() {
	    }
	    return HolidayWeek;
	}());
	exports.HolidayWeek = HolidayWeek;
	var HolidayBookingWeek = (function () {
	    function HolidayBookingWeek() {
	    }
	    return HolidayBookingWeek;
	}());
	exports.HolidayBookingWeek = HolidayBookingWeek;
	var HolidayStudent = (function () {
	    function HolidayStudent() {
	    }
	    return HolidayStudent;
	}());
	exports.HolidayStudent = HolidayStudent;
	var LunchStatus = (function () {
	    function LunchStatus() {
	    }
	    return LunchStatus;
	}());
	exports.LunchStatus = LunchStatus;
	exports.LUNCH_STATUS = [
	    {
	        id: 'true',
	        name: 'Yes'
	    },
	    {
	        id: 'false',
	        name: 'No'
	    }
	];
	var WeekList = (function () {
	    function WeekList() {
	    }
	    return WeekList;
	}());
	exports.WeekList = WeekList;
	exports.WEEK_LIST = [
	    {
	        id: 1,
	        name: 'Week 1'
	    },
	    {
	        id: 2,
	        name: 'Week 2'
	    },
	    {
	        id: 3,
	        name: 'Week 3'
	    },
	    {
	        id: 4,
	        name: 'Week 4'
	    },
	    {
	        id: 5,
	        name: 'Week 5'
	    },
	    {
	        id: 6,
	        name: 'Week 6'
	    },
	    {
	        id: 7,
	        name: 'Week 7'
	    },
	];
	var TransactionDetail = (function () {
	    function TransactionDetail() {
	        this.price = new TransactionPrice;
	        this.semester = new TransactionSemester;
	        this.student = new TransactionStudent;
	        this.transactions = new Array();
	        this.buses = new Array();
	    }
	    return TransactionDetail;
	}());
	exports.TransactionDetail = TransactionDetail;
	var TransactionBuses = (function () {
	    function TransactionBuses() {
	    }
	    return TransactionBuses;
	}());
	var HolTransactions = (function () {
	    function HolTransactions() {
	    }
	    return HolTransactions;
	}());
	exports.HolTransactions = HolTransactions;
	var ClassTransaction = (function () {
	    function ClassTransaction() {
	    }
	    return ClassTransaction;
	}());
	exports.ClassTransaction = ClassTransaction;
	var TransactionPrice = (function () {
	    function TransactionPrice() {
	    }
	    return TransactionPrice;
	}());
	exports.TransactionPrice = TransactionPrice;
	var TransactionSemester = (function () {
	    function TransactionSemester() {
	    }
	    return TransactionSemester;
	}());
	exports.TransactionSemester = TransactionSemester;
	var TransactionStudent = (function () {
	    function TransactionStudent() {
	        this.parents = new Array();
	    }
	    return TransactionStudent;
	}());
	exports.TransactionStudent = TransactionStudent;
	var TransactionParents = (function () {
	    function TransactionParents() {
	    }
	    return TransactionParents;
	}());
	exports.TransactionParents = TransactionParents;
	var MakeHolTransaction = (function () {
	    function MakeHolTransaction() {
	        this.command = new HolTransactionCommand;
	    }
	    return MakeHolTransaction;
	}());
	exports.MakeHolTransaction = MakeHolTransaction;
	var UpdateHolTransaction = (function () {
	    function UpdateHolTransaction() {
	        this.command = new UpdateHolTransactionCommand;
	    }
	    return UpdateHolTransaction;
	}());
	exports.UpdateHolTransaction = UpdateHolTransaction;
	var UpdateHolTransactionCommand = (function () {
	    function UpdateHolTransactionCommand() {
	    }
	    return UpdateHolTransactionCommand;
	}());
	exports.UpdateHolTransactionCommand = UpdateHolTransactionCommand;
	var HolTransactionCommand = (function () {
	    function HolTransactionCommand() {
	    }
	    return HolTransactionCommand;
	}());
	var DeleteHolTransaction = (function () {
	    function DeleteHolTransaction() {
	    }
	    return DeleteHolTransaction;
	}());
	exports.DeleteHolTransaction = DeleteHolTransaction;


/***/ }),
/* 352 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var BookingFilter = (function () {
	    function BookingFilter() {
	        this.campus_id = 0;
	        this.course_id = 0;
	        this.lunch = 0;
	        this.week = 0;
	        this.bus = "";
	    }
	    return BookingFilter;
	}());
	exports.BookingFilter = BookingFilter;


/***/ }),
/* 353 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var BookingDetail = (function () {
	    function BookingDetail() {
	    }
	    return BookingDetail;
	}());
	exports.BookingDetail = BookingDetail;
	var Semester = (function () {
	    function Semester() {
	    }
	    return Semester;
	}());
	var Classes = (function () {
	    function Classes() {
	    }
	    return Classes;
	}());
	var Transactions = (function () {
	    function Transactions() {
	    }
	    return Transactions;
	}());
	exports.Transactions = Transactions;
	var Student = (function () {
	    function Student() {
	    }
	    return Student;
	}());


/***/ }),
/* 354 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var BookingPayment = (function () {
	    function BookingPayment() {
	    }
	    return BookingPayment;
	}());
	exports.BookingPayment = BookingPayment;


/***/ }),
/* 355 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var StudentsInClass = (function () {
	    function StudentsInClass() {
	    }
	    return StudentsInClass;
	}());
	exports.StudentsInClass = StudentsInClass;
	var Homeroom = (function () {
	    function Homeroom() {
	    }
	    return Homeroom;
	}());


/***/ }),
/* 356 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ScheduleImportResult = (function () {
	    function ScheduleImportResult() {
	    }
	    return ScheduleImportResult;
	}());
	exports.ScheduleImportResult = ScheduleImportResult;


/***/ }),
/* 357 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var StudentStatus = (function () {
	    function StudentStatus() {
	    }
	    return StudentStatus;
	}());
	exports.StudentStatus = StudentStatus;
	exports.STUDENT_STATUS = [
	    {
	        id: 'true',
	        name: 'Active'
	    },
	    {
	        id: 'false',
	        name: 'Unactive'
	    }
	];


/***/ }),
/* 358 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var AttendancesFilter = (function () {
	    function AttendancesFilter() {
	        this.classId = 0;
	        this.studentCode = '';
	        this.schoolYear = 0;
	        this.date = '';
	        this.fromDate = '';
	        this.toDate = '';
	        this.campusId = 0;
	        this.page = 1;
	        this.max_per_page = 1000;
	    }
	    return AttendancesFilter;
	}());
	exports.AttendancesFilter = AttendancesFilter;


/***/ }),
/* 359 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var AttendancesList = (function () {
	    function AttendancesList() {
	        this.page = 1;
	        this.data = [];
	    }
	    return AttendancesList;
	}());
	exports.AttendancesList = AttendancesList;
	var ListAttendanceItem = (function () {
	    function ListAttendanceItem() {
	        this.attendances = [];
	    }
	    return ListAttendanceItem;
	}());
	exports.ListAttendanceItem = ListAttendanceItem;
	var Attendances = (function () {
	    function Attendances() {
	    }
	    return Attendances;
	}());
	exports.Attendances = Attendances;
	var CheckAttendances = (function () {
	    function CheckAttendances() {
	    }
	    return CheckAttendances;
	}());
	exports.CheckAttendances = CheckAttendances;


/***/ }),
/* 360 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Auth = (function () {
	    function Auth(username, password) {
	        this.username = username;
	        this.password = password;
	    }
	    return Auth;
	}());
	exports.Auth = Auth;


/***/ }),
/* 361 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Manager = (function () {
	    function Manager() {
	    }
	    return Manager;
	}());
	exports.Manager = Manager;


/***/ }),
/* 362 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var MakeTransaction = (function () {
	    function MakeTransaction() {
	        this.command = new TransactionCommand();
	    }
	    return MakeTransaction;
	}());
	exports.MakeTransaction = MakeTransaction;
	var TransactionCommand = (function () {
	    function TransactionCommand() {
	    }
	    return TransactionCommand;
	}());


/***/ }),
/* 363 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var CourseFilter = (function () {
	    function CourseFilter() {
	        this.name = "";
	        this.type = 0;
	        this.status = "";
	        this.page = 1;
	        this.limit = 100;
	    }
	    return CourseFilter;
	}());
	exports.CourseFilter = CourseFilter;


/***/ }),
/* 364 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var CourseStatus = (function () {
	    function CourseStatus() {
	    }
	    return CourseStatus;
	}());
	exports.CourseStatus = CourseStatus;
	exports.COURSE_STATUS = [
	    {
	        id: 'opened',
	        name: 'Opened'
	    },
	    {
	        id: 'closed',
	        name: 'Closed'
	    }
	];


/***/ }),
/* 365 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var CourseType = (function () {
	    function CourseType() {
	    }
	    return CourseType;
	}());
	exports.CourseType = CourseType;
	exports.COURSE_TYPE = [
	    {
	        id: 'summer_school',
	        name: 'Summer School',
	        semesterId: 2,
	    },
	    {
	        id: 'winter_school',
	        name: 'Winter School',
	        semesterId: 1,
	    },
	];


/***/ }),
/* 366 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var CourseItem = (function () {
	    function CourseItem() {
	        this.name = "";
	        this.type = "";
	        this.description = "";
	    }
	    return CourseItem;
	}());
	exports.CourseItem = CourseItem;
	var CourseList = (function () {
	    function CourseList() {
	        this.count = 0;
	        this.data = [];
	    }
	    return CourseList;
	}());
	exports.CourseList = CourseList;
	var ListCourseItem = (function () {
	    function ListCourseItem() {
	    }
	    return ListCourseItem;
	}());
	exports.ListCourseItem = ListCourseItem;
	var CourseClassItem = (function () {
	    function CourseClassItem() {
	        this.name = "";
	        this.room = "";
	        this.teacher = "";
	        this.activities = "";
	        this.suitable_from = "";
	        this.suitable_to = "";
	        this.status = "";
	        this.total_cost = 0;
	        this.prices = [];
	    }
	    return CourseClassItem;
	}());
	exports.CourseClassItem = CourseClassItem;


/***/ }),
/* 367 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Email = (function () {
	    function Email() {
	        this.count = 0;
	        this.rows = [];
	    }
	    return Email;
	}());
	exports.Email = Email;
	var ListEmail = (function () {
	    function ListEmail() {
	    }
	    return ListEmail;
	}());
	exports.ListEmail = ListEmail;
	var EmailFilter = (function () {
	    function EmailFilter() {
	        this.email_type = 0;
	        this.page = 1;
	        this.limit = 50;
	    }
	    return EmailFilter;
	}());
	exports.EmailFilter = EmailFilter;
	var SendEmail = (function () {
	    function SendEmail() {
	    }
	    return SendEmail;
	}());
	exports.SendEmail = SendEmail;
	var SaveEmail = (function () {
	    function SaveEmail() {
	    }
	    return SaveEmail;
	}());
	exports.SaveEmail = SaveEmail;
	var EmailStudentsFilter = (function () {
	    function EmailStudentsFilter() {
	        this.programme_type = 0;
	        this.schoolYear = 0;
	        this.campusId = 0;
	        this.classId = 0;
	        this.isBus = 0;
	        this.tuitionStatus = '';
	    }
	    return EmailStudentsFilter;
	}());
	exports.EmailStudentsFilter = EmailStudentsFilter;
	var JobSendMail = (function () {
	    function JobSendMail() {
	        this.status = true;
	        this.content = { day_interval: null };
	    }
	    return JobSendMail;
	}());
	exports.JobSendMail = JobSendMail;


/***/ }),
/* 368 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Weeks = (function () {
	    function Weeks() {
	    }
	    return Weeks;
	}());
	exports.Weeks = Weeks;
	var WeekDetail = (function () {
	    function WeekDetail() {
	    }
	    return WeekDetail;
	}());
	exports.WeekDetail = WeekDetail;
	var Excursion = (function () {
	    function Excursion() {
	    }
	    return Excursion;
	}());
	exports.Excursion = Excursion;
	var AddExcursion = (function () {
	    function AddExcursion() {
	    }
	    return AddExcursion;
	}());
	exports.AddExcursion = AddExcursion;
	var ExcursionDetail = (function () {
	    function ExcursionDetail() {
	    }
	    return ExcursionDetail;
	}());
	exports.ExcursionDetail = ExcursionDetail;
	var Questionnarie = (function () {
	    function Questionnarie() {
	    }
	    return Questionnarie;
	}());
	exports.Questionnarie = Questionnarie;
	var UpsertQuestionnarie = (function () {
	    function UpsertQuestionnarie() {
	    }
	    return UpsertQuestionnarie;
	}());
	exports.UpsertQuestionnarie = UpsertQuestionnarie;
	var DiscoundConfig = (function () {
	    function DiscoundConfig() {
	    }
	    return DiscoundConfig;
	}());
	exports.DiscoundConfig = DiscoundConfig;


/***/ }),
/* 369 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Payment = (function () {
	    function Payment() {
	        this.currency = 'VND';
	    }
	    return Payment;
	}());
	exports.Payment = Payment;


/***/ }),
/* 370 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Pagination = (function () {
	    function Pagination(page, totalPage, pageSize, itemPerPage) {
	        if (page === void 0) { page = 1; }
	        if (totalPage === void 0) { totalPage = 0; }
	        if (pageSize === void 0) { pageSize = 10; }
	        if (itemPerPage === void 0) { itemPerPage = 15; }
	        this.currentPage = page;
	        this.totalPage = totalPage;
	        this.pageSize = pageSize;
	        this.itemPerPage = itemPerPage;
	        this.startIndex = 0;
	        this.endIndex = 0;
	    }
	    return Pagination;
	}());
	exports.Pagination = Pagination;


/***/ }),
/* 371 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Questionnaire = (function () {
	    function Questionnaire() {
	    }
	    return Questionnaire;
	}());
	exports.Questionnaire = Questionnaire;
	var Answer = (function () {
	    function Answer() {
	    }
	    return Answer;
	}());
	exports.Answer = Answer;
	var Answers = (function () {
	    function Answers() {
	    }
	    return Answers;
	}());


/***/ }),
/* 372 */
/***/ (function(module, exports) {

	module.exports = "<main>\n  <div class=\"component-title\">\n    <h1>Step 4: Payment</h1>\n  </div>\n  <div class=\"camp-payment-container row\">\n    <div class=\"camp-payment-info large-12 medium-12 small-12 row\">\n      <div class=\"large-8\">\n        <h2>{{booking.class.name}}</h2>\n        <table>\n          <tr>\n            <th>Start date</th>\n            <td *ngIf=\"startDate\">\n              {{timeDataFormat(startDate, 'DD-MM-YYYY')}}\n            </td>\n            <th>Campus</th>\n            <td>\n              <span>{{booking.class.campus.name}}</span>\n            </td>\n          </tr>\n          <tr>\n            <th>End date</th>\n            <td *ngIf=\"endDate\">{{timeDataFormat(endDate, 'DD-MM-YYYY')}}</td>\n            <th>Teacher</th>\n            <td>{{booking.class.teacher}}</td>\n          </tr>\n          <tr *ngIf=\"filteredExcursions\">\n            <th>Excursions</th>\n            <td colspan=\"3\" class=\"text-left\">{{filteredExcursions}}</td>\n          </tr>\n          <tr *ngIf=\"duration && currentSemester.name === 'Semester 2'\">\n            <th>Duration</th>\n            <td colspan=\"3\" class=\"text-left\">{{duration}}</td>\n          </tr>\n        </table>\n      </div>\n      <div class=\"large-4\">\n        <div>\n          <!-- <h4 *ngIf=\"!booking.discount.discount && !earlyBirdDiscount()\">{{booking.periodWeeks.length * booking.class.cost_per_week | number : '1.0-2'}} VND</h4>\n                    <h4 *ngIf=\"booking.discount.discount || earlyBirdDiscount()\">{{(booking.periodWeeks.length * booking.class.cost_per_week) - (booking.periodWeeks.length * booking.class.cost_per_week * 0.1) | number : '1.0-2'}} VND</h4> -->\n          <h4>{{ calculatorTotalAmount() | number : '1.0-2'}} VND</h4>\n          <!-- <small [hidden]=\"!booking.discount.discount\">included 10% discount</small> -->\n          <small\n            *ngIf=\"booking.discount.discount || (earlyBirdDiscount() && checkFullWeek())\"\n            >included 10% discount</small\n          >\n          <!--<button>\n                        <span class=\"selected-icon\">Pay</span>\n                    </button>-->\n        </div>\n      </div>\n    </div>\n    <div class=\"camp-payment-info large-12 medium-12 small-12 row\">\n      <div class=\"large-8 add-on\">\n        <h2>Add on service</h2>\n        <table>\n          <tr>\n            <th *ngIf=\"booking.busType == 'paid' && checkFullWeek()\">\n              <label>\n                <input\n                  type=\"checkbox\"\n                  checked=\"checked\"\n                  name=\"bus\"\n                  [(ngModel)]=\"checkBus\"\n                  [disabled]=\"isDisableBusCheck\"\n                />Bus registration fee {{btBusCost | number : '1.0-2'}} VND {{\n                currentSemester.name !== 'Semester 2' ? 'for the duration of a\n                programme' : '/' + booking.periodWeeks.length + ' Weeks'}}\n              </label>\n              <!-- <p style=\"font-size: 0.875rem\">Please note that the bus fee above is not included in the total amount.<br/>\n                            The Bus Coordinator will contact you for the final confirmation.\n                            </p> -->\n            </th>\n\n            <!-- <th *ngIf=\"booking.busType == 'paid' && booking.bus.district === 'Others'\">\n                            <label>\n                                <input type=\"checkbox\" checked=\"checked\" name=\"bus\" [(ngModel)]=\"checkBus\" [disabled]=\"isDisableBusCheck\">Bus registration fee {{othersBusCost | number : '1.0-2'}} VND / {{booking.periodWeeks.length}} Weeks\n                            </label>\n                            <p style=\"font-size: 0.875rem\">Please note that the bus fee above is not included in the total amount..<br/>\n                            The Bus Coordinator will contact you for the final confirmation.\n                            </p>\n                        </th> -->\n            <th *ngIf=\"booking.busType == 'free'\">\n              <label>\n                <input type=\"checkbox\" checked=\"checked\" disabled />Bus free\n              </label>\n            </th>\n          </tr>\n          <tr>\n            <th *ngIf=\"booking.busType == 'paid' && !checkFullWeek()\">\n              <label>\n                <input\n                  type=\"checkbox\"\n                  checked=\"checked\"\n                  name=\"busInformed\"\n                  [disabled]=\"true\"\n                />Bus registration fee {{btBusCost | number : '1.0-2'}} VND {{\n                  currentSemester.name !== 'Semester 2' ? 'for the duration of a\n                  programme' : '/' + booking.periodWeeks.length + ' Weeks'}}\n              </label>\n            </th>\n          </tr>\n          <tr>\n            <th *ngIf=\"!checkFullWeek()\">\n              <label>\n                <input\n                  type=\"checkbox\"\n                  [(ngModel)]=\"checkLunch\"\n                  name=\"lunch\"\n                />Lunch and snack are available each day for {{lunchPrice |\n                  number : '1.0-2'}} VND {{ currentSemester.name !== 'Semester 2'\n                  ? 'for the duration of a programme' : '/' +\n                  booking.periodWeeks.length + ' Weeks'}}\n              </label>\n            </th>\n          </tr>\n          <tr>\n            <th *ngIf=\"checkFullWeek()\">\n              <label>\n                <input\n                  type=\"checkbox\"\n                  name=\"lunch\"\n                  [(ngModel)]=\"checkLunch\"\n                />Lunch and snack are available each day for {{lunchPrice |\n                number : '1.0-2'}} VND {{ currentSemester.name !== 'Semester 2'\n                ? 'for the duration of a programme' : '/' +\n                booking.periodWeeks.length + ' Weeks'}}\n              </label>\n              <!-- <p>\n                                Please <a class=\"clickable guideline\" target=\"_blank\" href=\"https://issuu.com/aissaigon/docs/ais_lunch_menu1-combined_1_organized?fr=sYjQ5ODQ4NTg5NDE\">click here</a>  for the AIS Summer School menus for your reference.\n                            </p> -->\n            </th>\n          </tr>\n        </table>\n      </div>\n    </div>\n    <div class=\"total-amount large-12 medium-12 small-12\">\n      <h2>Total Amount {{countTotalCost() | number : '1.0-2'}} VND<br /></h2>\n    </div>\n    <div class=\"camp-payment-section row\">\n      <div class=\"camp-payment-term large-6 medium-12 small-12\">\n        <h5>Term and conditions</h5>\n        <ul>\n          <li>\n            Enrolment is only confirmed when payment is received in full;\n            failure to do so may result in the student's placement being\n            forfeited.\n          </li>\n          <li>\n            Fees (or part fees thereof) are not refundable once the course has\n            started. This includes voluntary withdrawal and missed classes due\n            to student vacations, bad weather, illness or lack of interest, etc.\n          </li>\n          <li>Fees are non-refundable and non-transferable.</li>\n          <li>\n            If a student can't longer continue with the course, through illness\n            or injury, fees will be refunded on a pro rata basis when supported\n            by a doctor's note. Note an administration charge may apply.\n          </li>\n        </ul>\n      </div>\n      <div class=\"camp-payment-method large-6 medium-12 small-12\">\n        <h5>Payment menthod</h5>\n        <form>\n          <!--<div *ngIf=\"checkFullWeek()\">-->\n          <div>  \n            <input\n              type=\"radio\"\n              name=\"payment\"\n              [(ngModel)]=\"paymentType\"\n              value=\"domestic\"\n              id=\"atm\"\n              *ngIf=\"!isFree\"\n            /><label for=\"atm\" *ngIf=\"!isFree\">\n              Online payment - Domestic cards (ATM)</label\n            >\n            <input\n              type=\"radio\"\n              name=\"payment\"\n              [(ngModel)]=\"paymentType\"\n              value=\"international\"\n              id=\"visa\"\n              *ngIf=\"!isFree\"\n            /><label for=\"visa\" *ngIf=\"!isFree\">\n              Online payment - International cards (VISA, Master)</label\n            >\n          </div>\n          <input\n            type=\"radio\"\n            name=\"payment\"\n            [(ngModel)]=\"paymentType\"\n            value=\"\"\n            id=\"other\"\n          /><label for=\"other\"> Pay later with cash or bank transfer</label>\n        </form>\n        <!--<p *ngIf=\"!checkFullWeek()\">\n          For weekly booking, Summer school fee confirmation will be sent to\n          your email later by Admin Team via <a>AIS.Admin@AISVIETNAM.COM</a>\n        </p>-->\n      </div>\n    </div>\n\n    <!--Survey-->\n    <div class=\"survey\">\n      <h4>\n        How did you hear about the {{currentSemester.name !== 'Semester 2' ?\n        'Winter' : 'Summer'}} Programme ?\n      </h4>\n      <div class=\"row\">\n        <div class=\"columns large-8\">\n          <select name=\"survey\" id=\"survey\" [(ngModel)]=\"surveySelect\">\n            <option value=\"\">-- Select survey --</option>\n            <option value=\"Newspaper\">Newspaper</option>\n            <option value=\"Online news website\">Online news website</option>\n            <option value=\"Magazine\">Magazine</option>\n            <option value=\"Online banner ads\">Online banner ads</option>\n            <option value=\"Banner ads on campus\">Banner ads on campus</option>\n            <option value=\"AIS Facebook\">AIS Facebook</option>\n            <option value=\"Flyer\">Flyer</option>\n            <option value=\"Newsletter\">Newsletter</option>\n            <option value=\"Email invitation\">Email invitation</option>\n            <option value=\"Word of mouth\">Word of mouth</option>\n          </select>\n        </div>\n      </div>\n    </div>\n    <!--End of Survey-->\n\n    <!-- Description Modal -->\n    <div class=\"modal\" [hidden]=\"!showSurveyMessage\">\n      <!-- Modal content -->\n      <div class=\"modal-content\">\n        <div class=\"modal-header\">\n          <span class=\"close\" (click)=\"showSurveyMessage = false\">×</span>\n          <h2>Pick an option for survey</h2>\n        </div>\n        <div class=\"modal-body\">\n          <span\n            >Please select an option for our survey to provide better\n            services</span\n          >\n        </div>\n      </div>\n    </div>\n    <!-- End of Description Modal -->\n\n    <!-- Loading Modal -->\n    <div class=\"modal\" [hidden]=\"!loadingSubmit\">\n      <!-- Modal content -->\n      <div class=\"modal-content\">\n        <div class=\"loading-logo\" [hidden]=\"!loadingSubmit\">\n          <div class=\"loader\"></div>\n          <div class=\"loader-text\">Processing...</div>\n        </div>\n      </div>\n    </div>\n    <!-- End of Loading Modal -->\n  </div>\n  <div id=\"submit\" class=\"row\">\n    <div class=\"large-4 l-btn\">\n      <button class=\"back-btn\" (click)=\"backToBusOption()\">Back</button>\n    </div>\n    <div class=\"large-8 r-btn\">\n      <button\n        *ngIf=\"!loadingSubmit\"\n        class=\"submit large-5\"\n        (click)=\"submitPayment()\"\n        [disabled]=\"disabledSumit()\"\n      >\n        CONTINUE\n      </button>\n      <button *ngIf=\"loadingSubmit\" class=\"submit large-5 text-center\">\n        CONTINUE\n      </button>\n    </div>\n  </div>\n</main>\n";

/***/ }),
/* 373 */
/***/ (function(module, exports) {

	module.exports = ".text-left{text-align:left}.countdown{text-align:right;font-size:18px;padding:10px 20px}.container{width:80%;margin:0 auto;padding:2rem 1.25rem}.container .headline{background:#faa635;border-bottom-left-radius:5px;border-bottom-right-radius:5px;padding:0.3rem 1.5rem;margin:2rem 0 1rem}.container .headline h2{font-size:1.5625rem;color:#043d7a;font-weight:bold;text-align:right}.container .headline .algn-l{text-align:left}.container div p{font-size:0.875rem;color:#6e6e6e;line-height:1.6}.component-title{color:#043d7a;background-color:#f8f8f8;padding:1.5rem 10%;border-bottom:1px solid #eaeaea}.component-title h1{margin:0 auto;padding:0 1.25rem;font-size:1.5256rem}.component-title small{padding:0 1.25rem;font-size:90%}.wrap-select-camp-header-inner{width:100%;padding:1rem calc(10% + 1.25rem) 0;background:#f8f8f8;border-top:1px solid white}.wrap-select-camp-header-inner .camp-child-icon{vertical-align:-3px;margin-right:10px}.wrap-select-camp-header-inner .wrap-select-option-header{display:inline-block;position:relative}.wrap-select-camp-header-inner .wrap-select-option-header:before{content:'';color:#ddd;width:2.5rem;height:1.5625rem;position:absolute;pointer-events:none;right:17px;top:17px;width:0;height:0;border-left:5px solid transparent;border-right:5px solid transparent;border-top:8px solid #ddd}.wrap-select-camp-header-inner .wrap-select-option-header:after{content:'';position:absolute;height:1.5625rem;width:1px;background:#ddd;top:8px;right:40px}.wrap-select-camp-header-inner .wrap-select-option-header select{padding:0 50px 0 13px;border-radius:5px;font-size:1rem;background:#f8f8f8;border:1px solid #ddd;height:2.5rem;color:#282828;outline:none}#submit{max-width:100%;width:100%;padding:2rem 10%;border-top:1px solid #ddd}#submit .l-btn{padding-left:1.25rem}#submit .l-btn button{text-align:left;padding:1.25rem 5.25rem;font-size:1.25rem;font-weight:bold;background:#eaeaea;color:#6e6e6e}#submit .r-btn{text-align:right;padding-right:1.25rem}#submit .r-btn p{text-align:right;font-size:0.875rem;padding-right:1.125rem;padding-top:1rem}#submit .r-btn p a{font-weight:bold}#submit .r-btn .submit{padding:1.25rem 3rem;text-align:center;font-size:1.25rem;font-weight:bold}.bus-registration-container{width:80%;margin:0 auto;padding:0px 1.25rem;margin-bottom:1.5rem}.bus-registration-container h3{font-size:1.525rem;font-weight:bold;color:#043d7a;text-align:center;margin:2rem auto 1rem}.bus-registration-container .total-amount{background:#faa635;border-bottom-left-radius:5px;border-bottom-right-radius:5px;padding:0.3rem 1.5rem}.bus-registration-container .total-amount h2{font-size:1.5625rem;color:#043d7a;font-weight:bold;text-align:right}.bus-registration-container .total-amount .algn-l{text-align:left}.bus-registration-container .total-amount p{font-size:0.875rem;color:#6e6e6e;text-align:justify;line-height:1.6}.bus-registration-container .bus-registration-section{padding:0 1.25rem;margin-top:1rem;justify-content:space-between}.bus-registration-container .bus-registration-section table{text-align:left}.bus-registration-container .bus-registration-section table tr:first-child{background:#043d7a;color:#fff}.bus-registration-container .bus-registration-section p{font-size:0.875rem;color:#6e6e6e;text-align:justify;line-height:1.6}.bus-registration-container .bus-registration-section h5{font-size:1.125rem;color:#043d7a;font-weight:bold;margin-bottom:0.375rem}.bus-registration-container .bus-registration-section ul{list-style-type:decimal}.bus-registration-container .bus-registration-section ul li{font-size:0.875rem;color:#6e6e6e;text-align:justify}.bus-registration-container .bus-registration-section .bus-registration-term{padding-right:3rem}.bus-registration-container .bus-registration-section .bus-registration-method form{box-shadow:none;padding:0;font-size:1rem}.bus-registration-container .bus-registration-section .bus-registration-method form input[type=\"radio\"]{display:none}.bus-registration-container .bus-registration-section .bus-registration-method form input[type=\"radio\"]+label{margin-bottom:0.5rem;font-size:1rem;font-weight:bold;color:#6e6e6e}.bus-registration-container .bus-registration-section .bus-registration-method form input[type=\"radio\"]:disabled+label:before{background:#eee}.bus-registration-container .bus-registration-section .bus-registration-method form input[type=\"radio\"]+label:before{color:#6e6e6e;content:\"\\00a0\";display:inline-block;font:1em sans-serif;margin-right:0.5rem;padding:0;vertical-align:middle;width:1.25rem;height:1.25rem;border-radius:10px;border:1px solid #b8b8b8}.bus-registration-container .bus-registration-section .bus-registration-method form input[type=\"radio\"]:checked+label:before{content:\"\\2022\";color:#b8b8b8;font-size:2.5rem;line-height:19px;text-align:center}.modal{position:fixed;z-index:1;left:0;top:0;width:100%;height:100%;overflow:auto;background-color:#000;background-color:rgba(0,0,0,0.4)}.modal table{display:block;padding:5px 10px;margin-bottom:0;background:#fff;border-bottom-right-radius:5px;border-bottom-left-radius:5px}.modal table tbody{border:none}.modal table tbody td{font-weight:bold;font-size:0.875rem;color:#6e6e6e}.modal .modal-content{margin:0;max-width:400px;position:absolute;top:50%;left:50%;-ms-transform:translateX(-50%) translateY(-50%);-webkit-transform:translate(-50%, -50%);transform:translate(-50%, -50%)}.modal .modal-content .close{color:#fff;float:right;font-size:20px;font-weight:bold;line-height:1}.modal .modal-content .close:hover,.modal .modal-content .close:focus{color:#eee;text-decoration:none;cursor:pointer}.modal .modal-header{text-align:center;padding:10px 20px;color:#fff;background:#043d7a;font-size:1.25rem;font-weight:bold;border-top-right-radius:5px;border-top-left-radius:5px}.modal .modal-header h2{text-align:left;font-size:1rem;font-weight:bold;margin-bottom:0}.modal .modal-body{padding:10px 20px;background:#fff;border-bottom-right-radius:5px;border-bottom-left-radius:5px}@media only screen and (max-width: 40em){.select-camp-header .select-camp-header-inner{padding:0}.select-camp-header .select-camp-header-inner h4{padding-left:10%;padding-right:10%}.select-camp-header .select-camp-header-inner .wrap-select-camp-header-inner{padding:0}.select-camp-header .select-camp-header-inner .wrap-select-camp-header-inner .camp-child-icon{display:none}.list-camp h3{margin:1.5rem auto 1.5rem;line-height:0.7;font-size:1.4rem}.list-camp .row li{padding:0}}.algn-l{text-align:left}.camp-payment-container{width:80%;margin:0 auto;padding:0px 1.25rem;margin-bottom:1.5rem}.camp-payment-container h3{font-size:1.525rem;font-weight:bold;color:#043d7a;text-align:center;margin:2rem auto 1rem}.camp-payment-container .camp-payment-info{background:#f8f8f8;border:1px solid #ddd;border-radius:5px;margin:1rem auto}.camp-payment-container .camp-payment-info div.large-4{padding:1.75rem 1.25rem;text-align:center}.camp-payment-container .camp-payment-info div.large-4 div{position:relative;top:50%;transform:translateY(-50%)}.camp-payment-container .camp-payment-info div.large-4 div h4{font-weight:bold}.camp-payment-container .camp-payment-info div.large-4 div button{width:70%;background:#faa635}.camp-payment-container .camp-payment-info div.large-4 div button span.selected-icon{margin-left:2rem;position:relative;font-weight:bold;color:#043d7a}.camp-payment-container .camp-payment-info div.large-4 div button span.selected-icon:after{content:\"\";position:absolute;top:-1px;left:-36px;border:2px solid;width:24px;height:24px;border-radius:50%}.camp-payment-container .camp-payment-info div.large-4 div button span.selected-icon:before{content:\"\";position:absolute;top:15px;left:-27px;width:5px;height:12px;border-width:0 2px 2px 0;border-style:solid;margin-top:-11px;-webkit-transform:rotate(30deg);-moz-transform:rotate(30deg);-ms-transform:rotate(30deg);-o-transform:rotate(30deg);transform:rotate(30deg)}.camp-payment-container .camp-payment-info div.large-4 div button.paid{background:#f8f8f8;border:1px solid #ddd;box-shadow:none}.camp-payment-container .camp-payment-info div.large-4 div button.paid span{color:#282828;opacity:0.55}.camp-payment-container .camp-payment-info div.large-8{padding:1.75rem 1.25rem;border-right:1px solid #ddd;padding-right:5rem}.camp-payment-container .camp-payment-info div.large-8.add-on{padding-right:2rem}.camp-payment-container .camp-payment-info div.large-8 h2{font-size:1.5625rem;color:#FAA635;margin-bottom:1.5rem;font-weight:bold}.camp-payment-container .camp-payment-info div.large-8 table tbody{border:none}.camp-payment-container .camp-payment-info div.large-8 table tbody tr{background:#f8f8f8}.camp-payment-container .camp-payment-info div.large-8 table tbody tr input{vertical-align:-3px}.camp-payment-container .camp-payment-info div.large-8 table tbody tr label{font-size:0.875rem;font-weight:bold;color:#666}.camp-payment-container .camp-payment-info div.large-8 table tbody tr:last-child{border-bottom:none}.camp-payment-container .camp-payment-info div.large-8 table tbody tr th,.camp-payment-container .camp-payment-info div.large-8 table tbody tr td{color:#6e6e6e;font-size:0.875rem}.camp-payment-container .camp-payment-info div.large-8 table tbody tr>th{font-weight:normal;text-align:left;vertical-align:top}.camp-payment-container .camp-payment-info div.large-8 table tbody tr>th:nth-child(1){width:20%}.camp-payment-container .camp-payment-info div.large-8 table tbody tr>th:nth-child(3){padding-left:15%;width:30%}.camp-payment-container .camp-payment-info div.large-8 table tbody tr td{font-weight:bold;text-align:right;width:25%}.camp-payment-container .camp-payment-info div.large-8 table tbody tr td.text-left{text-align:left}.camp-payment-container .total-amount{background:#faa635;border-bottom-left-radius:5px;border-bottom-right-radius:5px;padding:0.3rem 1.5rem 0.1rem}.camp-payment-container .total-amount h2{font-size:1.5625rem;color:#043d7a;font-weight:bold;text-align:right}.camp-payment-container .total-amount h2 small{font-size:60%;color:#043d7a}.camp-payment-container .total-amount .algn-l{text-align:left}.camp-payment-container .camp-payment-section{padding:0 1.25rem;margin-top:1rem;justify-content:space-between}.camp-payment-container .camp-payment-section table{text-align:left}.camp-payment-container .camp-payment-section table tr:first-child{background:#043d7a;color:#fff}.camp-payment-container .camp-payment-section p{font-size:0.875rem;color:#6e6e6e;text-align:justify;line-height:1.6}.camp-payment-container .camp-payment-section h5{font-size:1.125rem;color:#043d7a;font-weight:bold;margin-bottom:0.375rem}.camp-payment-container .camp-payment-section ul{list-style-type:decimal}.camp-payment-container .camp-payment-section ul li{font-size:0.875rem;color:#6e6e6e;text-align:justify}.camp-payment-container .camp-payment-section .camp-payment-term{padding-right:3rem}.camp-payment-container .camp-payment-section .camp-payment-method form{box-shadow:none;padding:0;font-size:1rem}.camp-payment-container .camp-payment-section .camp-payment-method form input[type=\"radio\"]{display:none}.camp-payment-container .camp-payment-section .camp-payment-method form input[type=\"radio\"]+label{margin-bottom:0.5rem;font-size:1rem;font-weight:bold;color:#6e6e6e}.camp-payment-container .camp-payment-section .camp-payment-method form input[type=\"radio\"]:disabled+label:before{background:#eee}.camp-payment-container .camp-payment-section .camp-payment-method form input[type=\"radio\"]+label:before{color:#6e6e6e;content:\"\\00a0\";display:inline-block;font:1em sans-serif;margin-right:0.5rem;padding:0;vertical-align:middle;width:1.25rem;height:1.25rem;border-radius:10px;border:1px solid #b8b8b8}.camp-payment-container .camp-payment-section .camp-payment-method form input[type=\"radio\"]:checked+label:before{content:\"\\2022\";color:#b8b8b8;font-size:2.5rem;line-height:19px;text-align:center}.survey .button{margin-top:0px}\n"

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var services_1 = __webpack_require__(58);
	var BookingComponent_1 = __webpack_require__(314);
	// Services
	var services_2 = __webpack_require__(315);
	var services_3 = __webpack_require__(315);
	var FinishComponent = (function (_super) {
	    __extends(FinishComponent, _super);
	    function FinishComponent(fileService, router, bookingService, emailService, sessionStorageService, local, services) {
	        var _this = _super.call(this, router, services, sessionStorageService) || this;
	        _this.fileService = fileService;
	        _this.router = router;
	        _this.bookingService = bookingService;
	        _this.emailService = emailService;
	        _this.sessionStorageService = sessionStorageService;
	        _this.local = local;
	        _this.services = services;
	        return _this;
	    }
	    FinishComponent.prototype.ngOnInit = function () {
	        this.booking = this.getBooking();
	        this.getBookingDetail(this.booking.id);
	        if (this.booking.postedPeriods) {
	            this.startDate = this.booking.postedPeriods[0].start_date;
	        }
	        this.user = this.sessionStorageService.getData('eca-user');
	    };
	    FinishComponent.prototype.getBookingDetail = function (bookingId) {
	        var _this = this;
	        this.bookingDetail = {};
	        var query = {
	            id: bookingId,
	            page: 1
	        };
	        this.bookingService.getBooking(query)
	            .subscribe(function (bookingDetail) {
	            _this.bookingDetail = bookingDetail.data[0];
	        }, function (error) {
	        });
	    };
	    FinishComponent.prototype.finishBooking = function () {
	        this.sessionStorageService.removeData('holidayBooking');
	        this.router.navigate(['booking/students']);
	    };
	    return FinishComponent;
	}(BookingComponent_1.BookingComponent));
	FinishComponent = __decorate([
	    core_1.Component({
	        selector: 'complete',
	        template: __webpack_require__(375),
	        styles: [__webpack_require__(376)]
	    }),
	    __metadata("design:paramtypes", [services_1.FileService,
	        router_1.Router,
	        services_2.BookingHolidayService,
	        services_3.EmailService,
	        services_1.SessionStorageService,
	        services_1.LocalStorageService,
	        services_2.BookingHolidayService])
	], FinishComponent);
	exports.FinishComponent = FinishComponent;


/***/ }),
/* 375 */
/***/ (function(module, exports) {

	module.exports = "<main>\n\t<div class=\"component-title\">\n        <h1>Step 5: Finish</h1>\n    </div>\n    <div class=\"container\">\n        <div class=\"list-activity\">\n            <h3>Booking reference: <b>{{bookingDetail.code}}</b></h3>\n            <div class=\"content\">\n                <p>Thank you for booking into the AIS Holiday Programme. Your reference number is <b>{{bookingDetail.code}}</b>. An email has been sent to <b>{{user.email}}</b>, outlining your registration details and how payment can be made. We look forward to seeing you at the Holiday Programme.</p>\n            </div>\n        </div>\n    </div>\n\n    <div id=\"submit\">\n        <div class=\"r-btn\">\n            <button class=\"submit large-5\" (click)=\"finishBooking()\">Finish</button>\n        </div>\n    </div>\n</main>";

/***/ }),
/* 376 */
/***/ (function(module, exports) {

	module.exports = ".text-left{text-align:left}.countdown{text-align:right;font-size:18px;padding:10px 20px}.container{width:80%;margin:0 auto;padding:2rem 1.25rem}.container .headline{background:#faa635;border-bottom-left-radius:5px;border-bottom-right-radius:5px;padding:0.3rem 1.5rem;margin:2rem 0 1rem}.container .headline h2{font-size:1.5625rem;color:#043d7a;font-weight:bold;text-align:right}.container .headline .algn-l{text-align:left}.container div p{font-size:0.875rem;color:#6e6e6e;line-height:1.6}.component-title{color:#043d7a;background-color:#f8f8f8;padding:1.5rem 10%;border-bottom:1px solid #eaeaea}.component-title h1{margin:0 auto;padding:0 1.25rem;font-size:1.5256rem}.component-title small{padding:0 1.25rem;font-size:90%}.wrap-select-camp-header-inner{width:100%;padding:1rem calc(10% + 1.25rem) 0;background:#f8f8f8;border-top:1px solid white}.wrap-select-camp-header-inner .camp-child-icon{vertical-align:-3px;margin-right:10px}.wrap-select-camp-header-inner .wrap-select-option-header{display:inline-block;position:relative}.wrap-select-camp-header-inner .wrap-select-option-header:before{content:'';color:#ddd;width:2.5rem;height:1.5625rem;position:absolute;pointer-events:none;right:17px;top:17px;width:0;height:0;border-left:5px solid transparent;border-right:5px solid transparent;border-top:8px solid #ddd}.wrap-select-camp-header-inner .wrap-select-option-header:after{content:'';position:absolute;height:1.5625rem;width:1px;background:#ddd;top:8px;right:40px}.wrap-select-camp-header-inner .wrap-select-option-header select{padding:0 50px 0 13px;border-radius:5px;font-size:1rem;background:#f8f8f8;border:1px solid #ddd;height:2.5rem;color:#282828;outline:none}#submit{max-width:100%;width:100%;padding:2rem 10%;border-top:1px solid #ddd}#submit .l-btn{padding-left:1.25rem}#submit .l-btn button{text-align:left;padding:1.25rem 5.25rem;font-size:1.25rem;font-weight:bold;background:#eaeaea;color:#6e6e6e}#submit .r-btn{text-align:right;padding-right:1.25rem}#submit .r-btn p{text-align:right;font-size:0.875rem;padding-right:1.125rem;padding-top:1rem}#submit .r-btn p a{font-weight:bold}#submit .r-btn .submit{padding:1.25rem 3rem;text-align:center;font-size:1.25rem;font-weight:bold}.bus-registration-container{width:80%;margin:0 auto;padding:0px 1.25rem;margin-bottom:1.5rem}.bus-registration-container h3{font-size:1.525rem;font-weight:bold;color:#043d7a;text-align:center;margin:2rem auto 1rem}.bus-registration-container .total-amount{background:#faa635;border-bottom-left-radius:5px;border-bottom-right-radius:5px;padding:0.3rem 1.5rem}.bus-registration-container .total-amount h2{font-size:1.5625rem;color:#043d7a;font-weight:bold;text-align:right}.bus-registration-container .total-amount .algn-l{text-align:left}.bus-registration-container .total-amount p{font-size:0.875rem;color:#6e6e6e;text-align:justify;line-height:1.6}.bus-registration-container .bus-registration-section{padding:0 1.25rem;margin-top:1rem;justify-content:space-between}.bus-registration-container .bus-registration-section table{text-align:left}.bus-registration-container .bus-registration-section table tr:first-child{background:#043d7a;color:#fff}.bus-registration-container .bus-registration-section p{font-size:0.875rem;color:#6e6e6e;text-align:justify;line-height:1.6}.bus-registration-container .bus-registration-section h5{font-size:1.125rem;color:#043d7a;font-weight:bold;margin-bottom:0.375rem}.bus-registration-container .bus-registration-section ul{list-style-type:decimal}.bus-registration-container .bus-registration-section ul li{font-size:0.875rem;color:#6e6e6e;text-align:justify}.bus-registration-container .bus-registration-section .bus-registration-term{padding-right:3rem}.bus-registration-container .bus-registration-section .bus-registration-method form{box-shadow:none;padding:0;font-size:1rem}.bus-registration-container .bus-registration-section .bus-registration-method form input[type=\"radio\"]{display:none}.bus-registration-container .bus-registration-section .bus-registration-method form input[type=\"radio\"]+label{margin-bottom:0.5rem;font-size:1rem;font-weight:bold;color:#6e6e6e}.bus-registration-container .bus-registration-section .bus-registration-method form input[type=\"radio\"]:disabled+label:before{background:#eee}.bus-registration-container .bus-registration-section .bus-registration-method form input[type=\"radio\"]+label:before{color:#6e6e6e;content:\"\\00a0\";display:inline-block;font:1em sans-serif;margin-right:0.5rem;padding:0;vertical-align:middle;width:1.25rem;height:1.25rem;border-radius:10px;border:1px solid #b8b8b8}.bus-registration-container .bus-registration-section .bus-registration-method form input[type=\"radio\"]:checked+label:before{content:\"\\2022\";color:#b8b8b8;font-size:2.5rem;line-height:19px;text-align:center}.modal{position:fixed;z-index:1;left:0;top:0;width:100%;height:100%;overflow:auto;background-color:#000;background-color:rgba(0,0,0,0.4)}.modal table{display:block;padding:5px 10px;margin-bottom:0;background:#fff;border-bottom-right-radius:5px;border-bottom-left-radius:5px}.modal table tbody{border:none}.modal table tbody td{font-weight:bold;font-size:0.875rem;color:#6e6e6e}.modal .modal-content{margin:0;max-width:400px;position:absolute;top:50%;left:50%;-ms-transform:translateX(-50%) translateY(-50%);-webkit-transform:translate(-50%, -50%);transform:translate(-50%, -50%)}.modal .modal-content .close{color:#fff;float:right;font-size:20px;font-weight:bold;line-height:1}.modal .modal-content .close:hover,.modal .modal-content .close:focus{color:#eee;text-decoration:none;cursor:pointer}.modal .modal-header{text-align:center;padding:10px 20px;color:#fff;background:#043d7a;font-size:1.25rem;font-weight:bold;border-top-right-radius:5px;border-top-left-radius:5px}.modal .modal-header h2{text-align:left;font-size:1rem;font-weight:bold;margin-bottom:0}.modal .modal-body{padding:10px 20px;background:#fff;border-bottom-right-radius:5px;border-bottom-left-radius:5px}@media only screen and (max-width: 40em){.select-camp-header .select-camp-header-inner{padding:0}.select-camp-header .select-camp-header-inner h4{padding-left:10%;padding-right:10%}.select-camp-header .select-camp-header-inner .wrap-select-camp-header-inner{padding:0}.select-camp-header .select-camp-header-inner .wrap-select-camp-header-inner .camp-child-icon{display:none}.list-camp h3{margin:1.5rem auto 1.5rem;line-height:0.7;font-size:1.4rem}.list-camp .row li{padding:0}}#submit .r-btn{text-align:center}\n"

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var _ = __webpack_require__(64);
	// Libraries
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var BookingComponent_1 = __webpack_require__(314);
	var common_1 = __webpack_require__(22);
	// Services
	var services_1 = __webpack_require__(315);
	var services_2 = __webpack_require__(58);
	var models_1 = __webpack_require__(340);
	var ViewBookingComponent = (function (_super) {
	    __extends(ViewBookingComponent, _super);
	    function ViewBookingComponent(router, route, services, sessionStorageService, local, catalogService, location) {
	        var _this = _super.call(this, router, services, sessionStorageService, catalogService) || this;
	        _this.router = router;
	        _this.route = route;
	        _this.services = services;
	        _this.sessionStorageService = sessionStorageService;
	        _this.local = local;
	        _this.catalogService = catalogService;
	        _this.location = location;
	        _this.questionnaire = [];
	        return _this;
	    }
	    ViewBookingComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.payment = new models_1.Payment;
	        // Get id from param
	        this.sub = this.route.params.subscribe(function (params) {
	            _this.bookingId = params['id'];
	            // Get booking info by id
	            _this.getBookingInfo();
	        });
	        this.getSemester();
	    };
	    ViewBookingComponent.prototype.getSemester = function () {
	        var _this = this;
	        this.catalogService.getSemesters()
	            .subscribe(function (semesterList) {
	            _this.currentSemester = _.find(semesterList, 'is_current');
	        }, function (error) {
	            console.log("Cannot get semester list from API.");
	        });
	    };
	    ViewBookingComponent.prototype.submitPayment = function () {
	        var _this = this;
	        this.payment.booking_id = this.bookingInfo.id;
	        this.payment.currency = 'VND';
	        this.payment.zone = this.paymentType;
	        this.payment.amount = this.bookingInfo.balance;
	        this.services.payment(this.payment)
	            .subscribe(function (result) {
	            window.location.href = result.url;
	            _this.local.setData('updateBookingDetail', result);
	        }, function (error) {
	        });
	    };
	    ViewBookingComponent.prototype.disabledSumit = function () {
	        if (this.paymentType === undefined) {
	            return true;
	        }
	        else {
	            return false;
	        }
	    };
	    ViewBookingComponent.prototype.getBookingInfo = function () {
	        var _this = this;
	        var query = {
	            id: this.bookingId,
	            page: 1
	        };
	        this.services.getBooking(query).subscribe(function (result) {
	            if (result.data) {
	                // Get booking info
	                _this.bookingInfo = result.data[0];
	                // Sort hol_weeks
	                _this.bookingInfo.hol_weeks = _.sortBy(_this.bookingInfo.hol_weeks, function (o) { return o.name; });
	                if (_this.bookingInfo.question_answer && _this.bookingInfo.question_answer.length > 0) {
	                    _this.getQuestionnaire();
	                }
	            }
	        }, function (error) {
	        });
	    };
	    ViewBookingComponent.prototype.getQuestionnaire = function () {
	        var _this = this;
	        this.services.getQuestionnaire(true).subscribe(function (result) {
	            if (result)
	                //get all questionnaire
	                _this.questionnaire = result;
	            //map question to answer
	            _this.bookingInfo.question_answer.forEach(function (val) {
	                var question = _this.questionnaire.find(function (item) { return item.id == val.question_id; });
	                val.question = question.question;
	            });
	        }, function (error) {
	        });
	    };
	    ViewBookingComponent.prototype.downloadLunchMenu = function () {
	        var link = window.document.createElement('a');
	        link.href = '/assets/AIS Summer Menu - 2017-18.xlsx';
	        link['download'] = "AIS Summer Menu - 2017-18.xlsx";
	        document.body.appendChild(link);
	        link.click();
	        setTimeout(function () {
	            document.body.removeChild(link);
	        }, 100);
	    };
	    ViewBookingComponent.prototype.ngOnDestroy = function () {
	        // Unsubscribe
	        this.sub.unsubscribe();
	    };
	    ViewBookingComponent.prototype.isHidePaymentMethod = function () {
	        var MAX_WEEK = 5;
	        return this.bookingInfo.hol_weeks.length < MAX_WEEK;
	    };
	    return ViewBookingComponent;
	}(BookingComponent_1.BookingComponent));
	ViewBookingComponent = __decorate([
	    core_1.Component({
	        selector: 'children-list',
	        template: __webpack_require__(378),
	        styles: [__webpack_require__(379)]
	    }),
	    __metadata("design:paramtypes", [router_1.Router,
	        router_1.ActivatedRoute,
	        services_1.BookingHolidayService,
	        services_2.SessionStorageService,
	        services_2.LocalStorageService,
	        services_2.CatalogService,
	        common_1.Location])
	], ViewBookingComponent);
	exports.ViewBookingComponent = ViewBookingComponent;


/***/ }),
/* 378 */
/***/ (function(module, exports) {

	module.exports = "<main>\n  <div class=\"component-title\">\n    <h1>View Booking</h1>\n  </div>\n\n  <div class=\"container row\" *ngIf=\"bookingInfo\">\n    <div class=\"large-12 medium-12 small-12\">\n      <h2 class=\"booking-code\">\n        Booking code: <b>{{bookingInfo.code}}</b>\n        <p class=\"small accepted\" *ngIf=\"bookingInfo.status == 'accepted'\">\n          Confirmed\n        </p>\n        <p class=\"small waited\" *ngIf=\"bookingInfo.status == 'waited'\">\n          Waiting list\n        </p>\n      </h2>\n\n      <!--Student information-->\n      <section>\n        <div class=\"view-headline large-12 medium-12 small-12\">\n          Student information\n        </div>\n        <div>\n          <table>\n            <tr>\n              <td>Student Name</td>\n              <td>\n                <b\n                  >{{bookingInfo.hol_student.given_name}}\n                  {{bookingInfo.hol_student.family_name}}</b\n                >\n              </td>\n            </tr>\n            <tr>\n              <td>Student ID</td>\n              <td><b>{{bookingInfo.hol_student.code}}</b></td>\n            </tr>\n          </table>\n        </div>\n      </section>\n\n      <!--QA information-->\n      <section>\n        <div class=\"view-headline large-12 medium-12 small-12\">\n          Q&A information\n        </div>\n        <div>\n          <table>\n            <tr *ngFor=\"let qa of bookingInfo.question_answer\">\n              <td>{{ qa.question }}</td>\n              <td><b>{{ qa.answer }}</b></td>\n            </tr>\n          </table>\n        </div>\n      </section>\n      <!--Fees information-->\n      <section>\n        <div class=\"view-headline large-12 medium-12 small-12\">Fees</div>\n        <div>\n          <table>\n            <tr>\n              <td>Booking Class</td>\n              <td>\n                <b>{{bookingInfo.price.booking | number : '1.0-0'}} VND</b>\n              </td>\n            </tr>\n            <tr class=\"discount\">\n              <td>Discounted (for class)</td>\n              <td>\n                <b>{{bookingInfo.price.discounted | number : '1.0-0'}} VND</b>\n              </td>\n            </tr>\n            <tr>\n              <td>Bus</td>\n              <td><b>{{bookingInfo.price.bus | number : '1.0-0'}} VND</b></td>\n            </tr>\n            <tr>\n              <td>\n                Lunch\n                <!--<a (click)=\"downloadLunchMenu()\">(Download Lunch Menu)</a>\n                                <p style=\"font-size: 0.875rem\">Please complete lunch menu and email to <a href=\"mailto:AIS.Admin@aisvietnam.com\">AIS.Admin@aisvietnam.com</a> or submit to AIS reception</p>-->\n              </td>\n              <td><b>{{bookingInfo.price.lunch | number : '1.0-0'}} VND</b></td>\n            </tr>\n          </table>\n\n          <!--payment section-->\n          <div class=\"total-amount large-12 medium-12 small-12\">\n            <h2>\n              Balance Due: {{bookingInfo.balance | number : '1.0-2'}} VND<br />\n            </h2>\n          </div>\n          <div class=\"camp-payment-section row\">\n            <div\n              class=\"camp-payment-term large-6 medium-12 small-12\"\n              *ngIf=\"bookingInfo.balance > 0\"\n            >\n              <h5>Term and conditions</h5>\n              <ul>\n                <li>\n                  Enrolment is only confirmed when payment is received in full;\n                  failure to do so may result in the student's placement being\n                  forfeited.\n                </li>\n                <li>\n                  Fees (or part fees thereof) are not refundable once the course\n                  has started. This includes voluntary withdrawal and missed\n                  classes due to student vacations, bad weather, illness or lack\n                  of interest, etc.\n                </li>\n                <li>Fees are non-refundable and non-transferable.</li>\n                <li>\n                  If a student can't longer continue with the course, through\n                  illness or injury, fees will be refunded on a pro rata basis\n                  when supported by a doctor's note. Note an administration\n                  charge may apply.\n                </li>\n              </ul>\n            </div>\n            <div\n              class=\"camp-payment-method large-6 medium-12 small-12\"\n              *ngIf=\"bookingInfo.balance > 0 && !isHidePaymentMethod()\"\n            >\n              <h5>Payment menthod</h5>\n              <form>\n                <input\n                  type=\"radio\"\n                  name=\"payment\"\n                  [(ngModel)]=\"paymentType\"\n                  value=\"domestic\"\n                  id=\"atm\"\n                  *ngIf=\"!isFree\"\n                /><label for=\"atm\" *ngIf=\"!isFree\">\n                  Online payment - Domestic cards (ATM)</label\n                >\n                <input\n                  type=\"radio\"\n                  name=\"payment\"\n                  [(ngModel)]=\"paymentType\"\n                  value=\"international\"\n                  id=\"visa\"\n                  *ngIf=\"!isFree\"\n                /><label for=\"visa\" *ngIf=\"!isFree\">\n                  Online payment - International cards (VISA, Master)</label\n                >\n              </form>\n              <p>\n                <button\n                  class=\"paymnet-button\"\n                  (click)=\"submitPayment()\"\n                  [disabled]=\"disabledSumit()\"\n                >\n                  Payment\n                </button>\n              </p>\n            </div>\n          </div>\n          <!--end payment section-->\n        </div>\n      </section>\n      <!--End of Pricing information-->\n      <!--Class information-->\n      <section>\n        <div class=\"view-headline large-12 medium-12 small-12\">\n          Class information\n        </div>\n        <div>\n          <table>\n            <tr>\n              <td>Name</td>\n              <td><b>{{bookingInfo.hol_class.name}}</b></td>\n            </tr>\n            <tr>\n              <td>Campus</td>\n              <td><b>{{bookingInfo.hol_class.campus.name}}</b></td>\n            </tr>\n            <tr>\n              <td>Room</td>\n              <td><b>{{bookingInfo.hol_class.room}}</b></td>\n            </tr>\n            <tr>\n              <td>Teacher</td>\n              <td><b>{{bookingInfo.hol_class.teacher}}</b></td>\n            </tr>\n            <tr>\n              <td>Activities</td>\n              <td>\n                <div [innerHTML]=\"bookingInfo.hol_class.activities\"></div>\n              </td>\n            </tr>\n          </table>\n        </div>\n      </section>\n      <!--End of Class information-->\n\n      <!--Week attending-->\n      <section *ngIf=\"currentSemester.name === 'Semester 2'\">\n        <div class=\"view-headline large-12 medium-12 small-12\">\n          Week attending\n        </div>\n        <div>\n          <table>\n            <tr *ngFor=\"let week of bookingInfo.hol_weeks\">\n              <td>{{week.name}}</td>\n              <td>\n                From <b>{{timeDataFormat(week.start_date, 'YYYY-MM-DD')}}</b> To\n                <b>{{timeDataFormat(week.end_date, 'YYYY-MM-DD')}}</b>\n              </td>\n              <td *ngIf=\"week.hol_booking_week.excursions.length\">\n                Have excursion\n              </td>\n              <td *ngIf=\"!week.hol_booking_week.excursions.length\"></td>\n            </tr>\n          </table>\n        </div>\n      </section>\n      <!--End of Week attending-->\n\n      <!--Bus information-->\n      <section *ngIf=\"bookingInfo.hol_booking_buses.length\">\n        <div class=\"view-headline large-12 medium-12 small-12\">\n          Bus information\n        </div>\n        <div>\n          <table>\n            <tr>\n              <td>Bus type</td>\n              <td>\n                <b\n                  >{{bookingInfo.hol_booking_buses[0].price ? 'Bus Service\n                  (Additional Fee)' : 'Bus Service (Complimentary)'}}</b\n                >\n              </td>\n            </tr>\n            <tr>\n              <td>District</td>\n              <td><b>{{bookingInfo.hol_booking_buses[0].district}}</b></td>\n            </tr>\n            <tr>\n              <td>Address</td>\n              <td><b>{{bookingInfo.hol_booking_buses[0].address}}</b></td>\n            </tr>\n          </table>\n        </div>\n      </section>\n      <!--End of Bus information-->\n\n      <!--Additional-->\n      <section *ngIf=\"bookingInfo.hol_booking_buses.length\">\n        <div class=\"view-headline large-12 medium-12 small-12\">\n          Additional options\n        </div>\n        <div>\n          <table>\n            <tr>\n              <td>Lunch</td>\n              <td><b>{{bookingInfo.lunch ? 'Yes' : 'No'}}</b></td>\n            </tr>\n            <tr>\n              <td>Payment method</td>\n              <td><b>Pay later</b></td>\n            </tr>\n          </table>\n        </div>\n      </section>\n      <!--End of Additional-->\n    </div>\n\n    <div>\n      <a class=\"button large\" routerLink=\"/booking/students\">Back</a>\n    </div>\n  </div>\n</main>\n";

/***/ }),
/* 379 */
/***/ (function(module, exports) {

	module.exports = ".text-left{text-align:left}.countdown{text-align:right;font-size:18px;padding:10px 20px}.container{width:80%;margin:0 auto;padding:2rem 1.25rem}.container .headline{background:#faa635;border-bottom-left-radius:5px;border-bottom-right-radius:5px;padding:0.3rem 1.5rem;margin:2rem 0 1rem}.container .headline h2{font-size:1.5625rem;color:#043d7a;font-weight:bold;text-align:right}.container .headline .algn-l{text-align:left}.container div p{font-size:0.875rem;color:#6e6e6e;line-height:1.6}.component-title{color:#043d7a;background-color:#f8f8f8;padding:1.5rem 10%;border-bottom:1px solid #eaeaea}.component-title h1{margin:0 auto;padding:0 1.25rem;font-size:1.5256rem}.component-title small{padding:0 1.25rem;font-size:90%}.wrap-select-camp-header-inner{width:100%;padding:1rem calc(10% + 1.25rem) 0;background:#f8f8f8;border-top:1px solid white}.wrap-select-camp-header-inner .camp-child-icon{vertical-align:-3px;margin-right:10px}.wrap-select-camp-header-inner .wrap-select-option-header{display:inline-block;position:relative}.wrap-select-camp-header-inner .wrap-select-option-header:before{content:'';color:#ddd;width:2.5rem;height:1.5625rem;position:absolute;pointer-events:none;right:17px;top:17px;width:0;height:0;border-left:5px solid transparent;border-right:5px solid transparent;border-top:8px solid #ddd}.wrap-select-camp-header-inner .wrap-select-option-header:after{content:'';position:absolute;height:1.5625rem;width:1px;background:#ddd;top:8px;right:40px}.wrap-select-camp-header-inner .wrap-select-option-header select{padding:0 50px 0 13px;border-radius:5px;font-size:1rem;background:#f8f8f8;border:1px solid #ddd;height:2.5rem;color:#282828;outline:none}#submit{max-width:100%;width:100%;padding:2rem 10%;border-top:1px solid #ddd}#submit .l-btn{padding-left:1.25rem}#submit .l-btn button{text-align:left;padding:1.25rem 5.25rem;font-size:1.25rem;font-weight:bold;background:#eaeaea;color:#6e6e6e}#submit .r-btn{text-align:right;padding-right:1.25rem}#submit .r-btn p{text-align:right;font-size:0.875rem;padding-right:1.125rem;padding-top:1rem}#submit .r-btn p a{font-weight:bold}#submit .r-btn .submit{padding:1.25rem 3rem;text-align:center;font-size:1.25rem;font-weight:bold}.bus-registration-container{width:80%;margin:0 auto;padding:0px 1.25rem;margin-bottom:1.5rem}.bus-registration-container h3{font-size:1.525rem;font-weight:bold;color:#043d7a;text-align:center;margin:2rem auto 1rem}.bus-registration-container .total-amount{background:#faa635;border-bottom-left-radius:5px;border-bottom-right-radius:5px;padding:0.3rem 1.5rem}.bus-registration-container .total-amount h2{font-size:1.5625rem;color:#043d7a;font-weight:bold;text-align:right}.bus-registration-container .total-amount .algn-l{text-align:left}.bus-registration-container .total-amount p{font-size:0.875rem;color:#6e6e6e;text-align:justify;line-height:1.6}.bus-registration-container .bus-registration-section{padding:0 1.25rem;margin-top:1rem;justify-content:space-between}.bus-registration-container .bus-registration-section table{text-align:left}.bus-registration-container .bus-registration-section table tr:first-child{background:#043d7a;color:#fff}.bus-registration-container .bus-registration-section p{font-size:0.875rem;color:#6e6e6e;text-align:justify;line-height:1.6}.bus-registration-container .bus-registration-section h5{font-size:1.125rem;color:#043d7a;font-weight:bold;margin-bottom:0.375rem}.bus-registration-container .bus-registration-section ul{list-style-type:decimal}.bus-registration-container .bus-registration-section ul li{font-size:0.875rem;color:#6e6e6e;text-align:justify}.bus-registration-container .bus-registration-section .bus-registration-term{padding-right:3rem}.bus-registration-container .bus-registration-section .bus-registration-method form{box-shadow:none;padding:0;font-size:1rem}.bus-registration-container .bus-registration-section .bus-registration-method form input[type=\"radio\"]{display:none}.bus-registration-container .bus-registration-section .bus-registration-method form input[type=\"radio\"]+label{margin-bottom:0.5rem;font-size:1rem;font-weight:bold;color:#6e6e6e}.bus-registration-container .bus-registration-section .bus-registration-method form input[type=\"radio\"]:disabled+label:before{background:#eee}.bus-registration-container .bus-registration-section .bus-registration-method form input[type=\"radio\"]+label:before{color:#6e6e6e;content:\"\\00a0\";display:inline-block;font:1em sans-serif;margin-right:0.5rem;padding:0;vertical-align:middle;width:1.25rem;height:1.25rem;border-radius:10px;border:1px solid #b8b8b8}.bus-registration-container .bus-registration-section .bus-registration-method form input[type=\"radio\"]:checked+label:before{content:\"\\2022\";color:#b8b8b8;font-size:2.5rem;line-height:19px;text-align:center}.modal{position:fixed;z-index:1;left:0;top:0;width:100%;height:100%;overflow:auto;background-color:#000;background-color:rgba(0,0,0,0.4)}.modal table{display:block;padding:5px 10px;margin-bottom:0;background:#fff;border-bottom-right-radius:5px;border-bottom-left-radius:5px}.modal table tbody{border:none}.modal table tbody td{font-weight:bold;font-size:0.875rem;color:#6e6e6e}.modal .modal-content{margin:0;max-width:400px;position:absolute;top:50%;left:50%;-ms-transform:translateX(-50%) translateY(-50%);-webkit-transform:translate(-50%, -50%);transform:translate(-50%, -50%)}.modal .modal-content .close{color:#fff;float:right;font-size:20px;font-weight:bold;line-height:1}.modal .modal-content .close:hover,.modal .modal-content .close:focus{color:#eee;text-decoration:none;cursor:pointer}.modal .modal-header{text-align:center;padding:10px 20px;color:#fff;background:#043d7a;font-size:1.25rem;font-weight:bold;border-top-right-radius:5px;border-top-left-radius:5px}.modal .modal-header h2{text-align:left;font-size:1rem;font-weight:bold;margin-bottom:0}.modal .modal-body{padding:10px 20px;background:#fff;border-bottom-right-radius:5px;border-bottom-left-radius:5px}@media only screen and (max-width: 40em){.select-camp-header .select-camp-header-inner{padding:0}.select-camp-header .select-camp-header-inner h4{padding-left:10%;padding-right:10%}.select-camp-header .select-camp-header-inner .wrap-select-camp-header-inner{padding:0}.select-camp-header .select-camp-header-inner .wrap-select-camp-header-inner .camp-child-icon{display:none}.list-camp h3{margin:1.5rem auto 1.5rem;line-height:0.7;font-size:1.4rem}.list-camp .row li{padding:0}}.booking-code{line-height:40px;margin-bottom:25px}.booking-code .price{float:right;display:inline-block;border-radius:3px;background:#F9BF3B;color:#fff;padding:5px 10px}.booking-code p.small{display:inline;font-weight:bold}.booking-code p.small.waited{color:red}.booking-code p.small.accepted{color:green}.view-headline{font-size:18px;border-bottom:solid 2px #E87E04;padding-bottom:5px;font-weight:bold;margin-bottom:10px}.discount{background:#26A65B;color:#fff}.total-amount{background:#E87E04;border-bottom-left-radius:5px;border-bottom-right-radius:5px;padding:0.3rem 1.5rem 0.1rem}.total-amount h2{font-size:20px;color:#fff;font-weight:bold;text-align:right}.total-amount h2 small{font-size:60%;color:#043d7a}.total-amount .algn-l{text-align:left}.camp-payment-section{padding:0 1.25rem;margin-top:1rem;justify-content:space-between}.camp-payment-section table{text-align:left}.camp-payment-section table tr:first-child{background:#043d7a;color:#fff}.camp-payment-section p{font-size:0.875rem;color:#6e6e6e;text-align:justify;line-height:1.6}.camp-payment-section h5{font-size:1.125rem;color:#043d7a;font-weight:bold;margin-bottom:0.375rem}.camp-payment-section ul{list-style-type:decimal}.camp-payment-section ul li{font-size:0.875rem;color:#6e6e6e;text-align:justify}.camp-payment-section .camp-payment-term{padding-right:3rem}.camp-payment-section .camp-payment-method form{box-shadow:none;padding:0;font-size:1rem}.camp-payment-section .camp-payment-method form input[type=\"radio\"]{display:none}.camp-payment-section .camp-payment-method form input[type=\"radio\"]+label{margin-bottom:0.5rem}.camp-payment-section .camp-payment-method form input[type=\"radio\"]:disabled+label:before{background:#eee}.camp-payment-section .camp-payment-method form input[type=\"radio\"]+label:before{color:#6e6e6e;content:\"\\00a0\";display:inline-block;font:1em sans-serif;margin-right:0.5rem;padding:0;vertical-align:middle;width:1.25rem;height:1.25rem;border-radius:10px;border:1px solid #b8b8b8}.camp-payment-section .camp-payment-method form input[type=\"radio\"]:checked+label:before{content:\"\\2022\";color:#b8b8b8;font-size:2.5rem;line-height:19px;text-align:center}.payment-button{margin:30px 10px 15px}\n"

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var BookingComponent_1 = __webpack_require__(314);
	var _ = __webpack_require__(64);
	var moment = __webpack_require__(169);
	// Services
	var services_1 = __webpack_require__(315);
	var services_2 = __webpack_require__(315);
	var services_3 = __webpack_require__(58);
	//Models
	var models_1 = __webpack_require__(340);
	var AttendanceComponent = (function (_super) {
	    __extends(AttendanceComponent, _super);
	    function AttendanceComponent(router, route, services, sessionStorageService, local, catalogService, attendanceService) {
	        var _this = _super.call(this, router, services, sessionStorageService, catalogService) || this;
	        _this.router = router;
	        _this.route = route;
	        _this.services = services;
	        _this.sessionStorageService = sessionStorageService;
	        _this.local = local;
	        _this.catalogService = catalogService;
	        _this.attendanceService = attendanceService;
	        _this.holidayChildren = [];
	        _this.attendanceFilter = new models_1.AttendancesFilter;
	        _this.attendanceList = [];
	        // Current selected date
	        _this.currentStudent = [];
	        _this.currentAisId = '';
	        _this.currentDate = new Date();
	        // Init days of week tabs
	        _this.tabs = [
	            { id: 'Mon', name: 'Monday' },
	            { id: 'Tue', name: 'Tuesday' },
	            { id: 'Wed', name: 'Wednesday' },
	            { id: 'Thu', name: 'Thursday' },
	            { id: 'Fri', name: 'Friday' }
	        ];
	        // Init attendance array with keys are days of week
	        _this.attendanceList = {
	            Mon: [],
	            Tue: [],
	            Wed: [],
	            Thu: [],
	            Fri: []
	        };
	        return _this;
	    }
	    AttendanceComponent.prototype.ngOnInit = function () {
	        // Get student list
	        this.holidayChildren = this.getHolidayChildren();
	        // Get 1st child
	        if (this.holidayChildren) {
	            this.currentAisId = this.holidayChildren.holStudents[0].code;
	        }
	        // Get attendance list of current date
	        this.getWeekDates(this.currentDate);
	    };
	    // Get attendance list
	    AttendanceComponent.prototype.getAttendance = function () {
	        var _this = this;
	        // Init attendance array with keys are days of week
	        this.attendanceList = {
	            Mon: [],
	            Tue: [],
	            Wed: [],
	            Thu: [],
	            Fri: []
	        };
	        // Get current selected child id
	        this.attendanceFilter.studentCode = this.currentAisId;
	        // Get attendance info with range
	        this.attendanceFilter.fromDate = this.startOfWeek;
	        this.attendanceFilter.toDate = this.endOfWeek;
	        // Set high max per page for getting all records
	        this.attendanceFilter.max_per_page = 100;
	        // Retrieve attendance info
	        this.attendanceService.getAttendancesList(this.attendanceFilter).subscribe(function (result) {
	            if (result.data.length) {
	                _this.currentStudent = result.data[0];
	                _this.getBookingDetail();
	                _this.currentStudentStartDate = result.data[0].weeks[0].start_date;
	                _this.currentStudentEndDate = result.data[0].weeks[result.data[0].weeks.length - 1].end_date;
	                // Filter attendance info with day of weeks slot
	                _.forEach(result.data[0].attendances, function (val, key) {
	                    var day = moment(val.date).days();
	                    switch (+day) {
	                        case 1:
	                            _this.attendanceList['Mon'].push(val);
	                            break;
	                        case 2:
	                            _this.attendanceList['Tue'].push(val);
	                            break;
	                        case 3:
	                            _this.attendanceList['Wed'].push(val);
	                            break;
	                        case 4:
	                            _this.attendanceList['Thu'].push(val);
	                            break;
	                        case 5:
	                            _this.attendanceList['Fri'].push(val);
	                            break;
	                    }
	                });
	                // Get start and end date of class
	                _this.getStartEndDate(result.data[0].weeks);
	            }
	        }, function (error) {
	        });
	    };
	    // Retrieve start/end date base on week
	    AttendanceComponent.prototype.getStartEndDate = function (weeks) {
	        var start;
	        var end;
	        // Init start/end date
	        start = weeks[0].start_date;
	        end = weeks[0].end_date;
	        _.forEach(weeks, function (pVal, pKey) {
	            if (pKey) {
	                var week = _.find(weeks, { 'id': pVal });
	                if (week) {
	                    // Compare start date
	                    if (moment(week.start_date).isBefore(start)) {
	                        start = week.start_date;
	                    }
	                    // Compare end date
	                    if (moment(week.end_date).isAfter(end)) {
	                        end = week.end_date;
	                    }
	                }
	            }
	        });
	        this.startDate = moment(start).format('MMM d YYYY');
	        this.endDate = moment(end).format('MMM d YYYY');
	    };
	    //Get booking detail
	    AttendanceComponent.prototype.getBookingDetail = function () {
	        var _this = this;
	        this.services.getBookingById(this.currentStudent.aisid)
	            .subscribe(function (result) {
	            _this.bookingDetail = result.data[0];
	            // Get the min and max date
	            var startDate = [];
	            var endDate = [];
	            var Weeks = _.forEach(_this.bookingDetail.hol_weeks, function (week, key) {
	                startDate.push(new Date(week.start_date));
	                endDate.push(new Date(week.end_date));
	            });
	            //Get the min date of week array
	            _this.minDate = new Date(Math.min.apply(null, startDate));
	            //Get the max date of week array
	            _this.maxDate = new Date(Math.max.apply(null, endDate));
	        }, function (error) {
	        });
	    };
	    // Get start/end of week with specific date input
	    // @date: string or Date
	    // based on momentjs Sunday is 0 and Saturday is 6, our Week days are counted from 1 to 5
	    AttendanceComponent.prototype.getWeekDates = function (date) {
	        // Detect input date current day of week
	        var currentDOW = moment(date).day();
	        // Detect how many day to start of week
	        var toStartWeek = 1 - currentDOW;
	        // Detect how many day to end of week
	        var toEndWeek = 5 - currentDOW;
	        // Retrieve start/end date of week
	        this.startOfWeek = moment(date).add(toStartWeek, 'days').format('YYYY-MM-DD');
	        this.endOfWeek = moment(date).add(toEndWeek, 'days').format('YYYY-MM-DD');
	        // Retrieve attendance list
	        this.getAttendance();
	    };
	    // Set current date to today
	    AttendanceComponent.prototype.setToday = function () {
	        this.currentDate = new Date;
	        // New data
	        this.getWeekDates(this.currentDate);
	    };
	    // Get next week data
	    AttendanceComponent.prototype.nextWeek = function () {
	        // Add 3 days from end of current week (Friday) to Monday of next week
	        var date = moment(this.endOfWeek, 'YYYY-MM-DD').add(3, 'days');
	        this.currentDate = new Date(date);
	        // New data
	        this.getWeekDates(date);
	    };
	    // Get previous week data
	    AttendanceComponent.prototype.prevWeek = function () {
	        // Substract 3 days from start of current week (Monday) to Friday of previous week
	        var date = moment(this.startOfWeek, 'YYYY-MM-DD').add(-3, 'days');
	        this.currentDate = new Date(date);
	        // New data
	        this.getWeekDates(date);
	    };
	    // Change child function
	    AttendanceComponent.prototype.changeChild = function (e) {
	        // Refresh attendance data
	        this.getAttendance();
	    };
	    return AttendanceComponent;
	}(BookingComponent_1.BookingComponent));
	AttendanceComponent = __decorate([
	    core_1.Component({
	        selector: 'attendance',
	        template: __webpack_require__(381),
	        styles: [__webpack_require__(382)]
	    }),
	    __metadata("design:paramtypes", [router_1.Router,
	        router_1.ActivatedRoute,
	        services_1.BookingHolidayService,
	        services_3.SessionStorageService,
	        services_3.LocalStorageService,
	        services_3.CatalogService,
	        services_2.AttendanceService])
	], AttendanceComponent);
	exports.AttendanceComponent = AttendanceComponent;


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<main>\n\t<div class=\"component-title clearfix\">\n        <!--<h1>Attendance</h1>-->\n\t\t<!--Select child-->\n\t\t<div class=\"wrap-select-camp-header-inner\">\n\t\t\t<img src=\"" + __webpack_require__(330) + "\" alt=\"camp-child-icon\" class=\"camp-child-icon\">\n\t\t\t<div class=\"wrap-select-option-header\">\n\t\t\t\t<select [(ngModel)]=\"currentAisId\" (ngModelChange)=\"changeChild($event)\">\n\t\t\t\t\t<option *ngFor=\"let classChild of holidayChildren.holStudents\" [attr.value]=\"classChild.code\">\n\t\t\t\t\t\t{{classChild.code}} - {{classChild.given_name}} {{classChild.family_name}}\n\t\t\t\t\t</option>\n\t\t\t\t</select>\n\t\t\t</div>\n\t\t</div>\n\t\t<!--End of select child-->\n    </div>\n    \n    <div class=\"container\">\n\t\t<div class=\"option-bar row\">\n\t\t\t<div class=\"large-2\">\n\t\t\t\t<p-calendar [(ngModel)]=\"currentDate\" (onSelect)=\"getWeekDates(currentDate)\"></p-calendar>\n\t\t\t</div>\n\t\t\t<div class=\"columns large-2\">\n\t\t\t\t<button class=\"button secondary\" (click)=\"setToday()\">Today</button>\n\t\t\t</div>\n\t\t\t<div class=\"large-4\">\n\t\t\t\t<p class=\"current-week\">{{timeDataFormat(startOfWeek, 'MMM, DD')}} - {{timeDataFormat(endOfWeek, 'MMM, DD')}}</p>\n\t\t\t</div>\n\t\t\t<div class=\"large-4 text-right\">\n\t\t\t\t<button class=\"button\" (click)=\"prevWeek()\">Prev</button>\n\t\t\t\t<button class=\"button\" (click)=\"nextWeek()\">Next</button>\n\t\t\t</div>\n\t\t</div>\n        <div class=\"list-activity\">\n            <ul class=\"tabs\" *ngIf=\"currentStudent && currentStudent.class_id\">\n                <li class=\"tabs-title\" *ngFor=\"let tab of tabs; let i = index;\" [ngClass]=\"{'active': timeDataFormat(currentDate, 'ddd') == tab.id}\">\n                    <a>{{tab.name}}</a>\n\t\t\t\t\t<!--Tab content-->\n                    <ul class=\"tab-content\" *ngIf=\"attendanceList[tab.id]\">\n\t\t\t\t\t\t<li *ngFor=\"let days of attendanceList[tab.id]; let i = index;\" [ngClass]=\"{'absent': days.is_present === 'false'}\">\n\t\t\t\t\t\t\t<p class=\"status\">\n\t\t\t\t\t\t\t\t<span *ngIf=\"days.is_present === 'false'\">Absent</span>\n\t\t\t\t\t\t\t\t<span *ngIf=\"days.is_present === 'true'\">Attend</span>\n\t\t\t\t\t\t\t\t<span *ngIf=\"days.is_present === null\">Other</span>\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<div>\n                                <p><b>{{currentStudent.class_name}}</b></p>\n                                <p>\n                                    <span>{{timeDataFormat(minDate, 'YYYY-MM-DD')}}</span>\n                                    <span>{{timeDataFormat(maxDate, 'YYYY-MM-DD')}}</span>\n\t\t\t\t\t\t\t\t\t<!--<span>2:45 - 3:45</span>-->\n                                </p>\n\t\t\t\t\t\t\t\t<p>Note: {{days.note}}</p>\n\t\t\t\t\t\t\t\t<p>Teacher: {{currentStudent.teacher}}</p>\n                            </div>\n\t\t\t\t\t\t</li>\n                    </ul>\n\t\t\t\t\t<!--End of Tab content-->\n                </li>\n            </ul>\n\n\t\t\t<p class=\"text-center\" *ngIf=\"currentStudent && !currentStudent.class_id\">\n\t\t\t\tNo attendance record found\n\t\t\t</p>\n        </div>\n    </div>\n</main>\n";

/***/ }),
/* 382 */
/***/ (function(module, exports) {

	module.exports = ".text-left{text-align:left}.countdown{text-align:right;font-size:18px;padding:10px 20px}.container{width:80%;margin:0 auto;padding:2rem 1.25rem}.container .headline{background:#faa635;border-bottom-left-radius:5px;border-bottom-right-radius:5px;padding:0.3rem 1.5rem;margin:2rem 0 1rem}.container .headline h2{font-size:1.5625rem;color:#043d7a;font-weight:bold;text-align:right}.container .headline .algn-l{text-align:left}.container div p{font-size:0.875rem;color:#6e6e6e;line-height:1.6}.component-title{color:#043d7a;background-color:#f8f8f8;padding:1.5rem 10%;border-bottom:1px solid #eaeaea}.component-title h1{margin:0 auto;padding:0 1.25rem;font-size:1.5256rem}.component-title small{padding:0 1.25rem;font-size:90%}.wrap-select-camp-header-inner{width:100%;padding:1rem calc(10% + 1.25rem) 0;background:#f8f8f8;border-top:1px solid white}.wrap-select-camp-header-inner .camp-child-icon{vertical-align:-3px;margin-right:10px}.wrap-select-camp-header-inner .wrap-select-option-header{display:inline-block;position:relative}.wrap-select-camp-header-inner .wrap-select-option-header:before{content:'';color:#ddd;width:2.5rem;height:1.5625rem;position:absolute;pointer-events:none;right:17px;top:17px;width:0;height:0;border-left:5px solid transparent;border-right:5px solid transparent;border-top:8px solid #ddd}.wrap-select-camp-header-inner .wrap-select-option-header:after{content:'';position:absolute;height:1.5625rem;width:1px;background:#ddd;top:8px;right:40px}.wrap-select-camp-header-inner .wrap-select-option-header select{padding:0 50px 0 13px;border-radius:5px;font-size:1rem;background:#f8f8f8;border:1px solid #ddd;height:2.5rem;color:#282828;outline:none}#submit{max-width:100%;width:100%;padding:2rem 10%;border-top:1px solid #ddd}#submit .l-btn{padding-left:1.25rem}#submit .l-btn button{text-align:left;padding:1.25rem 5.25rem;font-size:1.25rem;font-weight:bold;background:#eaeaea;color:#6e6e6e}#submit .r-btn{text-align:right;padding-right:1.25rem}#submit .r-btn p{text-align:right;font-size:0.875rem;padding-right:1.125rem;padding-top:1rem}#submit .r-btn p a{font-weight:bold}#submit .r-btn .submit{padding:1.25rem 3rem;text-align:center;font-size:1.25rem;font-weight:bold}.bus-registration-container{width:80%;margin:0 auto;padding:0px 1.25rem;margin-bottom:1.5rem}.bus-registration-container h3{font-size:1.525rem;font-weight:bold;color:#043d7a;text-align:center;margin:2rem auto 1rem}.bus-registration-container .total-amount{background:#faa635;border-bottom-left-radius:5px;border-bottom-right-radius:5px;padding:0.3rem 1.5rem}.bus-registration-container .total-amount h2{font-size:1.5625rem;color:#043d7a;font-weight:bold;text-align:right}.bus-registration-container .total-amount .algn-l{text-align:left}.bus-registration-container .total-amount p{font-size:0.875rem;color:#6e6e6e;text-align:justify;line-height:1.6}.bus-registration-container .bus-registration-section{padding:0 1.25rem;margin-top:1rem;justify-content:space-between}.bus-registration-container .bus-registration-section table{text-align:left}.bus-registration-container .bus-registration-section table tr:first-child{background:#043d7a;color:#fff}.bus-registration-container .bus-registration-section p{font-size:0.875rem;color:#6e6e6e;text-align:justify;line-height:1.6}.bus-registration-container .bus-registration-section h5{font-size:1.125rem;color:#043d7a;font-weight:bold;margin-bottom:0.375rem}.bus-registration-container .bus-registration-section ul{list-style-type:decimal}.bus-registration-container .bus-registration-section ul li{font-size:0.875rem;color:#6e6e6e;text-align:justify}.bus-registration-container .bus-registration-section .bus-registration-term{padding-right:3rem}.bus-registration-container .bus-registration-section .bus-registration-method form{box-shadow:none;padding:0;font-size:1rem}.bus-registration-container .bus-registration-section .bus-registration-method form input[type=\"radio\"]{display:none}.bus-registration-container .bus-registration-section .bus-registration-method form input[type=\"radio\"]+label{margin-bottom:0.5rem;font-size:1rem;font-weight:bold;color:#6e6e6e}.bus-registration-container .bus-registration-section .bus-registration-method form input[type=\"radio\"]:disabled+label:before{background:#eee}.bus-registration-container .bus-registration-section .bus-registration-method form input[type=\"radio\"]+label:before{color:#6e6e6e;content:\"\\00a0\";display:inline-block;font:1em sans-serif;margin-right:0.5rem;padding:0;vertical-align:middle;width:1.25rem;height:1.25rem;border-radius:10px;border:1px solid #b8b8b8}.bus-registration-container .bus-registration-section .bus-registration-method form input[type=\"radio\"]:checked+label:before{content:\"\\2022\";color:#b8b8b8;font-size:2.5rem;line-height:19px;text-align:center}.modal{position:fixed;z-index:1;left:0;top:0;width:100%;height:100%;overflow:auto;background-color:#000;background-color:rgba(0,0,0,0.4)}.modal table{display:block;padding:5px 10px;margin-bottom:0;background:#fff;border-bottom-right-radius:5px;border-bottom-left-radius:5px}.modal table tbody{border:none}.modal table tbody td{font-weight:bold;font-size:0.875rem;color:#6e6e6e}.modal .modal-content{margin:0;max-width:400px;position:absolute;top:50%;left:50%;-ms-transform:translateX(-50%) translateY(-50%);-webkit-transform:translate(-50%, -50%);transform:translate(-50%, -50%)}.modal .modal-content .close{color:#fff;float:right;font-size:20px;font-weight:bold;line-height:1}.modal .modal-content .close:hover,.modal .modal-content .close:focus{color:#eee;text-decoration:none;cursor:pointer}.modal .modal-header{text-align:center;padding:10px 20px;color:#fff;background:#043d7a;font-size:1.25rem;font-weight:bold;border-top-right-radius:5px;border-top-left-radius:5px}.modal .modal-header h2{text-align:left;font-size:1rem;font-weight:bold;margin-bottom:0}.modal .modal-body{padding:10px 20px;background:#fff;border-bottom-right-radius:5px;border-bottom-left-radius:5px}@media only screen and (max-width: 40em){.select-camp-header .select-camp-header-inner{padding:0}.select-camp-header .select-camp-header-inner h4{padding-left:10%;padding-right:10%}.select-camp-header .select-camp-header-inner .wrap-select-camp-header-inner{padding:0}.select-camp-header .select-camp-header-inner .wrap-select-camp-header-inner .camp-child-icon{display:none}.list-camp h3{margin:1.5rem auto 1.5rem;line-height:0.7;font-size:1.4rem}.list-camp .row li{padding:0}}.container{margin:2rem auto}.container .option-bar button{margin-top:0px}.container .option-bar .current-week{text-align:center;font-size:20px;font-weight:bold;line-height:40px}.container .tabs{border:none;background:#f8f8f8;border-radius:5px;border:1px solid #dddddd;display:flex}.container .tabs li.active{background:#F5D76E}.container .tabs .tabs-title{width:20%;border-right:1px solid #dddddd}.container .tabs .tabs-title:last-child{border-right:none}.container .tabs .tabs-title:last-child>a:before{content:\"\";width:0}.container .tabs .tabs-title>a{text-align:center;font-size:1.25rem;color:#282828;font-weight:bold;cursor:default;border-bottom:1px solid #dddddd;position:relative}.container .tabs .tabs-title>a:before{content:\"\";position:absolute;height:100%;width:0px;background:#f8f8f8;right:-1;top:0}.container .tabs .tabs-title>a:hover{background:transparent}.container .tabs .tabs-title .tab-content{list-style:none;padding:1rem 10px;margin-left:0}.container .tabs .tabs-title .tab-content li{margin-bottom:1rem}.container .tabs .tabs-title .tab-content li p{overflow:hidden}.container .tabs .tabs-title .tab-content li .status{font-size:1rem;text-align:center;margin:0;padding:9px 0;border-top-left-radius:5px;border-top-right-radius:5px;color:#fff;background:#4caf50}.container .tabs .tabs-title .tab-content li div{padding:1rem;border-bottom-right-radius:5px;border-bottom-left-radius:5px;background:#E3E3E3;color:#000}.container .tabs .tabs-title .tab-content li div p{font-weight:bold}.container .tabs .tabs-title .tab-content li div p span{font-weight:normal;display:block;font-size:0.875rem}.container .tabs .tabs-title .tab-content li.absent .status{background:#ec5840}.container .tabs .tabs-title .tab-content li.other .status{background:#666}\n"

/***/ }),
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var router_1 = __webpack_require__(26);
	var ChildrenListComponent_1 = __webpack_require__(313);
	var ActivitesListComponent_1 = __webpack_require__(328);
	var ExcursionsComponent_1 = __webpack_require__(333);
	var BusOptionComponent_1 = __webpack_require__(336);
	var PaymentComponent_1 = __webpack_require__(339);
	var FinishComponent_1 = __webpack_require__(374);
	var ViewBookingComponent_1 = __webpack_require__(377);
	var AttendanceComponent_1 = __webpack_require__(380);
	var QuestionAnswerComponent_1 = __webpack_require__(455);
	var BookingRoutes = [
	    {
	        path: 'booking',
	        children: [
	            {
	                path: 'students',
	                component: ChildrenListComponent_1.ChildrenListComponent
	            },
	            {
	                path: 'activites-list',
	                component: ActivitesListComponent_1.ActivitesListComponent
	            },
	            {
	                path: 'question-answer',
	                component: QuestionAnswerComponent_1.QuestionAnswerComponent
	            },
	            {
	                path: 'excursions',
	                component: ExcursionsComponent_1.ExcursionsComponent
	            },
	            {
	                path: 'bus',
	                component: BusOptionComponent_1.BusOptionComponent
	            },
	            {
	                path: 'payment',
	                component: PaymentComponent_1.PaymentComponent
	            },
	            {
	                path: 'finish',
	                component: FinishComponent_1.FinishComponent
	            }
	        ],
	    },
	    {
	        path: 'booking/:id',
	        component: ViewBookingComponent_1.ViewBookingComponent
	    },
	    {
	        path: 'view-attendance',
	        component: AttendanceComponent_1.AttendanceComponent
	    },
	];
	exports.bookingRouting = router_1.RouterModule.forChild(BookingRoutes);


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var BookingComponent_1 = __webpack_require__(314);
	var _ = __webpack_require__(64);
	var $ = __webpack_require__(456);
	// Services
	var services_1 = __webpack_require__(315);
	var services_2 = __webpack_require__(58);
	var QuestionAnswerComponent = (function (_super) {
	    __extends(QuestionAnswerComponent, _super);
	    function QuestionAnswerComponent(route, router, services, sessionStorageService, local) {
	        var _this = _super.call(this, router, services, sessionStorageService) || this;
	        _this.route = route;
	        _this.router = router;
	        _this.services = services;
	        _this.sessionStorageService = sessionStorageService;
	        _this.local = local;
	        _this.clases = [];
	        // Q&A
	        _this.questionnaires = [];
	        _this.answerList = [];
	        _this.showNoteModal = false;
	        _this.hasError = false;
	        return _this;
	    }
	    QuestionAnswerComponent.prototype.ngOnInit = function () {
	        // Retrieve holiday children from session
	        this.children = this.getHolidayChildren();
	        // Get selected child
	        this.selectedChild = this.getSelectedChild();
	        //check class avaiable
	        this.getAvailableClasses();
	        // Get questionaire
	        this.getAllQuestionnaire();
	    };
	    // Retrieve all available classes for selected child by his dob
	    QuestionAnswerComponent.prototype.getAvailableClasses = function () {
	        var _this = this;
	        var query = {
	            "date_of_birth": this.timeDataFormat(this.selectedChild.date_of_birth, 'YYYY-MM-DD'),
	            "limit": 100,
	            "page": 1
	        };
	        // Get courses arcordingly to selected child dob
	        this.services.getClasses(query).subscribe(function (result) {
	            // Get clases
	            _this.clases = _.filter(result.data, { 'status': 'opened' });
	            // Default set full period
	            if (!_this.clases || !_this.clases.length) {
	                //throw popup
	                _this.showNoteModal = true;
	            }
	        }, function (error) {
	        });
	    };
	    QuestionAnswerComponent.prototype.checkQAExist = function () {
	        if (this.getBooking()) {
	            //check for booking create in session
	            this.booking = this.getBooking();
	            //check for QA info exist
	            if (this.booking.question_answer && this.booking.question_answer.length > 0) {
	                this.setAnswers(this.booking.question_answer);
	                //remove QA from session
	                this.sessionStorageService.removeData('answerList');
	            }
	            else {
	                //get QA from session
	                if (this.getQuestionAnswer()) {
	                    var answerList = this.getQuestionAnswer();
	                    this.setAnswers(answerList);
	                    //set answerList into booking session
	                    this.booking.question_answer = answerList;
	                }
	            }
	        }
	        else {
	            //get QA from session
	            if (this.getQuestionAnswer()) {
	                var answerList = this.getQuestionAnswer();
	                this.setAnswers(answerList);
	            }
	        }
	    };
	    QuestionAnswerComponent.prototype.onCloseNoteModal = function (event) {
	        this.showNoteModal = false;
	        this.backToStudentList();
	    };
	    QuestionAnswerComponent.prototype.getAllQuestionnaire = function () {
	        var _this = this;
	        this.services.getQuestionnaire(true).subscribe(function (result) {
	            // Get excursions
	            // this.questionnaires = result;
	            if (result && result.length) {
	                var res = result;
	                _.forEach(_.orderBy(res, ['order']), function (val, key) {
	                    var item = {
	                        id: val.id,
	                        order: val.order,
	                        question: val.question,
	                        answer: val.answer,
	                        choosen_answer: null
	                    };
	                    _this.questionnaires.push(item);
	                });
	                //check for questionaire in booking and session
	                _this.checkQAExist();
	            }
	        }, function (error) {
	        });
	    };
	    QuestionAnswerComponent.prototype.updateQAForBooking = function () {
	    };
	    QuestionAnswerComponent.prototype.setAnswers = function (answerList) {
	        var _this = this;
	        _.forEach(answerList, function (val) {
	            _.forEach(_this.questionnaires, function (valQ) {
	                if (val.question_id == valQ.id)
	                    valQ.choosen_answer = val.answer;
	            });
	        });
	    };
	    QuestionAnswerComponent.prototype.submitQuestion = function (isValid) {
	        var _this = this;
	        if (isValid) {
	            _.forEach(this.questionnaires, function (val, key) {
	                var item = {
	                    question_id: val.id,
	                    answer: val.choosen_answer
	                };
	                _this.answerList.push(item);
	            });
	            if (this.booking) {
	                this.booking.question_answer = this.answerList;
	                this.setBooking(this.booking);
	            }
	            else {
	                // Set answerList to session
	                this.setQuestionAnswer(this.answerList);
	            }
	            //  Navigate to activities page
	            this.toActivitiesListPage();
	        }
	        else {
	            this.hasError = true;
	            var flag_1 = false;
	            _.forEach(this.questionnaires, function (val, key) {
	                var item = {
	                    question_id: val.id,
	                    answer: val.choosen_answer
	                };
	                if (item.answer)
	                    flag_1 = true;
	            });
	            if (!flag_1) {
	                //if all radio not checked , show only first error
	                setTimeout(function () {
	                    $('.custom-danger').not(':first').hide();
	                    $('.custom-danger').first().focus();
	                }, 10);
	            }
	            else {
	                setTimeout(function () {
	                    $('.custom-danger').show();
	                    $('.custom-danger').first().focus();
	                }, 10);
	            }
	        }
	    };
	    return QuestionAnswerComponent;
	}(BookingComponent_1.BookingComponent));
	QuestionAnswerComponent = __decorate([
	    core_1.Component({
	        selector: 'question-answer',
	        template: __webpack_require__(457),
	        styles: [__webpack_require__(458)]
	    }),
	    __metadata("design:paramtypes", [router_1.ActivatedRoute,
	        router_1.Router,
	        services_1.BookingHolidayService,
	        services_2.SessionStorageService,
	        services_2.LocalStorageService])
	], QuestionAnswerComponent);
	exports.QuestionAnswerComponent = QuestionAnswerComponent;


/***/ }),
/* 456 */,
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<main>\n    <form #f=\"ngForm\" (submit)=\"submitQuestion(f.valid)\">\n        <div class=\"component-title\">\n                <h1 #err>Step 2: Select the correct choice based on your child’s English ability.</h1>\n            </div>\n            <div class=\"wrap-select-camp-header-inner\">\n                <img src=\"" + __webpack_require__(330) + "\" alt=\"camp-child-icon\" class=\"camp-child-icon\">\n                <div class=\"wrap-select-option-header\">\n                    <select [(ngModel)]=\"selectedChild.code\" name=\"select-child\" (ngModelChange)=\"changeChild()\" disabled>\n                        <option *ngFor=\"let child of children.holStudents\" [attr.value]=\"child.code\">\n                            {{child.code}} - {{child.given_name}} {{child.family_name}} -\n                            ({{timeDataFormat(child.date_of_birth, 'YYYY-MM-DD')}})\n                        </option>\n                    </select>\n                </div>\n            </div>\n            <div class=\"container\">\n                <!--Question list-->\n                <div class=\"question-list\" *ngIf=\"questionnaires && questionnaires.length > 0\">\n                    <ol>\n                        <li *ngFor=\"let question of questionnaires\">\n                            <div class=\"wrap-question\">\n                                <div class=\"block-question\">\n                                        <div class=\"question\">\n                                            {{ question.question }}      \n                                        </div>                          \n                                        <br/>\n                                        <ul>\n                                            <li *ngFor=\"let answer of question.answer\">\n                                                <label><input type=\"radio\" [(ngModel)]=\"question.choosen_answer\" name=\"question_{{ question.id }}\" [value]=\"answer.content\" required #myModel=\"ngModel\"/>{{  answer.content }} </label>\n                                            </li>\n                                        </ul>\n                                    </div>\n                                    <div class=\"arrow_box custom-danger\" tabindex='1' *ngIf=\"hasError && !question.choosen_answer\">\n                                        Please select an option .\n                                </div>\n                            </div>\n                            <br/>\n                        </li>\n                    </ol>\n                </div>\n                <!--End of question list-->\n            </div>\n        \n            <div id=\"submit\" class=\"row\">                   \n\n                <div class=\"large-4 l-btn\">\n                    <button class=\"l-btn\" (click)=\"backToStudentList()\">Back</button>\n                </div>\n                <div class=\"large-8 r-btn\">\n                    <button [disabled]=\"!questionnaires\" class=\"submit\">Continue</button>\n                </div>\n            </div>\n    </form>\n\n    <p-dialog #dialog [(visible)]=\"showNoteModal\" [draggable]=\"false\" [closable]=\"false\" [resizable]=\"false\" [modal]=\"true\" [responsive]=\"true\" [appendTo]=\"main\" [styleClass]=\"'medium'\">\n        <p-header>\n            WARNING\n        </p-header>\n        <div>\n            <label>There are no suitable class for your student, please contact admin !</label>\n        </div>\n        <footer class=\"text-center\">\n            <button class=\"button\" (click)=\"onCloseNoteModal($event)\">OK</button>\n        </footer>\n    </p-dialog>\n</main>";

/***/ }),
/* 458 */
/***/ (function(module, exports) {

	module.exports = ".text-left{text-align:left}.countdown{text-align:right;font-size:18px;padding:10px 20px}.container{width:80%;margin:0 auto;padding:2rem 1.25rem}.container .headline{background:#faa635;border-bottom-left-radius:5px;border-bottom-right-radius:5px;padding:0.3rem 1.5rem;margin:2rem 0 1rem}.container .headline h2{font-size:1.5625rem;color:#043d7a;font-weight:bold;text-align:right}.container .headline .algn-l{text-align:left}.container div p{font-size:0.875rem;color:#6e6e6e;line-height:1.6}.component-title{color:#043d7a;background-color:#f8f8f8;padding:1.5rem 10%;border-bottom:1px solid #eaeaea}.component-title h1{margin:0 auto;padding:0 1.25rem;font-size:1.5256rem}.component-title small{padding:0 1.25rem;font-size:90%}.wrap-select-camp-header-inner{width:100%;padding:1rem calc(10% + 1.25rem) 0;background:#f8f8f8;border-top:1px solid white}.wrap-select-camp-header-inner .camp-child-icon{vertical-align:-3px;margin-right:10px}.wrap-select-camp-header-inner .wrap-select-option-header{display:inline-block;position:relative}.wrap-select-camp-header-inner .wrap-select-option-header:before{content:'';color:#ddd;width:2.5rem;height:1.5625rem;position:absolute;pointer-events:none;right:17px;top:17px;width:0;height:0;border-left:5px solid transparent;border-right:5px solid transparent;border-top:8px solid #ddd}.wrap-select-camp-header-inner .wrap-select-option-header:after{content:'';position:absolute;height:1.5625rem;width:1px;background:#ddd;top:8px;right:40px}.wrap-select-camp-header-inner .wrap-select-option-header select{padding:0 50px 0 13px;border-radius:5px;font-size:1rem;background:#f8f8f8;border:1px solid #ddd;height:2.5rem;color:#282828;outline:none}#submit{max-width:100%;width:100%;padding:2rem 10%;border-top:1px solid #ddd}#submit .l-btn{padding-left:1.25rem}#submit .l-btn button{text-align:left;padding:1.25rem 5.25rem;font-size:1.25rem;font-weight:bold;background:#eaeaea;color:#6e6e6e}#submit .r-btn{text-align:right;padding-right:1.25rem}#submit .r-btn p{text-align:right;font-size:0.875rem;padding-right:1.125rem;padding-top:1rem}#submit .r-btn p a{font-weight:bold}#submit .r-btn .submit{padding:1.25rem 3rem;text-align:center;font-size:1.25rem;font-weight:bold}.bus-registration-container{width:80%;margin:0 auto;padding:0px 1.25rem;margin-bottom:1.5rem}.bus-registration-container h3{font-size:1.525rem;font-weight:bold;color:#043d7a;text-align:center;margin:2rem auto 1rem}.bus-registration-container .total-amount{background:#faa635;border-bottom-left-radius:5px;border-bottom-right-radius:5px;padding:0.3rem 1.5rem}.bus-registration-container .total-amount h2{font-size:1.5625rem;color:#043d7a;font-weight:bold;text-align:right}.bus-registration-container .total-amount .algn-l{text-align:left}.bus-registration-container .total-amount p{font-size:0.875rem;color:#6e6e6e;text-align:justify;line-height:1.6}.bus-registration-container .bus-registration-section{padding:0 1.25rem;margin-top:1rem;justify-content:space-between}.bus-registration-container .bus-registration-section table{text-align:left}.bus-registration-container .bus-registration-section table tr:first-child{background:#043d7a;color:#fff}.bus-registration-container .bus-registration-section p{font-size:0.875rem;color:#6e6e6e;text-align:justify;line-height:1.6}.bus-registration-container .bus-registration-section h5{font-size:1.125rem;color:#043d7a;font-weight:bold;margin-bottom:0.375rem}.bus-registration-container .bus-registration-section ul{list-style-type:decimal}.bus-registration-container .bus-registration-section ul li{font-size:0.875rem;color:#6e6e6e;text-align:justify}.bus-registration-container .bus-registration-section .bus-registration-term{padding-right:3rem}.bus-registration-container .bus-registration-section .bus-registration-method form{box-shadow:none;padding:0;font-size:1rem}.bus-registration-container .bus-registration-section .bus-registration-method form input[type=\"radio\"]{display:none}.bus-registration-container .bus-registration-section .bus-registration-method form input[type=\"radio\"]+label{margin-bottom:0.5rem;font-size:1rem;font-weight:bold;color:#6e6e6e}.bus-registration-container .bus-registration-section .bus-registration-method form input[type=\"radio\"]:disabled+label:before{background:#eee}.bus-registration-container .bus-registration-section .bus-registration-method form input[type=\"radio\"]+label:before{color:#6e6e6e;content:\"\\00a0\";display:inline-block;font:1em sans-serif;margin-right:0.5rem;padding:0;vertical-align:middle;width:1.25rem;height:1.25rem;border-radius:10px;border:1px solid #b8b8b8}.bus-registration-container .bus-registration-section .bus-registration-method form input[type=\"radio\"]:checked+label:before{content:\"\\2022\";color:#b8b8b8;font-size:2.5rem;line-height:19px;text-align:center}.modal{position:fixed;z-index:1;left:0;top:0;width:100%;height:100%;overflow:auto;background-color:#000;background-color:rgba(0,0,0,0.4)}.modal table{display:block;padding:5px 10px;margin-bottom:0;background:#fff;border-bottom-right-radius:5px;border-bottom-left-radius:5px}.modal table tbody{border:none}.modal table tbody td{font-weight:bold;font-size:0.875rem;color:#6e6e6e}.modal .modal-content{margin:0;max-width:400px;position:absolute;top:50%;left:50%;-ms-transform:translateX(-50%) translateY(-50%);-webkit-transform:translate(-50%, -50%);transform:translate(-50%, -50%)}.modal .modal-content .close{color:#fff;float:right;font-size:20px;font-weight:bold;line-height:1}.modal .modal-content .close:hover,.modal .modal-content .close:focus{color:#eee;text-decoration:none;cursor:pointer}.modal .modal-header{text-align:center;padding:10px 20px;color:#fff;background:#043d7a;font-size:1.25rem;font-weight:bold;border-top-right-radius:5px;border-top-left-radius:5px}.modal .modal-header h2{text-align:left;font-size:1rem;font-weight:bold;margin-bottom:0}.modal .modal-body{padding:10px 20px;background:#fff;border-bottom-right-radius:5px;border-bottom-left-radius:5px}@media only screen and (max-width: 40em){.select-camp-header .select-camp-header-inner{padding:0}.select-camp-header .select-camp-header-inner h4{padding-left:10%;padding-right:10%}.select-camp-header .select-camp-header-inner .wrap-select-camp-header-inner{padding:0}.select-camp-header .select-camp-header-inner .wrap-select-camp-header-inner .camp-child-icon{display:none}.list-camp h3{margin:1.5rem auto 1.5rem;line-height:0.7;font-size:1.4rem}.list-camp .row li{padding:0}}label{margin-bottom:0.5rem;font-size:1rem;font-weight:bold;color:#6e6e6e}input{vertical-align:-3px}.question-list .arrow_box{position:relative;background:#ffffff;border:1px solid #aaa}.question-list .arrow_box:after,.question-list .arrow_box:before{right:100%;top:50%;border:solid transparent;content:\" \";height:0;width:0;position:absolute;pointer-events:none}.question-list .arrow_box:after{border-color:rgba(255,255,255,0);border-right-color:#ffffff;border-width:5px;margin-top:-5px}.question-list .arrow_box:before{border-color:rgba(170,170,170,0);border-right-color:#aaa;border-width:6px;margin-top:-6px}.question-list .wrap-question{display:inline-flex;position:relative}.question-list .question{float:left}.question-list .custom-danger{font-size:15px;color:red;position:absolute;left:40vw;top:40%;border:1px solid #ccc;border-radius:5px;padding:5px 15px;-webkit-box-shadow:1px 1px 4px 0px rgba(0,0,0,0.32);-moz-box-shadow:1px 1px 4px 0px rgba(0,0,0,0.32);box-shadow:1px 1px 4px 0px rgba(0,0,0,0.32);float:left;margin-left:50px;font-size:15px;color:red;width:205px}.question-list label{font-weight:normal;cursor:pointer;color:#000}.question-list ul{margin-top:5px;list-style-type:none;margin-left:0 !important}.question-list input[type=radio]{margin-right:5px}\n"

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var shared_1 = __webpack_require__(106);
	// import { BookingListComponent } from './booking-list/BookingListComponent';
	// import { BookingDetailComponent } from './booking-detail/BookingDetailComponent';
	var ParentProfileRouting_1 = __webpack_require__(460);
	var AddParentComponent_1 = __webpack_require__(461);
	var primeng_1 = __webpack_require__(383);
	// import { BookingService } from '../../services';
	var ParentProfileModule = (function () {
	    function ParentProfileModule() {
	    }
	    return ParentProfileModule;
	}());
	ParentProfileModule = __decorate([
	    core_1.NgModule({
	        imports: [
	            shared_1.SharedModule,
	            ParentProfileRouting_1.parentProfileRouting,
	            primeng_1.GrowlModule
	        ],
	        declarations: [
	            AddParentComponent_1.AddParentComponent,
	        ],
	        providers: [],
	    })
	], ParentProfileModule);
	exports.ParentProfileModule = ParentProfileModule;


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var router_1 = __webpack_require__(26);
	var AddParentComponent_1 = __webpack_require__(461);
	var ParentProfileRoutes = [
	    { path: 'profile',
	        children: [
	            {
	                path: 'add-parent',
	                component: AddParentComponent_1.AddParentComponent
	            },
	            {
	                path: 'edit-parent',
	                component: AddParentComponent_1.AddParentComponent
	            }
	        ] }
	];
	exports.parentProfileRouting = router_1.RouterModule.forChild(ParentProfileRoutes);


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var Parent_1 = __webpack_require__(123);
	var NonAisParent_1 = __webpack_require__(129);
	var Credential_1 = __webpack_require__(124);
	var RegisterService_1 = __webpack_require__(128);
	var HolidayService_1 = __webpack_require__(86);
	var router_2 = __webpack_require__(26);
	var Observable_1 = __webpack_require__(7);
	var forms_1 = __webpack_require__(108);
	var core_2 = __webpack_require__(3);
	var AddParentComponent = (function () {
	    function AddParentComponent(router, registerService, holidayService) {
	        var _this = this;
	        this.router = router;
	        this.registerService = registerService;
	        this.holidayService = holidayService;
	        this.formSubmitted = false;
	        this.EDIT_PROFILE_PAGE = 'edit-parent';
	        this.isEditProfile = false;
	        this.parentDetail = new Parent_1.Parent();
	        this.router.events.filter(function (evt) { return evt instanceof router_2.NavigationEnd; })
	            .subscribe(function (event) {
	            if (event['url'].indexOf(_this.EDIT_PROFILE_PAGE) > -1) {
	                _this.isEditProfile = true;
	            }
	        });
	    }
	    AddParentComponent.prototype.ngOnInit = function () {
	        this.nonAisParent = new NonAisParent_1.NonAisParent();
	        this.getParent();
	    };
	    AddParentComponent.prototype.onSubmitNonAis = function () {
	        this.credential = new Credential_1.Credential('hol-parent', '', '');
	        this.formSubmitted = true;
	        // Reset message content
	        this.message = "";
	        // Post user login data to create session
	        if (this.isEditProfile)
	            this.updateProfile(this.parentDetail);
	        else
	            this.registerNonAis(this.nonAisParent);
	    };
	    AddParentComponent.prototype.updateProfile = function (parentDetail) {
	        var _this = this;
	        if (!this.validateForm()) {
	            this.msgs = [];
	            this.msgs.push({ severity: 'error', summary: 'Error', detail: 'Please fill required fields!' });
	            return;
	        }
	        if (parentDetail.hol_parent_details.length < 2)
	            parentDetail.hol_parent_details.push(this.nonAisParent);
	        if (parentDetail.hol_parent_details[0].email == parentDetail.hol_parent_details[1].email)
	            return;
	        var listObservables = [];
	        for (var _i = 0, _a = parentDetail.hol_parent_details; _i < _a.length; _i++) {
	            var parent_1 = _a[_i];
	            listObservables.push(this.registerService.updateParent(parent_1));
	        }
	        Observable_1.Observable.forkJoin(listObservables).subscribe(function (data) {
	            _this.msgs = [];
	            _this.msgs.push({ severity: 'success', summary: 'Success', detail: 'Update profile success!' });
	            setTimeout(function () {
	                if (_this.parentDetail.holStudents.length > 1) {
	                    _this.router.navigateByUrl('/booking/students');
	                }
	                else {
	                    _this.router.navigateByUrl('/add-student');
	                }
	            }, 2000);
	        }, function (error) {
	            _this.messageType = "alert";
	            _this.message = "Update Error";
	            _this.formSubmitted = false;
	        });
	    };
	    AddParentComponent.prototype.registerNonAis = function (nonAisParent) {
	        var _this = this;
	        if (this.parentDetail.hol_parent_details[0].email == this.nonAisParent.email)
	            return;
	        this.registerService.updateParent(nonAisParent)
	            .subscribe(function (complete) {
	            _this.messageType = "success",
	                _this.message = "Adding Successfully";
	            _this.formSubmitted = false;
	            console.log(_this.parentDetail);
	            if (_this.parentDetail.holStudents.length > 1) {
	                _this.router.navigateByUrl('/booking/students');
	            }
	            else {
	                _this.router.navigateByUrl('/add-student');
	            }
	        }, function (error) {
	            _this.messageType = "alert";
	            _this.message = "Adding Error";
	            _this.formSubmitted = false;
	        });
	    };
	    AddParentComponent.prototype.getParent = function () {
	        var _this = this;
	        this.holidayService.getParent()
	            .subscribe(function (parent) {
	            _this.parentDetail = parent;
	            console.log(_this.parentDetail);
	        }, function (error) {
	            //TO DO: Handle any error if needed in the furture
	            _this.message = "";
	            _this.messageType = "alert";
	        });
	    };
	    AddParentComponent.prototype.validateForm = function () {
	        if (this.parentDetail.hol_parent_details.length < 2) {
	            if (this.registerNonAisForm.form.valid && this.registerNonAisForm1.form.valid)
	                return true;
	            else
	                return false;
	        }
	        else {
	            if (this.registerNonAisForm.form.valid)
	                return true;
	            else
	                return false;
	        }
	    };
	    return AddParentComponent;
	}());
	__decorate([
	    core_2.ViewChild('registerNonAisForm'),
	    __metadata("design:type", forms_1.FormGroupDirective)
	], AddParentComponent.prototype, "registerNonAisForm", void 0);
	__decorate([
	    core_2.ViewChild('registerNonAisForm1'),
	    __metadata("design:type", forms_1.FormGroupDirective)
	], AddParentComponent.prototype, "registerNonAisForm1", void 0);
	AddParentComponent = __decorate([
	    core_1.Component({
	        selector: 'add-parent',
	        template: __webpack_require__(462),
	        styles: [__webpack_require__(463)]
	    }),
	    __metadata("design:paramtypes", [router_1.Router,
	        RegisterService_1.RegisterService,
	        HolidayService_1.HolidayService])
	], AddParentComponent);
	exports.AddParentComponent = AddParentComponent;


/***/ }),
/* 462 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"component-content\">   \n    <form #registerNonAisForm=\"ngForm\" *ngFor=\"let parent of parentDetail.hol_parent_details; let i = index\">\n        <!-- Form Title -->\n        <h3 class=\"text-center\">Parent Information {{ i + 1 }}</h3>\n        <!-- Alert Box -->\n        <div class=\"row\">\n            <div class=\"medium-12 columns\">\n                <alert-box [message]=\"message2\" [type]=\"messageType2\"></alert-box>\n            </div>\n        </div>\n        <!-- Relationship Input Field -->\n        <div class=\"row\">\n            <div class=\"medium-12 columns\">\n                <label for=\"relationship\">Relationship to student</label>\n                <input type=\"text\" placeholder=\"Type your Relationship to student\" id=\"nonais-relationship_{{i}}\" name=\"nonais-relationship_{{i}}\" required\n                    [(ngModel)]=\"parent.relationship\" #nonaisRelationship=\"ngModel\" [disabled]=\"!isEditProfile\">\n            </div>\n        </div>\n        <!-- Email Input Field -->\n        <div class=\"row\">\n            <div class=\"medium-12 columns\">\n                <label for=\"family-name\">Family Name</label>\n                <input type=\"text\" placeholder=\"Type your Family Name\" id=\"nonais-family-name_{{i}}\" name=\"nonais-family-name_{{i}}\" required\n                    [(ngModel)]=\"parent.family_name\" #nonaisFamilyName=\"ngModel\" [disabled]=\"!isEditProfile\">\n            </div>\n        </div>\n        <!-- Email Input Field -->\n        <div class=\"row\">\n            <div class=\"medium-12 columns\">\n                <label for=\"given-name\">Given Name</label>\n                <input type=\"text\" placeholder=\"Type your Given Name\" id=\"nonais-given-name_{{i}}\" name=\"nonais-given-name_{{i}}\" required\n                    [(ngModel)]=\"parent.given_name\" #nonaisGivenName=\"ngModel\" [disabled]=\"!isEditProfile\">\n            </div>\n        </div>\n        <!-- Email Input Field -->\n        <div class=\"row\">\n            <div class=\"medium-12 columns\">\n                <label for=\"nonais-email\">Email</label>\n                <input type=\"text\" placeholder=\"Email\" id=\"nonais-email_{{i}}\" name=\"nonais-email_{{i}}\" \n                        [(ngModel)]=\"parent.email\" #nonaisEmail=\"ngModel\" [disabled]=\"!isEditProfile\">\n            </div>\n        </div>\n        <!-- Phone Number Input Field -->\n        <div class=\"row\">\n            <div class=\"medium-12 columns\">\n                <label for=\"phone\">Phone Number</label>\n                <input type=\"text\" placeholder=\"Type your Phone number\" id=\"nonais-phone_{{i}}\" name=\"nonais-phone_{{i}}\"\n                    [(ngModel)]=\"parent.phone\" #nonaisPhone=\"ngModel\" [disabled]=\"!isEditProfile\" required>\n\n            </div>\n        </div>\n    </form>\n\n     <form #registerNonAisForm1=\"ngForm\" *ngIf=\"parentDetail.hol_parent_details?.length < 2\">\n        <!-- Form Title -->\n        <h3 class=\"text-center\">Parent Information 2</h3>\n        <!-- Relationship Input Field -->\n        <div class=\"row\">\n            <div class=\"medium-12 columns\">\n                <label for=\"relationship\">Relationship to student</label>\n                <input type=\"text\" placeholder=\"Type your Relationship to student\" id=\"nonais-relationship_1\" name=\"nonais-relationship_1\" required\n                    [(ngModel)]=\"nonAisParent.relationship\" #nonaisRelationship1=\"ngModel\">\n            </div>\n        </div>\n        <!-- Alert Box -->\n        <div class=\"row\">\n            <div class=\"medium-12 columns\">\n                <alert-box [message]=\"message2\" [type]=\"messageType2\"></alert-box>\n            </div>\n        </div>\n        <!-- Email Input Field -->\n        <div class=\"row\">\n            <div class=\"medium-12 columns\">\n                <label for=\"family-name\">Family Name</label>\n                <input type=\"text\" placeholder=\"Type your Family Name\" id=\"nonais-family-name_1\" name=\"nonais-family-name_1\" required\n                    [(ngModel)]=\"nonAisParent.family_name\" #nonaisFamilyName2=\"ngModel\" required>\n            </div>\n        </div>\n        <!-- Email Input Field -->\n        <div class=\"row\">\n            <div class=\"medium-12 columns\">\n                <label for=\"given-name\">Given Name</label>\n                <input type=\"text\" placeholder=\"Type your Given Name\" id=\"nonais-given-name_1\" name=\"nonais-given-name_1\" required\n                    [(ngModel)]=\"nonAisParent.given_name\" #nonaisGivenName2=\"ngModel\" required>\n            </div>\n        </div>\n        <!-- Email Input Field -->\n        <div class=\"row\">\n            <div class=\"medium-12 columns\">\n                <label for=\"nonais-email\">Email</label>\n                <input type=\"text\" placeholder=\"Email\" id=\"nonais-email_1\" name=\"nonais-email_1\" \n                        [(ngModel)]=\"nonAisParent.email\" #nonaisEmail2=\"ngModel\">\n                <span class=\"danger\" *ngIf=\"parentDetail && parentDetail.hol_parent_details && parentDetail.hol_parent_details[0].email == nonAisParent.email\">Email cannot be the same as parent 1</span>\n            </div>\n        </div>\n        <!-- Phone Number Input Field -->\n        <div class=\"row\">\n            <div class=\"medium-12 columns\">\n                <label for=\"phone\">Phone Number</label>\n                <input type=\"text\" placeholder=\"This will be used for emergency contact\" id=\"nonais-phone_1\" name=\"nonais-phone_1\"\n                    [(ngModel)]=\"nonAisParent.phone\" #nonaisPhone2=\"ngModel\" required>\n\n            </div>\n        </div>\n        \n        <!-- Submit Button -->\n        <div class=\"row\" *ngIf=\"!isEditProfile\">\n            <div class=\"medium-12 columns\">\n                <button type=\"submit\" name=\"submit\" (click)=\"onSubmitNonAis()\">Save</button>\n            </div>\n        </div>\n    </form>\n    \n    <div class=\"row group-button-2form\" *ngIf=\"isEditProfile\">\n        <div class=\"medium-12 columns\">\n            <button type=\"submit\" name=\"submit\" (click)=\"onSubmitNonAis()\" class=\"button-save-2form\">Save</button>\n        </div>\n    </div>\n</div>\n<p-growl [value]=\"msgs\"></p-growl>";

/***/ }),
/* 463 */
/***/ (function(module, exports) {

	module.exports = ".danger{color:red;font-size:12px}.button-save-2form{float:right;margin:0 4%}.group-button-2form{margin-top:20px;width:100%}.component-content{margin:3rem auto;width:90%;display:flex;flex-wrap:wrap;justify-content:center}.component-content form{width:40%;margin:0 5%;background:#fafafa}.component-content form .terms-conditions{font-size:0.65rem;font-weight:bold;text-align:center}.component-content form button{width:100%}@media (min-width: 1025px){#user-register-component .component-title{max-width:400px}#user-register-component .component-content{max-width:400px}}@media (min-width: 768px) and (max-width: 1024px){#user-register-component .component-title{width:50%;max-width:400px}#user-register-component .component-content{width:50%;max-width:400px}}@media (min-width: 320px) and (max-width: 767px){#user-register-component{padding:0}#user-register-component .component-title{display:none}#user-register-component .component-content{margin:0;width:100%}#user-register-component .component-content form{border:none;border-radius:0rem}}\n"

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var shared_1 = __webpack_require__(106);
	var RegisterComponent_1 = __webpack_require__(465);
	var HolRegisterService_1 = __webpack_require__(323);
	var RegisterRouting_1 = __webpack_require__(468);
	var RegisterManagementModule = (function () {
	    function RegisterManagementModule() {
	    }
	    return RegisterManagementModule;
	}());
	RegisterManagementModule = __decorate([
	    core_1.NgModule({
	        imports: [
	            shared_1.SharedModule,
	            RegisterRouting_1.registerManagementRouting,
	        ],
	        declarations: [
	            RegisterComponent_1.RegisterComponent,
	        ],
	        providers: [
	            HolRegisterService_1.HolRegisterService
	        ],
	    })
	], RegisterManagementModule);
	exports.RegisterManagementModule = RegisterManagementModule;


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	//Libraries
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	// Services
	var SessionService_1 = __webpack_require__(85);
	var UserService_1 = __webpack_require__(84);
	var HolRegisterService_1 = __webpack_require__(323);
	//Models
	var Credential_1 = __webpack_require__(124);
	var RegisterComponent = (function () {
	    function RegisterComponent(sessionService, userService, registerService, router) {
	        this.sessionService = sessionService;
	        this.userService = userService;
	        this.registerService = registerService;
	        this.router = router;
	        this.formSubmitted = false;
	    }
	    RegisterComponent.prototype.ngOnInit = function () {
	        this.credential = new Credential_1.Credential('hol-parent', '', '');
	        // Use Session Service to get session and check if user had already logged in.
	        this.getSession();
	    };
	    RegisterComponent.prototype.onSubmit = function () {
	        this.formSubmitted = true;
	        // Reset message content
	        this.message = "";
	        // Post user login data to create session
	        this.register(this.credential);
	    };
	    /**
	     * Get Session from API service to make sure that user had logged in.
	     * Update User Data on local storage and redirect to the desired URL
	     * if request responses session data.
	     * @param none
	     * @return none
	     */
	    RegisterComponent.prototype.getSession = function () {
	        var _this = this;
	        this.sessionService.getSession()
	            .subscribe(function (user) {
	            _this.userService.setUserSessionData(user);
	            _this.redirect();
	        }, function (error) {
	            //TO DO: Handle any error if needed in the furture
	            _this.message = "";
	            _this.messageType = "alert";
	        });
	    };
	    RegisterComponent.prototype.register = function (credential) {
	        var _this = this;
	        this.registerService.postNoneAisAccount(credential.email)
	            .subscribe(function (complete) {
	            _this.messageType = "success",
	                _this.message = "An activation email had been sent.";
	            _this.formSubmitted = false;
	            _this.redirectUrl = '/add-parent';
	            _this.redirect();
	        }, function (error) {
	            _this.messageType = "alert";
	            _this.message = "Please input the email you provided to AIS.";
	            _this.formSubmitted = false;
	        });
	    };
	    RegisterComponent.prototype.redirect = function () {
	        // Redirect to stored url
	        this.router.navigate([this.redirectUrl]);
	    };
	    return RegisterComponent;
	}());
	RegisterComponent = __decorate([
	    core_1.Component({
	        selector: 'user-register',
	        template: __webpack_require__(466),
	        styles: [__webpack_require__(467)]
	    }),
	    __metadata("design:paramtypes", [SessionService_1.SessionService,
	        UserService_1.UserService,
	        HolRegisterService_1.HolRegisterService,
	        router_1.Router])
	], RegisterComponent);
	exports.RegisterComponent = RegisterComponent;


/***/ }),
/* 466 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"user-register-component\" class=\"eca-background\">\n    <div class=\"component-title\">\n        <h1>WELCOME TO AIS</h1>\n    </div>\n    <div class=\"component-content\">\n        <form (ngSubmit)=onSubmit() #registerForm=\"ngForm\">\n\t\t\t<!-- Form Title -->\n            <h3 class=\"text-center\">Register Account</h3>\n\t\t\t<!-- Alert Box -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<alert-box [message]=\"message\" [type]=\"messageType\"></alert-box>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Email Input Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"email\">Please type the email you registered with AIS</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Email\" id=\"email\" name=\"email\" \n\t\t\t\t\t\t\t[(ngModel)]=\"credential.email\" #email=\"ngModel\" required>\n\t\t\t\t\t<div [hidden]=\"email.valid || email.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tEmail is required.\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Submit Button -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n            \t\t<button type=\"submit\" [disabled]=\"!registerForm.form.valid || formSubmitted\">Register</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Term & Condition Link -->\n\t\t\t<!--<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n            \t\t<label class=\"terms-conditions\">By clicking Register you are agreeing to the \n\t\t\t\t\t\t<a href=\"#\">Terms & Conditions</a>\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t</div>-->\n        </form>\n    </div>\n</div>";

/***/ }),
/* 467 */
/***/ (function(module, exports) {

	module.exports = "#user-register-component{padding:1rem}#user-register-component .component-title{margin:3rem auto;width:31.25%;color:#fff;text-align:center}#user-register-component .component-content{margin:3rem auto;width:31.25%}#user-register-component .component-content form .terms-conditions{font-size:0.65rem;font-weight:bold;text-align:center}#user-register-component .component-content form button{width:100%}@media (min-width: 1025px){#user-register-component .component-title{max-width:400px}#user-register-component .component-content{max-width:400px}}@media (min-width: 768px) and (max-width: 1024px){#user-register-component .component-title{width:50%;max-width:400px}#user-register-component .component-content{width:50%;max-width:400px}}@media (min-width: 320px) and (max-width: 767px){#user-register-component{padding:0}#user-register-component .component-title{display:none}#user-register-component .component-content{margin:0;width:100%}#user-register-component .component-content form{border:none;border-radius:0rem}}\n"

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var router_1 = __webpack_require__(26);
	var RegisterComponent_1 = __webpack_require__(465);
	var RegisterManagementRoutes = [
	    {
	        path: 'sign-on',
	        component: RegisterComponent_1.RegisterComponent
	    },
	];
	exports.registerManagementRouting = router_1.RouterModule.forChild(RegisterManagementRoutes);


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	// Services
	var SessionService_1 = __webpack_require__(85);
	var UserService_1 = __webpack_require__(84);
	var Credential_1 = __webpack_require__(124);
	var LoginComponent = (function () {
	    function LoginComponent(sessionService, userService, router) {
	        this.sessionService = sessionService;
	        this.userService = userService;
	        this.router = router;
	        this.formSubmitted = false;
	    }
	    LoginComponent.prototype.ngOnInit = function () {
	        this.redirectUrl = '/booking/students';
	        this.credential = new Credential_1.Credential('hol-parent', '', '');
	        // Use Session Service to get session and check if user had already logged in.
	        this.getSession();
	    };
	    ;
	    LoginComponent.prototype.onSubmit = function () {
	        this.formSubmitted = true;
	        // Reset message content
	        this.message = "";
	        // Post user login data to create session
	        this.postSession(this.credential);
	    };
	    /**
	     * Get Session from API service to make sure that user had logged in.
	     * Update User Data on local storage and redirect to the desired URL
	     * if request responses session data.
	     * @param none
	     * @return none
	     */
	    LoginComponent.prototype.getSession = function () {
	        var _this = this;
	        this.sessionService.getSession()
	            .subscribe(function (user) {
	            _this.userService.setUserSessionData(user);
	            _this.redirect(_this.redirectUrl);
	        }, function (error) {
	            //TO DO: Handle any error if needed in the furture
	            _this.message = "";
	            _this.messageType = "alert";
	        });
	    };
	    /**
	     * Post Session to API service to create new session.
	     * Update User Data on local storage and redirect to desired URL
	     * if request responses session data.
	     * @param {Credential} - user credential input
	     * @return none
	     */
	    LoginComponent.prototype.postSession = function (credential) {
	        var _this = this;
	        this.sessionService.postSession(credential)
	            .subscribe(function (user) {
	            // Set user session data
	            _this.userService.setUserSessionData(user);
	            // Fire user session data changed event
	            _this.userService.userDataChanged(user);
	            // Redirect to desired URL
	            _this.redirect(_this.redirectUrl);
	        }, function (error) {
	            _this.formSubmitted = false;
	            _this.message = "Invalid email address or password.";
	            _this.messageType = "alert";
	        });
	    };
	    // Redirect to desired url
	    LoginComponent.prototype.redirect = function (redirectUrl) {
	        this.router.navigate([redirectUrl]);
	    };
	    return LoginComponent;
	}());
	LoginComponent = __decorate([
	    core_1.Component({
	        selector: 'user-login',
	        template: __webpack_require__(470),
	        styles: [__webpack_require__(471)],
	    }),
	    __metadata("design:paramtypes", [SessionService_1.SessionService,
	        UserService_1.UserService,
	        router_1.Router])
	], LoginComponent);
	exports.LoginComponent = LoginComponent;


/***/ }),
/* 470 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"user-login-component\" class=\"eca-background\">\n    <div class=\"component-title\">\n        <h1>WELCOME TO AUSTRALIAN INTERNATIONAL SCHOOL</h1>\n    </div>\n    <div class=\"component-content\">\n        <form (ngSubmit)=\"onSubmit()\" #loginForm=\"ngForm\">\n\t\t\t<!-- Form Title -->\n            <h3 class=\"text-center\">Login to your account</h3>\n\t\t\t<!-- Alert Box -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<alert-box [message]=\"message\" [type]=\"messageType\"></alert-box>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Email Input Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"email\">Email</label>\n\t\t\t\t\t<input type=\"email\" placeholder=\"Type your email address\" id=\"email\" \n\t\t\t\t\t\t[(ngModel)]=\"credential.email\" name=\"email\" #email=\"ngModel\" required>\n\t\t\t\t\t<div [hidden]=\"email.valid || email.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tEmail is required.\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Password Input Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"password\">Password</label>\n\t\t\t\t\t<input type=\"password\" placeholder=\"Type your password\" id=\"password\" \n\t\t\t\t\t\t[(ngModel)]=\"credential.password\" name=\"password\" #password=\"ngModel\" required>\n\t\t\t\t\t<div [hidden]=\"password.valid || password.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tPassword is required.\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Remember Me & Forgot Password -->\n            <div class=\"row\">\n\t\t\t\t<!--<div class=\"medium-6 columns remember-block\">\n\t\t\t\t\t<input id=\"remember_me\" type=\"checkbox\" name=\"remember_me\" class=\"remember-me\" checked disabled>\n\t\t\t\t\t<label for=\"remember_me\">Remember me</label>\n\t\t\t\t</div>-->\n\t\t\t\t<div class=\"medium-6 columns\">\n\t\t\t\t\t<a routerLink=\"/forgot-password\" class=\"forgot-password text-right\">Forgot Password?</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Submit Button -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<button type=\"submit\" name=\"submit\" [disabled]=\"!loginForm.form.valid || formSubmitted\">Login</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Register Link -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n            \t\t<label class=\"register-link\">Do not have an account yet? <a routerLink=\"/register\">REGISTER NOW</a></label>\n\t\t\t\t</div>\n\t\t\t</div>\n        </form>\n    </div>\n</div>";

/***/ }),
/* 471 */
166,
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var moment = __webpack_require__(169);
	var core_1 = __webpack_require__(3);
	var Rx_1 = __webpack_require__(473);
	var Subscription_1 = __webpack_require__(11);
	var router_1 = __webpack_require__(26);
	var HolidayService_1 = __webpack_require__(86);
	// Service
	var services_1 = __webpack_require__(315);
	var services_2 = __webpack_require__(58);
	var SessionService_1 = __webpack_require__(85);
	var UserService_1 = __webpack_require__(84);
	__webpack_require__(767);
	var _ = __webpack_require__(64);
	var AppComponent = (function () {
	    function AppComponent(service, router, userService, sessionService, sessionStorageService, holidayService, services) {
	        var _this = this;
	        this.service = service;
	        this.router = router;
	        this.userService = userService;
	        this.sessionService = sessionService;
	        this.sessionStorageService = sessionStorageService;
	        this.holidayService = holidayService;
	        this.services = services;
	        // For Countdown
	        this.showCountdown = false;
	        this.currentCountdown = '';
	        this.isTimedOut = false;
	        this.devEnv = ['camp.eca.dev.nascorp.vn', 'asa.eca.dev.nascorp.vn', 'holiday.eca.dev.nascorp.vn', 'bus.eca.dev.nascorp.vn'];
	        this.testEnv = ['camp.eca.test.nascorp.vn', 'asa.eca.test.nascorp.vn', 'holiday.eca.test.nascorp.vn', 'bus.eca.test.nascorp.vn'];
	        this.stagingEnv = ['auth.eca.uat.nascorp.vn', 'services.eca.uat.nascorp.vn', 'asa.eca.uat.nascorp.vn', 'holidayschool.eca.uat.nascorp.vn', 'bus.eca.uat.nascorp.vn', 'outdooreducation.eca.uat.nascorp.vn', 'reen.eca.uat.nascorp.vn', 'acs.eca.uat.nascorp.vn', 'pcbs.eca.uat.nascorp.vn'];
	        this.procEnv = ['outdooreducation.aisvietnam.com', 'asa.aisvietnam.com', 'holidayschool.aisvietnam.com', 'bus.aisvietnam.com'];
	        this.module = 'holiday';
	        var allowCountdownRoute = ['/booking/activites-list', '/booking/excursions', '/booking/bus', '/booking/payment'];
	        this.router.events.subscribe(function (val) {
	            // On end route change
	            if (val instanceof router_1.NavigationEnd) {
	                // IF not on allowed route
	                if (allowCountdownRoute.indexOf(val.url) === -1) {
	                    _this.sessionStorageService.removeData('countdown');
	                    // Unsubscript
	                    if (_this.subscribtion instanceof Subscription_1.Subscription) {
	                        _this.subscribtion.unsubscribe();
	                    }
	                    if (_this.countDownSubscribe instanceof Subscription_1.Subscription) {
	                        _this.countDownSubscribe.unsubscribe();
	                    }
	                    _this.showCountdown = false;
	                    // Re-setup subscription
	                    _this.setupSubscript();
	                    _this.sessionStorageService.setData('currentRoute', val.url);
	                }
	                else {
	                    if (val.url == _this.currentRoute) {
	                        _this.service.startCountdown(true);
	                    }
	                    else {
	                        _this.sessionStorageService.setData('currentRoute', val.url);
	                        _this.currentRoute = val.url;
	                    }
	                }
	            }
	            _this.currentRoute = _this.sessionStorageService.getData('currentRoute').toString();
	        });
	        this.setupSubscript();
	    }
	    AppComponent.prototype.ngOnInit = function () {
	        this.getSession();
	        this.hostName = window.location.hostname;
	    };
	    // Get all children of logged parent
	    AppComponent.prototype.getChildren = function () {
	        var _this = this;
	        this.services.getChildren().subscribe(function (result) {
	            _this.parent = result.type;
	            // Get all children
	            if (result.holStudents) {
	                _this.children = _.filter(result.holStudents, { 'status': 'active' });
	            }
	            // Set session children to avoid re-request
	            _this.setHolidayChildren(result);
	        }, function (error) {
	        });
	    };
	    AppComponent.prototype.redirectLogin = function () {
	        // Redirect to desired URL                    
	        if (this.devEnv.indexOf(this.hostName) !== -1) {
	            return window.location.href = 'http://services.eca.dev.nascorp.vn';
	        }
	        else if (this.testEnv.indexOf(this.hostName) !== -1) {
	            return window.location.href = 'http://services.eca.test.nascorp.vn';
	        }
	        else if (this.stagingEnv.indexOf(this.hostName) !== -1) {
	            return window.location.href = 'http://services.eca.uat.nascorp.vn';
	        }
	        else if (this.procEnv.indexOf(this.hostName) !== -1) {
	            return window.location.href = 'https://services.aisvietnam.com';
	        }
	        else {
	            return window.location.href = 'http://services.local.eca.dev.nascorp.vn';
	        }
	    };
	    // Set holiday children to session
	    AppComponent.prototype.setHolidayChildren = function (children) {
	        this.sessionStorageService.setData('holChildren', children);
	        // check is ias parent hide profile on menu
	        if (children.type == 'ais') {
	            this.sessionStorageService.setData('isAisParent', true);
	        }
	        else {
	            this.sessionStorageService.setData('isAisParent', false);
	        }
	    };
	    AppComponent.prototype.getHolidayChildren = function () {
	        return this.sessionStorageService.getData('holChildren');
	    };
	    AppComponent.prototype.convertParent = function () {
	        var _this = this;
	        this.holidayService.convertParent()
	            .subscribe(function (complete) {
	            _this.getSession();
	            _this.getParent();
	        }, function (error) {
	        });
	    };
	    AppComponent.prototype.getSession = function () {
	        var _this = this;
	        this.sessionService.getSession()
	            .subscribe(function (user) {
	            _this.userService.setUserSessionData(user);
	            _this.userService.userDataChanged(user);
	            _this.userData = _this.userService.getUserSessionData();
	        }, function (error) {
	            //TO DO: Handle any error if needed in the furture
	            _this.message = "";
	            _this.messageType = "alert";
	            _this.redirectLogin();
	        });
	    };
	    AppComponent.prototype.getParent = function () {
	        var _this = this;
	        this.holidayService.getParent()
	            .subscribe(function (parent) {
	            _this.parent = parent;
	            if (_this.parent.status === "fill-info") {
	                _this.router.navigate(['/profile/add-parent']);
	            }
	            else if (_this.parent.status == "full") {
	                _this.router.navigate(['/booking/students']);
	            }
	            else {
	                _this.router.navigate(['/add-student']);
	            }
	        }, function (error) {
	            //TO DO: Handle any error if needed in the furture
	            _this.message = "";
	            _this.messageType = "alert";
	        });
	    };
	    AppComponent.prototype.setupSubscript = function () {
	        var _this = this;
	        // Subscribe to service start countdown
	        this.subscribtion = this.service.countdownAnnounced$.subscribe(function (start) {
	            if (start) {
	                // Set time
	                if (_this.getCurrentCountdown()) {
	                    _this._diff = +_this.getCurrentCountdown();
	                }
	                else {
	                    _this._diff = 600000;
	                }
	                // Show countdown
	                _this.showCountdown = true;
	                _this.countDownSubscribe = Rx_1.Observable.interval(1000).map(function (x) {
	                    _this._diff = _this._diff - 1000;
	                }).subscribe(function (x) {
	                    // If end countdown
	                    if (!_this._diff) {
	                        _this.sessionTimedOut();
	                    }
	                    // Get current countdown
	                    _this.currentCountdown = moment(_this._diff).format('mm:ss');
	                    // Save current countdown
	                    _this.setCurrentCountdown(_this._diff);
	                });
	            }
	            else {
	            }
	        });
	    };
	    // Timeout session handler
	    AppComponent.prototype.sessionTimedOut = function () {
	        this.isTimedOut = true;
	        this.sessionStorageService.removeData('countdown');
	        // Stop countdown & unsubscribe
	        this.countDownSubscribe.unsubscribe();
	        this.showCountdown = false;
	        // Navigate to student list on timed out
	        // this.router.navigate(['booking/students']);
	    };
	    // Set countdown to storage
	    AppComponent.prototype.setCurrentCountdown = function (countdown) {
	        this.sessionStorageService.setData('countdown', countdown);
	    };
	    // Get countdown from storage
	    AppComponent.prototype.getCurrentCountdown = function () {
	        return this.sessionStorageService.getData('countdown');
	    };
	    return AppComponent;
	}());
	AppComponent = __decorate([
	    core_1.Component({
	        selector: 'my-app',
	        template: __webpack_require__(781),
	        styles: [__webpack_require__(782)]
	    }),
	    __metadata("design:paramtypes", [services_1.BookingHolidayService,
	        router_1.Router,
	        UserService_1.UserService,
	        SessionService_1.SessionService,
	        services_2.SessionStorageService,
	        HolidayService_1.HolidayService,
	        services_1.BookingHolidayService])
	], AppComponent);
	exports.AppComponent = AppComponent;


/***/ }),
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */
/***/ (function(module, exports) {

	module.exports = "<!-- Application Top Menu -->\n<top-menu></top-menu>\n<!-- Application Main Menu -->\n<main-menu [module]=\"module\"></main-menu>\n<!-- Process bar -->\n<!--<process-bar></process-bar>-->\n<div class=\"countdown\" [hidden]=\"!showCountdown\">Your session will expire in: <b>{{this.currentCountdown}}</b></div>\n\n<!-- Application Content -->\n<router-outlet></router-outlet>\n\n<!-- Timedout Modal -->\n<div class=\"modal\" [hidden]=\"!isTimedOut\">\n    <!-- Modal content -->\n    <div class=\"modal-content\">\n        <div class=\"modal-header\">\n            <span class=\"close\" (click)=\"isTimedOut = false\">×</span>\n            <h2>Time out session</h2>\n        </div>\n        <div class=\"modal-body\">\n            <span>Your booking session has been timed out.</span>\n        </div>\n    </div>\n</div>\n<!-- End of Timedout Modal -->\n\n<!-- Application Footer -->\n<footer></footer>\n<!-- Application Inspired -->\n<inspired></inspired>";

/***/ }),
/* 782 */
/***/ (function(module, exports) {

	module.exports = ".text-left{text-align:left}.countdown{text-align:right;font-size:18px;padding:10px 20px}.container{width:80%;margin:0 auto;padding:2rem 1.25rem}.container .headline{background:#faa635;border-bottom-left-radius:5px;border-bottom-right-radius:5px;padding:0.3rem 1.5rem;margin:2rem 0 1rem}.container .headline h2{font-size:1.5625rem;color:#043d7a;font-weight:bold;text-align:right}.container .headline .algn-l{text-align:left}.container div p{font-size:0.875rem;color:#6e6e6e;line-height:1.6}.component-title{color:#043d7a;background-color:#f8f8f8;padding:1.5rem 10%;border-bottom:1px solid #eaeaea}.component-title h1{margin:0 auto;padding:0 1.25rem;font-size:1.5256rem}.component-title small{padding:0 1.25rem;font-size:90%}.wrap-select-camp-header-inner{width:100%;padding:1rem calc(10% + 1.25rem) 0;background:#f8f8f8;border-top:1px solid white}.wrap-select-camp-header-inner .camp-child-icon{vertical-align:-3px;margin-right:10px}.wrap-select-camp-header-inner .wrap-select-option-header{display:inline-block;position:relative}.wrap-select-camp-header-inner .wrap-select-option-header:before{content:'';color:#ddd;width:2.5rem;height:1.5625rem;position:absolute;pointer-events:none;right:17px;top:17px;width:0;height:0;border-left:5px solid transparent;border-right:5px solid transparent;border-top:8px solid #ddd}.wrap-select-camp-header-inner .wrap-select-option-header:after{content:'';position:absolute;height:1.5625rem;width:1px;background:#ddd;top:8px;right:40px}.wrap-select-camp-header-inner .wrap-select-option-header select{padding:0 50px 0 13px;border-radius:5px;font-size:1rem;background:#f8f8f8;border:1px solid #ddd;height:2.5rem;color:#282828;outline:none}#submit{max-width:100%;width:100%;padding:2rem 10%;border-top:1px solid #ddd}#submit .l-btn{padding-left:1.25rem}#submit .l-btn button{text-align:left;padding:1.25rem 5.25rem;font-size:1.25rem;font-weight:bold;background:#eaeaea;color:#6e6e6e}#submit .r-btn{text-align:right;padding-right:1.25rem}#submit .r-btn p{text-align:right;font-size:0.875rem;padding-right:1.125rem;padding-top:1rem}#submit .r-btn p a{font-weight:bold}#submit .r-btn .submit{padding:1.25rem 3rem;text-align:center;font-size:1.25rem;font-weight:bold}.bus-registration-container{width:80%;margin:0 auto;padding:0px 1.25rem;margin-bottom:1.5rem}.bus-registration-container h3{font-size:1.525rem;font-weight:bold;color:#043d7a;text-align:center;margin:2rem auto 1rem}.bus-registration-container .total-amount{background:#faa635;border-bottom-left-radius:5px;border-bottom-right-radius:5px;padding:0.3rem 1.5rem}.bus-registration-container .total-amount h2{font-size:1.5625rem;color:#043d7a;font-weight:bold;text-align:right}.bus-registration-container .total-amount .algn-l{text-align:left}.bus-registration-container .total-amount p{font-size:0.875rem;color:#6e6e6e;text-align:justify;line-height:1.6}.bus-registration-container .bus-registration-section{padding:0 1.25rem;margin-top:1rem;justify-content:space-between}.bus-registration-container .bus-registration-section table{text-align:left}.bus-registration-container .bus-registration-section table tr:first-child{background:#043d7a;color:#fff}.bus-registration-container .bus-registration-section p{font-size:0.875rem;color:#6e6e6e;text-align:justify;line-height:1.6}.bus-registration-container .bus-registration-section h5{font-size:1.125rem;color:#043d7a;font-weight:bold;margin-bottom:0.375rem}.bus-registration-container .bus-registration-section ul{list-style-type:decimal}.bus-registration-container .bus-registration-section ul li{font-size:0.875rem;color:#6e6e6e;text-align:justify}.bus-registration-container .bus-registration-section .bus-registration-term{padding-right:3rem}.bus-registration-container .bus-registration-section .bus-registration-method form{box-shadow:none;padding:0;font-size:1rem}.bus-registration-container .bus-registration-section .bus-registration-method form input[type=\"radio\"]{display:none}.bus-registration-container .bus-registration-section .bus-registration-method form input[type=\"radio\"]+label{margin-bottom:0.5rem;font-size:1rem;font-weight:bold;color:#6e6e6e}.bus-registration-container .bus-registration-section .bus-registration-method form input[type=\"radio\"]:disabled+label:before{background:#eee}.bus-registration-container .bus-registration-section .bus-registration-method form input[type=\"radio\"]+label:before{color:#6e6e6e;content:\"\\00a0\";display:inline-block;font:1em sans-serif;margin-right:0.5rem;padding:0;vertical-align:middle;width:1.25rem;height:1.25rem;border-radius:10px;border:1px solid #b8b8b8}.bus-registration-container .bus-registration-section .bus-registration-method form input[type=\"radio\"]:checked+label:before{content:\"\\2022\";color:#b8b8b8;font-size:2.5rem;line-height:19px;text-align:center}.modal{position:fixed;z-index:1;left:0;top:0;width:100%;height:100%;overflow:auto;background-color:#000;background-color:rgba(0,0,0,0.4)}.modal table{display:block;padding:5px 10px;margin-bottom:0;background:#fff;border-bottom-right-radius:5px;border-bottom-left-radius:5px}.modal table tbody{border:none}.modal table tbody td{font-weight:bold;font-size:0.875rem;color:#6e6e6e}.modal .modal-content{margin:0;max-width:400px;position:absolute;top:50%;left:50%;-ms-transform:translateX(-50%) translateY(-50%);-webkit-transform:translate(-50%, -50%);transform:translate(-50%, -50%)}.modal .modal-content .close{color:#fff;float:right;font-size:20px;font-weight:bold;line-height:1}.modal .modal-content .close:hover,.modal .modal-content .close:focus{color:#eee;text-decoration:none;cursor:pointer}.modal .modal-header{text-align:center;padding:10px 20px;color:#fff;background:#043d7a;font-size:1.25rem;font-weight:bold;border-top-right-radius:5px;border-top-left-radius:5px}.modal .modal-header h2{text-align:left;font-size:1rem;font-weight:bold;margin-bottom:0}.modal .modal-body{padding:10px 20px;background:#fff;border-bottom-right-radius:5px;border-bottom-left-radius:5px}@media only screen and (max-width: 40em){.select-camp-header .select-camp-header-inner{padding:0}.select-camp-header .select-camp-header-inner h4{padding-left:10%;padding-right:10%}.select-camp-header .select-camp-header-inner .wrap-select-camp-header-inner{padding:0}.select-camp-header .select-camp-header-inner .wrap-select-camp-header-inner .camp-child-icon{display:none}.list-camp h3{margin:1.5rem auto 1.5rem;line-height:0.7;font-size:1.4rem}.list-camp .row li{padding:0}}\n"

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var router_1 = __webpack_require__(26);
	var ChildrenListComponent_1 = __webpack_require__(313);
	var appRoutes = [
	    { path: 'booking/students', component: ChildrenListComponent_1.ChildrenListComponent },
	    { path: '', redirectTo: 'booking/students', pathMatch: 'full' }
	];
	exports.appRoutingProviders = [];
	exports.routing = router_1.RouterModule.forRoot(appRoutes);


/***/ })
]);


// WEBPACK FOOTER //
// app.64a71492ca5553791637.js